import { Component, ViewEncapsulation, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0900Model } from './kymw0900.model';
import { KYMW0900InputModel } from './vo/kymw0900-input.model';
import { KYMW0400Component } from '../../kymw04/kymw0400/kymw0400.component';
import { KYMW0700Component } from '../../kymw07/kymw0700/kymw0700.component';
import { KYMW0A00Component } from '../../kymw0a/kymw0a00/kymw0a00.component';
import { KYMW0901Component } from '../kymw0901/kymw0901.component';
import { KYMW0600Component } from '../../kymw06/kymw0600/kymw0600.component';
import { KYMW0905Component } from '../kymw0905/kymw0905.component';
import { KYMW1600Component } from '../../../kymw/kymw16/kymw1600/kymw1600.component';
import { KYMW0F00Component } from '../../kymw0f/kymw0f00/kymw0f00.component';
import { KYMW5002Component } from '../../kymw50/kymw5002/kymw5002.component';

import { CellRange, FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { TabPanel, AccordionPane } from '@grapecity/wijmo.nav';
import { Menu } from '@grapecity/wijmo.input';

import { GetPlanGoodsMaintainService } from './api-services/get-plan-goods-maintain.service';
import { CheckNgWordsService } from '../../kymw02/check-ng-words/api-services/check-ng-words.service';
import { CheckPlanGoodsService } from './api-services/check-plan-goods.service';
import { GetCoopPlanNumService } from './api-services/get-coop-plan-num.service';
import { GetNextGuideService } from './api-services/get-next-guide.service';
import { GetSupplierService } from './api-services/get-supplier.service';
import { ClearPlanGoodsChangeManageService } from './api-services/clear-plan-goods-change-manage.service';
import { GetPreOrderFlagService } from './api-services/get-pre-order-flag.service';
import { GetPreOrderService } from './api-services/get-pre-order.service';
import { GetPlanGoodsECService } from './api-services/get-plan-goods-ec.service';
import { GetImageDataService } from './api-services/get-image-data.service';
import { GetStockInfoService } from './api-services/get-stock-info.service';
import { GetGroupingInfoService } from './api-services/get-grouping-info.service';
import { GetWebLinkInfoService } from './api-services/get-web-link-info.service';
import { GetGroupingListService } from './api-services/get-grouping-list.service';
import { GetGroupingDataService } from './api-services/get-grouping-data.service';
import { GetTagListService } from './api-services/get-tag-list.service';

import { ClassCodeComboBoxComponent } from '../../kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { LargeClassCodeComboBoxComponent } from '../../kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from '../../kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { CodeComboBoxComponent } from '../../kymw02/combo-box/code-combo-box/code-combo-box.component';
import { NotNullTextAreaComponent } from '../../kymw02/not-null-text-area/not-null-text-area.component';
import { NotNullTextInputComponent } from '../../kymw02/not-null-text-input/not-null-text-input.component';
import { CheckboxLabelComponent } from '../../kymw02/checkbox-label/checkbox-label.component';
import { TextAreaComponent } from '../../kymw02/text-input/text-area/text-area.component';
import { TextInputComponent } from '../../kymw02/text-input/text-input/text-input.component';

import { CheckPlanGoodsRequestModel } from './vo/kymw0900-check-plan-goods-request.model';
import { PlanGoodsBaseModel } from './vo/kymw0900-plan-goods-base.model';
import { PlanGoodsCoopModel } from './vo/kymw0900-plan-goods-coop.model';
import { PlanGoodsListingModel } from './vo/kymw0900-plan-goods-listing.model';
import { PlanGoodsDetailModel } from './vo/kymw0900-plan-goods-detail.model';
import { KYMW0900OutputModel } from './vo/kymw0900-output.model';
import { MarkPlanGoodsModel } from './vo/kymw0900-mark-plan-goods.model';
import { PlanTextInfoGoodsModel } from './vo/kymw0900-plan-text-info-goods.model';
import { PlanTextInfoItemModel } from './vo/kymw0900-plan-text-info-item.model';
import { UseMarkModel } from './vo/kymw0900-use-mark.model';
import { PlanGoodsEcology1Model } from './vo/kymw0900-plan-goods-ecology1.model';
import { PlanGoodsEcology2Model } from './vo/kymw0900-plan-goods-ecology2.model';
import { PlanGoodsGWStopModel } from './vo/kymw0900-plan-goods-gws-top.model';
import { PlanGoodsContainModel } from './vo/kymw0900-plan-goods-contain';
import { PlanMediumTextModel } from './vo/kymw0900-plan-medium-text.model';
import { PlanGoodsNutritionUnitModel } from './vo/kymw0900-plan-goods-nutrition-unit.model';
import { PlanGoodsNutritionDetailModel } from './vo/kymw0900-plan-goods-nutrition-detail.model';
import { CoopPlanNumRequestModel } from './vo/kymw0900-coop-plan-num-request.model';
import { PlanNumRecModel } from './vo/kymw0900-plan-num-rec.model';
import { NextGuideRequestModel } from './vo/kymw0900-next-guide-request.model';
import { SupplierRequestVO } from './vo/kymw0900-supplier-request.model';
import { ClearPlanGoodsChangeManageRequestModel } from './vo/kymw0900-clear-plan-goods-change-manage-request.model';
import { PlanGoodsMaintainModel } from './vo/kymw0900-plan-goods-maintain.model';
import { ConsumeTaxRequestModel } from './vo/kymw0900-consume-tax-request.model';
import { PlanGoodsAllergenModel } from './vo/kymw0900-plan-goods-allergen.model';

import { KYMW0400InputModel } from '../../kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0400OutputModel } from '../../kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW0600OutputModel } from '../../kymw06/kymw0600/vo/kymw0600-output.model';
import { KYMW0600InputModel } from '../../kymw06/kymw0600/vo/kymw0600-input.model';
import { KYMW0700InputModel } from '../../kymw07/kymw0700/vo/kymw0700-input.model';
import { KYMW0700OutputModel } from '../../kymw07/kymw0700/vo/kymw0700-output.model';
import { KYMW0905OutputModel } from '../kymw0905/vo/kymw0905-output.model';
import { KYMW0905InputModel } from '../kymw0905/vo/kymw0905-input.model';
import { KYMW0A00InputModel } from '../../kymw0a/kymw0a00/vo/kymw0a00-input.model';
import { KYMW0A00OutputModel } from '../../kymw0a/kymw0a00/vo/kymw0a00-output.model';
import { KYMW1600InputModel } from '../../../kymw/kymw16/kymw1600/vo/kymw1600-input.model';
import { KYMW0F00InputModel } from '../../kymw0f/kymw0f00/vo/kymw0f00-input.model';
import { KYMW0F00OutputModel } from '../../kymw0f/kymw0f00/vo/kymw0f00-output.model';
import { KYMW5002InputModel } from '../../kymw50/kymw5002/vo/kymw5002-input.model';
import { KYMW5002OutputModel } from '../../kymw50/kymw5002/vo/kymw5002-output.model';

import { PublishVoiceHistoryRequestModel } from './vo/kymw0900-publish-voice-history-request.model';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { GetPublishVoiceHistoryService } from './api-services/get-publish-voice-history.service';
import { RadioLabelComponent } from '../../kymw02/radio-label/radio-label.component';
import { GetDefaultConsumeTaxInfoService } from './api-services/get-default-consume-tax-info.service';
import { EventArgs } from '@grapecity/wijmo';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { GuideInfoRequestModel } from './vo/kymw0900-guide-info-request.model';
import { GetGuideInfoService } from './api-services/get-guide-info.service';
import { KYMW0800InputModel } from '../../kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW0800Component } from '../../kymw08/kymw0800/kymw0800.component';
import { GetOrderNumQuotaCodeListRequestModel } from './vo/kymw0900-order-num-quota-code-list-request.model';
import { GetOrderNumQuotaCodeListService } from './api-services/get-order-num-quota-code-list.service';
import { PlanGoodsLotteryPromotionRequestModel } from './vo/kymw0900-plan-goods-lottery-promotion-request.model';
import { PlanGoodsLotteryPromotionService } from './api-services/get-plan-goods-lottery-promotion.service';
import { NumberOfUsersService } from './api-services/get-number-of-users.service';
import { NumberOfUsersRequestModel } from './vo/kymw0900-number-of-users-request.model';
import { PlanGoodsPointExchangePromotionService } from './api-services/get-plan-goods-point-exchange-promotion.service';
import { PlanGoodsPointExchangePromotionRequestModel } from './vo/kymw0900-plan-goods-point-exchange-promotion-request.model';
import { PlanGoodsNvalPromotionService } from './api-services/get-plan-goods-nval-promotion.service';
import { PlanGoodsNvalPromotionRequestModel } from './vo/kymw0900-plan-goods-nval-promotion-request.model';
import { PlanGoodsCouponPromotionRequestModel } from './vo/kymw0900-plan-goods-coupon-promotion-request.model';
import { PlanGoodsCouponPromotionService } from './api-services/get-plan-goods-coupon-promotion.service';
import { GetPreOrderFlagRequestModel } from './vo/kymw0900-get-pre-order-flag-request.model';
import { GetPreOrderRequestModel } from './vo/kymw0900-get-pre-order-request.model';
import { GetPlanGoodsECRequestModel } from './vo/kymw0900-get-plan-goods-ec-request.model';
import { GetImageDataRequestModel } from './vo/kymw0900-get-image-data-request.model';
import { GetStockInfoRequestModel } from './vo/kymw0900-get-stock-info-request.model';
import { GetGroupingInfoRequestModel } from './vo/kymw0900-get-grouping-info-request.model';
import { GetWebLinkInfoRequestModel } from './vo/kymw0900-get-web-link-info-request.model';
import { GetGroupingListRequestModel } from './vo/kymw0900-get-grouping-list-request.model';
import { GetGroupingDataRequestModel } from './vo/kymw0900-get-grouping-data-request.model';
import { GetTagListRequestModel } from './vo/kymw0900-get-tag-list-request.model';
import { GetNotUseCoopRequestModel } from './vo/kymw0900-get-not-use-coop-request.model';
import { GetNotUseCoopService } from './api-services/get-not-use-coop.service';
import { CatalogProgressTextInputComponent } from '../../kymw02/text-input/catalog-progress-text-input/catalog-progress-text-input.component';
import { VersatileComboBoxComponent } from '../../kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { PlanGoodsLockService } from '../../kymw00/api-services/plan-goods-lock.service';
import { KYMW0906InputModel } from '../kymw0906/vo/kymw0906-input.model';
import { KYMW0906Component } from '../kymw0906/kymw0906.component';
import { KYMW0906OutputModel } from '../kymw0906/vo/kymw0906-output.model';
import { GetGoodsUseCoopService } from './api-services/get-goods-use-coop.service';
import { FilterType, FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import { GetIconDataService } from './api-services/get-icon-data.service';
import { KYMW0907Component } from '../kymw0907/kymw0907.component';
import { KYMW0907InputModel } from '../kymw0907/vo/kymw0907-input.model';
import { KYMW0907OutputModel } from '../kymw0907/vo/kymw0907-output.model';
import { GetSelectedNvalMediumListResponse, GetSelectedNvalMediumListService } from './api-services/get-selected-nval-medium-list.service';
import { GetCodeListService } from '../../kymw02/api-services/get-code-list.service';
import { KYMW0908Component } from '../kymw0908/kymw0908.component';
import { KYMW0908InputModel } from '../kymw0908/vo/kymw0908-input.model';
import { KYMW0908OutputModel } from '../kymw0908/vo/kymw0908-output.model';
import { KYMW0909Component } from '../kymw0909/kymw0909.component';
import { KYMW0909InputModel } from '../kymw0909/vo/kymw0909-input.model';
import { KYMW0909OutputModel } from '../kymw0909/vo/kymw0909-output.model';
import { GetGoodsSupplyPriceService } from './api-services/get-goods-supply-price.service';
/**
 * 商品企画メンテナンス画面を管理するクラス
 *
 * @export KYMW0900Component
 * @class KYMW0900Component
 */
@Component({
  selector: 'app-kymw0900',
  templateUrl: 'kymw0900.component.html',
  styleUrls: ['kymw0900.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0900Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  // Function
  setKYMW0900Parameter: Function;

  plessEnabledFlag = false;

  public coopMarkList: Array<any> = new Array<any>();

  isComposing = false;

  // tab
  @ViewChild('tab_pCode', { static: true }) tab_pCode: TabPanel;
  @ViewChild('tab_item', { static: true }) tab_item: TabPanel;

  // 共通
  @ViewChild('btn_ChangeConfirmation', { static: true }) btn_ChangeConfirmation: ElementRef;

  // Ｐコード共通
  @ViewChild('cmb_PCode', { static: true }) cmb_PCode: ElementRef;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_LargeClassCode', { static: true }) cmb_LargeClassCode: LargeClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode', { static: true }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCodeList', { static: true }) cmb_SmallClassCodeList: SmallClassCodeComboBoxComponent;
  @ViewChild('txti_GuideGoodsName', { static: true }) txti_GuideGoodsName: NotNullTextInputComponent;
  @ViewChild('txti_GuideStandardName', { static: true }) txti_GuideStandardName: NotNullTextInputComponent;
  @ViewChild('chk_PackMaterialShowFlag', { static: true }) chk_PackMaterialShowFlag: ElementRef;

  // 基本
  @ViewChild('txti_RelationPcodeOld', { static: true }) txti_RelationPcodeOld: ElementRef;
  @ViewChild('txti_RelationPcodeNew', { static: true }) txti_RelationPcodeNew: ElementRef;
  @ViewChild('cmb_ConsumeTaxDivList', { static: true }) cmb_ConsumeTaxDivList: CodeComboBoxComponent;
  @ViewChild('cmb_CycleTerm', { static: true }) cmb_CycleTerm: CodeComboBoxComponent;
  @ViewChild('cmb_EdlpDiv', { static: true }) cmb_EdlpDiv: CodeComboBoxComponent;
  @ViewChild('cmb_RoomTempZoneDiv', { static: true }) cmb_RoomTempZoneDiv: CodeComboBoxComponent;
  @ViewChild('cmb_UnitPriceDiv', { static: true }) cmb_UnitPriceDiv: CodeComboBoxComponent;
  @ViewChild('cmb_LiquorCode', { static: true }) cmb_LiquorCode: CodeComboBoxComponent;
  @ViewChild('cmb_ContainerForm', { static: true }) cmb_ContainerForm: CodeComboBoxComponent;
  @ViewChild('cmb_BlindDiv', { static: true }) cmb_BlindDiv: CodeComboBoxComponent;
  @ViewChild('cmb_KomaScheduleDiv', { static: true }) cmb_KomaScheduleDiv: CodeComboBoxComponent;
  @ViewChild('txti_AlcoholType', { static: true }) txti_AlcoholType: ElementRef;
  @ViewChild('txti_ContainerCapacity', { static: true }) txti_ContainerCapacity: ElementRef;
  @ViewChild('chk_EFriendsSendDiv', { static: true }) chk_EFriendsSendDiv: ElementRef;
  @ViewChild('txti_DeliveryGoodsNameKanji', { static: true }) txti_DeliveryGoodsNameKanji: NotNullTextInputComponent;
  @ViewChild('txti_DeliveryStandardNameKanji', { static: true }) txti_DeliveryStandardNameKanji: NotNullTextInputComponent;
  @ViewChild('txti_DeliveryGoodsNameKana', { static: true }) txti_DeliveryGoodsNameKana: NotNullTextInputComponent;
  @ViewChild('txti_DeliveryStandardNameKana', { static: true }) txti_DeliveryStandardNameKana: NotNullTextInputComponent;
  @ViewChild('txti_OcrGoodsName', { static: true }) txti_OcrGoodsName: NotNullTextInputComponent;
  @ViewChild('txti_ConsumeTaxDivRate', { static: true }) txti_ConsumeTaxDivRate: ElementRef;
  @ViewChild('txti_UnitPriceCoefficient', { static: true }) txti_UnitPriceCoefficient: ElementRef;
  @ViewChild('txti_UnitPriceUnit', { static: true }) txti_UnitPriceUnit: NotNullTextInputComponent;
  @ViewChild('txti_ConsumeTerm', { static: true }) txti_ConsumeTerm: ElementRef;
  @ViewChild('txti_ConsumeByDate', { static: true }) txti_ConsumeByDate: ElementRef;
  @ViewChild('txti_LeaveConsumeTerm', { static: true }) txti_LeaveConsumeTerm: ElementRef;
  @ViewChild('btn_RelationPcode', { static: true }) btn_RelationPcode: ElementRef;

  // 会員
  @ViewChild('dtg_PriceList', { static: true }) dtg_PriceList: FlexGrid;
  @ViewChild('dtg_CoopMarkList', { static: true }) dtg_CoopMarkList: FlexGrid;
  @ViewChild('cmb_PricePattern', { static: true }) cmb_PricePattern: ElementRef;
  @ViewChild('chk_AllcoopValue', { static: true }) chk_AllcoopValue: ElementRef;
  @ViewChild('txti_AllthistimeSupplyPrice', { static: true }) txti_AllthistimeSupplyPrice: ElementRef;
  @ViewChild('txti_AllthistimeCostPrice', { static: true }) txti_AllthistimeCostPrice: ElementRef;
  @ViewChild('btn_BatchReflection', { static: true }) btn_BatchReflection: ElementRef;

  // 詳細
  @ViewChild('dtg_CoopDetailList', { static: true }) dtg_CoopDetailList: FlexGrid;
  @ViewChild('dtg_ListingItemList', { static: true }) dtg_ListingItemList: FlexGrid;
  @ViewChild('txti_ListingGoodsName', { static: true }) txti_ListingGoodsName: NotNullTextInputComponent;

  // マーク
  @ViewChild('dtg_MarkList', { static: true }) dtg_MarkList: FlexGrid;
  @ViewChild('dtg_SelectedMark', { static: true }) dtg_SelectedMark: FlexGrid;

  // 付加
  @ViewChild('lnb_TextInfo1', { static: true }) lnb_TextInfo1: ElementRef;
  @ViewChild('txta_TextInfo1', { static: true }) txta_TextInfo1: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo2', { static: true }) lnb_TextInfo2: ElementRef;
  @ViewChild('txta_TextInfo2', { static: true }) txta_TextInfo2: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo3', { static: true }) lnb_TextInfo3: ElementRef;
  @ViewChild('txta_TextInfo3', { static: true }) txta_TextInfo3: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo4', { static: true }) lnb_TextInfo4: ElementRef;
  @ViewChild('txta_TextInfo4', { static: true }) txta_TextInfo4: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo5', { static: true }) lnb_TextInfo5: ElementRef;
  @ViewChild('txta_TextInfo5', { static: true }) txta_TextInfo5: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo6', { static: true }) lnb_TextInfo6: ElementRef;
  @ViewChild('txta_TextInfo6', { static: true }) txta_TextInfo6: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfo7', { static: true }) txta_TextInfo7: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo8', { static: true }) lnb_TextInfo8: ElementRef;
  @ViewChild('txta_TextInfo8', { static: true }) txta_TextInfo8: NotNullTextAreaComponent;

  @ViewChild('lnb_TextInfo9', { static: true }) lnb_TextInfo9: ElementRef;
  @ViewChild('txta_TextInfo9', { static: true }) txta_TextInfo9: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoA', { static: true }) txta_TextInfoA: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoB', { static: true }) txta_TextInfoB: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoC', { static: true }) txta_TextInfoC: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoD', { static: true }) txta_TextInfoD: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoE', { static: true }) txta_TextInfoE: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoF', { static: true }) txta_TextInfoF: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoG', { static: true }) txta_TextInfoG: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoH', { static: true }) txta_TextInfoH: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoI', { static: true }) txta_TextInfoI: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoJ', { static: true }) txta_TextInfoJ: NotNullTextAreaComponent;

  @ViewChild('txta_TextInfoK', { static: true }) txta_TextInfoK: NotNullTextAreaComponent;

  // 発注業態
  @ViewChild('cmb_StinkGoodsDivList', { static: true }) cmb_StinkGoodsDivList: CodeComboBoxComponent;
  @ViewChild('cmb_CaseSupplyDivList', { static: true }) cmb_CaseSupplyDivList: CodeComboBoxComponent;
  @ViewChild('cmb_LongKeepDivList', { static: true }) cmb_LongKeepDivList: CodeComboBoxComponent;
  @ViewChild('cmb_ArrivalAreaDivList', { static: true }) cmb_ArrivalAreaDivList: CodeComboBoxComponent;
  @ViewChild('cmb_DutiesFormDailyDiv', { static: true }) cmb_DutiesFormDailyDiv: CodeComboBoxComponent;
  @ViewChild('cmb_DutiesFormSpotDiv', { static: true }) cmb_DutiesFormSpotDiv: CodeComboBoxComponent;
  @ViewChild('txti_ArrivalGoodsTemp', { static: true }) txti_ArrivalGoodsTemp: ElementRef;
  @ViewChild('txti_ArrivalAdminDays', { static: true }) txti_ArrivalAdminDays: ElementRef;

  // 組合員
  @ViewChild('txta_InquiryContentsAll', { static: true }) txta_InquiryContentsAll: ElementRef;
  @ViewChild('btn_InquiryContentsAll', { static: true }) btn_InquiryContentsAll: ElementRef;
  @ViewChild('btn_BatchReflectionAll', { static: true }) btn_BatchReflectionAll: ElementRef;

  @ViewChild('txta_InquiryContents1', { static: true }) txta_InquiryContents1: ElementRef;
  @ViewChild('btn_InquiryContents1', { static: true }) btn_InquiryContents1: ElementRef;
  @ViewChild('btn_ClearContents1', { static: true }) btn_ClearContents1: ElementRef;
  @ViewChild('txta_InquiryContents2', { static: true }) txta_InquiryContents2: ElementRef;
  @ViewChild('btn_InquiryContents2', { static: true }) btn_InquiryContents2: ElementRef;
  @ViewChild('btn_ClearContents2', { static: true }) btn_ClearContents2: ElementRef;
  @ViewChild('txta_InquiryContents3', { static: true }) txta_InquiryContents3: ElementRef;
  @ViewChild('btn_InquiryContents3', { static: true }) btn_InquiryContents3: ElementRef;
  @ViewChild('btn_ClearContents3', { static: true }) btn_ClearContents3: ElementRef;
  @ViewChild('txta_InquiryContents4', { static: true }) txta_InquiryContents4: ElementRef;
  @ViewChild('btn_InquiryContents4', { static: true }) btn_InquiryContents4: ElementRef;
  @ViewChild('btn_ClearContents4', { static: true }) btn_ClearContents4: ElementRef;
  @ViewChild('txta_InquiryContents5', { static: true }) txta_InquiryContents5: ElementRef;
  @ViewChild('btn_InquiryContents5', { static: true }) btn_InquiryContents5: ElementRef;
  @ViewChild('btn_ClearContents5', { static: true }) btn_ClearContents5: ElementRef;
  @ViewChild('txta_InquiryContents6', { static: true }) txta_InquiryContents6: ElementRef;
  @ViewChild('btn_InquiryContents6', { static: true }) btn_InquiryContents6: ElementRef;
  @ViewChild('btn_ClearContents6', { static: true }) btn_ClearContents6: ElementRef;
  @ViewChild('txta_InquiryContents7', { static: true }) txta_InquiryContents7: ElementRef;
  @ViewChild('btn_InquiryContents7', { static: true }) btn_InquiryContents7: ElementRef;
  @ViewChild('btn_ClearContents7', { static: true }) btn_ClearContents7: ElementRef;
  @ViewChild('txta_InquiryContents8', { static: true }) txta_InquiryContents8: ElementRef;
  @ViewChild('btn_InquiryContents8', { static: true }) btn_InquiryContents8: ElementRef;
  @ViewChild('btn_ClearContents8', { static: true }) btn_ClearContents8: ElementRef;

  @ViewChild('chk_SelectValue1', { static: true }) chk_SelectValue1: ElementRef;
  @ViewChild('chk_SelectValue2', { static: true }) chk_SelectValue2: ElementRef;
  @ViewChild('chk_SelectValue3', { static: true }) chk_SelectValue3: ElementRef;
  @ViewChild('chk_SelectValue4', { static: true }) chk_SelectValue4: ElementRef;
  @ViewChild('chk_SelectValue5', { static: true }) chk_SelectValue5: ElementRef;
  @ViewChild('chk_SelectValue6', { static: true }) chk_SelectValue6: ElementRef;
  @ViewChild('chk_SelectValue7', { static: true }) chk_SelectValue7: ElementRef;
  @ViewChild('chk_SelectValue8', { static: true }) chk_SelectValue8: ElementRef;

  // 計画数
  @ViewChild('dtg_PlanList', { static: true }) dtg_PlanList: FlexGrid;
  @ViewChild('txti_PlanPInum', { static: true }) txti_PlanPInum: ElementRef;
  @ViewChild('btn_PlanDistribution', { static: true }) btn_PlanDistribution: ElementRef;
  @ViewChild('btn_PlanAutoSetting', { static: true }) btn_PlanAutoSetting: ElementRef;

  // 案内
  @ViewChild('dtg_GuideList', { static: true }) dtg_GuideList: FlexGrid;
  @ViewChild('btn_SettingNextGuide', { static: true }) btn_SettingNextGuide: ElementRef;
  // 保健
  @ViewChild('txta_LicencedNo', { static: true }) txta_LicencedNo: NotNullTextInputComponent;
  @ViewChild('txta_LicencedDescription', { static: true }) txta_LicencedDescription: NotNullTextAreaComponent;
  @ViewChild('txta_LicencedDescriptionDef', { static: true }) txta_LicencedDescriptionDef: NotNullTextAreaComponent;

  // プロモ設定
  @ViewChild('cnv_PromotionInfoSettingTab', { static: true }) cnv_PromotionInfoSettingTab: TabPanel;
  // プロモ設定：抽選プロモーション
  @ViewChild('acc_UseLotteryPromotion', { static: true }) acc_UseLotteryPromotion: AccordionPane;
  @ViewChild('chk_UseLotteryPromotion', { static: true }) chk_UseLotteryPromotion: CheckboxLabelComponent;
  @ViewChild('dtg_UseLotteryPromotionList', { static: true }) dtg_UseLotteryPromotionList: FlexGrid;
  @ViewChild('btn_WinningGoodsNumDistribution', { static: true }) btn_WinningGoodsNumDistribution: ElementRef;
  /** 抽選商品プロモーションと連動する企画マスタ管理マークコード 033「０１：数量限定」*/
  readonly LOTTERYPROMOTION_MARKCODE = "033";
  // プロモ設定：ポイント交換商品プロモーション
  @ViewChild('acc_PointPromotion', { static: true }) acc_PointPromotion: AccordionPane;
  @ViewChild('chk_PointPromotion', { static: true }) chk_PointPromotion: CheckboxLabelComponent;
  @ViewChild('dtg_PointPromotionList', { static: true }) dtg_PointPromotionList: FlexGrid;
  // プロモ設定：1物N価媒体プロモーション
  @ViewChild('dtg_NvalPromotionList', { static: true }) dtg_NvalPromotionList: FlexGrid;
  @ViewChild('acc_NvalPromotion', { static: true }) acc_NvalPromotion: AccordionPane;
  @ViewChild('chk_NvalPromotion', { static: true }) chk_NvalPromotion: CheckboxLabelComponent;
  // プロモ設定：クーポン商品プロモーション
  @ViewChild('acc_CouponPromotion', { static: true }) acc_CouponPromotion: AccordionPane;
  @ViewChild('chk_CouponPromotion', { static: true }) chk_CouponPromotion: CheckboxLabelComponent;
  @ViewChild('dtg_CouponPromotionList', { static: true }) dtg_CouponPromotionList: FlexGrid;

  // タグ
  @ViewChild('dtg_TagList', { static: true }) dtg_TagList: FlexGrid;

  // EC設定
  @ViewChild('acc_stock', { static: true }) acc_stock: AccordionPane;
  @ViewChild('acc_weblink', { static: true }) acc_weblink: AccordionPane;
  @ViewChild('dtg_StockList', { static: true }) dtg_StockList: FlexGrid;
  @ViewChild('dtg_GroupingList', { static: true }) dtg_GroupingList: FlexGrid;
  @ViewChild('dtg_ECImage', { static: true }) dtg_ECImage: FlexGrid;
  @ViewChild('chk_StockNumShowFlg', { static: true }) chk_StockNumShowFlg: CheckboxLabelComponent;
  @ViewChild('txti_BrandName', { static: true }) txti_BrandName: ElementRef;
  @ViewChild('txti_CoopGoodsUrlTitle', { static: true }) txti_CoopGoodsUrlTitle: ElementRef;
  @ViewChild('txti_CoopGoodsUrl', { static: true }) txti_CoopGoodsUrl: ElementRef;
  @ViewChild('txti_RelatedUrlTitle', { static: true }) txti_RelatedUrlTitle: ElementRef;
  @ViewChild('txti_RelatedUrl', { static: true }) txti_RelatedUrl: ElementRef;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: CatalogProgressTextInputComponent;
  @ViewChild('groupingCode', { static: true }) groupingCode: VersatileComboBoxComponent;
  @ViewChild('cmb_OrderGoodsDiv', { static: true }) cmb_OrderGoodsDiv: CodeComboBoxComponent;
  @ViewChild('chk_CmFlg', { static: true }) chk_CmFlg: ElementRef;
  @ViewChild('chk_OrderLimitFlg', { static: true }) chk_OrderLimitFlg: ElementRef;
  @ViewChild('chk_NonDispFlg', { static: true }) chk_NonDispFlg: ElementRef;
  @ViewChild('chk_WebLimitFlg', { static: true }) chk_WebLimitFlg: ElementRef;
  @ViewChild('chk_RecommendFlg', { static: true }) chk_RecommendFlg: ElementRef;
  @ViewChild('txti_MinOrderNum', { static: true }) txti_MinOrderNum: ElementRef;
  @ViewChild('txti_MaxOrderNum', { static: true }) txti_MaxOrderNum: ElementRef;
  @ViewChild('btn_ECSearch', { static: true }) btn_ECSearch: ElementRef;
  @ViewChild('btn_Instructions', { static: true }) btn_Instructions: ElementRef;

  // アイコン
  @ViewChild('chk_AllCoopValueIcon', { static: true }) chk_AllCoopValueIcon: CheckboxLabelComponent;
  @ViewChild('dtg_IconList', { static: true }) dtg_IconList: FlexGrid;
  @ViewChild('fltr_Icon', { static: false }) fltr_Icon: FlexGridFilter;
  @ViewChild('dtg_SelectedIconList', { static: true }) dtg_SelectedIconList: FlexGrid;

  // 予約設定
  @ViewChild('dtg_PreOrderDetailList', { static: true }) dtg_PreOrderDetailList: FlexGrid;

  // アイテムコード共通
  @ViewChild('lbl_RegistDate', { static: true }) lbl_RegistDate: ElementRef;
  @ViewChild('lbl_UpdateDate', { static: true }) lbl_UpdateDate: ElementRef;
  @ViewChild('cmb_ItemCode', { static: true }) cmb_ItemCode: ElementRef;
  @ViewChild('txti_BuyerCode', { static: true }) txti_BuyerCode: ElementRef;
  @ViewChild('txti_JanCode', { static: true }) txti_JanCode: ElementRef;
  @ViewChild('chk_JanCodeDiv', { static: true }) chk_JanCodeDiv: CheckboxLabelComponent;

  // アイテム
  @ViewChild('txti_FcmcFee', { static: true }) txti_FcmcFee: ElementRef;
  @ViewChild('txti_PayeeClientName', { static: true }) txti_PayeeClientName: ElementRef;
  @ViewChild('txti_ItfCode', { static: true }) txti_ItfCode: ElementRef;
  @ViewChild('txti_OrderClientName', { static: true }) txti_OrderClientName: ElementRef;
  @ViewChild('txti_MakerPrice', { static: true }) txti_MakerPrice: ElementRef;
  @ViewChild('txti_BundlePrice', { static: true }) txti_BundlePrice: ElementRef;
  @ViewChild('txti_OrderClientCode', { static: true }) txti_OrderClientCode: ElementRef;
  @ViewChild('txti_PayeeClientCode', { static: true }) txti_PayeeClientCode: ElementRef;
  @ViewChild('txti_InstallmentTimes', { static: true }) txti_InstallmentTimes: ElementRef;
  @ViewChild('txti_PdPilingUpDays', { static: true }) txti_PdPilingUpDays: ElementRef;
  @ViewChild('txti_FixContainNum', { static: true }) txti_FixContainNum: ElementRef;
  @ViewChild('txti_SetQuantity', { static: true }) txti_SetQuantity: ElementRef;
  @ViewChild('cmb_SpecialOrderTypeList', { static: true }) cmb_SpecialOrderTypeList: CodeComboBoxComponent;
  @ViewChild('cmb_StockTypeList', { static: true }) cmb_StockTypeList: CodeComboBoxComponent;
  @ViewChild('cmb_OrderUnitType', { static: true }) cmb_OrderUnitType: CodeComboBoxComponent;
  @ViewChild('cmb_MakerType', { static: true }) cmb_MakerType: CodeComboBoxComponent;
  @ViewChild('btn_OrderClientCode', { static: true }) btn_OrderClientCode: ElementRef;
  @ViewChild('btn_PayeeClientCode', { static: true }) btn_PayeeClientCode: ElementRef;

  // 仕様書1
  @ViewChild('txti_MakerName', { static: true }) txti_MakerName: NotNullTextInputComponent;
  @ViewChild('txti_EbaseSpecCode', { static: true }) txti_EbaseSpecCode: ElementRef;
  @ViewChild('txti_SpecApplyDate', { static: true }) txti_SpecApplyDate: ElementRef;
  @ViewChild('txti_CaseWeight', { static: true }) txti_CaseWeight: ElementRef;
  @ViewChild('txti_CaseSizeHight', { static: true }) txti_CaseSizeHight: ElementRef;
  @ViewChild('txti_CaseSizeWidth', { static: true }) txti_CaseSizeWidth: ElementRef;
  @ViewChild('txti_CaseSizeLength', { static: true }) txti_CaseSizeLength: ElementRef;
  @ViewChild('txti_PeaceWeight', { static: true }) txti_PeaceWeight: ElementRef;
  @ViewChild('txti_PeaceSizeWidth', { static: true }) txti_PeaceSizeWidth: ElementRef;
  @ViewChild('txti_PeaceSizeLength', { static: true }) txti_PeaceSizeLength: ElementRef;
  @ViewChild('txti_PeaceSizeHight', { static: true }) txti_PeaceSizeHight: ElementRef;
  @ViewChild('cmb_GeneRecombinationDivList', { static: true }) cmb_GeneRecombinationDivList: CodeComboBoxComponent;
  @ViewChild('chk_MakerNamePublishType', { static: true }) chk_MakerNamePublishType: ElementRef;
  @ViewChild('txta_StringValue1', { static: true }) txta_StringValue1: NotNullTextAreaComponent;
  @ViewChild('txta_StringValue2', { static: true }) txta_StringValue2: NotNullTextAreaComponent;
  @ViewChild('txta_StringValue3', { static: true }) txta_StringValue3: NotNullTextAreaComponent;
  @ViewChild('txta_StringValue4', { static: true }) txta_StringValue4: NotNullTextAreaComponent;
  @ViewChild('txta_StringValue5', { static: true }) txta_StringValue5: NotNullTextAreaComponent;
  @ViewChild('txta_StringValue6', { static: true }) txta_StringValue6: NotNullTextAreaComponent;

  // 仕様書2
  @ViewChild('dtg_AllergenInfo', { static: true }) dtg_AllergenInfo: FlexGrid;
  @ViewChild('cmb_AllergenTergetType', { static: true }) cmb_AllergenTergetType: CodeComboBoxComponent;

  // プロモ
  @ViewChild('cmb_MarkGroup', { static: true }) cmb_MarkGroup: ElementRef;
  @ViewChild('dtg_MarkInfo', { static: true }) dtg_MarkInfo: FlexGrid;
  @ViewChild('chk_AllcoopValue2', { static: true }) chk_AllcoopValue2: CheckboxLabelComponent;

  // 栄養成分
  @ViewChild('cnv_NutrientTab', { static: true }) cnv_NutrientTab: TabPanel;
  @ViewChild('dtg_NutrientUnitList', { static: true }) dtg_NutrientUnitList: FlexGrid;
  @ViewChild('dtg_NutrientComponentList', { static: true }) dtg_NutrientComponentList: FlexGrid;
  @ViewChild('txta_NutrientComponentComment', { static: true }) txta_NutrientComponentComment: NotNullTextAreaComponent;
  @ViewChild('chk_HasMultiNutrientInfo', { static: true }) chk_HasMultiNutrientInfo: CheckboxLabelComponent;

  // 複数栄養成分
  @ViewChild('cnv_MultiNutrientTab', { static: true }) cnv_MultiNutrientTab: TabPanel;
  @ViewChild('dtg_NutrientComponentListMulti', { static: true }) dtg_NutrientComponentListMulti: FlexGrid;
  @ViewChild('txta_NutrientComponentCommentMulti', { static: true }) txta_NutrientComponentCommentMulti: NotNullTextAreaComponent;

  // 環境
  @ViewChild('rdbg_EcologyDiv', { static: true }) rdbg_EcologyDiv: RadioLabelComponent;
  @ViewChild('rdb_Ecology0', { static: true }) rdb_Ecology0: RadioLabelComponent;
  @ViewChild('rdb_Ecology1', { static: true }) rdb_Ecology1: RadioLabelComponent;
  @ViewChild('dtg_GoodsEcologyList', { static: true }) dtg_GoodsEcologyList: FlexGrid;
  @ViewChild('dtg_ContainPackingList', { static: true }) dtg_ContainPackingList: FlexGrid;
  @ViewChild('dtg_GoodsGWStopList', { static: true }) dtg_GoodsGWStopList: FlexGrid;
  @ViewChild('dtg_NutrientUnitListMulti', { static: true }) dtg_NutrientUnitListMulti: FlexGrid;

  // 各タブのリンク
  @ViewChild('a_BaseInfo', { static: true }) a_BaseInfo: ElementRef;
  @ViewChild('a_CoopInfo', { static: true }) a_CoopInfo: ElementRef;
  @ViewChild('a_DetailsInfo', { static: true }) a_DetailsInfo: ElementRef;
  @ViewChild('a_MarkInfo', { static: true }) a_MarkInfo: ElementRef;
  @ViewChild('a_AddInfo', { static: true }) a_AddInfo: ElementRef;
  @ViewChild('a_DivInfo', { static: true }) a_DivInfo: ElementRef;
  @ViewChild('a_InquirInfo', { static: true }) a_InquirInfo: ElementRef;
  @ViewChild('a_PlanInfo', { static: true }) a_PlanInfo: ElementRef;
  @ViewChild('a_GuideInfo', { static: true }) a_GuideInfo: ElementRef;
  @ViewChild('a_HealthPromotion', { static: true }) a_HealthPromotion: ElementRef;
  @ViewChild('a_PromotionInfoSetting', { static: true }) a_PromotionInfoSetting: ElementRef;
  @ViewChild('a_TagInfo', { static: true }) a_TagInfo: ElementRef;
  @ViewChild('a_ECInfoSetting', { static: true }) a_ECInfoSetting: ElementRef;
  @ViewChild('a_IconSetting', { static: true }) a_IconSetting: ElementRef;
  @ViewChild('a_ReservationInfoSetting', { static: true }) a_ReservationInfoSetting: ElementRef;
  @ViewChild('a_ItemInfo', { static: true }) a_ItemInfo: ElementRef;
  @ViewChild('a_Spec1Info', { static: true }) a_Spec1Info: ElementRef;
  @ViewChild('a_Spec2Info', { static: true }) a_Spec2Info: ElementRef;
  @ViewChild('a_PromotionInfo', { static: true }) a_PromotionInfo: ElementRef;
  @ViewChild('a_Nutrient', { static: true }) a_Nutrient: ElementRef;
  @ViewChild('a_MultiNutrient', { static: true }) a_MultiNutrient: ElementRef;
  @ViewChild('a_EnvInfo', { static: true }) a_EnvInfo: ElementRef;

  iconQuestion = faQuestionCircle;

  /** 受渡情報（商品企画メンテナンスインプットVO）*/
  public inputVo: KYMW0900InputModel = null;

  /** model定義 */
  kymw0900Model: KYMW0900Model = new KYMW0900Model();

  /** コンテキストメニュー */
  private contextMenuDtl: Menu;
  private contextMenuGuide: Menu;
  private contextMenuPointPromotion: Menu;
  private contextMenuNvalPromotion: Menu;
  private contextMenuCouponPromotion: Menu;
  private contextMenuStock: Menu;
  private contextMenuPreOrderDetail: Menu;

  /** 編集済みカウンタ */
  public editCount: number = <number>0;

  /**
   * 一時保存用業態区分（デイリー）
   */
  public tmpDutiesFormDailyDiv: string = <string>'';

  /**
 * 権限「1」は閲覧モード「２」フルコントロール
 */
  public funcPermission: string = <string>'2';

  /** 表示モード　編集 */
  public readonly USER_PERMISSION_EDIT: string = <string>'0';
  /** 表示モード　閲覧 */
  public readonly USER_PERMISSION_READONLY: string = <string>'1';

  public mediumTypeList: Array<any> = new Array<any>(); // 媒体別文字情報リスト

  /** 商品マスタでのアイテムコードに紐づく会員生協を格納するための変数 */
  public itemRelatedCoop = [];
  /** 会員タブでのアイテムコードに紐づく会員生協を格納するための変数 */
  public itemRelatedCoop_CoopTab = [];

  public readonly NVAL_COLUMN_WIDTH = {
    orderCode: { min: 120, default: 361 },
  };

  // 1物N価媒体プロモーションの列の横幅HTMLバインド用
  public colWidths = {
    orderCode: this.NVAL_COLUMN_WIDTH['orderCode'].min,
  };

  //////////////////////   各タブのデータグリッドカラムを生成したかどうかのフラグ   Start by KIHARA
  // データグリッドカラムを生成したかどうかのフラグ
  //   会員生協タブ
  private makeFlgCoopInfoTab: boolean = <boolean>false;
  //   詳細タブ
  private makeFlgDetailsInfoTab: boolean = <boolean>false;
  //   マークタブ
  private makeFlgMarkInfoTab: boolean = <boolean>false;
  //   計画数タブ
  private makeFlgPlanInfoTab: boolean = <boolean>false;
  //   次回案内タブ
  private makeFlgGuideInfoTab: boolean = <boolean>false;
  //   仕様書２タブ
  private makeFlgSpec2InfoTab: boolean = <boolean>false;
  //   誌面栄養成分生成済フラグ
  private makeNutrientTab: boolean = <boolean>false;
  //   複数栄養成分生成済フラグ
  private makeMultiNutrientTab: boolean = <boolean>false;
  //   プロモーションタブ
  private makeFlgPromotionInfoTab: boolean = <boolean>false;
  //   環境タブ
  private makeFlgEnvInfoTab: boolean = <boolean>false;
  // contextmenu
  public cmDtgNutrientUnitList: Menu = null;
  public cmDtgNutrientUnitListMulti: Menu = null;

  // アイコンタブ：フィルター対象カラム
  private static readonly FILTER_TARGET_COLUMS = [
    'iconCode',
    'iconName',
    'arrangeDiv',
    'icon0',
    'icon1',
    'icon2',
    'icon3',
    'icon4',
    'icon5',
    'icon6',
    'icon7',
  ];

  /**
   *Creates an instance of KYMW0900Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0900Component
   */
  constructor(
    public dialogServiceSub: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private getPlanGoodsMaintainService: GetPlanGoodsMaintainService,
    private checkNgWordsService: CheckNgWordsService,
    private checkPlanGoodsService: CheckPlanGoodsService,
    private getPublishVoiceHistoryService: GetPublishVoiceHistoryService,
    private getCoopPlanNumService: GetCoopPlanNumService,
    private getNextGuideService: GetNextGuideService,
    private getSupplierService: GetSupplierService,
    private clearPlanGoodsChangeManageService: ClearPlanGoodsChangeManageService,
    private getDefaultConsumeTaxInfoService: GetDefaultConsumeTaxInfoService,
    private getGuideInfoService: GetGuideInfoService,
    private getOrderNumQuotaCodeListService: GetOrderNumQuotaCodeListService,
    private planGoodsLotteryPromotionService: PlanGoodsLotteryPromotionService,
    private numberOfUsersService: NumberOfUsersService,
    private planGoodsPointExchangePromotionService: PlanGoodsPointExchangePromotionService,
    private planGoodsNvalPromotionService: PlanGoodsNvalPromotionService,
    private planGoodsCouponPromotionService: PlanGoodsCouponPromotionService,
    private getPreOrderFlagService: GetPreOrderFlagService,
    private getPreOrderService: GetPreOrderService,
    private getPlanGoodsECService: GetPlanGoodsECService,
    private getImageDataService: GetImageDataService,
    private getStockInfoService: GetStockInfoService,
    private getGroupingInfoService: GetGroupingInfoService,
    private getWebLinkInfoService: GetWebLinkInfoService,
    private getGroupingListService: GetGroupingListService,
    private getGroupingDataService: GetGroupingDataService,
    private getTagListService: GetTagListService,
    private getNotUseCoopService: GetNotUseCoopService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    private elementRef: ElementRef,
    private getGoodsUseCoopService: GetGoodsUseCoopService,
    private getIconDataService: GetIconDataService,
    private getSelectedNvalMediumListService: GetSelectedNvalMediumListService,
    private getCodeListService: GetCodeListService,
    private getGoodsSupplyPriceService: GetGoodsSupplyPriceService,
  ) {
    super(kymw00Model);
  }

  private defaultRowHeight = Number(0);

  public ngAfterViewInit(): void {
    setTimeout(() => {
      // 組合員の声 一括反映
      this.plessEnabled(this.txta_InquiryContentsAll, false);
      // 組合員の声 いばらき
      this.plessEnabled(this.txta_InquiryContents1, false);
      // 組合員の声 とちぎ
      this.plessEnabled(this.txta_InquiryContents2, false);
      // 組合員の声 ぐんま
      this.plessEnabled(this.txta_InquiryContents3, false);
      // 組合員の声 ちば
      this.plessEnabled(this.txta_InquiryContents4, false);
      // 組合員の声 さいたま
      this.plessEnabled(this.txta_InquiryContents5, false);
      // 組合員の声 とうきょう
      this.plessEnabled(this.txta_InquiryContents6, false);
      // 組合員の声 ながの
      this.plessEnabled(this.txta_InquiryContents7, false);
      // 組合員の声 にいがた
      this.plessEnabled(this.txta_InquiryContents8, false);

      // アレルゲン調査対象
      this.plessEnabled(this.cmb_AllergenTergetType, false);
      // 届出表示・許可表示固定メッセージ
      this.plessEnabled(this.txta_LicencedDescriptionDef, false);

      // 栄養成分備考
      this.plessEnabled(this.txta_NutrientComponentComment, false);
    });

    // アイコン：フィルタ 設定
    if (this.fltr_Icon) {
      this.fltr_Icon.defaultFilterType = FilterType.Both;
      this.fltr_Icon.showSortButtons = false;
      this.fltr_Icon.filterColumns = KYMW0900Component.FILTER_TARGET_COLUMS;
      this.fltr_Icon.filterChanged.addHandler(
        (f: FlexGridFilter, e: EventArgs) => {
          const activeFilter = f.filterColumns.find(
            _ => f.getColumnFilter(_).isActive
          );
        }
      );
    }
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0900Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0900';
    this.kymw0900Model.kymw0900Component = this;
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // 会員の価格一覧
    this.dtg_PriceList.columnHeaders.rows[0].height = 48;
    this.dtg_PriceList.rows.defaultSize = 23;

    // 情報一覧
    this.dtg_CoopDetailList.rows.defaultSize = 23;

    // プロモのマーク情報
    this.dtg_MarkInfo.columnHeaders.rows[0].height = 28;
    this.dtg_MarkInfo.rows.defaultSize = 21;

    // 栄養成分　分析単位
    this.dtg_NutrientUnitList.rows.defaultSize = 50;
    // コンテキストメニューの設定
    // 詳細タブ
    this.setDetailInfoContextMenu();
    this.dtg_CoopDetailList.select(0, 0);
    // 案内タブ
    this.setGuideContextMenu();
    this.dtg_GuideList.select(0, 0);
    // プロモ設定タブ
    this.setPromotionContextMenu();
    // EC設定タブ
    this.setECSettingContextMenu();
    // 予約設定タブ
    this.setPreOrderDetailContextMenu();
    // 栄養成分タブ
    this.setNutrientUnitListContextMenu();
    this.dtg_NutrientComponentList.select(0, 0);
    // 複数栄養成分タブ
    this.setNutrientUnitListMultiContextMenu();
    this.dtg_NutrientComponentListMulti.select(0, 0);
    this.dtg_NutrientUnitListMulti.rows.defaultSize = 50;

    // 権限、ロック状態を取得し、編集モード、閲覧モードの判定を行う
    const permission: string = PlessViewUtilsSub.nullToBlank(this.kymw0900Model.permission);
    const lock: string = PlessViewUtilsSub.nullToBlank(this.kymw0900Model.lockInfo);

    if (permission === '0' && lock === '0') {
      // 編集モード
      this.kymw0900Model.permission = '0';
      // 「権限：閲覧のみ」または「ロック状態：編集不可(ロック時)」
    } else if (permission === '1' || lock === '1') {
      this.sharedModel.kymw1001Model.formReadOnlyMode.set(this.popupView, true);
      // 閲覧モードを設定
      this.kymw0900Model.permission = '1';
    }

    // 商品企画メンテナンスインプットVOのＰコードリストで、画面のＰコードリストを設定
    const pCodeList: Array<any> = new Array<any>();
    for (let i = 0; i < this.kymw0900Model.pCodeList.length; i++) {
      const ob = {
        PCode: this.kymw0900Model.pCodeList[i],
        Caption: this.kymw0900Model.pCodeList[i],
      };
      pCodeList.push(ob);
    }
    // Ｐコード一覧と、初期表示Ｐコードを保持
    this.kymw0900Model.pCodeList = pCodeList;
    this.kymw0900Model.pCode = <string>pCodeList[0].PCode;
    this.kymw0900Model.selectedPCode = <string>pCodeList[0].PCode;

    // 編集カウントをクリア
    this.editCount = 0;

    // 編集済みチェック用に、イベントを割り当て
    const changeObj: Array<any> = [
      'chk_MakerNamePublishType',
      'chk_PackMaterialShowFlag',
      'cmb_AllergenTergetType',
      'cmb_ArrivalAreaDivList',
      'cmb_BlindDiv',
      'cmb_CaseSupplyDivList',
      'cmb_ClassCode',
      'cmb_ConsumeTaxDivList',
      'cmb_ContainerForm',
      'cmb_CycleTerm',
      'cmb_EdlpDiv',
      'cmb_GeneRecombinationDivList',
      'cmb_LargeClassCode',
      'cmb_LiquorCode',
      'cmb_LongKeepDivList',
      'cmb_MakerType',
      'cmb_MiddleClassCode',
      'cmb_OrderUnitType',
      'cmb_RoomTempZoneDiv',
      'cmb_SmallClassCodeList',
      'cmb_SpecialOrderTypeList',
      'cmb_StinkGoodsDivList',
      'cmb_StockTypeList',
      'cmb_UnitPriceDiv',
      'rdb_Ecology0',
      'rdb_Ecology1',
      'txta_InquiryContents1',
      'txta_InquiryContents2',
      'txta_InquiryContents3',
      'txta_InquiryContents4',
      'txta_InquiryContents5',
      'txta_InquiryContents6',
      'txta_InquiryContents7',
      'txta_InquiryContents8',
      'txta_InquiryContentsAll',
      'txta_StringValue1',
      'txta_StringValue2',
      'txta_StringValue3',
      'txta_StringValue5',
      'txta_StringValue6',
      'txta_TextInfo1',
      'txta_TextInfo2',
      'txta_TextInfo3',
      'txta_TextInfo4',
      'txta_TextInfo5',
      'txta_TextInfo6',
      'txta_TextInfo7',
      'txta_TextInfo8',
      'txta_TextInfo9',
      'txta_TextInfoA',
      'txta_TextInfoB',
      'txta_TextInfoC',
      'txta_TextInfoD',
      'txta_TextInfoE',
      'txta_TextInfoF',
      'txta_TextInfoG',
      'txta_TextInfoH',
      'txta_TextInfoI',
      'txta_TextInfoJ',
      'txta_TextInfoK',
      'txti_AlcoholType',
      'txti_ArrivalAdminDays',
      'txti_ArrivalGoodsTemp',
      'txti_BundlePrice',
      'txti_CaseSizeHight',
      'txti_CaseSizeLength',
      'txti_CaseSizeWidth',
      'txti_CaseWeight',
      'txti_ConsumeByDate',
      'txti_ConsumeTaxDivRate',
      'txti_ConsumeTerm',
      'txti_ContainerCapacity',
      'txti_DeliveryGoodsNameKana',
      'txti_DeliveryGoodsNameKanji',
      'txti_DeliveryStandardNameKana',
      'txti_DeliveryStandardNameKanji',
      'txti_FcmcFee',
      'txti_FixContainNum',
      'txti_GuideGoodsName',
      'txti_GuideStandardName',
      'txti_InstallmentTimes',
      'txti_JanCode',
      'txti_LeaveConsumeTerm',
      'txti_ListingGoodsName',
      'txti_MakerName',
      'txti_MakerPrice',
      'txti_OcrGoodsName',
      'txti_OrderClientCode',
      'txti_PayeeClientCode',
      'txti_PdPilingUpDays',
      'txti_PeaceSizeHight',
      'txti_PeaceSizeLength',
      'txti_PeaceSizeWidth',
      'txti_PeaceWeight',
      'txti_SetQuantity',
      'txti_UnitPriceCoefficient',
      'txti_UnitPriceUnit',
      'chk_JanCodeDiv',
      'cmb_DutiesFormDailyDiv',
      'cmb_KomaScheduleDiv',
      'txta_LicencedNo',
      'txta_LicencedDescription',
      'chk_UseLotteryPromotion',
      'acc_PointPromotion',
      'acc_CouponPromotion',
      'chk_StockNumShowFlg',
      'txti_BrandName',
      'txti_RelatedUrlTitle',
      'txti_RelatedUrl',
      'chk_CmFlg',
      'chk_RecommendFlg',
      'chk_NonDispFlg',
      'chk_OrderLimitFlg',
      'chk_WebLimitFlg',
      'txti_MinOrderNum',
      'txti_MaxOrderNum',
    ];

    for (let i = 0; i < changeObj.length; i++) {
      document.getElementById(changeObj[i])
        .addEventListener('change', () => this.eventEditHandler());
    }

    // 商品マスタでのアイテムコードに紐づく会員生協を取得
    this.getGoodsUseCoopService.execute(this.kymw0900Model, (data: any) => {
      this.itemRelatedCoop = data.CoopCodeList;
    });

    // 選定済1物N価媒体リスト取得（1物N価プロモーションモーダルで使用）
    const requestVO = {
      OrderCode: this.kymw0900Model.orderCode,
      PCode: this.kymw0900Model.pCode
    }
    this.getSelectedNvalMediumListService.execute(requestVO, (data: GetSelectedNvalMediumListResponse[]) => {
      this.kymw0900Model.nvalMediumTypeList = data;
    });

    // 画面へ表示する情報を取得する要求を発行する。
    this.getPlanGoodsMaintain(this.kymw0900Model.pCode, () => {
      // 案内タブ情報取得処理
      this.getGuideInfo(this.kymw0900Model.pCode);
      // プロモ設定タブ情報取得処理
      this.getPromotionSettingInfo(this.kymw0900Model.pCode, () => {
        // 抽選商品グリッドのヘッダー高さ設定
        this.dtg_UseLotteryPromotionList.columnHeaders.rows[0].height = 50;
        // クーポンプロモーショングリッドのヘッダー高さ設定
        this.dtg_CouponPromotionList.columnHeaders.rows[0].height = 50;
        // 予約設定タブ情報取得処理
        this.getPreOrder();
        // ポイント交換プロモーショングリッドのヘッダー高さ設定
        this.dtg_PointPromotionList.columnHeaders.rows[0].height = 50;
      });
      // タグ情報タブ情報取得処理
      this.getTagInfo();
      // EC設定タブ情報取得処理
      this.getECSettingInfo(() => {
        // 初期表示のみ：アイコンタブのチェックボックスを、会員タブでアイテムコードが選択済みの生協以外非活性とする
        this.kymw0900Model.coopPriceList.map(cp => {
          this.kymw0900Model.iconListDisable[cp.CoopCode] = PlessViewUtilsSub.isEmpty(cp.SelectItemCode)
        })
      });
    });

    // グリッドの初期選択行はなしとする
    this.dtg_CoopMarkList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_CoopMarkList.select(-1, -1);
    });
    this.dtg_PriceList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_PriceList.select(-1, -1);
    });
    this.dtg_CoopDetailList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_CoopDetailList.select(-1, -1);
    });
    this.dtg_ListingItemList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ListingItemList.select(-1, -1);
    });
    this.dtg_MarkList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_MarkList.select(-1, -1);
    });
    this.dtg_SelectedMark.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_SelectedMark.select(-1, -1);
    });
    this.dtg_PlanList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_PlanList.select(-1, -1);
    });
    this.dtg_GuideList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GuideList.select(-1, -1);
    });
    this.dtg_AllergenInfo.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_AllergenInfo.select(-1, -1);
    });
    this.dtg_MarkInfo.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_MarkInfo.select(-1, -1);
    });
    this.dtg_NutrientUnitList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientUnitList.select(-1, -1);
    });
    this.dtg_NutrientComponentList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientComponentList.select(-1, -1);
    });
    this.dtg_NutrientUnitListMulti.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientUnitListMulti.select(-1, -1);
    });
    this.dtg_NutrientComponentListMulti.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientComponentListMulti.select(-1, -1);
    });
    this.dtg_GoodsEcologyList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsEcologyList.select(-1, -1);
    });
    this.dtg_GoodsGWStopList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsGWStopList.select(-1, -1);
    });
    this.dtg_ContainPackingList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ContainPackingList.select(-1, -1);
    });
    this.dtg_CouponPromotionList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_CouponPromotionList.select(-1, -1);
    });
    this.dtg_PreOrderDetailList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_PreOrderDetailList.select(-1, -1);
    });
    this.dtg_StockList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_StockList.select(-1, -1);
    });
    this.dtg_GroupingList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GroupingList.select(-1, -1);
    });
    this.dtg_ECImage.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ECImage.select(-1, -1);
    });
    this.dtg_TagList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_TagList.select(-1, -1);
    });
    this.dtg_IconList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_IconList.select(-1, -1);
    });
    this.dtg_SelectedIconList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_SelectedIconList.select(-1, -1);
    });
    this.dtg_PointPromotionList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_PointPromotionList.select(-1, -1);
    });

    // グリッドの仮想化を行わない([行数, 列数])
    this.dtg_CoopDetailList.virtualizationThreshold = [9, 7];
    this.dtg_PriceList.virtualizationThreshold = [9, 9];

    // グリッドのセルクリックでチェックボックス、ラジオボタンのON/OFF
    this.dtg_CoopMarkList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_CoopMarkList.hitTest(e);
      if (0 <= ht.row && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        switch (ht.col) {
          case 1:
            document.getElementById(`cb_coop_mark_1_${ht.row}`).click();
            break;
          case 2:
            document.getElementById(`cb_coop_mark_3_${ht.row}`).click();
            break;
          case 3:
            document.getElementById(`cb_coop_mark_4_${ht.row}`).click();
            break;
          case 4:
            document.getElementById(`cb_coop_mark_5_${ht.row}`).click();
            break;
        }
      }
    });
    this.dtg_PriceList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_PriceList.hitTest(e);
      if ((0 <= ht.row) && (1 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_price_${ht.row}`).click();
      }
    });
    this.dtg_MarkList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_MarkList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_mark_${ht.row}`).click();
      }
    });
    this.dtg_AllergenInfo.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_AllergenInfo.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_algen_${ht.row}`).click();
      }
    });
    this.dtg_MarkInfo.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_MarkInfo.hitTest(e);
      if ((0 <= ht.row) && (2 <= ht.col) && (ht.col <= 10) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_mark_info_${ht.col - 1}_${ht.row}`).click();
      }
    });
    this.dtg_GoodsEcologyList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_GoodsEcologyList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_goods_eco_${ht.row}`).click();
      }
    });
    this.dtg_GoodsGWStopList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_GoodsGWStopList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_good_gws_${ht.row}`).click();
      }
    });
    this.dtg_ContainPackingList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_ContainPackingList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_contain_pack_${ht.row}`).click();
      }
    });
    this.dtg_ECImage.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_ECImage.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col)) {
        document.getElementById(`rdb_coop_image_${ht.row}`).click();
      }
    });
    this.dtg_IconList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_IconList.hitTest(e);
      if ((0 <= ht.row) && (3 <= ht.col) && (ht.col <= 10) && (!ht.target.className.includes('wj-cell') &&
        !ht.target.className.includes('wj-header') && !ht.target.className.includes('wj-glyph-filter') &&
        !ht.target.className.includes('wj-btn-glyph'))) {
        document.getElementById(`cb_icon_${ht.col - 2}_${ht.row}`).click();
      }
    });
    this.dtg_UseLotteryPromotionList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_UseLotteryPromotionList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`use_lottery_promotion_list_check_${ht.row}`).click();
      }
    });

    this.txti_OrderCode.functionAfterSuccessResponse = () => {
      // 商品企画メンテナスインプットVOの「媒体区分」より、企画進捗管理情報リストAPI実行
      let isExist = false;
      this.txti_OrderCode.catalogProgressTextInputModel.catalogProgressList.forEach(_ => {
        if (_.OrderCode === this.kymw0900Model.orderCode) {
          isExist = true;
          // 取得したリスト.VO.受注コード＝商品企画メンテナスインプットVO.受注コードの場合取得したリスト.VO.工程管理Noを取得する。
          if (Number(_.ProgressWorkNum) < 7) {
            // 1. 取得した工程管理No < 07(企画確定前)の場合
            if (permission === '0' && lock === '0') {
              this.plessEnabledFlag = true;
              setTimeout(() => {
                this.plessEnabledSetting();
              });

              // 複数栄養素成分の表示制御
              this.chk_HasMultiNutrientInfo.disabled = false;

              // マーク・アレルゲンの活性・非活性フラグ
              this.kymw0900Model.markFlag = false;
              this.kymw0900Model.allergenFlag = false;

              // 「権限：閲覧のみ」または「ロック状態：編集不可(ロック時)」
            } else if (permission === '1' || lock === '1') {
              // 閲覧モードを設定
              this.setEnabledByViewPermission();
            }
          } else {
            // 2. 取得した工程管理No >= 07(企画確定以降)の場合
            this.kymw0900Model.isConfirmedForPromo = true;
            // ①【権限：フルコントロール】且つ【編集モード：閲覧】の場合
            if (permission === '0' && lock === '1') {
              this.plessEnabledFlag = false;
              this.LockUtilForPlanGoods('REGIST',
                this.kymw0900Model.orderCode, this.kymw0900Model.mediumType, this.kymw0900Model.pCode,
                (successParam: any) => {
                  setTimeout(() => {
                    // ロック成功のフラグを設けてtrueとする。(このフラグは閉じるボタン押下時に使用する)	
                    this.kymw0900Model.lockSucceeded = true;
                    // 「EC情報タブ」の入力項目(ボタンを含む)を使用可能（活性化）とする。
                    this.chk_CmFlg.nativeElement.disabled = false;
                    this.chk_OrderLimitFlg.nativeElement.disabled = false;
                    this.chk_WebLimitFlg.nativeElement.disabled = false;
                    this.chk_RecommendFlg.nativeElement.disabled = false;
                    this.chk_NonDispFlg.nativeElement.disabled = false;
                    this.chk_StockNumShowFlg.checkbox.nativeElement.disabled = false;
                    this.txti_MinOrderNum.nativeElement.disabled = false;
                    this.txti_MaxOrderNum.nativeElement.disabled = false;
                    this.plessEnabled(this.btn_ECSearch.nativeElement, true);
                    this.plessEnabled(this.btn_Instructions.nativeElement, true);
                    this.plessEnabled(this.groupingCode, true);
                    this.plessEnabled(this.txti_BrandName, true);
                    this.plessEnabled(this.txti_CoopGoodsUrlTitle, true);
                    this.plessEnabled(this.txti_CoopGoodsUrl, true);
                    this.plessEnabled(this.txti_RelatedUrlTitle, true);
                    this.plessEnabled(this.txti_RelatedUrl, true);
                    this.cmb_OrderGoodsDiv.comboBox.nativeElement.disabled = false;
                    // 「アイコンタブ」の入力項目(ボタンを含む)を使用可能（活性化）とする。
                    this.plessEnabled(this.chk_AllCoopValueIcon, true);
                    // 変更確認ボタンを使用可能（活性化）とする。	
                    this.btn_ChangeConfirmation.nativeElement.disabled = false;
                    // Ｐコード、アイテムコードを使用可能（活性化）とする。
                    this.cmb_PCode.nativeElement.disabled = false;
                    this.plessEnabled(this.cmb_ItemCode, true);

                    this.kymw0900Model.isDisabledForGrid = true;
                    this.kymw0900Model.isConfirmed = true;

                    // 複数栄養素成分の表示制御
                    this.chk_HasMultiNutrientInfo.disabled = true;
                  });
                }, this.componentName,
                (faultParam: any) => {
                  // ロック失敗時(他のユーザが編集中の場合)	
                  // Ｐコード、アイテムコードを使用可能（活性化）とする。
                  this.setEnabledByViewPermission();
                }, this.componentName,
                false);
            } else {
              // ② ①のケース以外の場合、1.②と同様の画面制御とする。
              // 閲覧モードを設定
              this.setEnabledByViewPermission();
            }
          }
        }
      });

      if (!isExist) {
        // 工程管理No不明時に閲覧モードとならない問題の対応
        if (permission === '1' || lock === '1') {
          this.setEnabledByViewPermission();
        }
        // 工程管理No不明時にプロモ設定タブのラジオボタン初期表示の活性状態が不整合となる問題の対応
        this.kymw0900Model.isConfirmedForPromo = true;
      }
    };
  }

  /**
   *
   *
   * @param {*}this.inputVo
   * @memberof KYMW0900Component
   */
  public setInterfaceParam(inputVO: any) {

    this.inputVo = <KYMW0900InputModel>inputVO;
    // 受渡情報より権限を取得
    this.kymw0900Model.permission = this.inputVo.UserPermission;
    // 受渡情報より受注コードを取得
    this.kymw0900Model.orderCode = this.inputVo.orderCode;
    // 受渡情報より媒体区分を取得
    this.kymw0900Model.mediumType = this.inputVo.MediumType;
    // 受渡情報よりＰコードリストを取得
    this.kymw0900Model.pCodeList = this.inputVo.pCodeList;
    // 受渡情報よりロック情報を取得?
    this.kymw0900Model.lockInfo = this.inputVo.lockInfo;
    // 受渡情報より束ね企画回の終了受注コード
    this.kymw0900Model.bundleCatalogOrderCode = this.inputVo.bundleCatalogOrderCode;
  }


  /**
   * 詳細タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  private setDetailInfoContextMenu(): void {
    this.contextMenuDtl = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '全生協にコピー', cmd: 'coopDtlCopyAllCoop' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuDtl.selectedValue) {
            case 'coopDtlCopyAllCoop':
              this.eventICoopDtlCopyAllCoop_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CoopDetailList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuDtl !== undefined) {
        this.eventCoopDtlContextMenu_CLICKHandler(this.contextMenuDtl);
        this.contextMenuDtl.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('全生協にコピー', 'none');
  }

  /**
   * 案内タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  private setGuideContextMenu(): void {
    this.contextMenuGuide = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '全生協にコピー', cmd: 'coopGuideCopyAllCoop' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuGuide.selectedValue) {
            case 'coopGuideCopyAllCoop':
              this.eventIGuideCopyAllCoop_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_GuideList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuGuide !== undefined) {
        this.eventGuideContextMenu_CLICKHandler(this.contextMenuGuide);
        this.contextMenuGuide.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('全生協にコピー', 'none');
  }

  /**
   * プロモ設定タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  private setPromotionContextMenu(): void {
    // ポイント交換プロモーション
    this.contextMenuPointPromotion = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '詳細', caption: '詳細', cmd: 'detailPointPromotion' },
          { header: '削除', caption: '削除', cmd: 'deletePointPromotion' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuPointPromotion.selectedValue) {
            case 'detailPointPromotion':
              this.detailPointPromotionList_CLICKHandler();
              break;
            case 'deletePointPromotion':
              this.deletePointPromotionList_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_PointPromotionList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuPointPromotion !== undefined) {
        this.eventPointPromotionContextMenu_CLICKHandler(this.contextMenuPointPromotion);
        this.contextMenuPointPromotion.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuPointPromotion.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuPointPromotion.itemsSource[1], 'none');

    // 1物N価プロモーション
    this.contextMenuNvalPromotion = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '詳細', caption: '詳細', cmd: 'detailNvalPromotionList' },
          { header: '削除', caption: '削除', cmd: 'deleteNvalPromotionList' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuNvalPromotion.selectedValue) {
            case 'detailNvalPromotionList':
              this.detailNvalPromotionList_CLICKHandler();
              break;
            case 'deleteNvalPromotionList':
              this.deleteNvalPromotionList_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NvalPromotionList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuNvalPromotion !== undefined) {
        this.eventNvalPromotionContextMenu_CLICKHandler(this.contextMenuNvalPromotion);
        this.contextMenuNvalPromotion.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuNvalPromotion.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuNvalPromotion.itemsSource[1], 'none');

    // クーポン商品プロモーション
    this.contextMenuCouponPromotion = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '詳細', caption: '詳細', cmd: 'detailCouponPromotionList' },
          { header: '削除', caption: '削除', cmd: 'deleteCouponPromotionList' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuCouponPromotion.selectedValue) {
            case 'detailCouponPromotionList':
              this.detailCouponPromotionList_CLICKHandler();
              break;
            case 'deleteCouponPromotionList':
              this.deleteCouponPromotionList_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CouponPromotionList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuCouponPromotion !== undefined) {
        this.eventCouopnPromotionContextMenu_CLICKHandler(this.contextMenuCouponPromotion);
        this.contextMenuCouponPromotion.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuCouponPromotion.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuCouponPromotion.itemsSource[1], 'none');
  }

  /**
   * EC設定タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  private setECSettingContextMenu(): void {
    this.contextMenuStock = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '全生協にコピー', cmd: 'copyStock' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuStock.selectedValue) {
            case 'copyStock':
              this.copyStock_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_StockList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuStock !== undefined) {
        this.eventECSettingStockContextMenu_CLICKHandler(this.contextMenuStock);
        this.contextMenuStock.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('全生協にコピー', 'none');
  }

  /**
   * 予約設定タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  private setPreOrderDetailContextMenu(): void {
    this.contextMenuPreOrderDetail = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '詳細', caption: '詳細', cmd: 'detailPreOrderDetailList' },
          { header: '削除', caption: '削除', cmd: 'deletePreOrderDetailList' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuPreOrderDetail.selectedValue) {
            case 'detailPreOrderDetailList':
              this.detailPreOrderDetailList_CLICKHandler();
              break;
            case 'deletePreOrderDetailList':
              this.deletePreOrderDetailList_CLICKHandler();
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_PreOrderDetailList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuPreOrderDetail !== undefined) {
        this.eventPreOrderDetailContextMenu_CLICKHandler(this.contextMenuPreOrderDetail);
        this.contextMenuPreOrderDetail.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuPreOrderDetail.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenuPreOrderDetail.itemsSource[1], 'none');
  }

  /**
   * プロモ設定タブ ポイント交換：コンテキストメニューイベント
   */
  public eventPointPromotionContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_PointPromotionList.selection.row < 0 && this.dtg_PointPromotionList.selection.col < 0) {
        // セルが未選択の場合は非活性
        enableFlag = false;
      } else {
        // セルが選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は詳細を活性、削除を非活性
          if (item.cmd === 'detailPointPromotion') {
            enableFlag = true;
          } else {
            enableFlag = false;
          }
        } else {
          if (this.dtg_PointPromotionList.itemsSource.length === 1 && item.cmd === 'deletePointPromotion') {
            // データが一つしかない場合、削除を非活性
            enableFlag = false;
          } else {
            enableFlag = true;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * プロモ設定タブ 1物N価媒体：コンテキストメニューイベント
   */
  public eventNvalPromotionContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_NvalPromotionList.selection.row < 0 && this.dtg_NvalPromotionList.selection.col < 0) {
        // セルが未選択の場合は非活性
        enableFlag = false;
      } else {
        // セルが選択されている場合
        // 閲覧時
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は詳細を活性、削除を非活性
          if (item.cmd === 'detailNvalPromotionList') {
            enableFlag = true;
          } else {
            enableFlag = false;
          }
        } else {
          // 「削除」の場合
          if (item.cmd === 'deleteNvalPromotionList') {
            // 画面に表示しているデータを受注コード・媒体区分でグルーピングしたときに
            // データが1件しか存在しない場合、非活性
            let onlyFlg = true;
            // 選択したデータの対象の受注コードに値引情報があるのかチェック
            const selectedOrderCode = this.dtg_NvalPromotionList.selectedItems[0].dataList.find(_ => _.orderCode === this.kymw0900Model.orderCode);
            if (selectedOrderCode && !PlessViewUtilsSub.isEmpty(selectedOrderCode?.displayDiscount)) {
              this.kymw0900Model.nvalPromotionListDisplay.map(_ => {
                if (_.mediumType === this.dtg_NvalPromotionList.selectedItems[0].mediumType &&
                  _.nvalDetailId !== this.dtg_NvalPromotionList.selectedItems[0].nvalDetailId) {
                  // 同一のデータ以外（1物N価詳細情報IDが異なる）で媒体が一致するデータ
                  _.dataList.map(data => {
                    if (data.orderCode === this.kymw0900Model.orderCode) {
                      // 対象の受注コードに値引情報があるか確認
                      if (!PlessViewUtilsSub.isEmpty(data.displayDiscount)) {
                        // 媒体が同じデータで対象の受注コードに値引情報がある場合はfalse
                        onlyFlg = false;
                      }
                    }
                  })
                }
              })
              // 検索した結果が1件以下の場合、「削除」は非活性
              if (onlyFlg) {
                // データが一つしかない場合、「削除」を非活性
                enableFlag = false
              } else {
                enableFlag = true;
              }
            } else {
              // 選択したデータに表示されている値引情報がない場合（＝データがない場合）、「削除」を非活性
              enableFlag = false;
            }
          } else {
            enableFlag = true;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * プロモ設定タブ クーポン商品：コンテキストメニューイベント
   */
  public eventCouopnPromotionContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_CouponPromotionList.selection.row < 0) {
        // 行が未選択の場合は非活性
        enableFlag = false;
      } else {
        // 行が選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は詳細を活性、削除を非活性
          if (item.cmd === 'detailCouponPromotionList') {
            enableFlag = true;
          } else {
            enableFlag = false;
          }
        } else {
          // フルコントロール時
          if (this.dtg_CouponPromotionList.itemsSource.length === 1 && item.cmd === 'deleteCouponPromotionList') {
            // 表示されているデータが一件の場合「削除」を非活性
            enableFlag = false;
          } else {
            enableFlag = true;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * EC設定タブ コンテキストメニューイベント
   */
  public eventECSettingStockContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_StockList.selection.row < 0) {
        // 行が未選択の場合は非活性
        enableFlag = false;
      } else {
        // 行が選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は非活性
          enableFlag = false;
        } else {
          if (this.kymw0900Model.isEnabledCoop(this.dtg_StockList.selectedItems[0].coopCode)) {
            // 有効な生協の場合に活性
            enableFlag = true;
          } else {
            enableFlag = false;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * 予約設定タブ コンテキストメニューイベント
   */
  public eventPreOrderDetailContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_PreOrderDetailList.selection.row < 0) {
        // 行が未選択の場合は非活性
        enableFlag = false;
      } else {
        // 行が選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は詳細を活性、削除を非活性
          if (item.cmd === 'detailPreOrderDetailList') {
            enableFlag = true;
          } else {
            enableFlag = false;
          }
        } else {
          // フルコントロール時
          if (this.dtg_PreOrderDetailList.itemsSource.length === 1 && item.cmd === 'deletePreOrderDetailList') {
            // データが一つしかない場合、削除を非活性
            enableFlag = false;
          } else {
            enableFlag = true;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * 栄養成分タブコンテキストメニュー設定
   *
   * @private
   * @memberof KYMW0900Component
   */
  public setNutrientUnitListContextMenu(): void {
    this.cmDtgNutrientUnitList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '栄養成分新規登録', cmd: 'nutrientUnitAdd' },
          { caption: '栄養成分メンテナンス', cmd: 'nutrientUnitUpdate' },
          { caption: '栄養成分削除', cmd: 'nutrientUnitRemove' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgNutrientUnitList.selectedValue) {
            case 'nutrientUnitAdd':
              this.eventAddNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList);
              break;
            case 'nutrientUnitUpdate':
              this.eventUpdateNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList);
              break;
            case 'nutrientUnitRemove':
              this.eventRemoveNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList, false);
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NutrientUnitList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDtgNutrientUnitList !== undefined) {
        this.eventContextMenu_Handler(this.cmDtgNutrientUnitList);
        this.cmDtgNutrientUnitList.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分新規登録', 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分メンテナンス', 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分削除', 'none');
  }

  public setNutrientUnitListMultiContextMenu(): void {
    this.cmDtgNutrientUnitListMulti = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '栄養成分新規登録', cmd: 'nutrientUnitAdd' },
          { caption: '栄養成分メンテナンス', cmd: 'nutrientUnitUpdate' },
          { caption: '栄養成分削除', cmd: 'nutrientUnitRemove' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgNutrientUnitListMulti.selectedValue) {
            case 'nutrientUnitAdd':
              this.eventAddNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti);
              break;
            case 'nutrientUnitUpdate':
              this.eventUpdateNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti);
              break;
            case 'nutrientUnitRemove':
              this.eventRemoveNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti, true);
              break;
          }
        }
      }
    );
    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NutrientUnitListMulti.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDtgNutrientUnitListMulti !== undefined) {
        this.eventContextMenuMulti_Handler(this.cmDtgNutrientUnitListMulti);
        this.cmDtgNutrientUnitListMulti.show(e);
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分新規登録', 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分メンテナンス', 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode('栄養成分削除', 'none');
  }

  /**
  * コンテキストメニュー項目活性・非活性制御(ポイント)
  *
  * @private
  * @returns
  * @memberof KYMW0900Component
  */
  public eventContextMenu_Handler(contextMenu: Menu): any {
    contextMenu.itemsSource.forEach(item => {
      let enableFlag: boolean = <boolean>false;
      if (this.kymw0900Model.permission === '1') {
        // 権限が無い場合、非活性
        enableFlag = false;
      } else if (0 === this.kymw0900Model.nutrientUnitList.length) {
        // 権限があり、分析単位が0の場合、新規登録を表示、それ以外を非表示
        if (item.caption === '栄養成分新規登録') {
          enableFlag = true;
        } else {
          enableFlag = false;
        }
      } else if (0 < this.kymw0900Model.nutrientUnitList.length
        && this.dtg_NutrientUnitList.selection.row >= 0) {
        // 権限があり、分析単位が0の場合、新規登録を表示、それ以外を非表示
        if (item.caption === '栄養成分新規登録') {
          enableFlag = false;
        } else {
          enableFlag = true;
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
    * コンテキストメニュー項目活性・非活性制御(ポイント)
    *
    * @private
    * @returns
    * @memberof KYMW0900Component
    */
  public eventContextMenuMulti_Handler(contextMenu: Menu): any {
    contextMenu.itemsSource.forEach(item => {
      let enableFlag: boolean = <boolean>false;
      if (this.kymw0900Model.permission === '1') {
        // 権限が無い場合、非活性
        enableFlag = false;
      } else if (0 === this.kymw0900Model.nutrientUnitListMulti.length) {
        // 権限があり、分析単位が0の場合、新規登録を表示、それ以外を非表示
        if (item.caption === '栄養成分新規登録') {
          enableFlag = true;
        } else {
          enableFlag = false;
        }
      } else if (0 < this.kymw0900Model.nutrientUnitListMulti.length
        && this.dtg_NutrientUnitListMulti.selection.row >= 0) {
        // 権限があり、分析単位が1件以上の場合、すべて表示する
        enableFlag = true;
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * タブ移動制御
   *
   * @param {*} event
   * @memberof KYMW0900Component
   */
  public nextFocus(event: any): void {

    // keyCode:9 = tabキー
    if (event.keyCode === 9 && !event.shiftKey) {
      // 後続のデフォルトイベントをキャンセル
      event.preventDefault();
      // Ｐコード領域タブ
      if (event.target.id === 'txti_ContainerCapacity') {
        // 基本→会員
        this.tab_pCode.selectedIndex = 1;
      } else if (event.target.id === 'dtg_PriceList') {
        // 会員→詳細
      } else if (event.target.id === 'dtg_ListingItemList') {
        // 詳細→マーク
        this.tab_pCode.selectedIndex = 3;
      } else if (event.target.id === 'dtg_SelectedMark') {
        // マーク→付加
        this.tab_pCode.selectedIndex = 4;
      } else if (event.target.id === 'txta_TextInfoA_sub') {
        // 付加→発注
        this.tab_pCode.selectedIndex = 5;
      } else if (event.target.id === 'cmb_DutiesFormDailyDiv_sub') {
        // 発注→組合員
        this.tab_pCode.selectedIndex = 6;
      } else if (event.target.id === 'dtg_ListingList') {
        if (!this.dtg_PlanList.isReadOnly) {
          // データ一覧 組合員→案内
          this.tab_pCode.selectedIndex = 8;
        }
      } else if (event.target.id === 'dtg_PlanList') {
        // 計画数→案内
        this.tab_pCode.selectedIndex = 8;
      } else if (event.target.id === 'dtg_GuideList') {
        // 案内→保険機能
        this.tab_pCode.selectedIndex = 9;
        // アイテムコード領域タブ
      } else if (event.target.id === 'txti_SetQuantity') {
        // アイテム→仕様書１
        this.tab_item.selectedIndex = 1;
      } else if (event.target.id === 'txta_StringValue6_sub') {
        // 仕様書１→仕様書２
        this.tab_item.selectedIndex = 2;
      } else if (event.target.id === 'dtg_AllergenInfo') {
        // 仕様書2→プロモ
        this.tab_item.selectedIndex = 3;
      } else if (event.target.id === 'dtg_MarkInfo') {
        // プロモ→栄養成分
        this.tab_item.selectedIndex = 4;
      } else if (event.target.id === 'chk_HasMultiNutrientInfo_sub') {
        if (!this.chk_HasMultiNutrientInfo.disabled
          && this.kymw0900Model.hasMultiNutrientInfo) {
          // タブ活性化
          this.cnv_NutrientTab.isDisabled = false;
          // 栄養成分→複数栄養成分
          this.tab_item.selectedIndex = 5;
        } else {
          // 栄養成分→環境
          this.tab_item.selectedIndex = 6;
        }
      } else if (event.target.id === 'dtg_NutrientComponentListMulti') {
        this.tab_item.selectedIndex = 6;
      }
    }
  }

  /**
   * 編集カウントをクリアする。
   *
   * @memberof KYMW0900Component
   */
  public clearEditCount(): void {
    this.editCount = 0;
  }

  /**
   * 計画数タブ「計画数一覧」合計更新(クリックイベント)
   *
   * @memberof KYMW0900Component
   */
  public updatePlanList(data: any): void {

    // 現在表示中の計画数一覧（データグリッド）を取得
    const viewPlanList = this.dtg_PlanList.collectionView.items;
    let changeFlag: boolean = <boolean>false;

    // 値が変更されたかチェックする
    for (let i = 1; i < viewPlanList.length; i++) {
      if (viewPlanList[i].Plannum !== this.kymw0900Model.oldPlannumList[i - 1]) {
        changeFlag = true;
        break;
      } else if (viewPlanList[i].LimitnumPerson !== this.kymw0900Model.oldLimitnumPersonList[i - 1]) {
        changeFlag = true;
        break;
      } else if (viewPlanList[i].LimitnumTotal !== this.kymw0900Model.oldLimitnumTotalList[i - 1]) {
        changeFlag = true;
        break;
      }
    }

    // 比較用のリストに値を保持する
    this.kymw0900Model.setOldPlanList();

    // 入力値に変更がない場合は処理しない
    if (!changeFlag) {
      return;
    }

    // 編集カウントをインクリメント
    this.kymw0900Model.addEditCount();

    // 計画数（合計）
    let planNumTotal: number = <number>0;
    // 限定数量総数（合計）
    let limitnumTotal: number = <number>0;
    // 限定数量個人（合計）
    let limitnumPerson: number = <number>0;

    // 各会員生協の計画数を再設定
    for (let j = 1; j < viewPlanList.length; j++) {
      // 合計を計算
      planNumTotal += Number(viewPlanList[j].Plannum);
      limitnumTotal += Number(viewPlanList[j].LimitnumTotal);
      limitnumPerson += Number(viewPlanList[j].LimitnumPerson);
    }

    // 0行目に合計計画数を設定する
    const coopXml = {
      CoopCode: '',
      CoopName: '合計',
      Plannum: planNumTotal,
      LimitnumTotal: limitnumTotal,
      LimitnumPerson: '',
      DeliveryLeadTimeType: '',
      DelivCatalogID: '',
      Enabled: '1',
    };
    this.kymw0900Model.planList.push(coopXml, 0);

    if (planNumTotal > 9999999) {
      this.dialogServiceSub.openAlertGetMessage('E0207', ['計画数合計', '8桁以上', 'このままでは登録']);
    }
  }
  /**
   * 選択マーク一覧表示更新
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public updateGoodsMarkCheck(event: Event, gridMark: FlexGrid, gridSelectedMark: FlexGrid): void {

    // collectinViewでgridに表示している情報を取得
    const tempSelectedMarkList = new Array<any>();
    const tempItems = this.kymw0900Model.markList;
    // マーク情報一覧、選択マーク一覧（データグリッド）の設定
    for (let i = Number(0); i < tempItems.length; i++) {
      // 設定チェックされているマーク情報を選択マーク一覧に設定
      if (tempItems[i].SelectValue) {
        // チェックされているマーク情報を選択マーク一覧に設定
        tempSelectedMarkList.push(tempItems[i]);
      }
    }
    this.kymw0900Model.createSelectedMarkList(tempSelectedMarkList);
    gridSelectedMark.refreshCells(true);
  }

  /**
   * 選択アイコン一覧表示更新
   * @param {Event} _event イベント情報（インターフェイス維持のためのみに定義）
   * @param {FlexGrid} _gridIcon アイコン一覧グリッド（インターフェイス維持のためのみに定義）
   * @param {FlexGrid} gridSelectedIcon 選択アイコン一覧グリッド
   * @memberof KYMW0900Component
   */
  public updateIconCheck(_event: Event, _gridIcon: FlexGrid, gridSelectedIcon: FlexGrid): void {
    this.kymw0900Model.selectedIconList = this.createSelectedIconList();
    gridSelectedIcon.refreshCells(true);
  }

  /**
   * アイコンタブ遷移時の選択済みアイコンリスト初期化
   *
   * @memberof KYMW0900Component
   */
  public initializeSelectedIconList(): void {
    this.kymw0900Model.selectedIconList = this.createSelectedIconList();
    // グリッドが存在する場合はリフレッシュ
    if (this.dtg_SelectedIconList) {
      this.dtg_SelectedIconList.refreshCells(true);
    }
  }

  /**
   * アイコン一覧から、チェックされている行のみを抽出して返却
   */
  private createSelectedIconList(): Array<any> {
    const tempSelectedIconList = new Array<any>();
    const tempItems = this.kymw0900Model.iconList;

    for (let i = Number(0); i < tempItems.length; i++) {
      const item = tempItems[i];
      // いずれかの生協でチェックされている場合に追加
      if (item.icon0 || item.icon1 || item.icon2 || item.icon3 ||
        item.icon4 || item.icon5 || item.icon6 || item.icon7) {
        tempSelectedIconList.push(item);
      }
    }
    return tempSelectedIconList;
  }

  /**
* 商品説明テキスト入力完了イベントリスナ
*
* @param {Event} e
* @memberof KYMW0900Component
*/
  public eventTextInfo1_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo1.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='商品説明' %2=NGワード）
      const vo = {
        itemName: '商品説明',
        string: this.txta_TextInfo1.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * キャッチコピーテキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfo2_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo2.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='キャッチコピー' %2=NGワード）
      const vo = {
        itemName: 'キャッチコピー',
        string: this.txta_TextInfo2.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * おすすめコメントテキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfo3_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo3.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='おすすめコメント' %2=NGワード）
      const vo = {
        itemName: 'おすすめコメント',
        string: this.txta_TextInfo3.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
 * 便利情報(囲み)テキスト入力完了イベントリスナ
 *
 * @param {Event} e
 * @memberof KYMW0900Component
 */
  public eventTextInfo4_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo4.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='便利情報(囲み)' %2=NGワード）
      const vo = {
        itemName: '便利情報(囲み)',
        string: this.txta_TextInfo4.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
 * 便利情報(商品構成内容)テキスト入力完了イベントリスナ
 *
 * @param {Event} e
 * @memberof KYMW0900Component
 */
  public eventTextInfo5_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo5.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='便利情報(商品構成内容)' %2=NGワード）
      const vo = {
        itemName: '便利情報(商品構成内容)',
        string: this.txta_TextInfo5.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
 * 便利情報(その他)テキスト入力完了イベントリスナ
 *
 * @param {Event} e
 * @memberof KYMW0900Component
 */
  public eventTextInfo6_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo6.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='便利情報(その他)' %2=NGワード）
      const vo = {
        itemName: '便利情報(その他)',
        string: this.txta_TextInfo6.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
 * 便利情報(ｅフレンズ)テキスト入力完了イベントリスナ
 *
 * @param {Event} e
 * @memberof KYMW0900Component
 */
  public eventTextInfo7_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo7.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='便利情報(ｅフレンズ)' %2=NGワード）
      const vo = {
        itemName: '便利情報(ｅフレンズ)',
        string: this.txta_TextInfo7.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 便利情報(サイズ他)テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfo8_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo8.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='便利情報(サイズ他)' %2=NGワード）
      const vo = {
        itemName: '便利情報(サイズ他)',
        string: this.txta_TextInfo8.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 取扱注意テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfo9_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfo9.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='取扱注意' %2=NGワード）
      const vo = {
        itemName: '取扱注意',
        string: this.txta_TextInfo9.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * EC用商品説明テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoB_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoB.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='EC用商品説明' %2=NGワード）
      const vo = {
        itemName: 'EC用商品説明',
        string: this.txta_TextInfoB.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 便利情報(月齢情報)テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoC_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoC.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='月齢情報' %2=NGワード）
      const vo = {
        itemName: '月齢情報',
        string: this.txta_TextInfoC.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 人気商品情報テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoD_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoD.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='人気商品情報' %2=NGワード）
      const vo = {
        itemName: '人気商品情報',
        string: this.txta_TextInfoD.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 健康管理情報テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoE_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoE.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='健康管理情報' %2=NGワード）
      const vo = {
        itemName: '健康管理情報',
        string: this.txta_TextInfoE.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 成分情報テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoF_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoF.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='成分情報' %2=NGワード）
      const vo = {
        itemName: '成分情報',
        string: this.txta_TextInfoF.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 吸水量テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoG_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoG.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='吸水量' %2=NGワード）
      const vo = {
        itemName: '吸水量',
        string: this.txta_TextInfoG.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 調理時間の目安テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoH_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoH.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='調理時間の目安' %2=NGワード）
      const vo = {
        itemName: '調理時間の目安',
        string: this.txta_TextInfoH.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 〇人前情報テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoI_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoI.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='〇人前情報' %2=NGワード）
      const vo = {
        itemName: '〇人前情報',
        string: this.txta_TextInfoI.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 材料テキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoJ_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoJ.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='材料' %2=NGワード）
      const vo = {
        itemName: '材料',
        string: this.txta_TextInfoJ.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * ご家庭で用意いただくものテキスト入力完了イベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW0900Component
   */
  public eventTextInfoK_FOCUS_OUTHandler(e: Event): void {
    if (!PlessViewUtilsSub.isEmpty(this.txta_TextInfoK.text)) {
      // ・全角文字へ変換し、入力文字数のチェックを行う。
      // ・NGワードの、入力文字チェックを行う。（ID=Q0129 %1='ご家庭で用意いただくもの' %2=NGワード）
      const vo = {
        itemName: 'ご家庭で用意いただくもの',
        string: this.txta_TextInfoK.text,
      };
      this.checkNgWordsService.execute(this.kymw0900Model, vo);
    }
  }


  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW0900Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        if (!param.enabled) {
          return false;
        } else {
          return true;
        }
      }
    };
  }

  /**
   * 詳細タブ・情報一覧 コンテキストメニューイベント
   */
  public eventCoopDtlContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_CoopDetailList.selection.row < 0) {
        // 行が未選択の場合は非活性
        enableFlag = false;
      } else {
        // 行が選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は非活性
          enableFlag = false;
        } else {
          if (this.dtg_CoopDetailList.selectedItems[0].Enabled === '1') {
            // 取扱生協の場合は活性
            enableFlag = true;
          } else {
            // 取扱生協でない場合は非活性
            enableFlag = false;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * コンテキスト「全生協にコピー」メニュー選択イベント
   *
   * @param event:イベント
   */
  public eventICoopDtlCopyAllCoop_CLICKHandler(): void {
    const selectedRow = this.dtg_CoopDetailList.selection.row;
    const coopDetailListData = this.kymw0900Model.coopDetailList[selectedRow];
    const coopDetailList = new Array<any>();
    if (coopDetailListData.OrderNum6Digits !== null) {
      for (let i = Number(0); i < this.kymw0900Model.coopDetailList.length; i++) {
        if (this.kymw0900Model.coopDetailList[i].Enabled === '1'
          && this.kymw0900Model.coopDetailList[i].OrderNum6Digits !== null) {
          // 注文コード割当に入れる値を設定
          let tmpOrderNumWQuotaCode = '';
          let tmpOrderNumWQuotaCodeName = '';
          // isDisabledCoopItemの判定式（DealCoopDiv）とgetEnabledCoopで注文コード割当が活性かどうかを判定
          if (!this.kymw0900Model.coopPriceList[selectedRow].DealCoopDiv || !this.getEnabledCoop(this.kymw0900Model.coopDetailList[i].CoopCode)) {
            // 注文コード割当が非活性の時は空を設定
            tmpOrderNumWQuotaCode = '';
            tmpOrderNumWQuotaCodeName = '';
          } else {
            // 活性の場合は選択した注文コードを格納
            tmpOrderNumWQuotaCode = coopDetailListData.OrderNumQuotaCode;
            tmpOrderNumWQuotaCodeName = coopDetailListData.OrderNumQuotaCodeName;
          }

          const data = {
            CoopCode: this.kymw0900Model.coopDetailList[i].CoopCode,
            CoopName: this.kymw0900Model.coopDetailList[i].CoopName,
            BrandType: coopDetailListData.BrandType,
            SetDiv: coopDetailListData.SetDiv,
            AssortTempDiv: coopDetailListData.AssortTempDiv,
            OrderNumQuotaCode: tmpOrderNumWQuotaCode,
            OrderNumQuotaCodeName: tmpOrderNumWQuotaCodeName,
            ProducingAreaComment1: this.kymw0900Model.coopDetailList[i].ProducingAreaComment1,
            ProducingAreaComment2: this.kymw0900Model.coopDetailList[i].ProducingAreaComment2,
            DetailUseRegularFlg: this.kymw0900Model.coopDetailList[i].DetailUseRegularFlg,
            ClassCode: this.kymw0900Model.coopDetailList[i].ClassCode,
            Enabled: this.kymw0900Model.coopDetailList[i].Enabled,
          };
          this.editCount++;
          coopDetailList.push(data);
        } else {
          coopDetailList.push(this.kymw0900Model.coopDetailList[i]);
        }
      }
      this.kymw0900Model.coopDetailList = coopDetailList;
      this.dtg_CoopDetailList.editableCollectionView.refresh();

      // 注文コード割当コンボボックス変更時処理を呼び出す
      setTimeout(() => {
        const orderNumQuotaCodes = this.elementRef.nativeElement.querySelectorAll('#cmb_OrderNumQuotaCode');
        for (let i = Number(0); i < orderNumQuotaCodes.length; i++) {
          if (this.kymw0900Model.coopDetailList[i].OrderNum6Digits !== null) {
            orderNumQuotaCodes[i].dispatchEvent(new CustomEvent('change', { detail: { index: i } }));
          }
        }
      }, 100);
    }
  }

  /**
   * 案内タブ・案内一覧 コンテキストメニューイベント
   */
  public eventGuideContextMenu_CLICKHandler(contextMenu: Menu): void {
    let enableFlag = Boolean(false);
    contextMenu.itemsSource.forEach(item => {
      if (this.dtg_GuideList.selection.row < 0) {
        // 行が未選択の場合は非活性
        enableFlag = false;
      } else {
        // 行が選択されている場合
        if (this.kymw0900Model.permission === '1') {
          // 閲覧時は非活性
          enableFlag = false;
        } else {
          if (this.dtg_GuideList.selectedItems[0].Enabled === '1') {
            // 取扱生協の場合は活性
            enableFlag = true;
          } else {
            // 取扱生協でない場合は非活性
            enableFlag = false;
          }
        }
      }
      item.enabled = this.setContextMenuEnabled(item, enableFlag);
    });
  }

  /**
   * コンテキスト「全生協にコピー」メニュー選択イベント
   *
   * @param event:イベント
   */
  public eventIGuideCopyAllCoop_CLICKHandler(): void {
    const selectedRow = this.dtg_GuideList.selection.row;
    const guideListData = this.kymw0900Model.guideList[selectedRow];
    const guideList = new Array<any>();
    if (guideListData.OrderNum6Digits !== null) {
      for (let i = Number(0); i < this.kymw0900Model.guideList.length; i++) {
        if (this.kymw0900Model.guideList[i].OrderNum6Digits !== null) {
          // 詳細情報一覧で自生協以外の場合、コピーする
          const data = {
            CoopCode: this.kymw0900Model.guideList[i].CoopCode,
            CoopName: this.kymw0900Model.guideList[i].CoopName,
            OrderNum: this.kymw0900Model.guideList[i].OrderNum,
            AppearDiv: PlessViewUtilsSub.nullToBlank(this.kymw0900Model.guideList[i].Enabled) === '1' ? guideListData.AppearDiv : '',
            NextGuideMap: this.kymw0900Model.guideList[i].NextGuideMap,
            Enabled: this.kymw0900Model.guideList[i].Enabled,
          };
          // 編集有無フラグをカウント
          this.editCount++;
          guideList.push(data);
        }
      }
      this.kymw0900Model.guideList = guideList;
      this.dtg_GuideList.editableCollectionView.refresh();
    }
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/

  public eventCoopPriceListRefreshHandler(e: CustomEvent): void {
    // 画面で選択した行を取得
    const selectedRow = this.dtg_PriceList.selection.row;
    if (selectedRow !== -1) {
      // 一括反映の場合選択行がないため、
      // 選択行がある場合（selectedRowが-1以外）のみチェックがついているかの確認を行う
      if (!this.dtg_PriceList.collectionView.items[selectedRow].SelectValue) {
        // チェックがついてないときは更新しない
        return;
      }
    }
    this.eventPricePatternHandler(e, selectedRow);

    // プロモ設定に反映
    if (selectedRow !== -1) {
      // 選択行がある場合（一括設定の場合はpricePatternBtnClickで反映）
      // 選択した生協コード
      const selectedCoop = this.dtg_PriceList.collectionView.items[selectedRow].CoopCode;
      // 選択した生協コードの情報を取得
      const selectedItem = this.kymw0900Model.coopPriceList.find(_ => _.CoopCode === selectedCoop);
      this.setPromotionThistimeSupplyPrice(this.dtg_PriceList, selectedItem);
    }

    this.dtg_PriceList.editableCollectionView.refresh();
    if (selectedRow > -1) {
      this.dtg_PriceList.selection = new CellRange(selectedRow, -1, -1, -1);
    }
  }

  public eventPricePatternHandler(e: CustomEvent, selectedRow: number): void {
    let insInputSupplyPrice: boolean;
    let insInputCostPrice: boolean;
    if (selectedRow === -1) {
      insInputSupplyPrice = PlessViewUtilsSub.isEmpty(this.kymw0900Model.allthistimeSupplyPrice);
      insInputCostPrice = PlessViewUtilsSub.isEmpty(this.kymw0900Model.allthistimeCostPrice);
      selectedRow = e.detail.index;
    } else {
      insInputSupplyPrice = true;
      insInputCostPrice = true;
    }

    let workValue = new Array<any>();
    if (0 < this.kymw0900Model.coopPriceList.length) {
      workValue = e.target['value'];
      const data = {
        CoopCode: this.kymw0900Model.coopPriceList[selectedRow].CoopCode
      };
      // 選んだ値を一時待避
      this.kymw0900Model.updatePricePattern(data, workValue, insInputSupplyPrice, insInputCostPrice);
      // 編集カウントをインクリメント
      this.editCount++;
    }
  }

  /**
   * 画像ボタン押下イベント
   *
   */
  public eventImage_CLICKHandler(): void {
    const kymw1600InputVO = new KYMW1600InputModel();
    kymw1600InputVO.pcode = this.kymw0900Model.pCode;

    const componentRef = this.dialogServiceSub.openModal(KYMW1600Component);
    const instance = componentRef.componentInstance as KYMW1600Component;
    instance.dispDialog = true;
    instance.parent = this;
    instance.setInterfaceParam(kymw1600InputVO);
    // 画像画面からのコールバック無し
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 実績履歴ボタン押下イベント
   *
   */
  public eventHistory_CLICKHandler(): void {
    const kymw0800InputVO = new KYMW0800InputModel();
    kymw0800InputVO.pCodeList.push({
      PCode: this.kymw0900Model.pCode,
      GuideGoodsName: this.kymw0900Model.guideGoodsName,
      GuideStandardName: this.kymw0900Model.guideStandardName
    })

    const componentRef = this.dialogServiceSub.openModal(KYMW0800Component);
    const instance = componentRef.componentInstance as KYMW0800Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw0800InputVO);
    // 画像画面からのコールバック無し
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【Ｐコード共通】
   * 「変更確認」ボタンクリックイベントリスナ
   * @param e イベント
   */
  public async eventChangeConfirmation_CLICKHandler(e: Event): Promise<void> {
    // 値変更カウントが0の場合
    if (this.editCount === 0) {
      // エラーメッセージを表示する。（メッセージID：E0162）
      this.dialogServiceSub.openAlertGetMessage('E0162', ['']);
    } else {
      // 値変更フラグ（VO）が '1'（変更あり）の場合
      // Ｐコード：コンボボックス」へカーソル移動
      this.cmb_PCode.nativeElement.focus();

      // 計画数の再計算を行い、表示中の計画数の合計と不一致の場合、エラーメッセージを表示し、イベントを終了する
      if (!this.kymw0900Model.checkPlanListSum()) {
        this.dialogServiceSub.openAlertGetMessage('E0121', ['計画数合計', '各生協の計画数の合計']);
        return;
      }
      // 計画数合計が8桁を超過していればエラーメッセージを表示し、イベントを終了する
      if (Number(this.kymw0900Model.planList[0].Plannum) > 9999999) {
        this.dialogServiceSub.openAlertGetMessage('E0207', ['計画数合計', '8桁以上', 'このままでは登録']);
        return;
      }

      let makerPrice: number = <number>0;
      try {
        makerPrice = Number(this.kymw0900Model.makerPrice);
      } catch (Error) { }
      const priceType: string = this.cmb_MakerType.selectedCodeValue;
      if ((PlessViewUtilsSub.isEmpty(priceType) && makerPrice > 0) ||
        (!PlessViewUtilsSub.isEmpty(priceType) && makerPrice === 0)
      ) {
        this.dialogServiceSub.openAlertGetMessage('E0183', ['メーカー希望小売価格（参考）', '区分と', '価格', '一緒に設定']);
        return;
      }

      // 会員タブ、プロモタブ、予約タブのアイテムコード・取扱生協の相関チェック
      if (!this.validTabCrossSetting()) {
        return;
      }

      // プロモ設定タブのバリデーション
      if (!this.validPromotionInfoSetting()) {
        return;
      }

      // EC設定タブのバリデーション
      if (!this.validECSetting()) {
        return;
      }

      // 予約タブのバリデーション
      if (!this.validPreOrderSetting()) {
        return;
      }

      // 画面のアイテム情報をアイテムコード情報リストにコピーする
      this.kymw0900Model.copyDispContentsToItemCodeInfoList();

      // 商品企画マスタ変更確認の要求をサーバへ送信する。（要求ID：/KYMW09/checkPlanGoods.xml）
      // 商品企画マスタ変更確認リクエストVOを生成
      // ※入力の前後に空白スペースが入っている場合は削除する
      const checkPlanGoodsRequestVO: CheckPlanGoodsRequestModel = new CheckPlanGoodsRequestModel();
      checkPlanGoodsRequestVO.planGoodsBaseVO = this.getRequestPlanGoodsBaseVO();
      checkPlanGoodsRequestVO.planGoodsCoopList = this.getRequestPlanGoodsCoopList();
      checkPlanGoodsRequestVO.planGoodsNextGuide = this.getRequestPlanGoodsNextGuide();
      checkPlanGoodsRequestVO.planGoodsDetailList = this.getRequestPlanGoodsDetailList();
      checkPlanGoodsRequestVO.planGoodsListingList = this.getRequestPlanGoodsListingList();
      checkPlanGoodsRequestVO.markPlanGoodsList = this.getRequestMarkPlanGoodsList();
      checkPlanGoodsRequestVO.planTextInfoGoodsList = this.getRequestPlanTextInfoGoodsList();
      checkPlanGoodsRequestVO.planTextInfoItemList = this.getRequestPlanTextInfoItemList();
      checkPlanGoodsRequestVO.useMarkList = this.getRequestUseMarkList();
      checkPlanGoodsRequestVO.planGoodsAllergenList = this.getRequestPlanGoodsAllergenList();
      checkPlanGoodsRequestVO.planGoodsEcology1List = this.getRequestPlanGoodsEcology1List();
      checkPlanGoodsRequestVO.planGoodsEcology2List = this.getRequestPlanGoodsEcology2List();
      checkPlanGoodsRequestVO.itemCodePromoteList = this.getRequestPlanGoodsGWStopList();
      checkPlanGoodsRequestVO.planGoodsContainList = this.getRequestPlanGoodsContainList();
      checkPlanGoodsRequestVO.planGoodsNutritionUnitList = this.getRequestPlanGoodsNutritionUnitList();
      checkPlanGoodsRequestVO.planGoodsNutritionDetailList = this.getRequestPlanGoodsNutritionDetailList();
      checkPlanGoodsRequestVO.planGoodsLotteryPromotion = this.getRequestPlanGoodsLotteryPromotion();
      checkPlanGoodsRequestVO.planGoodsPointExchangePromotion = this.getRequestPlanGoodsPointExchangePromotion();
      checkPlanGoodsRequestVO.planGoodsCoopPointRate = this.getRequestPlanGoodsCoopPointRate();
      checkPlanGoodsRequestVO.planGoodsNvalPromotion = this.getRequestPlanGoodsNvalPromotion();
      checkPlanGoodsRequestVO.planGoodsCouponPromotion = this.getRequestPlanGoodsCouponPromotion();
      checkPlanGoodsRequestVO.couponApplicablePrice = this.getRequestCouponApplicablePrice();
      checkPlanGoodsRequestVO.planGoodsEC = this.getPlanGoodsEC();
      checkPlanGoodsRequestVO.planGoodsEcStock = this.getPlanGoodsEcStock();
      checkPlanGoodsRequestVO.preOrderInfo = this.getPreOrderInfo();
      checkPlanGoodsRequestVO.preOrderCoop = this.getPreOrderCoop();
      checkPlanGoodsRequestVO.cwsPlanGoodsIcon = this.getCwsPlanGoodsIcon();

      // 商品企画マスタ変更確認を実行
      this.checkPlanGoodsService.execute(this.kymw0900Model, checkPlanGoodsRequestVO);
    }
  }

  /**
   * 「会員」タブ、「プロモ」タブ、「予約」タブのタブを横断したバリデーションチェック
   * 
   * @returns 不正時にfalse
   */
  private validTabCrossSetting(): boolean {
    // 価格一覧でアイテムコードが選択済みと未選択を振り分ける
    const ItemCodeList_CoopInfo = this.kymw0900Model.coopPriceList.filter(_ => _.SelectItemCode).map(item => ({
      coopCode: item.CoopCode,
      itemCode: item.SelectItemCode,
      selected: item.SelectValue
    }));
    const ItemCodeEmptyList_CoopInfo = this.kymw0900Model.coopPriceList.filter(_ => !_.SelectItemCode).map(item => ({
      coopCode: item.CoopCode,
      itemCode: item.SelectItemCode,
      selected: item.SelectValue
    }));

    /**
     * アイテムコードが未選択、かつ、生協が１以上チェックされている場合、
     * または、
     * アイテムコードが選択済、かつ、生協が１つもチェックされていない場合、
     * エラー
     */
    const validate_ItemCodeCoopSelect = (itemCodeList, itemCodeSelected, errorCode) => {
      if (!PlessViewUtilsSub.isEmptyArray(itemCodeList)) {
        // 会員タブ 価格一覧の繰り返し
        for (const coop of itemCodeList) {
          // true: 生協選択済　false:生協未選択
          let selected;
          /** エラーダイアログ表示 */
          const errorModal = () => {
            const coopName = this.kymw00Model.COOP_MAP[coop.coopCode];
            this.dialogServiceSub.openAlertGetMessage(errorCode, [coopName, coopName]);
            return false;
          }

          // 会員タブ 価格一覧で生協が選択されている場合
          if (coop.selected) {
            // アイテムコードが選択済の場合
            if (itemCodeSelected) continue;
            // アイテムコードが未選択の場合
            return errorModal();
          }

          // 「プロモタブ」の「ポイント交換」一覧の繰り返し
          if (this.kymw0900Model.pointPromotionFlg) {
            for (const row of this.kymw0900Model.pointExchangeListDisplay) {
              // 「ポイント交換」一覧の生協毎の繰り返し
              for (const coopPoint of row.coopPointRateList) {
                if (coop.coopCode == coopPoint.CoopCode) {
                  selected = coopPoint.PlanGoodsCoopPointRateEnableFlg;
                  break;
                }
              }
              if (selected) break;
            }
          }
          if (selected) {
            if (itemCodeSelected) continue;
            return errorModal();
          }

          // 「プロモタブ」の「1物N価」一覧の繰り返し
          if (this.kymw0900Model.nvalPromotionFlg) {
            for (const row of this.kymw0900Model.nvalPromotionList) {
              if (row.orderCode !== this.kymw0900Model.orderCode) continue;

              // 「1物N価」一覧の生協毎の繰り返し
              const NvalCoopMap = new Map([
                [this.kymw00Model.COOP_CODE_IB, row.usePrefecture1Flg],
                [this.kymw00Model.COOP_CODE_TO, row.usePrefecture2Flg],
                [this.kymw00Model.COOP_CODE_GU, row.usePrefecture3Flg],
                [this.kymw00Model.COOP_CODE_TI, row.usePrefecture4Flg],
                [this.kymw00Model.COOP_CODE_SA, row.usePrefecture5Flg],
                [this.kymw00Model.COOP_CODE_TK, row.usePrefecture6Flg],
                [this.kymw00Model.COOP_CODE_NA, row.usePrefecture7Flg],
                [this.kymw00Model.COOP_CODE_NI, row.usePrefecture8Flg],
              ]);
              for (const [coopNval, flg] of NvalCoopMap.entries()) {
                if (coop.coopCode == coopNval) {
                  // 生協が選択されている場合1、未選択の場合0
                  selected = flg == 1;
                  break;
                }
              }
              if (selected) break;
            }
          }
          if (selected) {
            if (itemCodeSelected) continue;
            return errorModal();
          }

          // 「プロモタブ」の「クーポン」一覧の繰り返し
          if (this.kymw0900Model.couponPromotionFlg) {
            for (const row of this.kymw0900Model.couponPromotionListDisplay) {
              // 「クーポン」一覧の生協毎の繰り返し
              for (const coopCoupon of row.couponApplicablePriceList) {
                if (coop.coopCode == coopCoupon.coopCode) {
                  selected = coopCoupon.planGoodsCoopCouponApplicablePriceFlg
                  break;
                }
              }
              if (selected) break;
            }
          }
          if (selected) {
            if (itemCodeSelected) continue;
            return errorModal();
          }

          // 「予約タブ」の「予約」一覧の繰り返し
          if (this.kymw0900Model.preOrderFlag) {
            for (const row of this.kymw0900Model.preOrderDetailListDisplay) {
              // 「予約」一覧の生協毎の繰り返し
              for (const coopPreOrder of row.preOrderCoopList) {
                if (coop.coopCode == coopPreOrder.coopCode) {
                  selected = coopPreOrder.checked;
                  break;
                }
              }
              if (selected) break;
            }
          }

          if ((this.kymw0900Model.pointPromotionFlg || this.kymw0900Model.nvalPromotionFlg || this.kymw0900Model.couponPromotionFlg || this.kymw0900Model.preOrderFlag)) {
            // 「プロモタブ」の「ポイント交換」「1物N価」「クーポン」「予約」タブのいずれかが有効な場合
            // アイテムコードが選択済、かつ、生協が１つもチェックされていない場合、エラー
            // アイテムコードが未選択、かつ、生協が１以上チェックされている場合、エラー
            if ((itemCodeSelected && !selected) || (!itemCodeSelected && selected)) return errorModal();
          } else {
            // 「プロモタブ」の「ポイント交換」「1物N価」「クーポン」「予約」タブが全て無効な場合
            // アイテムコードが選択済、かつ生協が未選択の場合、エラー
            if (itemCodeSelected && !coop.selected) return errorModal();
          }
        };
      };
      return true;
    };

    // アイテムコードが選択済リストチェック
    let chk = validate_ItemCodeCoopSelect(ItemCodeList_CoopInfo, true, 'E0657');
    // アイテムコードが未選択リストチェック
    chk = chk ? validate_ItemCodeCoopSelect(ItemCodeEmptyList_CoopInfo, false, 'E0658') : false;
    return chk;
  }

  /**
   * プロモ設定タブのバリデーション
   *
   * @return 不正時にfalse
   */
  private validPromotionInfoSetting(): boolean {
    // 抽選商品プロモーション
    if (this.kymw0900Model.lotteryPromotionFlg) {
      let chkFlg = true;
      // 会員生協タブで選択されているアイテムコード
      const coopTabSelectedItemList = this.kymw0900Model.coopPriceList.map(_ => { return _.SelectItemCode });
      for (const item of this.kymw0900Model.planGoodsLotteryList) {
        // 選択（アイテムコード）のチェックボックスがONのものが対象
        if (item.check) {
          // 当選商品数と月曜日当選数(予定)～金曜日当選数(予定)の合計が不一致の場合、エラーダイアログにエラー内容を表示し処理を終了する
          if (!this.kymw0900Model.checkWinningGoodsNum(item)) {
            this.dialogServiceSub.openAlertGetMessage('E0121', ['当選上限数', '曜日別当選上限数']);
            chkFlg = false;
            break;
          }
          // 必須チェック
          if (PlessViewUtilsSub.isEmpty(item.winningGoodsNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['抽選商品当選数']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.winningGoodsPerPersonNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['一人あたりの抽選商品当選数']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.limitedMeaning)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['限定のワケ']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.mondayPlanNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['月曜日当選数（予定）']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.tuesdayPlanNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['火曜日当選数（予定）']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.wednesdayPlanNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['水曜日当選数（予定）']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.thursdayPlanNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['木曜日当選数（予定）']);
            chkFlg = false;
            break;
          }
          if (PlessViewUtilsSub.isEmpty(item.fridayPlanNum)) {
            this.dialogServiceSub.openAlertGetMessage('E0110', ['金曜日当選数（予定）']);
            chkFlg = false;
            break;
          }
          // １人当り当選上限数が１未満の場合
          if (Number(item.winningGoodsPerPersonNum) < 1) {
            this.dialogServiceSub.openAlertGetMessage('E0642', []);
            chkFlg = false;
            break;
          }
          // 以下チェックを月～金まで繰り返す
          // 曜日別当選上限数（予定）＜１人当り当選上限数の場合
          // ※曜日ごとにチェック、曜日別当選上限数（予定）が0の場合はチェック対象外
          if (Number(item.mondayPlanNum) !== 0) {
            if (Number(item.mondayPlanNum) < Number(item.winningGoodsPerPersonNum)) {
              this.dialogServiceSub.openAlertGetMessage('E0643', ['月']);
              chkFlg = false;
              break;
            }
          }
          if (Number(item.tuesdayPlanNum) !== 0) {
            if (Number(item.tuesdayPlanNum) < Number(item.winningGoodsPerPersonNum)) {
              this.dialogServiceSub.openAlertGetMessage('E0643', ['火']);
              chkFlg = false;
              break;
            }
          }
          if (Number(item.wednesdayPlanNum) !== 0) {
            if (Number(item.wednesdayPlanNum) < Number(item.winningGoodsPerPersonNum)) {
              this.dialogServiceSub.openAlertGetMessage('E0643', ['水']);
              chkFlg = false;
              break;
            }
          }
          if (Number(item.thursdayPlanNum) !== 0) {
            if (Number(item.thursdayPlanNum) < Number(item.winningGoodsPerPersonNum)) {
              this.dialogServiceSub.openAlertGetMessage('E0643', ['木']);
              chkFlg = false;
              break;
            }
          }
          if (Number(item.fridayPlanNum) !== 0) {
            if (Number(item.fridayPlanNum) < Number(item.winningGoodsPerPersonNum)) {
              this.dialogServiceSub.openAlertGetMessage('E0643', ['金']);
              chkFlg = false;
              break;
            }
          }
          // 抽選商品当選数が１未満の場合
          if (Number(item.winningGoodsNum) < 1) {
            this.dialogServiceSub.openAlertGetMessage('E0653', ['']);
            chkFlg = false;
            break;
          }
          // 相関チェック処理を行う
          if (!coopTabSelectedItemList.includes(item.itemCode)) {
            // 会員生協タブのアイテムコードに、プロモ設定タブの抽選商品で選択したアイテムコードが存在しない場合、
            // エラーダイアログにエラー内容を表示し、処理を終了する。
            this.dialogServiceSub.openAlertGetMessage('E0646', ['']);
            chkFlg = false;
            break;
          }
        }
      }

      if (chkFlg) {
        // 抽選商品プロモーションを使用する場合、かつ、プロモタブ>企画マスタ管理マークの全活性生協で033「０１：数量限定」が未選択の場合エラー
        const lotteryMark = this.kymw0900Model.markInfoList.find(mark => mark.MarkCode === this.LOTTERYPROMOTION_MARKCODE);
        const target = [
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_IB)] === lotteryMark.SelectValue1,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_TO)] === lotteryMark.SelectValue2,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_GU)] === lotteryMark.SelectValue3,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_TI)] === lotteryMark.SelectValue4,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_SA)] === lotteryMark.SelectValue5,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_TK)] === lotteryMark.SelectValue6,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_NA)] === lotteryMark.SelectValue7,
          !this.kymw0900Model.iconListDisable[PlessViewUtilsSub.stringToNumber(this.kymw00Model.COOP_CODE_NI)] === lotteryMark.SelectValue8,
        ]
        if (target.includes(false)) {
          this.dialogServiceSub.openAlertGetMessage('E0107', ['抽選商品プロモーションの「このプロモーション設定を使用する」', '、企画マスタ管理マークのマークコード033【０１：数量限定】'])
          chkFlg = false;
        }
      }

      if (!chkFlg) {
        return chkFlg;
      }
    }

    // ポイント交換商品プロモーション
    if (this.kymw0900Model.pointPromotionFlg) {
      // 相関チェック処理を行う。	
      // 会員生協タブのアイテムコードと、プロモ設定タブのポイント交換情報のアイテムコードと取扱生協が異なっている場合、	
      // エラーダイアログにエラー内容を表示し、処理を終了する。	
      const coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();
      let checkFlg = true;
      for (const c of this.kymw0900Model.pointExchangeListDisplay) {
        const coopList = coopInfoItemCoopCode.find(_ => _.itemCode === c.itemCode)?.coopCode;
        if (coopList) {
          for (const cp of c.coopPointRateList) {
            if (!coopList.includes(cp.CoopCode) && cp.PlanGoodsCoopPointRateEnableFlg) {
              checkFlg = false;
              break;
            }
          }
        } else {
          // coopListが空（＝会員生協タブでアイテムコードが選ばれていない）の場合、エラー。
          // ポイント交換は最低でも一つ生協を選ぶ必要があるため、会員生協タブで同アイテムコードが選ばれている必要がある
          checkFlg = false;
        }
        if (!checkFlg) {
          break;
        }
      }
      if (!checkFlg) {
        this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブのポイント交換']);
        return false;
      }

      // 表示用のデータを保持用のデータに格納
      for (const c of this.kymw0900Model.pointExchangeListDisplay) {
        this.kymw0900Model.pointExchangeList.forEach((data, index) => {
          if (c.itemCode === data.itemCode) {
            for (const key of Object.keys(data)) {
              this.kymw0900Model.pointExchangeList[index][key] = c[key];
            }
          }
        })
      }
    }

    // クーポン商品プロモーション
    if (this.kymw0900Model.couponPromotionFlg) {
      // 会員生協のチェックボックスにチェックが入っている会員生協に対して、相関チェック処理を行う。			
      // 会員生協タブの価格一覧の情報から、当モーダル内のアイテムコードに合致する行に紐付く生協について、		
      // 当モーダル内の選択チェックボックスのチェック状態と会員生協タブの生協毎のアイテムコードの選択状態が合わない行が存在する場合、
      // エラーダイアログにエラー内容を表示し処理を終了する。
      const coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();
      let checkFlg = true;

      if (!PlessViewUtilsSub.isEmptyArray(coopInfoItemCoopCode)) {
        for (const c of this.kymw0900Model.couponPromotionListDisplay) {
          const coopList = coopInfoItemCoopCode.find(_ => _.itemCode === c.itemCode)?.coopCode;
          if (coopList) {
            for (const cap of c.couponApplicablePriceList) {
              if (cap.planGoodsCoopCouponApplicablePriceFlg && !coopList.includes(cap.coopCode)) {
                // 「会員タブ」で選択したアイテムコードと、当該アイテムコードが異なる場合エラー
                this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブのクーポン']);
                checkFlg = false;
                break;
              }
            }
          } else {
            // 会員生協タブで該当のアイテムコードが選択されていない場合もエラー
            this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブのクーポン']);
            checkFlg = false;
            break;
          }
        }
      } else {
        // 選択アイテムコードがない場合、クーポンの生協と一致しないためエラー
        this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブのクーポン']);
        checkFlg = false;
      }
      if (!checkFlg) {
        return checkFlg;
      }

      for (const row of this.kymw0900Model.couponPromotionListDisplay) {
        // 「クーポン」一覧の生協毎の繰り返し
        for (const coopCoupon of row.couponApplicablePriceList) {
          if (!PlessViewUtilsSub.isEmpty(coopCoupon.discountUnitPrice)) {
            // 値引単価が入力されているかつ値引単価>供給単価の場合
            if (Number(coopCoupon.discountUnitPrice) > Number(PlessViewUtilsSub.editPriceComma(coopCoupon.thisTimeSupplyPrice, false))) {
              this.dialogServiceSub.openAlertGetMessage('E0578', ['値引単価には供給単価を超える金額']);
              checkFlg = false;
              break;
            }
          }
        }
        if (!checkFlg) {
          break;
        }
      }
      if (!checkFlg) {
        return checkFlg;
      }

      // 表示用のデータを保持用のデータに格納
      for (const c of this.kymw0900Model.couponPromotionListDisplay) {
        this.kymw0900Model.couponPromotionList.forEach((data, index) => {
          if (c.couponGoodsNo === data.couponGoodsNo) {
            for (const key of Object.keys(data)) {
              this.kymw0900Model.couponPromotionList[index][key] = c[key];
            }
          }
        })
      }
    }

    // 1物N価媒体プロモーション
    if (this.kymw0900Model.nvalPromotionFlg) {
      // 相関チェック処理を行う。	
      // 会員生協タブのアイテムコードと、プロモ設定タブの1物N価媒体情報のアイテムコードと取扱生協が異なっている場合、	
      // エラーダイアログにエラー内容を表示し、処理を終了する。	

      // 会員生協タブのアイテムコード、取扱生協
      const coopInfoItemCode = this.getSelectedCoopInfoItemCoopCode();
      let checkFlg = true;

      if (!PlessViewUtilsSub.isEmptyArray(coopInfoItemCode)) {
        for (const n of this.kymw0900Model.nvalPromotionList) {
          // 対象の受注コード（編集可能）かつ、削除フラグが'1'ではないデータのみ確認
          // ※削除フラグが'1'でもデータは残ったままとなっているので、チェックの対象から外しておく
          if (n.orderCode === this.kymw0900Model.orderCode && n.deleteFlg !== '1') {
            const coopList = coopInfoItemCode.find(_ => _.itemCode === n.itemCode)?.coopCode;
            if (coopList) {
              // 会員生協タブのアイテムコードと、プロモ設定タブ1物N価媒体情報のアイテムコード、取扱生協が一致するか
              if ((n.usePrefecture1Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_IB)) ||
                (n.usePrefecture2Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_TO)) ||
                (n.usePrefecture3Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_GU)) ||
                (n.usePrefecture4Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_TI)) ||
                (n.usePrefecture5Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_SA)) ||
                (n.usePrefecture6Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_TK)) ||
                (n.usePrefecture7Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_NA)) ||
                (n.usePrefecture8Flg === '1' && !coopList.includes(this.kymw00Model.COOP_CODE_NI))
              ) {
                // 「会員タブ」で選択したアイテムコードと、当該アイテムコードが異なる場合エラー
                this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブの1物N価']);
                checkFlg = false;
                break;
              }
            } else {
              // 会員生協タブで該当のアイテムコードが選択されていない場合もエラー
              this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブの1物N価']);
              checkFlg = false;
              break;
            }
          }
        }
      } else {
        this.dialogServiceSub.openAlertGetMessage('E0644', ['プロモ設定タブの1物N価']);
        checkFlg = false;
      }
      if (!checkFlg) {
        return checkFlg;
      }
    }

    return true;
  }

  /**
   * EC設定タブのバリデーション
   *
   * @return 不正時にfalse
   */
  private validECSetting(): boolean {
    if (PlessViewUtilsSub.isEmpty(this.kymw0900Model.minOrderNum)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['最低注文数']);
      return false;
    }
    return true;
  }

  /**
   * 予約タブのバリデーション
   * 
   * @returns 不正時にfalse
   * ci  CoopInfo
   * cpo CoopPreOrder
   */
  private validPreOrderSetting(): boolean {
    if (this.kymw0900Model.preOrderFlag) {
      // 会員生協タブのアイテムコード、取扱生協
      const coopInfoItemCode = this.getSelectedCoopInfoItemCoopCode();
      let checkFlg = true;

      if (!PlessViewUtilsSub.isEmptyArray(coopInfoItemCode)) {
        for (const cpo of this.kymw0900Model.preOrderDetailListDisplay) {
          const coopList = coopInfoItemCode.find(_ => _.itemCode === cpo.itemCode)?.coopCode;
          if (coopList) {
            for (const cap of cpo.preOrderCoopList) {
              if (cap.checked && !coopList.includes(cap.coopCode)) {
                // 「会員タブ」で選択したアイテムコードと、当該アイテムコードが異なる場合エラー
                this.dialogServiceSub.openAlertGetMessage('E0644', ['予約タブ']);
                checkFlg = false;
                break;
              }
            }
          } else {
            // 会員生協タブで該当のアイテムコードが選択されていない場合もエラー
            this.dialogServiceSub.openAlertGetMessage('E0644', ['予約タブ']);
            checkFlg = false;
            break;
          }
          if (!checkFlg) {
            break;
          }
        }
      }
      return checkFlg;
    }
    return true;
  }

  /**
   * 企画商品基本マスタVOの取得
   *
   * @return 企画商品基本マスタ
   */
  private getRequestPlanGoodsBaseVO(): PlanGoodsBaseModel {
    const requestVO: PlanGoodsBaseModel = new PlanGoodsBaseModel();

    // 受注コード（管理クラスから取得）
    requestVO.orderCode = this.kymw0900Model.orderCode;
    // Ｐコード（管理クラスから取得）
    requestVO.pCode = this.kymw0900Model.pCode;
    // 部門分類管理NO（管理クラスから取得）
    requestVO.classDivNum = this.kymw0900Model.classDivNum;
    // 包材一括表示フラグ（画面から取得）
    requestVO.packMaterialShowFlg = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.packMaterialShowFlag);
    // 部門コード（画面から取得）
    requestVO.classCode = this.cmb_ClassCode.selectedClassCode;
    // 大分類コード（画面から取得）
    requestVO.largeClassCode = this.cmb_LargeClassCode.selectedLargeClassCode;
    // 中分類コード（画面から取得）
    requestVO.middleClassCode = this.cmb_MiddleClassCode.selectedMiddleClassCode;
    // 小分類コード（画面から取得）
    requestVO.smallClassCode = this.cmb_SmallClassCodeList.selectedSmallClassCode;
    // データ種別（管理クラスから取得）
    requestVO.dataType = this.kymw0900Model.dataType;
    // 商品案内用商品名（画面から取得）
    requestVO.guideGoodsName = this.kymw00Model.deleteStartAndEndSpace(this.txti_GuideGoodsName.text);
    // 商品案内用規格名（画面から取得）
    requestVO.guideStandardName = this.kymw00Model.deleteStartAndEndSpace(this.txti_GuideStandardName.text);
    // 媒体区分（管理クラスから取得）
    requestVO.mediumType = this.kymw0900Model.mediumType;
    // お届け明細用商品名（漢字）（画面から取得）
    requestVO.deliveryGoodsNameKanji = this.kymw00Model.deleteStartAndEndSpace(this.txti_DeliveryGoodsNameKanji.text);
    // お届け明細用規格名（漢字）（画面から取得）
    requestVO.deliveryStandardNameKanji = this.kymw00Model.deleteStartAndEndSpace(this.txti_DeliveryStandardNameKanji.text);
    // お届け明細用商品名（カナ）（画面から取得）
    requestVO.deliveryGoodsNameKana = this.kymw00Model.deleteStartAndEndSpace(this.txti_DeliveryGoodsNameKana.text);
    // お届け明細用規格名（カナ）（画面から取得）
    requestVO.deliveryStandardNameKana = this.kymw00Model.deleteStartAndEndSpace(this.txti_DeliveryStandardNameKana.text);
    // ＯＣＲ商品名（画面から取得）
    requestVO.ocrGoodsName = this.kymw00Model.deleteStartAndEndSpace(this.txti_OcrGoodsName.text);
    // 消費税区分（画面から取得）
    requestVO.consumeTaxDiv = this.cmb_ConsumeTaxDivList.selectedCodeValue;
    // 消費税率（画面から取得）
    requestVO.consumeTaxRate = this.kymw0900Model.consumeTaxDivRate;
    // サイクル期間（画面から取得）
    requestVO.cycleTerm = this.cmb_CycleTerm.selectedCodeValue;
    // ＥＤＬＰ商品区分（画面から取得）
    requestVO.edlpDiv = this.cmb_EdlpDiv.selectedCodeValue;
    // ユニットプライス区分（画面から取得）
    requestVO.unitPriceDiv = this.cmb_UnitPriceDiv.selectedCodeValue;
    // ユニットプライス係数（画面から取得）
    requestVO.unitPriceCoefficient = this.kymw0900Model.unitPriceCoefficient;
    // ユニットプライス単位（画面から取得）
    requestVO.unitPriceUnit = this.kymw00Model.deleteStartAndEndSpace(this.txti_UnitPriceUnit.text);
    // 賞味期間（画面から取得）
    requestVO.consumeTerm = this.kymw0900Model.consumeTerm;
    // 消費期限（画面から取得）
    requestVO.consumeByDate = this.kymw0900Model.consumeByDate;
    // 残賞味期間（配達時）（画面から取得）
    requestVO.leaveConsumeTerm = this.kymw0900Model.leaveConsumeTerm;
    // 商品室内温度帯区分（画面から取得）
    requestVO.guideTempZoneDiv = this.cmb_RoomTempZoneDiv.selectedCodeValue;
    // 関連Ｐコード（旧）（画面から取得）
    requestVO.relationPCodeOld = this.kymw0900Model.relationPcodeOld;
    // 関連Ｐコード（新）（画面から取得）
    requestVO.relationPCodeNew = this.kymw0900Model.relationPcodeNew;
    // 目隠し区分（画面から取得）
    requestVO.blindDiv = this.cmb_BlindDiv.selectedCodeValue;
    // ｅフレンズ送信要否（画面から取得）
    requestVO.eFriendsSendDiv = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.eFriendsSendDiv);
    // コマ配置予定区分（画面から取得）
    requestVO.komaScheduleDiv = this.cmb_KomaScheduleDiv.selectedCodeValue;
    // 酒類コード（画面から取得）
    requestVO.liquorCode = this.cmb_LiquorCode.selectedCodeValue;
    // アルコール分別（画面から取得）
    requestVO.alocoholType = this.kymw0900Model.alcoholType;
    // 容器形態（画面から取得）
    requestVO.containerForm = this.cmb_ContainerForm.selectedCodeValue;
    // 容器容量（画面から取得）
    requestVO.containerCapacity = this.kymw0900Model.containerCapacity;
    // 表組用商品名（画面から取得）
    requestVO.listingGoodsName = this.kymw00Model.deleteStartAndEndSpace(this.txti_ListingGoodsName.text);
    // バイヤーコメント（画面から取得）
    requestVO.buyerComment = this.kymw00Model.deleteStartAndEndSpace(this.txta_TextInfoA.text);
    // 臭い商品区分（画面から取得）
    requestVO.StinkGoodsDiv = this.cmb_StinkGoodsDivList.selectedCodeValue;
    // ケース供給区分（画面から取得）
    requestVO.CaseSupplyDiv = this.cmb_CaseSupplyDivList.selectedCodeValue;
    // 長期保存区分（画面から取得）
    requestVO.LongKeepDiv = this.cmb_LongKeepDivList.selectedCodeValue;
    // 入荷場所区分（画面から取得）
    requestVO.ArrivalAreaDiv = this.cmb_ArrivalAreaDivList.selectedCodeValue;
    // 入荷許可品温（画面から取得）
    requestVO.ArrivalGoodsTemp = this.kymw0900Model.arrivalGoodsTemp;
    // 入荷管理日数（画面から取得）
    requestVO.ArrivalAdminDays = this.kymw0900Model.arrivalAdminDays;
    // 計画数（総数）（画面から取得）
    requestVO.planNumTotal = this.dtg_PlanList.collectionView.items[0].Plannum;
    // 業態区分（デイリー）（画面から取得）
    requestVO.DutiesFormDailyDiv = this.cmb_DutiesFormDailyDiv.selectedCodeValue;
    // 抽選商品プロモーションフラグ（画面から取得）
    requestVO.lotteryPromotionFlg = this.chk_UseLotteryPromotion.selected ? 1 : 0;
    // ポイント交換商品プロモーションフラグ（画面から取得）
    requestVO.pointPromotionFlg = this.chk_PointPromotion.selected ? 1 : 0;
    // 1物N価媒体プロモーションフラグ（画面から取得）
    requestVO.nvalPromotionFlg = this.chk_NvalPromotion.selected ? 1 : 0;
    // クーポン商品プロモーションフラグ（画面から取得）
    requestVO.couponPromotionFlg = this.chk_CouponPromotion.selected ? 1 : 0;
    // 在庫限定フラグ（画面から取得）
    requestVO.stockLimitFlg = this.kymw0900Model.stockLimitFlg ? 1 : 0;
    // 予約媒体フラグ
    requestVO.preOrderFlg = this.kymw0900Model.preOrderFlag ? 1 : 0;
    // 通常媒体フラグ
    requestVO.regularFlg = this.kymw0900Model.RegularFlg === '1' ? 1 : 0;

    return requestVO;
  }

  /**
   * 企画商品会員生協VOリストの取得
   *
   * @return 企画商品会員生協VOリスト
   */
  private getRequestPlanGoodsCoopList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsCoopModel = new PlanGoodsCoopModel();

    // 会員生協タブ　マーク一覧
    const settingCoopMarkList: Array<any> = Array<any>(this.dtg_CoopMarkList.collectionView.items);
    // 会員生協タブ　価格一覧
    const settingPriceList: Array<any> = Array<any>(this.dtg_PriceList.collectionView.items);
    // 詳細情報タブ　情報一覧
    const settingCoopDetailList: Array<any> = Array<any>(this.dtg_CoopDetailList.collectionView.items);
    // 計画数タブ　計画数一覧
    const settingPlanList: Array<any> = Array<any>(this.dtg_PlanList.collectionView.items);
    // 案内タブ　案内一覧
    const settingGuideList: Array<any> = Array<any>(this.dtg_GuideList.collectionView.items);

    // 会員生協数分繰り返し
    for (let i = Number(0); i < settingCoopMarkList[0].length; i++) {
      vo = new PlanGoodsCoopModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;

      // 生協コード
      vo.coopCode = settingCoopMarkList[0][i].CoopCode;
      // 取扱会員生協区分
      vo.dealCoopDiv = settingCoopMarkList[0][i].DealCoopDiv;
      // システムマーク１
      vo.systemMark1 = settingCoopMarkList[0][i].Mark1Value;
      // システムマーク２
      vo.systemMark2 = settingCoopMarkList[0][i].Mark2Value;
      // システムマーク３
      vo.systemMark3 = settingCoopMarkList[0][i].Mark3Value;
      // システムマーク４
      vo.systemMark4 = settingCoopMarkList[0][i].Mark4Value;
      // システムマーク５
      vo.systemMark5 = settingCoopMarkList[0][i].Mark5Value;
      // アイテムコード
      const itemCode: string = settingPriceList[0][i].SelectItemCode;
      if (itemCode === '0' || PlessViewUtilsSub.isEmpty(itemCode)) {
        vo.itemCode = '';
      } else {
        vo.itemCode = itemCode;
      }

      if (settingPriceList[0][i]) {
        // 価格パターン
        vo.pricePatern = settingPriceList[0][i].SelectPricePattern;
        // 今回供給価格
        vo.thisTimeSupplyPrice = settingPriceList[0][i].ThistimeSupplyPrice;
        // 今回仕入価格
        vo.thisTimeCostPrice = settingPriceList[0][i].ThistimeCostPrice;
        // 取り扱い生協フラグ
        vo.useRegularFlg = settingPriceList[0][i].SelectValue ? 1 : 0;
      }

      if (settingCoopDetailList[0][i]) {
        // ブランド区分
        vo.brandType = settingCoopDetailList[0][i].BrandType;
        // セット区分
        vo.setDiv = settingCoopDetailList[0][i].SetDiv;
        // 仕分温度帯区分
        vo.assortTempDiv = settingCoopDetailList[0][i].AssortTempDiv;
        // 注文コード割当コード
        vo.orderNumQuotaCode = settingCoopDetailList[0][i].OrderNumQuotaCode;
        // 通常媒体取扱フラグ
        vo.detailUseRegularFlg = settingCoopDetailList[0][i].DetailUseRegularFlg;
        // 産地コメント１
        vo.producingAreaComment1 = this.kymw00Model.deleteStartAndEndSpace(settingCoopDetailList[0][i].ProducingAreaComment1);
        // 産地コメント２
        vo.producingAreaComment2 = this.kymw00Model.deleteStartAndEndSpace(settingCoopDetailList[0][i].ProducingAreaComment2);
      }

      // 受付番号（管理クラスから取得）
      vo.receiptNum = this.kymw0900Model.receiptNumArray[i];

      if (settingPlanList[0][i + 1]) {
        // 計画数
        vo.planNum = settingPlanList[0][i + 1].Plannum;
        // 限定数量総数
        vo.limitNumTotal = settingPlanList[0][i + 1].LimitnumTotal;
        // 限定数量個人
        vo.limitNumPerson = settingPlanList[0][i + 1].LimitnumPerson;
        // 配達リード区分
        vo.deliveryLeadTimeType = settingPlanList[0][i + 1].DeliveryLeadTimeType;
        // 配達企画回
        vo.delivCatalogID = settingPlanList[0][i + 1].DelivCatalogID;
      }

      // 登場区分
      // 案内一覧では取扱生協のみ表示されているため、案内一覧にない生協の場合は空文字を設定
      const targetGuide = settingGuideList[0].find(_ => _.CoopCode === vo.coopCode);
      vo.appearDiv = targetGuide?.AppearDiv ?? '';

      // 企画商品会員生協VOリストに追加
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 企画商品媒体別次回案内情報VOの取得
   *
   * @return 企画商品媒体別次回案内情報VOの取得
   */
  private getRequestPlanGoodsNextGuide(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.guideList) {
      for (const n of this.kymw0900Model.nextGuideMediumTypeList) {
        ret.push({
          coopCode: _.CoopCode,
          mediumType: n.MediumType,
          nextGuide: this.kymw00Model.deleteStartAndEndSpace(_.NextGuideMap[n.MediumType]),
        })
      }
    }
    return ret;
  }

  /**
   * 企画商品詳細VOリストの取得
   *
   * @return 企画商品詳細VOリスト
   */
  private getRequestPlanGoodsDetailList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsDetailModel;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      vo = new PlanGoodsDetailModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // アイテムコード
      vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
      // ＪＡＮコード
      vo.jANCode = itemCodeList[i].ItemCodeCommon.JANCode;
      // JANコード識別フラグ
      vo.janCodeDiv = itemCodeList[i].ItemCodeCommon.JANCodeDiv;

      // ＦＣ・ＭＣ手数料
      vo.fCMCFee = itemCodeList[i].ItemCodeBase.FCMCFee;
      // 特殊発注区分
      vo.specialOrderType = itemCodeList[i].ItemCodeBase.SpecialOrderType;
      // 在庫繰越区分
      vo.stockType = itemCodeList[i].ItemCodeBase.StockType;
      // 分納指定回数
      vo.installmentTimes = itemCodeList[i].ItemCodeBase.InstallmentTimes;
      // 物流滞留日数
      vo.pDPilingUpDays = itemCodeList[i].ItemCodeBase.PDPilingUpDays;
      // 発注単位区分
      vo.orderUnitType = itemCodeList[i].ItemCodeBase.OrderUnitType;
      // 価格区分
      vo.priceType = itemCodeList[i].ItemCodeBase.PriceType;
      // メーカー希望小売価格(参考)
      vo.makerPrice = itemCodeList[i].ItemCodeBase.MakerPrice;
      // 発注先取引先コード
      vo.orderClientCode = itemCodeList[i].ItemCodeBase.OrderClientCode;
      // 支払先取引先コード
      vo.payeeClientCode = itemCodeList[i].ItemCodeBase.PayeeClientCode;
      // 価格バンドル
      vo.bundlePrice = itemCodeList[i].ItemCodeBase.BundlePrice;
      // 確定入数
      vo.fixContainNum = itemCodeList[i].ItemCodeBase.FixContainNum;
      // 組数
      vo.setQuantity = itemCodeList[i].ItemCodeBase.SetQuantity;
      // メーカー名称
      vo.makerName = this.kymw00Model.deleteStartAndEndSpace(itemCodeList[i].ItemCodeSpec1.MakerName);
      // メーカー名掲載表示区分
      vo.makerNamePublishType = itemCodeList[i].ItemCodeSpec1.MakerNamePublishType;
      // ピースサイズ（縦）
      vo.peaceSizeLength = itemCodeList[i].ItemCodeSpec1.PeaceSizeLength;
      // ピースサイズ（横）
      vo.peaceSizeWidth = itemCodeList[i].ItemCodeSpec1.PeaceSizeWidth;
      // ピースサイズ（高）
      vo.peaceSizeHight = itemCodeList[i].ItemCodeSpec1.PeaceSizeHight;
      // ピース重量
      vo.peaceWeight = itemCodeList[i].ItemCodeSpec1.PeaceWeight;
      // ケースサイズ（縦）
      vo.caseSizeLength = itemCodeList[i].ItemCodeSpec1.CaseSizeLength;
      // ケースサイズ（横）
      vo.caseSizeWidth = itemCodeList[i].ItemCodeSpec1.CaseSizeWidth;
      // ケースサイズ（高）
      vo.caseSizeHight = itemCodeList[i].ItemCodeSpec1.CaseSizeHight;
      // ケース重量
      vo.caseWeight = itemCodeList[i].ItemCodeSpec1.CaseWeight;
      // 遺伝子組換表示区分
      vo.geneRecombinationDiv = itemCodeList[i].ItemCodeSpec1.GeneRecombinationDiv;
      // 分析単位
      vo.analysisUnit = itemCodeList[i].ItemCodeSpec2.AnalysisUnit;
      // 熱量(Kcal)
      vo.calorie = itemCodeList[i].ItemCodeSpec2.Calorie;
      // たんぱく質(g)
      vo.protein = itemCodeList[i].ItemCodeSpec2.Protein;
      // 脂質(g)
      vo.lipid = itemCodeList[i].ItemCodeSpec2.Lipid;
      // 炭水化物(g)
      vo.carbohydrate = itemCodeList[i].ItemCodeSpec2.Carbohydrate;
      // ナトリウム(mg)
      vo.sodium = itemCodeList[i].ItemCodeSpec2.Sodium;
      // アレルゲン調査対象区分
      vo.allergenTargetType = itemCodeList[i].ItemCodeSpec2.AllergenTargetType;

      // 企画商品詳細VOリストに追加
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 企画商品表組情報VOリストの取得
   *
   * @return 企画商品表組情報VOリスト
   */
  private getRequestPlanGoodsListingList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsListingModel;

    // 詳細情報タブ　表組項目一覧
    const settingListingItemList: Array<any> = Array<any>(this.dtg_ListingItemList.collectionView.items);

    // 項目ＩＤ分繰り返し
    for (let i = Number(0); i < settingListingItemList[0].length; i++) {
      vo = new PlanGoodsListingModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // 表組用項目ＩＤ
      vo.listingItemID = settingListingItemList[0][i].ListingItemID;
      // 表示内容
      vo.dispContents = this.kymw00Model.deleteStartAndEndSpace(settingListingItemList[0][i].DispContents);
      // 企画商品表組情報VOリストに追加
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 企画商品付随マークVOリストの取得
   *
   * @return 企画商品付随マークVOリスト
   */
  private getRequestMarkPlanGoodsList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: MarkPlanGoodsModel;

    // マークタブ　マーク情報一覧
    const settingMarkList: Array<any> = Array<any>(this.dtg_MarkList.collectionView.items);

    // 項目ＩＤ分繰り返し
    for (let i = Number(0); i < settingMarkList[0].length; i++) {
      vo = new MarkPlanGoodsModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // 商品台帳マークコード
      vo.goodsMarkCode = String(Number(settingMarkList[0][i].MarkCode));
      // 商品台帳マーク
      vo.goodsMark = settingMarkList[0][i].SelectValue;
      // 企画商品付随マークVOリストに追加
      retVal.push(vo);
    }

    // 昇順に並び替え(マークグループ)
    retVal.sort(function (a, b) {
      return <number>a - <number>b; //
    });

    return retVal;
  }

  /**
   * 商品企画付随文字情報（Ｐコード）VOリストの取得
   *
   * @return 商品企画付随文字情報（Ｐコード）VOリスト
   */
  private getRequestPlanTextInfoGoodsList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanTextInfoGoodsModel;

    // 文字情報種別1～21
    const settingTextInfoDivArray: Array<any> = this.kymw0900Model.textInfoDivArray;

    // 文字情報連番1～21
    const settingTextKindNumArray: Array<any> = this.kymw0900Model.textKindNumArray;

    // 商品付随文字情報種別分繰り返し
    for (let i = Number(0); i < settingTextInfoDivArray.length; i++) {
      vo = new PlanTextInfoGoodsModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // 商品付随文字情報種別
      vo.textKindID = settingTextInfoDivArray[i];
      // 商品付随文字情報連番
      vo.textKindNum = settingTextKindNumArray[i];

      switch (i) {
        case 0:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo1.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 1:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo2.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 2:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo3.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 3:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo4.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 4:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo5.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 5:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo6.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 6:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo7.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 7:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo8.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 8:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfo9.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 9:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_LicencedNo.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 10:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_LicencedDescription.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 11:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoB.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 12:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoC.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 13:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoD.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 14:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoE.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 15:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoF.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 16:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoG.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 17:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoH.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 18:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoI.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 19:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoJ.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
        case 20:
          // 文字情報
          vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(this.txta_TextInfoK.text), 1));
          // 商品付随文字情報連番を再設定
          // （文字情報が入力されていて連番が空の場合は'0'を指定、それ以外はそのままの設定値）
          if (!PlessViewUtilsSub.isEmpty(vo.stringValue) && PlessViewUtilsSub.isEmpty(vo.textKindNum)) {
            vo.textKindNum = '0';
          }
          break;
      }
      // 商品企画付随文字情報（Ｐコード）VOリストに追加
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 商品企画付随文字情報（アイテムコード）VOリストの取得
   *
   * @return 商品企画付随文字情報（アイテムコード）VOリスト
   */
  private getRequestPlanTextInfoItemList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanTextInfoItemModel;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;
    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      // 文字情報種別1～6
      const textInfoList = itemCodeList[i].ItemCodeSpec1.TextInfoList;
      // 商品付随文字情報種別分繰り返し
      for (let j = Number(0); j < textInfoList.length; j++) {
        vo = new PlanTextInfoItemModel();
        // 受注コード（管理クラスから取得）
        vo.orderCode = this.kymw0900Model.orderCode;
        // アイテムコード
        vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
        // 商品付随文字情報種別
        vo.textKindID = textInfoList[j].TextKindID;
        // 商品付随文字情報連番(固定値:1)
        vo.textKindNum = '1';
        // 文字情報
        vo.stringValue = this.kymw00Model.deleteStartAndEndSpace(PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(textInfoList[j].StringValue), 1));
        // 商品企画付随文字情報（アイテムコード）VOリストに追加
        retVal.push(vo);
      }
    }
    return retVal;
  }

  /**
   * 使用マークVOリストの取得
   *
   * @return 使用マークVOリスト
   */
  private getRequestUseMarkList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: UseMarkModel;

    if (PlessViewUtilsSub.isEmpty(this.kymw0900Model.markGroup)) {
      // グループを選択して絞り込みをしていないとき、
      // markInfoMainが変更されていないことがあるので画面値の反映を行う
      this.kymw0900Model.markInfoListMain = this.kymw0900Model.markInfoList;
    }

    // プロモタブ　供給促進マーク一覧
    const settingMarkInfoList: Array<any> = this.kymw0900Model.markInfoListMain;

    // マークコード分繰り返し
    for (let i = Number(0); i < settingMarkInfoList.length; i++) {
      vo = new UseMarkModel();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // 供給促進マークコード
      vo.promoteMarkCode = String(Number(settingMarkInfoList[i].MarkCode));
      // 供給促進マーク（い）
      vo.promoteMark0 = settingMarkInfoList[i].SelectValue1;
      // 供給促進マーク（と）
      vo.promoteMark1 = settingMarkInfoList[i].SelectValue2;
      // 供給促進マーク（ぐ）
      vo.promoteMark2 = settingMarkInfoList[i].SelectValue3;
      // 供給促進マーク（ち）
      vo.promoteMark3 = settingMarkInfoList[i].SelectValue4;
      // 供給促進マーク（さ）
      vo.promoteMark4 = settingMarkInfoList[i].SelectValue5;
      // 供給促進マーク（とう）
      vo.promoteMark5 = settingMarkInfoList[i].SelectValue6;
      // 供給促進マーク（な）
      vo.promoteMark6 = settingMarkInfoList[i].SelectValue7;
      // 供給促進マーク（に）
      vo.promoteMark7 = settingMarkInfoList[i].SelectValue8;
      // 使用マークVOリストに追加
      retVal.push(vo);
    }

    // 昇順に並び替え(プロモマークコード)
    retVal.sort(function (a, b) {
      return <number>a - <number>b;
    });

    return retVal;
  }

  /**
   * 企画商品アレルゲンマスタVOリストの取得
   *
   * @return 企画商品アレルゲンマスタVOリスト
   */
  private getRequestPlanGoodsAllergenList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsAllergenModel;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      // 商品付随文字情報種別分繰り返し
      for (let j = Number(0); j < itemCodeList[i].ItemCodeSpec2.AllergenList.length; j++) {
        vo = new PlanGoodsAllergenModel();
        // 受注コード（管理クラスから取得）
        vo.orderCode = this.kymw0900Model.orderCode;
        // Ｐコード（管理クラスから取得）
        vo.pCode = this.kymw0900Model.pCode;
        // アイテムコード
        vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
        // アレルゲン区分
        vo.allergenDiv = itemCodeList[i].ItemCodeSpec2.AllergenList[j].AllergenDiv;
        // アレルゲン選択
        vo.allergenSelect = itemCodeList[i].ItemCodeSpec2.AllergenList[j].AllergenSelect;
        // 企画商品アレルゲンマスタVOリストに追加
        retVal.push(vo);
      }
    }
    return retVal;
  }

  /**
   * 企画商品環境配慮商品（有無）VOリストの取得
   *
   * @return 企画商品環境配慮商品（有無）VOリスト
   */
  private getRequestPlanGoodsEcology1List(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsEcology1Model;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      vo = new PlanGoodsEcology1Model();
      // 受注コード（管理クラスから取得）
      vo.orderCode = this.kymw0900Model.orderCode;
      // Ｐコード（管理クラスから取得）
      vo.pCode = this.kymw0900Model.pCode;
      // アイテムコード
      vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
      // 環境区分フラグ
      vo.ecologyDivFlag = itemCodeList[i].ItemCodeEcology.EcologyDivFlag;
      // 企画商品環境配慮商品（有無）VOリストに追加
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 企画商品環境配慮商品（区分）VOリストの取得
   *
   * @return 企画商品環境配慮商品（区分）VOリスト
   */
  private getRequestPlanGoodsEcology2List(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsEcology2Model;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      // 環境区分分繰り返し
      for (let j = Number(0); j < itemCodeList[i].ItemCodeEcology.EcologyDivList.length; j++) {
        vo = new PlanGoodsEcology2Model();
        // 受注コード（管理クラスから取得）
        vo.orderCode = this.kymw0900Model.orderCode;
        // Ｐコード（管理クラスから取得）
        vo.pCode = this.kymw0900Model.pCode;
        // アイテムコード
        vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
        // 環境区分
        vo.ecologyDiv = itemCodeList[i].ItemCodeEcology.EcologyDivList[j].EcologyDiv;
        // 環境区分選択
        vo.ecologyDivSelect = itemCodeList[i].ItemCodeEcology.EcologyDivList[j].EcologyDivSelect;
        // 企画商品環境配慮商品（区分）VOリストに追加
        retVal.push(vo);
      }
    }
    return retVal;
  }

  /**
   * 企画商品温暖化防止関連VOリストの取得
   *
   * @return 企画商品温暖化防止関連VOリスト
   */
  private getRequestPlanGoodsGWStopList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsGWStopModel;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = 0; i < itemCodeList.length; i++) {
      // 温暖化防止関連商品区分分繰り返し
      for (let j = 0; j < itemCodeList[i].ItemCodeEcology.GWStopGoodsList.length; j++) {
        vo = new PlanGoodsGWStopModel();
        // 受注コード（管理クラスから取得）
        vo.orderCode = this.kymw0900Model.orderCode;
        // Ｐコード（管理クラスから取得）
        vo.pCode = this.kymw0900Model.pCode;
        // アイテムコード
        vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
        // 温暖化防止関連商品区分
        vo.gWStopGoodsDiv = itemCodeList[i].ItemCodeEcology.GWStopGoodsList[j].GWStopGoodsDiv;
        // 温暖化防止選択
        vo.gWStopGoodsDivSelect = itemCodeList[i].ItemCodeEcology.GWStopGoodsList[j].GWStopGoodsDivSelect;
        // 企画商品温暖化防止関連VOリストに追加
        retVal.push(vo);
      }
    }
    return retVal;
  }

  /**
   * 企画商品容器包装材VOリストの取得
   *
   * @return 企画商品容器包装材VOリスト
   */
  private getRequestPlanGoodsContainList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanGoodsContainModel;

    // アイテムコード情報リスト
    const itemCodeList: Array<any> = this.kymw0900Model.itemCodeInfoList;

    // アイテムコード分繰り返し
    for (let i = Number(0); i < itemCodeList.length; i++) {
      // 容器包装材分類分繰り返し
      for (let j = Number(0); j < itemCodeList[i].ItemCodeEcology.ContainList.length; j++) {
        vo = new PlanGoodsContainModel();
        // 受注コード（管理クラスから取得）
        vo.orderCode = this.kymw0900Model.orderCode;
        // Ｐコード（管理クラスから取得）
        vo.pCode = this.kymw0900Model.pCode;
        // アイテムコード
        vo.itemCode = itemCodeList[i].ItemCodeCommon.ItemCode;
        // 容器包装材区分
        vo.containDiv = itemCodeList[i].ItemCodeEcology.ContainList[j].ContainDiv;
        // 容器包装材分類
        vo.containKind = itemCodeList[i].ItemCodeEcology.ContainList[j].ContainKind;
        // 包材重量
        vo.packMaterialWeight = itemCodeList[i].ItemCodeEcology.ContainList[j].PackMaterialWeight;
        // 容器包装材選択
        vo.containSelect = itemCodeList[i].ItemCodeEcology.ContainList[j].ContainSelect;
        // 企画商品容器包装材VOリストに追加
        retVal.push(vo);
      }
    }
    return retVal;
  }

  /**
   * 商品企画媒体別文字情報VOリストの取得
   *
   * @return 商品企画媒体別文字情報VOリスト
   */
  private getPlanGoodsMediumTextList(): Array<any> {
    const retVal: Array<any> = new Array<any>();
    let vo: PlanMediumTextModel;

    // 商品企画媒体別文字情報リスト
    const mediumTextList: Array<any> = this.kymw0900Model.mediumTextList;

    // 商品企画媒体別文字情報数分繰り返し
    for (let i = 0; i < mediumTextList.length; i++) {
      vo = mediumTextList[i];
      // Flexの初期値の引継ぎを再現
      if (vo.deleteFlg === null || vo.deleteFlg === undefined) {
        vo.deleteFlg = true;
      }
      if (vo.newData === null || vo.newData === undefined) {
        vo.newData = false;
      }
      vo.goodsCode = this.kymw0900Model.pCode;
      retVal.push(vo);
    }
    return retVal;
  }

  /**
   * 企画商品栄養成分分析単位VOリストの取得
   *
   * @return 企画商品栄養成分分析単位VOリスト
   */
  private getRequestPlanGoodsNutritionUnitList(): Array<any> {
    const retVal: Array<any> = new Array<any>();

    // アイテムコード分繰り返し
    for (let i = Number(0); i < this.kymw0900Model.itemCodeNutritionalInfoList.length; i++) {
      let unitVO: PlanGoodsNutritionUnitModel;
      ////////////////////
      // 栄養成分タブ
      ////////////////////
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length > 0) {
        for (let j = Number(0); j < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length; j++) {
          //// 分析単位 ////
          // コンテキストメニューにて削除操作、または新規登録操作した場合
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'D'
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
            unitVO = new PlanGoodsNutritionUnitModel();
            // 受注コード（管理クラスから取得）
            unitVO.orderCode = this.kymw0900Model.orderCode;
            // Ｐコード（管理クラスから取得）
            unitVO.pCode = this.kymw0900Model.pCode;
            // アイテムコード
            unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
            // 分析連番
            unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;

            // 分析単位
            unitVO.analysisUnit = '';
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
              unitVO.analysisUnit = this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisUnit));
            }
            // メンテナンス種別(分析単位用)
            unitVO.maintenanceDivUnit = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit;
            // 画面表示用データ項目名
            unitVO.itemNameForForm = this.kymw00Model.deleteStartAndEndSpace(this.editItemNameForUnit(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].
              itemCodeNutritional[j].analysisUnit)));
            // 栄養成分分析単位VOリストに追加
            retVal.push(unitVO);
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)
            let unitBefore: string = <string>'';
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisUnit !== null) {
              unitBefore = this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisUnit));
            }
            let unitAfter: string = <string>'';
            if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List.length > 0 &&
              this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0].AnalysisUnit !== null) {
              unitAfter = this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0].AnalysisUnit));
            }
            // 商品企画メンテナンス画面呼び出し直前と変更確認ボタン押下直後で値が変わっている場合
            if (unitBefore !== unitAfter) {
              unitVO = new PlanGoodsNutritionUnitModel();
              // 受注コード（管理クラスから取得）
              unitVO.orderCode = this.kymw0900Model.orderCode;
              // Ｐコード（管理クラスから取得）
              unitVO.pCode = this.kymw0900Model.pCode;
              // アイテムコード
              unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
              // 分析連番
              unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;

              // 分析単位
              unitVO.analysisUnit = this.kymw00Model.deleteStartAndEndSpace(unitAfter);
              // メンテナンス種別(分析単位用)
              unitVO.maintenanceDivUnit = 'U';
              // 画面表示用データ項目名
              unitVO.itemNameForForm = this.kymw00Model.deleteStartAndEndSpace(this.editItemNameForUnit(String(unitAfter)));
              // 栄養成分分析単位VOリストに追加
              retVal.push(unitVO);
            }
          }

          //// 栄養成分備考 ////
          // コンテキストメニューにて削除操作、または新規登録操作した場合
          // 分析単位を確認
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'D'
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
            // 栄養成分備考を確認
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivNote === 'D'
              || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivNote === 'I') {
              unitVO = new PlanGoodsNutritionUnitModel();
              // 受注コード（管理クラスから取得）
              unitVO.orderCode = this.kymw0900Model.orderCode;
              // Ｐコード（管理クラスから取得）
              unitVO.pCode = this.kymw0900Model.pCode;
              // アイテムコード
              unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
              // 分析連番
              unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;

              // 栄養成分備考
              unitVO.nutritionalNote = '';
              if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
                unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutritionalNote);
              }
              // メンテナンス種別(栄養成分備考用)
              unitVO.maintenanceDivNote = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivNote;
              // 画面表示用データ項目名
              unitVO.itemNameForForm = this.editItemNameForNote(this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j]
                .analysisUnit));

              // 栄養成分分析単位VOリストに追加
              retVal.push(unitVO);
            }
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)
            let noteBefore: string = <string>'';
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutritionalNote !== null) {
              noteBefore = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutritionalNote);
            }
            let noteAfter: string = <string>'';
            if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List.length > 0 &&
              this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0].NutritionalNote !== null) {
              noteAfter = this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0].NutritionalNote));
            }
            // 商品企画メンテナンス画面呼び出し直前と変更確認ボタン押下直後で値が変わっている場合
            if (noteBefore !== noteAfter) {
              unitVO = new PlanGoodsNutritionUnitModel();
              // 受注コード（管理クラスから取得）
              unitVO.orderCode = this.kymw0900Model.orderCode;
              // Ｐコード（管理クラスから取得）
              unitVO.pCode = this.kymw0900Model.pCode;
              // アイテムコード
              unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
              // 分析連番
              unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;
              // 栄養成分備考が入力されている場合
              if (PlessViewUtilsSub.isEmpty(noteBefore) && !PlessViewUtilsSub.isEmpty(noteAfter)) {
                // 栄養成分備考
                unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(noteAfter);
                // メンテナンス種別(栄養成分備考用)
                unitVO.maintenanceDivNote = 'I';
              } else if (!PlessViewUtilsSub.isEmpty(noteBefore) && !PlessViewUtilsSub.isEmpty(noteAfter)) {
                // 栄養成分備考が変更されている場合
                unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(noteAfter);
                unitVO.maintenanceDivNote = 'U';
              } else if (!PlessViewUtilsSub.isEmpty(noteBefore) && PlessViewUtilsSub.isEmpty(noteAfter)) {
                // 栄養成分備考が消去されている場合
                unitVO.nutritionalNote = '';
                unitVO.maintenanceDivNote = 'D';
              }

              // 画面表示用データ項目名
              unitVO.itemNameForForm = this.editItemNameForNote(this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i]
                .ItemCodeNutritional.List[0].AnalysisUnit));
              // 栄養成分分析単位VOリストに追加
              retVal.push(unitVO);
            }
          }
        }
      }

      ////////////////////////////////
      // 複数栄養成分タブ [分析単位分繰り返し]
      ////////////////////////////////
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length > 0) {
        for (let mj = 0; mj < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length; mj++) {
          //// 分析単位 ////
          // コンテキストメニューにて削除操作、または新規登録操作した場合
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'D'
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
            unitVO = new PlanGoodsNutritionUnitModel();
            // 受注コード（管理クラスから取得）
            unitVO.orderCode = this.kymw0900Model.orderCode;
            // Ｐコード（管理クラスから取得）
            unitVO.pCode = this.kymw0900Model.pCode;
            // アイテムコード
            unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
            // 分析連番
            unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

            // 分析単位
            unitVO.analysisUnit = '';
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
              unitVO.analysisUnit = this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisUnit));
            }
            // メンテナンス種別(分析単位用)
            unitVO.maintenanceDivUnit = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit;
            // 画面表示用データ項目名
            unitVO.itemNameForForm = this.editItemNameForUnit(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].
              itemCodeNutritionalMulti[mj].analysisUnit)));
            // 栄養成分分析単位VOリストに追加
            retVal.push(unitVO);
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)

            // 分析連番を取得
            const seqNo: string = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

            // 複数栄養成分タブはitemCodeInfoList[i].ItemCodeNutritionalMulti.Listの中を回して、該当の分析連番と一致するものを確認
            for (let mk = 0; mk < this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length; mk++) {
              if (seqNo === String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisSeqNo)) {
                let unitBeforeMulti: string = <string>'';
                if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisUnit !== null) {
                  unitBeforeMulti = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisUnit);
                }
                let unitAfterMulti: string = <string>'';
                if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisUnit !== null) {
                  // サーバから取得時は配列型、編集後はString型となるためどちらにも対応できるように修正
                  unitAfterMulti =
                    this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisUnit.constructor === Array
                      ? this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisUnit)
                      : this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisUnit);
                }
                // 商品企画メンテナンス画面呼び出し直前と変更確認ボタン押下直後で値が変わっている場合
                if (unitBeforeMulti !== unitAfterMulti) {
                  unitVO = new PlanGoodsNutritionUnitModel();
                  // 受注コード（管理クラスから取得）
                  unitVO.orderCode = this.kymw0900Model.orderCode;
                  // Ｐコード（管理クラスから取得）
                  unitVO.pCode = this.kymw0900Model.pCode;
                  // アイテムコード
                  unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                  // 分析連番
                  unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;
                  // 分析単位
                  unitVO.analysisUnit = this.kymw00Model.deleteStartAndEndSpace(unitAfterMulti);
                  // メンテナンス種別(分析単位用)
                  unitVO.maintenanceDivUnit = 'U';
                  // 画面表示用データ項目名
                  unitVO.itemNameForForm = this.editItemNameForUnit(this.kymw00Model.deleteStartAndEndSpace(String(unitAfterMulti)));

                  // 栄養成分分析単位VOリストに追加
                  retVal.push(unitVO);
                }
              }
            }
          }

          //// 栄養成分備考 ////
          // コンテキストメニューにて削除操作、または新規登録操作した場合
          // 分析単位を確認
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'D'
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
            // 栄養成分備考を確認
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivNote === 'D'
              || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivNote === 'I') {
              unitVO = new PlanGoodsNutritionUnitModel();
              // 受注コード（管理クラスから取得）
              unitVO.orderCode = this.kymw0900Model.orderCode;
              // Ｐコード（管理クラスから取得）
              unitVO.pCode = this.kymw0900Model.pCode;
              // アイテムコード
              unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
              // 分析連番
              unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

              // 栄養成分備考
              unitVO.nutritionalNote = '';
              if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
                unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutritionalNote);
              }
              // メンテナンス種別(栄養成分備考用)
              unitVO.maintenanceDivNote = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivNote;
              // 画面表示用データ項目名
              unitVO.itemNameForForm = this.editItemNameForNote(this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].
                itemCodeNutritionalMulti[mj].analysisUnit));

              // 栄養成分分析単位VOリストに追加
              retVal.push(unitVO);
            }
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)
            // 分析連番を取得
            const seqNoMulti: string = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

            // 複数栄養成分タブはitemCodeInfoList[i].ItemCodeNutritionalMulti.Listの中を回して、該当の分析連番と一致するものを確認
            for (let muk = 0; muk < this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length; muk++) {
              // 分析連番が一致した場合
              if (seqNoMulti === String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[muk].AnalysisSeqNo)) {
                let noteBeforeMulti: string = <string>'';
                if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutritionalNote !== null) {
                  noteBeforeMulti = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutritionalNote);
                }
                let noteAfterMulti: string = <string>'';
                if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[muk].NutritionalNote !== null) {
                  noteAfterMulti =
                    this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[muk].NutritionalNote.constructor === Array
                      ? this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[muk].NutritionalNote)
                      : this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[muk].NutritionalNote);
                }
                // 商品企画メンテナンス画面呼び出し前と変更確認ボタン押下直後で値が変わっている場合
                if (noteBeforeMulti !== noteAfterMulti) {
                  unitVO = new PlanGoodsNutritionUnitModel();
                  // 受注コード（管理クラスから取得）
                  unitVO.orderCode = this.kymw0900Model.orderCode;
                  // Ｐコード（管理クラスから取得）
                  unitVO.pCode = this.kymw0900Model.pCode;
                  // アイテムコード
                  unitVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                  // 分析連番
                  unitVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

                  // 栄養成分備考が入力されている場合
                  if (PlessViewUtilsSub.isEmpty(noteBeforeMulti) && !PlessViewUtilsSub.isEmpty(noteAfterMulti)) {
                    // 栄養成分備考
                    unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(noteAfterMulti);
                    // メンテナンス種別(栄養成分備考用)
                    unitVO.maintenanceDivNote = 'I';
                  } else if (!PlessViewUtilsSub.isEmpty(noteBeforeMulti) && !PlessViewUtilsSub.isEmpty(noteAfterMulti)) {
                    // 栄養成分備考が変更されている場合
                    unitVO.nutritionalNote = this.kymw00Model.deleteStartAndEndSpace(noteAfterMulti);
                    unitVO.maintenanceDivNote = 'U';
                  } else if (!PlessViewUtilsSub.isEmpty(noteBeforeMulti) && PlessViewUtilsSub.isEmpty(noteAfterMulti)) {
                    // 栄養成分備考が消去されている場合
                    unitVO.nutritionalNote = '';
                    unitVO.maintenanceDivNote = 'D';
                  }

                  // 画面表示用データ項目名
                  unitVO.itemNameForForm = this.editItemNameForNote(this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeInfoList[i].
                    ItemCodeNutritionalMulti.List[muk].AnalysisUnit));

                  // 栄養成分分析単位VOリストに追加
                  retVal.push(unitVO);
                }
              }
            }
          }
        }
      }
    }
    return retVal;
  }

  /**
   * 企画商品栄養成分詳細VOリストの取得
   *
   * @return 企画商品栄養成分詳細VOリスト
   */
  private getRequestPlanGoodsNutritionDetailList(): Array<any> {
    const retVal: Array<any> = new Array<any>();

    // アイテムコード分繰り返し
    for (let i = Number(0); i < this.kymw0900Model.itemCodeNutritionalInfoList.length; i++) {
      let detailVO: PlanGoodsNutritionDetailModel;
      ////////////////////
      // 栄養成分タブ
      ////////////////////
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length > 0) {
        // 1件だが、Array<any>で保持しているのでループ
        for (let j = Number(0); j < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length; j++) {
          //// 分析単位 ////
          // コンテキストメニューにて新規登録操作した場合
          // 分析単位を確認
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
            for (let k = Number(0);
              k < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList.length; k++) {
              // 栄養成分量を確認
              if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].
                maintenanceDivQuantity === 'D'
                || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].
                  maintenanceDivQuantity === 'I') {
                detailVO = new PlanGoodsNutritionDetailModel();
                // 受注コード（管理クラスから取得）
                detailVO.orderCode = this.kymw0900Model.orderCode;
                // Ｐコード（管理クラスから取得）
                detailVO.pCode = this.kymw0900Model.pCode;
                // アイテムコード
                detailVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                // 分析連番
                detailVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;

                // 栄養成分コード
                detailVO.nutritionalCode =
                  String((this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].nutritionalCode) ?
                    this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].nutritionalCode :
                    this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].nutritionalCode);

                // 栄養成分量
                detailVO.nutritionalQuantity = '';
                if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
                  detailVO.nutritionalQuantity =
                    this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].nutritionalQuantity);
                }
                // メンテナンス種別(栄養成分量用)
                detailVO.maintenanceDivQuantity =
                  this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].maintenanceDivQuantity;

                // 画面表示用データ項目名
                detailVO.itemNameForForm = this.editItemNameForQuantity(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].
                  itemCodeNutritional[j].analysisUnit)), String((this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                    nutrientDetailList[k].nutritionalName) ? this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                      nutrientDetailList[k].nutritionalName) : this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                        nutrientDetailList[k].nutritionalName)));

                // 栄養成分詳細VOリストに追加
                retVal.push(detailVO);
              }
            }
          } else if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'D') {
            // コンテキストメニューにて削除操作した場合

            // 栄養成分コード分繰り返し
            for (let k = Number(0);
              k < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList.length; k++) {
              // 栄養成分量を確認
              if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].
                MaintenanceDivQuantity === 'D'
                || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].
                  MaintenanceDivQuantity === 'I') {
                detailVO = new PlanGoodsNutritionDetailModel();
                // 受注コード（管理クラスから取得）
                detailVO.orderCode = this.kymw0900Model.orderCode;
                // Ｐコード（管理クラスから取得）
                detailVO.pCode = this.kymw0900Model.pCode;
                // アイテムコード
                detailVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                // 分析連番
                detailVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;

                // 栄養成分コード
                detailVO.nutritionalCode =
                  String((this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].NutritionalCode) ?
                    this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].NutritionalCode :
                    this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].NutritionalCode);

                // 栄養成分量
                detailVO.nutritionalQuantity = '';
                if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].maintenanceDivUnit === 'I') {
                  detailVO.nutritionalQuantity =
                    this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].NutritionalQuantity);
                }
                // メンテナンス種別(栄養成分量用)
                detailVO.maintenanceDivQuantity =
                  this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[k].MaintenanceDivQuantity;

                // 画面表示用データ項目名
                detailVO.itemNameForForm = this.editItemNameForQuantity(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i].
                  itemCodeNutritional[j].analysisUnit)), String((this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                    nutrientDetailList[k].NutritionalName) ? this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                      nutrientDetailList[k].NutritionalName) : this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
                        nutrientDetailList[k].NutritionalName)));

                // 栄養成分詳細VOリストに追加
                retVal.push(detailVO);
              }
            }
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)

            // 栄養成分コード分繰り返し
            for (let uk = 0; uk < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].
              nutrientDetailList.length; uk++) {
              const qtyBefore: string = PlessViewUtilsSub.nullToBlank(
                this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[uk].NutritionalQuantity);
              const qtyAfter: string = PlessViewUtilsSub.nullToBlank(
                this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0]
                  .NutrientComponentList.List[uk].NutritionalQuantity);
              // 商品企画メンテナンス画面呼び出し直前と変更確認ボタン押下直後で値が変わっている場合
              if (qtyBefore !== qtyAfter) {
                detailVO = new PlanGoodsNutritionDetailModel();
                // 受注コード（管理クラスから取得）
                detailVO.orderCode = this.kymw0900Model.orderCode;
                // Ｐコード（管理クラスから取得）
                detailVO.pCode = this.kymw0900Model.pCode;
                // アイテムコード
                detailVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                // 分析連番
                detailVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].analysisSeqNo;
                // 栄養成分コード
                detailVO.nutritionalCode = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[j].nutrientDetailList[uk]
                  .NutritionalCode;
                // 栄養成分量が入力されている場合
                if (PlessViewUtilsSub.isEmpty(qtyBefore) && !PlessViewUtilsSub.isEmpty(qtyAfter)) {
                  // 栄養成分量
                  detailVO.nutritionalQuantity = this.kymw00Model.deleteStartAndEndSpace(qtyAfter);
                  // メンテナンス種別(栄養成分量用)
                  detailVO.maintenanceDivQuantity = 'I';
                } else if (!PlessViewUtilsSub.isEmpty(qtyBefore) && !PlessViewUtilsSub.isEmpty(qtyAfter)) {
                  // 栄養成分量が変更されている場合
                  detailVO.nutritionalQuantity = this.kymw00Model.deleteStartAndEndSpace(qtyAfter);
                  detailVO.maintenanceDivQuantity = 'U';
                } else if (!PlessViewUtilsSub.isEmpty(qtyBefore) && PlessViewUtilsSub.isEmpty(qtyAfter)) {
                  // 栄養成分量が消去されている場合
                  detailVO.nutritionalQuantity = '';
                  detailVO.maintenanceDivQuantity = 'D';
                }

                // 画面表示用データ項目名
                detailVO.itemNameForForm = this.editItemNameForQuantity(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i].
                  ItemCodeNutritional.List[0].AnalysisUnit)), this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i].
                    ItemCodeNutritional.List[0].NutrientComponentList.List[uk].NutritionalName)));

                // 栄養成分詳細VOリストに追加
                retVal.push(detailVO);
              }
            }
          }
        }
      }

      ////////////////////////////////
      // 複数栄養成分タブ [分析単位分繰り返し]
      ////////////////////////////////
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length > 0) {
        for (let mj = 0; mj < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length; mj++) {
          //// 分析単位 ////
          // コンテキストメニューにて削除操作、または新規登録操作した場合
          // 分析単位を確認
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'D'
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
            // 栄養成分コード分繰り返し
            for (let ml = 0; ml < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj]
              .nutrientDetailList.length; ml++) {
              // 栄養成分量を確認
              if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[ml]
                .maintenanceDivQuantity === 'D'
                || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[ml]
                  .maintenanceDivQuantity === 'I') {
                detailVO = new PlanGoodsNutritionDetailModel();
                // 受注コード（管理クラスから取得）
                detailVO.orderCode = this.kymw0900Model.orderCode;
                // Ｐコード（管理クラスから取得）
                detailVO.pCode = this.kymw0900Model.pCode;
                // アイテムコード
                detailVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                // 分析連番
                detailVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

                // 栄養成分コード
                detailVO.nutritionalCode =
                  this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[ml].nutritionalCode;
                // 栄養成分量
                detailVO.nutritionalQuantity = '';
                if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].maintenanceDivUnit === 'I') {
                  detailVO.nutritionalQuantity =
                    this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[ml]
                      .nutritionalQuantity);
                }
                // メンテナンス種別(栄養成分量用)
                detailVO.maintenanceDivQuantity =
                  this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[ml]
                    .maintenanceDivQuantity;

                // 画面表示用データ項目名
                detailVO.itemNameForForm = this.editItemNameForQuantity(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i]
                  .itemCodeNutritionalMulti[mj].analysisUnit)), this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeNutritionalInfoList[i]
                    .itemCodeNutritionalMulti[mj].nutrientDetailList[ml].nutritionalName)));
                // 栄養成分詳細VOリストに追加
                retVal.push(detailVO);
              }
            }
          } else {
            // 上記以外の場合
            // (メンテナンス操作にて値を変更した場合、またはメンテナンス操作で変更したが最終的に元の値に戻した場合を想定)
            // 栄養成分コード分繰り返し
            for (let muk = 0; muk < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj]
              .nutrientDetailList.length; muk++) {
              // 分析連番を取得
              const seqNo: string = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

              // 複数栄養成分タブはitemCodeInfoList[i].ItemCodeNutritionalMulti.Listの中を回して、該当の分析連番と一致するものを確認
              for (let mk = 0; mk < this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length; mk++) {
                // 分析連番が一致した場合
                if (seqNo === String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].AnalysisSeqNo)) {
                  const qtyBeforeMulti: string = PlessViewUtilsSub.nullToBlank(
                    this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[muk]
                      .nutritionalQuantity);
                  const qtyAfterMulti: string = PlessViewUtilsSub.nullToBlank(
                    this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk].NutrientComponentList.List[muk]
                      .NutritionalQuantity);
                  // 商品企画メンテナンス画面呼び出し直前と変更確認ボタン押下直後で値が変わっている場合
                  if (qtyBeforeMulti !== qtyAfterMulti) {
                    detailVO = new PlanGoodsNutritionDetailModel();
                    // 受注コード（管理クラスから取得）
                    detailVO.orderCode = this.kymw0900Model.orderCode;
                    // Ｐコード（管理クラスから取得）
                    detailVO.pCode = this.kymw0900Model.pCode;
                    // アイテムコード
                    detailVO.itemCode = this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode;
                    // 分析連番
                    detailVO.analysisSeqNo = this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].analysisSeqNo;

                    // 栄養成分コード
                    detailVO.nutritionalCode =
                      this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[mj].nutrientDetailList[muk]
                        .nutritionalCode;
                    // 栄養成分量が入力されている場合
                    if (PlessViewUtilsSub.isEmpty(qtyBeforeMulti) && !PlessViewUtilsSub.isEmpty(qtyAfterMulti)) {
                      // 栄養成分量
                      detailVO.nutritionalQuantity = this.kymw00Model.deleteStartAndEndSpace(qtyAfterMulti);
                      // メンテナンス種別(栄養成分量用)
                      detailVO.maintenanceDivQuantity = 'I';
                    } else if (!PlessViewUtilsSub.isEmpty(qtyBeforeMulti) && !PlessViewUtilsSub.isEmpty(qtyAfterMulti)) {
                      // 栄養成分量が変更されている場合
                      detailVO.nutritionalQuantity = this.kymw00Model.deleteStartAndEndSpace(qtyAfterMulti);
                      detailVO.maintenanceDivQuantity = 'U';
                    } else if (!PlessViewUtilsSub.isEmpty(qtyBeforeMulti) && PlessViewUtilsSub.isEmpty(qtyAfterMulti)) {
                      // 栄養成分量が消去されている場合
                      detailVO.nutritionalQuantity = '';
                      detailVO.maintenanceDivQuantity = 'D';
                    }
                    detailVO.itemNameForForm = this.editItemNameForQuantity(this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i]
                      .ItemCodeNutritionalMulti.List[mk].AnalysisUnit)),
                      this.kymw00Model.deleteStartAndEndSpace(String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[mk]
                        .NutrientComponentList.List[muk].NutritionalName)));

                    // 栄養成分詳細VOリストに追加
                    retVal.push(detailVO);
                  }
                }
              }
            }
          }
        }
      }
    }
    return retVal;
  }

  /**
   * 抽選商品プロモーション情報VOの取得
   *
   * @return 抽選商品プロモーション情報VOの取得
   */
  private getRequestPlanGoodsLotteryPromotion(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.planGoodsLotteryList) {
      ret.push({
        itemCode: _.itemCode,
        winningGoodsNum: _.check ? Number(_.winningGoodsNum) : null,
        winningGoodsPerPersonNum: _.check ? Number(_.winningGoodsPerPersonNum) : null,
        limitedMeaning: _.check ? _.limitedMeaning : null,
        mondayPlanNum: _.check ? Number(_.mondayPlanNum) : null,
        tuesdayPlanNum: _.check ? Number(_.tuesdayPlanNum) : null,
        wednesdayPlanNum: _.check ? Number(_.wednesdayPlanNum) : null,
        thursdayPlanNum: _.check ? Number(_.thursdayPlanNum) : null,
        fridayPlanNum: _.check ? Number(_.fridayPlanNum) : null,
      })
    }
    return ret;
  }

  /**
   * ポイント交換商品プロモーション情報VOの取得
   *
   * @return ポイント交換商品プロモーション情報VOの取得
   */
  private getRequestPlanGoodsPointExchangePromotion(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.pointExchangeList) {
      ret.push({
        pCode: this.kymw0900Model.pointPromotionFlg ? this.kymw0900Model.pCode : null,
        itemCode: this.kymw0900Model.pointPromotionFlg ? _.itemCode : null,
        pointExchangeOrderNumQuotaCode: this.kymw0900Model.pointPromotionFlg ? _.pointExchangeOrderNumQuotaCode : null,
        pointExchangeGoodsName: this.kymw0900Model.pointPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.pointExchangeGoodsName) : null,
        pointExchangeGoodsNameKana: this.kymw0900Model.pointPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.pointExchangeGoodsNameKana) : null,
        pointExchangeGuideName: this.kymw0900Model.pointPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.pointExchangeGuideName) : null,
        pointExchangeGuideNameKana: this.kymw0900Model.pointPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.pointExchangeGuideNameKana) : null,
        shortOfPointDiv: _.shortOfPointDiv ? String(_.shortOfPointDiv) : null,
        ecOnlyFlg: this.kymw0900Model.pointPromotionFlg ? _.ecOnlyFlg : null,
        registFlg: this.kymw0900Model.pointPromotionFlg ? _.registFlg : null,
        deleteFlg: this.kymw0900Model.pointPromotionFlg ? _.deleteFlg : null,
      })
    }
    return ret;
  }

  /**
   * 会員生協別ポイント情報VOの取得
   *
   * @return 会員生協別ポイント情報VO
   */
  private getRequestPlanGoodsCoopPointRate(): any {
    const ret = [];
    for (const c of this.kymw0900Model.pointExchangeList) {
      for (const _ of c.coopPointRateList) {
        // チェックがついている生協もしくはDeleteFlgが１の生協のみ格納する
        // （チェックなしのデータはポイント率が空のためバックエンドでエラーとなってしまう）
        if (_.PlanGoodsCoopPointRateEnableFlg || _.DeleteFlg === '1') {
          const pointRate = _.PointRate ? _.PointRate.replace('%', '') : '';
          const exchangePointWithoutTax = _.ExchangePointWithoutTax ? Number(PlessViewUtilsSub.editPriceComma(_.ExchangePointWithoutTax, false)) : '';
          const exchangePoint = _.ExchangePoint ? Number(PlessViewUtilsSub.editPriceComma(_.ExchangePoint, false)) : '';
          ret.push({
            itemCode: this.kymw0900Model.pointPromotionFlg ? c.itemCode : null,
            coopCode: this.kymw0900Model.pointPromotionFlg ? _.CoopCode : null,
            pointRate: this.kymw0900Model.pointPromotionFlg ? pointRate : null,
            pointExchangeEquivalentAmount: this.kymw0900Model.pointPromotionFlg ? exchangePointWithoutTax : null,
            exchangePoints: this.kymw0900Model.pointPromotionFlg ? exchangePoint : null,
            registFlg: this.kymw0900Model.pointPromotionFlg ? _.RegistFlg : null,
            deleteFlg: this.kymw0900Model.pointPromotionFlg ? _.DeleteFlg : null,
          })
        }
      }
    }
    return ret;
  }

  /**
   * 1物N価媒体プロモーション情報VOの取得
   *
   * @return 1物N価媒体プロモーション情報VOの取得
   */
  private getRequestPlanGoodsNvalPromotion(): any {
    let ret = [];
    for (const _ of this.kymw0900Model.nvalPromotionListDisplay) {
      // 商品企画メンテナスインプットVO.受注コードに一致するデータのリストを取得
      const targetData = _.dataList.find(data => data.orderCode === this.kymw0900Model.orderCode);
      if (targetData) {
        // 取得したデータからリクエストパラメータを作成
        ret.push({
          pCode: this.kymw0900Model.nvalPromotionFlg ? this.kymw0900Model.pCode : null,
          nvalDetailId: this.kymw0900Model.nvalPromotionFlg ? targetData.nvalDetailId : null,
          mediumType: this.kymw0900Model.nvalPromotionFlg ? targetData.mediumType : null,
          itemCode: this.kymw0900Model.nvalPromotionFlg ? targetData.itemCode : null,
          nvalOrderNumQuotaCode: this.kymw0900Model.nvalPromotionFlg ? targetData.nvalOrderNumQuotaCode : null,
          ibnkssaKb: this.kymw0900Model.nvalPromotionFlg ? targetData.ibnkssaKb : null,
          shkkktantKb: this.kymw0900Model.nvalPromotionFlg ? targetData.shkkktantKb : null,
          nvalGoodsName: this.kymw0900Model.nvalPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(targetData.nvalGoodsName) : null,
          nvalGoodsNameKana: this.kymw0900Model.nvalPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(targetData.nvalGoodsNameKana) : null,
          nvalGuideName: this.kymw0900Model.nvalPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(targetData.nvalGuideName) : null,
          nvalGuideNameKana: this.kymw0900Model.nvalPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(targetData.nvalGuideNameKana) : null,
          nvalDiscountType: this.kymw0900Model.nvalPromotionFlg ? targetData.discountType : null,
          nvalDiscountUnitPrice: (this.kymw0900Model.nvalPromotionFlg && targetData.discountType === '1') ? targetData.discountUnitPrice : null,
          nvalDiscountRate: (this.kymw0900Model.nvalPromotionFlg && targetData.discountType === '2') ? targetData.discountRate : null,
          nvalPricePattern: this.kymw0900Model.nvalPromotionFlg ? targetData.pricePattern : null,
          nvalSupplyPriceStandard: this.kymw0900Model.nvalPromotionFlg ? targetData.supplyPriceStandard : null,
          nvalDiscountSupplyUnitPrice: this.kymw0900Model.nvalPromotionFlg ? targetData.nvalDiscountSupplyUnitPrice : null,
          nvalUsePrefecture1Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture1Flg : null,
          nvalUsePrefecture2Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture2Flg : null,
          nvalUsePrefecture3Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture3Flg : null,
          nvalUsePrefecture4Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture4Flg : null,
          nvalUsePrefecture5Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture5Flg : null,
          nvalUsePrefecture6Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture6Flg : null,
          nvalUsePrefecture7Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture7Flg : null,
          nvalUsePrefecture8Flg: this.kymw0900Model.nvalPromotionFlg ? targetData.usePrefecture8Flg : null,
          remarks: this.kymw0900Model.nvalPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(targetData.remarks) : null,
          registFlg: this.kymw0900Model.nvalPromotionFlg ? targetData.registFlg : null,
          deleteFlg: this.kymw0900Model.nvalPromotionFlg ? targetData.deleteFlg : null,
        })
      }
    }
    return ret;
  }

  /**
   * 企画商品クーポンプロモーション情報VOの取得
   *
   * @return 企画商品クーポンプロモーション情報VOの取得
   */
  private getRequestPlanGoodsCouponPromotion(): any {
    let ret = [];
    for (const _ of this.kymw0900Model.couponPromotionList) {
      ret.push({
        pCode: this.kymw0900Model.couponPromotionFlg ? this.kymw0900Model.pCode : null,
        couponGoodsNo: this.kymw0900Model.couponPromotionFlg ? _.couponGoodsNo : null,
        itemCode: this.kymw0900Model.couponPromotionFlg ? _.itemCode : null,
        couponType: this.kymw0900Model.couponPromotionFlg ? _.couponType : null,
        groupType: this.kymw0900Model.couponPromotionFlg ? _.groupType : null,
        couponOrderNumQuotaCode: this.kymw0900Model.couponPromotionFlg ? _.couponOrderNumQuotaCode : null,
        notificationFlg: this.kymw0900Model.couponPromotionFlg ? _.notificationFlg : null,
        deliveryFlg: this.kymw0900Model.couponPromotionFlg ? Number(_.deliveryFlg) : null,
        newsletterFlg: this.kymw0900Model.couponPromotionFlg ? Number(_.newsletterFlg) : null,
        standardUsageAmount: this.kymw0900Model.couponPromotionFlg ? _.standardUsageAmount : null,
        startMembershipWeeks: this.kymw0900Model.couponPromotionFlg ? ((_.startMembershipWeeks !== '') ? Number(_.startMembershipWeeks) : null) : null,
        endMembershipWeeks: this.kymw0900Model.couponPromotionFlg ? _.endMembershipWeeks : null,
        couponName: this.kymw0900Model.couponPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.couponName) : null,
        couponNameKana: this.kymw0900Model.couponPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.couponNameKana) : null,
        couponGuideName: this.kymw0900Model.couponPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.couponGuideName) : null,
        couponGuideNameKana: this.kymw0900Model.couponPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.couponGuideNameKana) : null,
        couponTitleEc: this.kymw0900Model.couponPromotionFlg ? this.kymw00Model.deleteStartAndEndSpace(_.couponTitleEc) : null,
        couponTitleDelivery: this.kymw0900Model.couponPromotionFlg ? _.couponTitleDelivery : null,
        contentOne: this.kymw0900Model.couponPromotionFlg ? this.contentOneSpacePadding(_.contentOne) : null,
        contentTwo: this.kymw0900Model.couponPromotionFlg ? _.contentTwo : null,
        contentThree: this.kymw0900Model.couponPromotionFlg ? _.contentThree : null,
        contentFour: this.kymw0900Model.couponPromotionFlg ? _.contentFour : null,
        validatedDate: this.kymw0900Model.couponPromotionFlg ? _.validatedDate : null,
        staffCouponFlg: this.kymw0900Model.couponPromotionFlg ? _.staffCouponFlg : null,
        registFlg: this.kymw0900Model.couponPromotionFlg ? _.registFlg : null,
        deleteFlg: this.kymw0900Model.couponPromotionFlg ? _.deleteFlg : null,
      });
    }
    return ret;
  }

  /**
   * 会員生協別値引情報VOの取得
   *
   * @return 会員生協別値引情報VO
   */
  private getRequestCouponApplicablePrice(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.couponPromotionList) {
      for (const p of _.couponApplicablePriceList) {
        ret.push({
          couponGoodsNo: this.kymw0900Model.couponPromotionFlg ? _.couponGoodsNo : null,
          itemCode: this.kymw0900Model.couponPromotionFlg ? _.itemCode : null,
          coopCode: this.kymw0900Model.couponPromotionFlg ? p.coopCode : null,
          planGoodsCoopCouponApplicablePriceFlg: this.kymw0900Model.couponPromotionFlg ? (p.planGoodsCoopCouponApplicablePriceFlg ? '1' : '0') : null,
          discountUnitPrice: this.kymw0900Model.couponPromotionFlg ? p.discountUnitPrice : null,
          discountRate: this.kymw0900Model.couponPromotionFlg ? p.discountRate : null,
          limitNum: this.kymw0900Model.couponPromotionFlg ? p.limitNum : null,
          discountedUnitPrice: this.kymw0900Model.couponPromotionFlg ? PlessViewUtilsSub.editPriceComma(p.discountedUnitPrice, false) : null,
        })
      }
    }
    return ret;
  }

  /**
   * 企画商品EC情報VOの取得
   *
   * @return 企画商品EC情報VO
   */
  private getPlanGoodsEC(): any {
    return {
      pCode: this.kymw0900Model.pCode,
      cmFlg: this.kymw0900Model.cmFlg ? '1' : '0',
      recommendFlg: this.kymw0900Model.recommendFlg ? '1' : '0',
      orderLimitFlg: this.kymw0900Model.orderLimitFlg ? '1' : '0',
      webLimitFlg: this.kymw0900Model.webLimitFlg ? '1' : '0',
      recommendCommentFlg: this.kymw0900Model.recommendCommentFlg ? '1' : '0',
      orderGoodsDiv: this.kymw0900Model.orderGoodsDiv,
      minOrderNum: this.kymw0900Model.minOrderNum !== '' ? Number(this.kymw0900Model.minOrderNum) : null,
      maxOrderNum: this.kymw0900Model.maxOrderNum !== '' ? Number(this.kymw0900Model.maxOrderNum) : null,
      stockNum: this.kymw0900Model.stockLimitFlg ? Number(this.kymw0900Model.stockNumTotal) : null,
      stockNumShowFlg: this.kymw0900Model.stockLimitFlg ? this.kymw0900Model.stockNumShowFlg ? '1' : '0' : null,
      brandName: this.kymw0900Model.stockLimitFlg ? this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.brandName) : null,
      groupingCode: this.kymw0900Model.stockLimitFlg ? this.kymw0900Model.groupingCode : null,
      relatedUrlTitle: this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.relatedUrlTitle),
      relatedUrl: this.kymw0900Model.relatedUrl,
      nonDispFlg: this.kymw0900Model.nonDispFlg ? '1' : '0',
    }
  }

  /**
   * 会員生協別在庫限定情報VOの取得
   *
   * @return 会員生協別在庫限定情報VO
   */
  private getPlanGoodsEcStock(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.stockList) {
      if (_.coopName !== '合計') {
        if (this.kymw0900Model.stockLimitFlg) {
          ret.push({
            coopCode: _.coopCode,
            stockNum: _.stockNum !== '' ? Number(_.stockNum) : null,
            supplyPrice: _.supplyPrice !== '' ? Number(_.supplyPrice) : null,
            supplyPriceExplanation: this.kymw00Model.deleteStartAndEndSpace(_.supplyPriceExplanation),
          })
        } else {
          ret.push({
            coopCode: null,
            stockNum: null,
            supplyPrice: null,
            supplyPriceExplanation: null,
          })
        }
      }
    }
    return ret;
  }

  /**
   * 予約商品情報VOリストの取得
   *
   * @return 予約商品情報VO
   */
  private getPreOrderInfo(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.preOrderDetailList) {
      ret.push({
        pCode: this.kymw0900Model.preOrderFlag ? this.kymw0900Model.pCode : null,
        preOrderDetailId: this.kymw0900Model.preOrderFlag ? _.preOrderDetailId : null,
        itemCode: this.kymw0900Model.preOrderFlag ? _.itemCode : null,
        preOrderNumQuotaCode: this.kymw0900Model.preOrderFlag ? _.preOrderNumQuotaCode : null,
        preOrderNum: this.kymw0900Model.preOrderFlag ? _.preOrderNum : null,
        delivCatalogId: this.kymw0900Model.preOrderFlag ? _.delivCatalogId : null,
        delivMonday: this.kymw0900Model.preOrderFlag ? _.delivMonday : null,
        delivTuesday: this.kymw0900Model.preOrderFlag ? _.delivTuesday : null,
        delivWednesday: this.kymw0900Model.preOrderFlag ? _.delivWednesday : null,
        delivThursday: this.kymw0900Model.preOrderFlag ? _.delivThursday : null,
        delivFriday: this.kymw0900Model.preOrderFlag ? _.delivFriday : null,
        preOrderGoodsName: this.kymw0900Model.preOrderFlag ? this.kymw00Model.deleteStartAndEndSpace(_.preOrderGoodsName) : null,
        preOrderGoodsNameKana: this.kymw0900Model.preOrderFlag ? this.kymw00Model.deleteStartAndEndSpace(_.preOrderGoodsNameKana) : null,
        preOrderStandardName: this.kymw0900Model.preOrderFlag ? this.kymw00Model.deleteStartAndEndSpace(_.preOrderStandardName) : null,
        preOrderStandardNameKana: this.kymw0900Model.preOrderFlag ? this.kymw00Model.deleteStartAndEndSpace(_.preOrderStandardNameKana) : null,
        discountType: this.kymw0900Model.preOrderFlag ? _.discountType : null,
        discountUnitPrice: this.kymw0900Model.preOrderFlag ? _.discountUnitPrice : null,
        discountRate: this.kymw0900Model.preOrderFlag ? _.discountRate : null,
        discountSupplyUnitPrice: this.kymw0900Model.preOrderFlag ? _.discountSupplyUnitPrice : null,
        preOrderPoints: this.kymw0900Model.preOrderFlag ? _.preOrderPoints : null,
        setPreOrderType: this.kymw0900Model.preOrderFlag ? _.setPreOrderType : null,
        pricePattern: this.kymw0900Model.preOrderFlag ? _.pricePattern : null,
        supplyUnitPrice: this.kymw0900Model.preOrderFlag ? _.supplyPriceStandard : null,
        registFlg: this.kymw0900Model.preOrderFlag ? _.registFlg : null,
        deleteFlg: this.kymw0900Model.preOrderFlag ? _.deleteFlg : null,
      });
    }
    return ret;
  }

  /**
   * 予約商品利用生協情報VOリストの取得
   *
   * @return 予約商品利用生協情報VO
   */
  private getPreOrderCoop(): any {
    const ret = [];
    for (const _ of this.kymw0900Model.preOrderDetailList) {
      for (const data of _.preOrderCoopList) {
        ret.push({
          preOrderDetailId: this.kymw0900Model.preOrderFlag ? _.preOrderDetailId : null,
          itemCode: this.kymw0900Model.preOrderFlag ? _.itemCode : null,
          coopCode: this.kymw0900Model.preOrderFlag ? data.coopCode : null,
          planNum: this.kymw0900Model.preOrderFlag ? data.planNum : null,
          registFlg: this.kymw0900Model.preOrderFlag ? data.registFlg : null,
          deleteFlg: this.kymw0900Model.preOrderFlag ? data.deleteFlg : null,
        });
      }
    }
    return ret;
  }

  /**
   * CWS商品企画アイコン指示情報VOリストの取得
   *  @return アイコン情報VO
   */
  public getCwsPlanGoodsIcon(): Array<any> {
    const iconReq = [];
    for (const _ of this.kymw0900Model.iconList) {
      iconReq.push({
        // 受注コード（管理クラスから取得）
        orderCode: this.kymw0900Model.orderCode,
        // Ｐコード（管理クラスから取得）
        pCode: this.kymw0900Model.pCode,
        iconCode: _.iconCode,
        arrangeDiv: _.arrangeDiv == '上部' ? '0' : '1',
        publishOrder: _.publishOrder,
        icon0: _.icon0 ? '1' : '0',
        icon1: _.icon1 ? '1' : '0',
        icon2: _.icon2 ? '1' : '0',
        icon3: _.icon3 ? '1' : '0',
        icon4: _.icon4 ? '1' : '0',
        icon5: _.icon5 ? '1' : '0',
        icon6: _.icon6 ? '1' : '0',
        icon7: _.icon7 ? '1' : '0',
      })
    }
    return iconReq;
  }

  /**
 * 【Ｐコード共通】
 * 小分類コードコンボボックス変更イベントリスナ
 * @param e イベント
 */
  public eventSmallClassCode_CHANGEHandler(e: Event): void {

    const vo: ConsumeTaxRequestModel = new ConsumeTaxRequestModel();

    // 消費税率取得リクエストVOにセットする
    vo.classCode = this.cmb_ClassCode.selectedClassCode;					// 部門コード
    vo.smallClassCode = this.cmb_SmallClassCodeList.selectedSmallClassCode;	// 小分類コード
    vo.delivCatalogID = this.kymw0900Model.delivCatalogID;					// 配達企画回

    this.getDefaultConsumeTaxInfoService.execute(this.kymw0900Model, vo);
  }

  /**
   * 【Ｐコード共通】
   * 「閉じる」ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClose_CLICKHandler(e: Event): void {

    if (0 < this.editCount) {
      this.dialogServiceSub.openAlertGetMessage('Q0110', [''],
        (closeDetail) => { // はいを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            this.closeWindow();
          }
        }
      );
    } else {
      this.closeWindow();
    }

    // 初期表示時の画面制御処理2.①で設けたロック成功フラグがtrueの場合、初期表示時にかけた自身のロックを解除する
    if (this.kymw0900Model.lockSucceeded) {
      this.LockUtilForPlanGoods('RELEASE',
        this.kymw0900Model.orderCode, this.kymw0900Model.mediumType, this.kymw0900Model.pCode,
        null, this.componentName,
        null, this.componentName,
        false);
    }
  }

  /**
   * 閉じる処理を行う
   * @param e イベント
   */
  private closeWindow(): void {
    const pCode: string = this.kymw0900Model.pCode;
    const orderCode: string = this.kymw0900Model.orderCode;

    // VOにセット
    const outputVO: KYMW0900OutputModel = new KYMW0900OutputModel();
    outputVO.pCode = pCode;

    // 変更管理テーブルのクリア
    this.clearPlanGoodsManage(pCode, orderCode, 'Close');
    this.setKYMW0900Parameter(outputVO);
    // 自画面を閉じる
    this.closeFunction();
  }

  /**
   * 【Ｐコード共通】
   * Ｐコードコンボボックス変更イベントリスナ
   * @param e イベント
   */
  public eventPCode_CHANGEHandler(e: Event): void {
    // 画面項目編集有無の確認
    // ①値変更フラグ（VO）が '0'（変更なし）の場合
    // ・何もしない（処理を継続する）
    // ②値変更フラグ（VO）が '1'（変更あり）の場合
    if (this.editCount > 0) {
      // ・該当Ｐコード商品の企画商品情報が変更されている場合は、警告メッセージの表示を行う。 ID=Q0107 %1='企画商品情報'
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['企画商品情報'],
        (closeDetail) => {
          if (<number>closeDetail === <number>PlessAlert.Yes) {
            // 商品企画メンテナンスデータの再取得
            this.requestPlanGoodsData(this.kymw0900Model.selectedPCode);
          } else {
            // 以下の処理をスキップする。（「部門」へカーソルを移動する）
            this.cmb_ClassCode.setFocus();
            for (let i = Number(0); i < this.kymw0900Model.pCodeList.length; i++) {
              const tmpPcode: string = this.kymw0900Model.pCodeList[i].PCode;
              if (tmpPcode === this.kymw0900Model.pCode) {
                this.cmb_PCode.nativeElement.selectedIndex = i;
                break;
              }
            }
          }
        });
    } else {
      // 商品企画メンテナンスデータの再取得
      this.requestPlanGoodsData(this.kymw0900Model.selectedPCode);
    }
  }

  /**
   * 【Ｐコード共通】
   * 部門コードコンボボックス変更イベントリスナ
   * @param e イベント
   */
  public eventClassCode_CHANGEHandler(): void {
    // ・部門コードチェック処理を行う。
    // 「01：農産」の場合、産地コメント1、2を入力可能にする。
    // 「01以外」の場合、産地コメント1、2を入力不可にする。
    this.kymw0900Model.changeHomeCommentProperties(this.cmb_ClassCode.selectedClassCode);
    this.dtg_CoopDetailList.editableCollectionView.refresh();
  }

  /**
   * 【Ｐコード共通】
   * 商品案内用商品名テキスト入力完了イベントリスナ
   * @param e イベント
   */
  public eventGuideGoodsName_FOCUS_OUTHandler(): void {
    // ・全角文字へ変換し、入力文字数のチェックを行う。(共通機能により処理：KYMW0900.mxml)
    // 下記の条件の場合、入力文字を他項目にコピーする。
    if (PlessViewUtilsSub.isEmpty(this.txti_DeliveryGoodsNameKanji.text)) {
      // ・「お届け明細書用商品名(漢字)」が空白の場合、入力文字（セット先の最大文字数分まで）をセットする。
      this.txti_DeliveryGoodsNameKanji.text = this.txti_GuideGoodsName.text.substr(0, 15);
    }
    if (PlessViewUtilsSub.isEmpty(this.txti_OcrGoodsName.text)) {
      // ・「ＯＣＲ商品名」が空白の場合、入力文字（セット先の最大文字数分まで）をセットする。
      this.txti_OcrGoodsName.text = this.txti_GuideGoodsName.text.substr(0, 16);
    }
  }

  /**
   * 【Ｐコード共通】
   * 商品案内用規格名テキスト入力完了イベントリスナ
   * @param e イベント
   */
  public eventGuideStandardName_FOCUS_OUTHandler(e: Event): void {
    // ・全角文字へ変換し、入力文字数のチェックを行う。(共通機能により処理：KYMW0900.mxml)
    // 下記の条件の場合、入力文字を他項目にコピーする。
    if (PlessViewUtilsSub.isEmpty(this.txti_DeliveryStandardNameKanji.text)) {
      // ・「お届け明細書用規格名(漢字)」が空白の場合、入力文字（セット先の最大文字数分まで）をセットする。
      this.txti_DeliveryStandardNameKanji.text = this.txti_GuideStandardName.text.substr(0, 10);
    }
  }

  /**
   * 【基本情報タブ】
   * 設定(関連Ｐコード)ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventConfig_CLICKHandler(e: Event): void {
    // ・関連商品設定インプットVOを作成し、『関連商品設定』画面を呼び出す。
    // 「関連商品設定ポップアップ用インプットVO」の生成
    const vo: KYMW0600InputModel = new KYMW0600InputModel();
    // VOに値を設定
    vo.pCode = this.kymw0900Model.pCode;		// Ｐコード
    const componentRef = this.dialogServiceSub.openModal(KYMW0600Component);
    const instance = componentRef.componentInstance as KYMW0600Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0600Parameter = (outputVo: KYMW0600OutputModel) => {
      // 関連商品設定画面を呼び出した場合
      this.setKYMW0600Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventConsumeTaxDivRate_FOCUS_OUTHandler(): void {
    // 画面背景色変更イベント
    this.kymw0900Model.backgroundColorChange();

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.consumeTaxDivRate)
      && this.kymw0900Model.consumeTaxDivRate !== this.kymw0900Model.defaultConsumeTaxRate) {
      // フォーカスを移動する。
      this.txti_DeliveryGoodsNameKanji.setFocus();

      // メッセージを表示する。（メッセージID：I0110）
      this.dialogServiceSub.openAlertGetMessage('I0110', ['']);
    }
  }

  /**
   * 詳細情報タブ「情報一覧」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 会員生協コード
   * @param enabled  活性：true、非活性：false
   */
  private setCoopDetailListEnabled(coopCode: string, enabled: boolean): void {

    // 現在表示中の詳細情報一覧（データグリッド）の設定
    const viewCoopDetailList = this.dtg_CoopDetailList.collectionView.items;

    const target = viewCoopDetailList.find(item => item.CoopCode === coopCode);
    // 非活性の場合は、注文コード割当コードをクリアする
    target.OrderNumQuotaCode = enabled ? target.OrderNumQuotaCode : '';

    this.kymw0900Model.coopDetailList = viewCoopDetailList;
    this.dtg_CoopDetailList.editableCollectionView.refresh();
  }


  /**
   * 【会員生協タブ】
   * 一括反映ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventBatchReflection_CLICKHandler(e: Event): void {

    // 「供給（今回）」「仕入（今回）」の入力チェックを行う。
    const insInputSupplyPrice: boolean = <boolean>PlessViewUtilsSub.isEmpty(this.kymw0900Model.allthistimeSupplyPrice);
    const insInputCostPrice: boolean = <boolean>PlessViewUtilsSub.isEmpty(this.kymw0900Model.allthistimeCostPrice);

    if (insInputSupplyPrice && insInputCostPrice && PlessViewUtilsSub.isEmpty(this.kymw0900Model.pricePatternLinkMarkCode)) {
      // HTML版は初期値空白
      // ・「供給（今回）」「仕入（今回）」両方が未入力状態の時、エラーメッセージを表示する。（ID=W0001 %1='供給（今回）または仕入（今回）'）
      this.dialogServiceSub.openAlertGetMessage('W0001', ['価格パターン/供給（今回）/仕入（今回）のいずれか']);
    } else {
      // ・「供給（今回）」「仕入（今回）」に数値以外の文字入力時、エラーメッセージを表示する。（ID=W0004 %1='供給（今回）または仕入（今回）'）
      const supplyPrice = Number(this.kymw0900Model.allthistimeSupplyPrice);
      const costPrice = Number(this.kymw0900Model.allthistimeCostPrice);

      // （数値以外（NaN）と0値をエラーにする）
      // 入力欄が数値入力制御であるため下記のエラー処理は不要？
      if (!(supplyPrice || costPrice) && PlessViewUtilsSub.isEmpty(this.kymw0900Model.pricePatternLinkMarkCode)) {
        this.dialogServiceSub.openAlertGetMessage('W0004', ['供給（今回）または仕入（今回）']);
      } else {
        const tmp: Array<any> = String(costPrice).split('.');

        if (tmp.length > 1 && tmp[1].length > 2) {
          // 小数点以下２桁を超えて入力された場合はエラー
          this.dialogServiceSub.openAlertGetMessage('W0015', ['仕入（今回）', '７', '２']);
        } else {
          // 管理クラスで価格一覧を一括反映
          this.kymw0900Model.reflectPriceList(this.dtg_PriceList.collectionView.items, supplyPrice, costPrice,
            this.kymw0900Model.pricePatternLinkMarkCode);
          this.dtg_PriceList.editableCollectionView.refresh();
        }
      }
    }

    // 「供給(今回)」に値が入力されている場合、今回供給価格.値変更時と同じ処理を行う
    for (const c of this.kymw0900Model.coopPriceList) {
      this.setPromotionThistimeSupplyPrice(this.dtg_PriceList, c);
    }
  }

  /**
   * 価格パターン一括設定
   *
   * @memberof KYMW0900Component
   */
  public pricePatternBtnClick(): void {
    if (this.cmb_PricePattern.nativeElement.selectedIndex !== 0) {
      setTimeout(() => {
        const selectPricePatterns = this.elementRef.nativeElement.querySelectorAll('#cmb_SelectPricePattern');
        for (let i = Number(0); i < selectPricePatterns.length; i++) {
          if (this.dtg_PriceList.collectionView.items[i].SelectValue) {
            selectPricePatterns[i].dispatchEvent(new CustomEvent('change', { detail: { index: i } }));
          }
        }
        // 「供給(今回)」に値が入力されている場合、今回供給価格.値変更時と同じ処理を行う
        for (const c of this.kymw0900Model.coopPriceList) {
          this.setPromotionThistimeSupplyPrice(this.dtg_PriceList, c);
        }
      }, 100);
    }
  }


  /**
   * 【付加情報タブ】
   * 商品説明リンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfo1_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    // ・返却情報より「商品説明」テキスト入力欄に文章をセットする。
    // 「文字情報選択ポップアップ用インプットVO」の生成
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '001';	                                      // 文字情報種別
    vo.formId = 'KYMW0900'; // 画面ＩＤ

    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【付加情報タブ】
   * キャッチコピーリンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfo2_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    // ・返却情報より「キャッチコピー」テキスト入力欄に文章をセットする。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '004';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';
    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【付加情報タブ】
   * おすすめコメント（吹き出し）リンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfo3_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    // ・返却情報より「おすすめコメント（吹き出し）」テキスト入力欄に文章をセットする。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '018';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';
    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【付加情報タブ】
   * 便利情報(サイズ他)リンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfo8_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    // ・返却情報より「便利情報(サイズ他)」テキスト入力欄に文章をセットする。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '024';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';
    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【付加情報タブ】
   * 取扱注意リンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfo9_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '003';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';
    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【付加情報タブ】
   * EC用商品説明リンククリックイベントリスナ
   * @param e イベント
   */
  public eventTextInfoB_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;		      // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '034';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';
    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（一括反映）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContentsAll_CLICKHandler(e: Event): void {
    // 組合員の声押下ボタンの識別コードを設定（一括反映）
    this.kymw0900Model.selectInquiryContentsButton = -1;
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    // ・返却情報より「組合員の声」テキスト表示欄に文章をセットする。
    const vo: KYMW0A00InputModel = new KYMW0A00InputModel();
    // VOに値を設定
    vo.formId = 'KYMW0900';		// 画面ID
    vo.pcodeList.push(this.kymw0900Model.selectedPCode);			 // Ｐコード
    vo.orderCode = this.kymw0900Model.orderCode;					// 受注コード
    vo.coopCode = '';	// 生協コード（指定しない？）
    vo.receiptNum = '';	// 受付番号（指定しない？）
    vo.orderGoodsFlg = '01';

    const componentRef = this.dialogServiceSub.openModal(KYMW0A00Component);
    const instance = componentRef.componentInstance as KYMW0A00Component;
    instance.dispDialog = true;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0A00Parameter = (outputVo: KYMW0A00OutputModel) => {
      // 画面から戻った場合
      this.setKYMW0A00Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【組合員の声タブ】
   * 一括反映ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventBatchReflectionAll_CLICKHandler(e: Event): void {
    // 下記の条件により、一括反映欄の「組合員の声」文章を各会員生協の「組合員の声」にコピー処理する。
    // ・一括反映欄の「組合員の声」文章をチェックする。

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsAll)
      && this.isPublishVoiceCoopSelected()) {
      // ②【一括反映欄の組合員の声文章指定あり】の場合
      // ・会員生協毎のチェックボックスがチェック状態にある生協に対して、指定した「組合員の声」の
      //  使用状況確認要求（/KYMW09/getPublishVoiceHistory.xml）をサーバへ送信し、各会員生協への
      //  コピーの可否を取得する。
      // ※同一受注コード、同一Ｐコード以外でチェックを行う。

      // チェック状態をKYMW090Manageに設定
      this.kymw0900Model.selectValueArray[0] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue1);
      this.kymw0900Model.selectValueArray[1] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue2);
      this.kymw0900Model.selectValueArray[2] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue3);
      this.kymw0900Model.selectValueArray[3] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue4);
      this.kymw0900Model.selectValueArray[4] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue5);
      this.kymw0900Model.selectValueArray[5] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue6);
      this.kymw0900Model.selectValueArray[6] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue7);
      this.kymw0900Model.selectValueArray[7] = PlessViewUtilsSub.booleanTOString(this.kymw0900Model.selectValue8);

      const publishVoiceHistoryRequestVO = new PublishVoiceHistoryRequestModel();
      publishVoiceHistoryRequestVO.orderCode = this.kymw0900Model.orderCode;
      publishVoiceHistoryRequestVO.pCode = this.kymw0900Model.pCode;
      publishVoiceHistoryRequestVO.receiptNum = this.kymw0900Model.receiptNumAll;
      const tempPublishVoiceArray: Array<any> = this.kymw0900Model.coopCodeArray;
      const coopInfoList: Array<any> = new Array<any>();

      for (let i = Number(0); i < tempPublishVoiceArray.length; i++) {
        const data = {
          CoopCode: this.kymw0900Model.coopCodeArray[i],
          CoopSelect: this.kymw0900Model.selectValueArray[i],
        };
        coopInfoList.push(data);
      }
      publishVoiceHistoryRequestVO.coopInfoList = coopInfoList;

      // 一括反映ボタン処理
      this.getPublishVoiceHistoryService.execute(this.kymw0900Model, publishVoiceHistoryRequestVO);
    }

  }

  /**
   * 【組合員の声タブ】
   * 「組合員の声掲載」に既存データありエラー表示
   */
  public showPublishVoiceErrorMessage(): void {
    // ID=E0164 %1='他で指定済み' %2='指定'
    this.dialogServiceSub.openAlertGetMessage('E0164', ['他で指定済み', '指定']);
  }

  /**
   * 【組合員の声タブ】
   * 各生協のチェックボックス選択が１つでも状態されているかどうかを判定
   * @return いずれかの生協が選択されている：true、どの生協も選択されていない：false
   */
  private isPublishVoiceCoopSelected(): boolean {
    // 会員生協のいずれかがチェックされている場合にtrue

    if (this.kymw0900Model.selectValue1 || this.kymw0900Model.selectValue2 ||
      this.kymw0900Model.selectValue3 || this.kymw0900Model.selectValue4 ||
      this.kymw0900Model.selectValue5 || this.kymw0900Model.selectValue6 ||
      this.kymw0900Model.selectValue7 || this.kymw0900Model.selectValue8) {
      return true;
    } else {
      return false;
    }
  }


  /**
   * 【組合員の声タブ】
   * 組合員の声（いばらき）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents1_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(0);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（とちぎ）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents2_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(1);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（ぐんま）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents3_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(2);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（ちば）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents4_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(3);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（さいたま）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents5_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(4);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（とうきょう）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents6_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(5);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（ながの）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents7_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(6);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（にいがた）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventInquiryContents8_CLICKHandler(e: Event): void {
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    this.setPublishVoice(7);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声（共通）ボタンクリックイベントリスナ
   * @param coopNum 各会員生協の順番（いばらき：0 ～ にいがた：7）
   */
  private setPublishVoice(coopNum: number): void {
    // 組合員の声押下ボタンの識別コードを設定
    this.kymw0900Model.selectInquiryContentsButton = coopNum;
    // 『組合員の声選択』画面（KYMW0A00）を呼び出し、文章を選択する。
    // ・返却情報より「組合員の声」テキスト表示欄に文章をセットする。
    // 返却情報を、組合員の声（『組合員の声選択』画面からの戻り値）に設定
    // 返却情報を、受付番号（『組合員の声選択』画面からの戻り値）に設定
    const vo: KYMW0A00InputModel = new KYMW0A00InputModel();
    // VOに値を設定
    vo.formId = 'KYMW0900';		// 画面ID
    vo.pcodeList.push(this.kymw0900Model.selectedPCode);			 // Ｐコード
    vo.orderCode = this.kymw0900Model.orderCode;				 // 受注コード
    vo.coopCode = this.kymw0900Model.coopCodeArray[coopNum];	 // 生協コード
    vo.receiptNum = this.kymw0900Model.receiptNumArray[coopNum]; // 受付番号
    vo.editLockInfo = this.inputVo.lockInfo;                         // 編集ロック情報
    vo.orderGoodsFlg = '01';
    const componentRef = this.dialogServiceSub.openModal(KYMW0A00Component);
    const instance = componentRef.componentInstance as KYMW0A00Component;
    instance.dispDialog = true;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0A00Parameter = (outputVo: KYMW0A00OutputModel) => {
      // 画面から戻った場合
      this.setKYMW0A00Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（いばらき）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents1_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[0])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue1 = false;
    this.clearPublishVoice(0);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（とちぎ）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents2_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[1])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue2 = false;
    this.clearPublishVoice(1);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（ぐんま）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents3_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[2])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue3 = false;
    this.clearPublishVoice(2);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（ちば）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents4_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[3])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue4 = false;
    this.clearPublishVoice(3);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（さいたま）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents5_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[4])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue5 = false;
    this.clearPublishVoice(4);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（とうきょう）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents6_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[5])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue6 = false;
    this.clearPublishVoice(5);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（ながの）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents7_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[6])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue7 = false;
    this.clearPublishVoice(6);
  }

  /**
   * 【組合員の声タブ】
   * 組合員の声クリア（にいがた）ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventClearContents8_CLICKHandler(e: Event): void {

    if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.inquiryContentsArray[7])) {
      // 編集カウントをインクリメント
      this.editCount++;
    }

    // 組合員の声の内容をクリア
    this.kymw0900Model.selectValue8 = false;
    this.clearPublishVoice(7);
  }

  /**
   * 【組合員の声タブ】
   * 特定会員生協の組合員の声情報をクリアする
   * @param coopNum 各会員生協の順番（いばらき：0 ～ にいがた：7）
   */
  private clearPublishVoice(coopNum: number): void {
    // 組合員の声をクリア
    this.kymw0900Model.inquiryContentsArray[coopNum] = '';
    // 受付番号をクリア
    this.kymw0900Model.receiptNumArray[coopNum] = '';
    // 生協選択ロックを解除
    this.kymw0900Model.selectLockArray[coopNum] = true;
  }

  /**
   * 【計画数タブ】
   * 計画数按分ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventPlanDistribution_CLICKHandler(e: Event): void {
    // 計画数一覧のデータを取得
    const planList: Array<any> = this.kymw0900Model.planList;
    // ①【「計画数（合計）」が未入力】の場合
    if (PlessViewUtilsSub.isEmpty(planList[0].Plannum)) {
      // エラーメッセージを表示する。(ID=W0004 %1='計画数（合計）'）
      this.dialogServiceSub.openAlertGetMessage('W0004', ['計画数（合計）']);
    } else {
      // ②【「計画数（合計）」が入力済】の場合      // ・入力不可状態にある会員生協は、「計画数」「限定数量総数」「限定数量個人」をクリアする。
      // → 会員生協タブのアイテムコード変更で実施

      // 計画数設定データ取得
      // ※要求区分：算出区分='1'（計画数按分）
      this.getPlanSetting(planList, '1');
    }
  }

  /**
   * 【計画数タブ】
   * 計画数自動設定ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventPlanAutoSetting_CLICKHandler(e: Event): void {
    // 計画数一覧のデータを取得
    const planList: Array<any> = this.kymw0900Model.planList;

    // PI値の取得
    const planPi: string = this.kymw0900Model.planPInum;

    // ①【「計画ＰＩ値」が未入力】の場合
    if (PlessViewUtilsSub.isEmpty(planPi)) {
      // エラーメッセージを表示する。(ID=W0004 %1='計画ＰＩ値'）
      this.dialogServiceSub.openAlertGetMessage('W0004', ['計画ＰＩ値']);
    } else {
      // ②【「計画ＰＩ値」が入力済】の場合
      // ・入力不可状態にある会員生協は、「計画数」「限定数量総数」「限定数量個人」をクリアする。
      // → 会員生協タブのアイテムコード変更で実施

      // 計画数設定データ取得
      // ※要求区分：算出区分='2'（計画数自動設定）
      this.getPlanSetting(planList, '2');
    }

  }

  /**
   * 【計画数タブ】
   * 計画数自動設定ボタンクリックイベントリスナ
   * @param planList 計画数一覧リスト
   * @param calcDiv 算出区分（計画数按分：'1'、計画数自動設定：'2'）
   */
  private getPlanSetting(planList: Array<any>, calcDiv: string): void {
    // ・「計画数（合計）」または「計画ＰＩ値」の入力値を基に計画数自動設定要求（/KYMW09/getCoopPlanNum.xml）
    //  をサーバーへ送信し、「計画数」「計画数（合計）」を画面にセットする。

    const coopPlanNumRequestVO: CoopPlanNumRequestModel = new CoopPlanNumRequestModel();
    // ※要求区分：算出区分パラメータ
    coopPlanNumRequestVO.calculationDiv = calcDiv;
    // ※媒体区分：入力パラメータの媒体区分を設定
    coopPlanNumRequestVO.mediumType = this.kymw0900Model.mediumType;
    // ※部門コード～中分類コード：画面設定値
    coopPlanNumRequestVO.classCode = this.kymw0900Model.classCode;
    coopPlanNumRequestVO.largeClassCode = this.kymw0900Model.largeClassCode;
    coopPlanNumRequestVO.middleClassCode = this.kymw0900Model.middleClassCode;
    // ※計画数（総数）：画面設定値
    coopPlanNumRequestVO.planNumTotal = planList[0].Plannum;
    // ※計画ＰＩ値：画面設定値
    coopPlanNumRequestVO.planPI = this.kymw0900Model.planPInum;

    // 生協コード、配達企画回、アイテムコード：会員生協タブ価格一覧からデータを取得
    const tempCoopInfoList: Array<any> = new Array<any>();
    const priceList: Array<any> = this.dtg_PriceList.collectionView.items;
    for (let i = Number(0); i < priceList.length; i++) {
      if (priceList[i].SelectValue) {
        const ob = {
          CoopCode: priceList[i].CoopCode,
          ItemCode: '',
          DelivCatalogID: '',
        };
        // 価格一覧のアイテムコードが未選択の場合
        if (PlessViewUtilsSub.isEmpty(priceList[i].SelectItemCode) || priceList[i].SelectItemCode === 0) {
          // アイテムコードと配達企画回は未設定
          ob.ItemCode = '';
          ob.DelivCatalogID = '';
        } else {
          // アイテムコードは価格一覧から設定
          ob.ItemCode = priceList[i].SelectItemCode;
          // 配達企画回は計画数一覧から設定（先頭行が合計行なので[i+1]行目）
          ob.DelivCatalogID = planList[i + 1].DelivCatalogID;
        }
        tempCoopInfoList.push(ob);
      }
    }
    coopPlanNumRequestVO.coopInfoList = tempCoopInfoList;
    // getCoopPlanNumServiceの呼び出し
    this.getCoopPlanNumService.execute(this.kymw0900Model, coopPlanNumRequestVO);

  }

  /**
   * 【計画数一覧】データグリッド アイテムフォーカスアウト時に呼び出されるメソッド
   *
   * @param event : Event
   */
  public eventPlanNumChange(event: Event): void {

    let i = 0;
    let j = 0;
    let tempSum: number = <number>0;
    const planNumRec: PlanNumRecModel = new PlanNumRecModel();
    const backNumRec: PlanNumRecModel = new PlanNumRecModel();
    const tempNumRec: PlanNumRecModel = new PlanNumRecModel();

    // 現在値と退避値を比較し、変更項目を取得する
    for (i = 0; i < this.kymw0900Model.planList.length; i++) {

      planNumRec.setXmlData(this.kymw0900Model.planList[i]);
      backNumRec.setXmlData(this.kymw0900Model.planListBackup[i]);

      if (Number(planNumRec.planNum) !== Number(backNumRec.planNum)) {
        // 計画数が変更された場合
        if (i > 0) {
          tempSum = 0;
          for (j = 1; j < this.kymw0900Model.planList.length; j++) {
            tempSum += Number(this.kymw0900Model.planList[j].Plannum);
          }
          tempNumRec.setXmlData(this.kymw0900Model.planList[0]);
          tempNumRec.planNum = String(tempSum);
          this.kymw0900Model.planList[0].Plannum = tempNumRec.planNum;
          this.kymw0900Model.planListBackup[0].Plannum = tempNumRec.planNum;
        }
        this.kymw0900Model.planListBackup[i].Plannum = this.kymw0900Model.planList[i].Plannum;
        break;
      } else if (Number(planNumRec.limitNumTotal) !== Number(backNumRec.limitNumTotal)) {
        // 限定数量総数が変更された場合
        tempSum = 0;
        for (j = 1; j < this.kymw0900Model.planList.length; j++) {
          tempSum += Number(this.kymw0900Model.planList[j].LimitnumTotal);
        }
        tempNumRec.setXmlData(this.kymw0900Model.planList[0]);
        tempNumRec.limitNumTotal = String(tempSum);
        this.kymw0900Model.planList[0].LimitnumTotal = tempNumRec.limitNumTotal;
        this.kymw0900Model.planListBackup[0].LimitnumTotal = tempNumRec.limitNumTotal;
        this.kymw0900Model.planListBackup[i].LimitnumTotal = this.kymw0900Model.planList[i].LimitnumTotal;
        break;
      } else if (Number(planNumRec.limitNumPerson) !== Number(backNumRec.limitNumPerson)) {
        // 限定数量個人が変更された場合
        this.kymw0900Model.planListBackup[i].LimitnumPerson = this.kymw0900Model.planList[i].LimitnumPerson;
        break;
      }
    }
    // event.preventDefault();
    this.dtg_PlanList.editableCollectionView.refresh();
  }

  /**
   * 【案内タブ】
   * 次回案内自動設定ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventSettingNextGuide_CLICKHandler(e: Event): void {
    // 「Ｐコード」（及び関連Ｐコード）の各会員生協の８週先までの選定状況を基に
    // 「次回案内」を編集し画面セットする。
    // ・サーバから取得した情報を画面に反映する。
    // ※画面編集定義（次回案内取得時）参照

    const nextGuideRequestVO: NextGuideRequestModel = new NextGuideRequestModel();
    // ※受注コード：入力パラメータの受注コード
    nextGuideRequestVO.orderCode = this.inputVo.orderCode;
    // ※Ｐコード：画面設定値
    nextGuideRequestVO.pCode = this.kymw0900Model.pCode;

    // getNextGuideサービス呼び出し
    this.getNextGuideService.execute(this.kymw0900Model, nextGuideRequestVO);
  }

  /**
   * 【詳細タブ：情報一覧】【案内タブ：案内一覧（EC列以外）】
   * 会員タブでチェックのついている生協が次回案内で活性となる（EC除く）
   * 媒体管理.業態区分='0'（いつでも注文）のとき「次回案内(次回案内用EC媒体区分)」を活性化する
   * 案内一覧：在庫限定フラグがtrueのとき非活性化する（html側で設定）
   */
  public getEnabledCoop(coopCode: string): boolean {
    // 業態区分が【0：いつでも注文媒体】の場合、活性化
    if (this.kymw0900Model.dutiesFormDiv === '0') {
      return true
    }
    for (const e of this.kymw0900Model.coopPriceList) {
      if (e.CoopCode === coopCode) {
        return e.SelectValue;
      }
    }
    return false
  }

  /**
   * 【案内タブ：案内一覧（EC列）】
   * 媒体管理.業態区分='0'（いつでも注文）のとき「次回案内(次回案内用EC媒体区分)」を活性化する
   * 1Nの情報があるとき、最小の1物N価詳細情報IDのデータで選択されていない生協区分を非活性とする
   * 予約情報があるとき、最小の予約詳細情報IDのデータで選択されていない生協区分を非活性とする
   * 案内一覧：在庫限定フラグがtrueのとき非活性化する（html側で設定）
   */
  public getEnabledNextGuideEC(coopCode: string, mediumType?: any): boolean {
    // 業態区分が【0：いつでも注文媒体】の場合、活性化
    if (this.kymw0900Model.dutiesFormDiv === '0') {
      return true
    }
    if (this.kymw0900Model.nvalPromotionFlg) {
      // 1Nの情報がある場合、価格一覧でアイテムコードが選択されていない生協区分を非活性とする
      const flg = !PlessViewUtilsSub.isEmpty(this.kymw0900Model.coopPriceList.find(cp => cp.CoopCode === coopCode).SelectItemCode);
      if (mediumType) {
        if (!flg) {
          this.kymw0900Model.guideList.map(_ => {
            // 非活性にする生協は次回案内を空にする
            if (_.CoopCode === coopCode) _.NextGuideMap[mediumType] = '';
          })
        }
      }
      return flg;
    } else if (!PlessViewUtilsSub.isEmptyArray(this.kymw0900Model.preOrderDetailListDisplay)) {
      // 1Nがなく予約の情報がある場合、通常媒体と同じ活性状態とする
      return this.getEnabledCoop(coopCode);
    }
    // 通常媒体のみのときのEC列は通常媒体と同じ活性状態とする
    return this.getEnabledCoop(coopCode);
  }

  /**
   * 【保健機能タブ】
   * 届出表示・許可表示リンククリックイベントリスナ
   * @param e イベント
   */
  public eventLicencedDescription_CLICKHandler(e: Event): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
    const vo: KYMW0700InputModel = new KYMW0700InputModel();
    // VOに値を設定
    vo.goodsCode = this.kymw0900Model.pCode;			  // Ｐコード
    vo.goodsName = this.kymw0900Model.guideGoodsName;		  // 商品名
    vo.guideGoodsName = this.kymw0900Model.guideStandardName; // 規格名
    vo.textKindId = '033';	                                      // 文字情報種別
    vo.formId = 'KYMW0900';

    const componentRef = this.dialogServiceSub.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.setInterfaceParam(vo);
    instance.parent = this;
    instance.setKYMW0700Parameter = (outputVo: KYMW0700OutputModel) => {
      // 文字情報選択画面から戻った場合
      this.setKYMW0700Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【EC設定タブ】
   * 在庫数イベントリスナ
   */
  public stockNum_CHANGEHandler(): void {
    this.editCount++;
    let sum = 0;
    for (const e of this.kymw0900Model.stockList) {
      if (e.coopName !== '合計') {
        sum = sum + Number(e.stockNum);
      }
    }
    for (const e of this.kymw0900Model.stockList) {
      if (e.coopName === '合計') {
        e.stockNum = String(sum);
        break;
      }
    }
    this.kymw0900Model.stockNumTotal = String(sum);
  }

  /**
   * 【EC設定タブ】
   * 通常価格イベントリスナ
   */
  public supplyPrice_CHANGEHandler(): void {
    this.editCount++;
  }

  /**
   * 【EC設定タブ】
   * 通常価格説明イベントリスナ
   */
  public supplyPriceExplanation_CHANGEHandler(): void {
    this.editCount++;
  }

  /**
   * 【EC設定タブ】
   * グルーピングコンボボックスイベントリスナ
   */
  public grouping_CHANGEHandler(): void {
    this.editCount++;
    if (PlessViewUtilsSub.isEmpty(this.kymw0900Model.groupingCode) || this.kymw0900Model.groupingCode === 'blankVal') {
      // 空欄を選択したとき表をクリアする
      this.kymw0900Model.groupingList = [];
      // グルーピングコードの値を空文字に変更する（APIエラー回避のため）
      this.kymw0900Model.groupingCode = '';
    } else {
      // 空欄以外を選択したときAPI実行
      const vo = new GetGroupingDataRequestModel();
      vo.groupingCode = this.kymw0900Model.groupingCode;
      this.getGroupingDataService.execute(this.kymw0900Model, vo);
    }
  }

  /**
   * 【EC設定タブ】
   * 検索ボタンイベントリスナ
   */
  public eventECSearch_CLICKHandler(): void {
    const vo: KYMW0F00InputModel = new KYMW0F00InputModel();
    vo.EnableCoop142 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_IB) ? '0' : '2';
    vo.EnableCoop163 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TO) ? '0' : '2';
    vo.EnableCoop185 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_GU) ? '0' : '2';
    vo.EnableCoop240 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TI) ? '0' : '2';
    vo.EnableCoop210 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_SA) ? '0' : '2';
    vo.EnableCoop302 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TK) ? '0' : '2';
    vo.EnableCoop515 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_NA) ? '0' : '2';
    vo.EnableCoop451 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_NI) ? '0' : '2';

    const componentRef = this.dialogServiceSub.openModal(KYMW0F00Component);
    const instance = componentRef.componentInstance as KYMW0F00Component;
    instance.parent = this;
    instance.setKYMW0F00Parameter = (outputVO: KYMW0F00OutputModel) => {
      this.kymw0900Model.groupingCode = outputVO.groupingCode;
      this.grouping_CHANGEHandler();
    };
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【EC設定タブ】
   * 注文トランコンボボックスイベントリスナ
   */
  public orderGoodsDiv_CHANGEHandler(): void {
    this.editCount++;
  }

  /**
   * 【EC設定タブ】
   * 指示ボタンイベントリスナ
   */
  public eventInstructions_CLICKHandler(): void {
    const selectedCoopCode = this.kymw0900Model.selectCoopImage;
    const vo: KYMW5002InputModel = new KYMW5002InputModel();
    vo.flg = '2';
    vo.orderCode = this.kymw0900Model.orderCode;
    vo.pcode = this.kymw0900Model.pCode;
    vo.pushCoopCode = selectedCoopCode;
    vo.goodsName = this.kymw0900Model.guideGoodsName;
    vo.goodsStandardName = this.kymw0900Model.guideStandardName;
    vo.enableCoopCodeVOList = this.kymw0900Model.enableCoopList.map((_) => {
      return {
        enableCoopCode: _
      }
    });

    let imageList;
    for (const e of this.kymw0900Model.imageList) {
      if (e.coopCode === selectedCoopCode) {
        imageList = e.coopImageList;
        break;
      }
    }
    vo.useImageInfoVOList = imageList.map((_) => {
      return {
        ImageId: _.imageId,
        ImageName: _.imageName,
        ImageFileName: _.imageFileName,
        StartOrderCode: _.startOrderCode,
        ShowSeq: _.showSeq,
        ImageURL: _.imagePreviewUrl,
        TextCaption: _.textCaption,
      }
    });

    vo.selectCoopInfoVOList = [{
      selectCoopCode: selectedCoopCode
    }];

    const componentRef = this.dialogServiceSub.openModal(KYMW5002Component);
    const instance = componentRef.componentInstance as KYMW5002Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW5002Parameter = (outputVO: KYMW5002OutputModel) => {
      const imageList = outputVO.useImageInfoVOList.map((_) => {
        return {
          imageId: _.ImageId,
          imageName: _.ImageName,
          imageFileName: _.ImageFileName,
          startOrderCode: _.StartOrderCode,
          showSeq: _.ShowSeq,
          imagePreviewUrl: _.ImageURL,
          textCaption: _.TextCaption,
        }
      })
      for (const e of outputVO.selectCoopInfoVOList) {
        for (const ee of this.kymw0900Model.imageList) {
          if (e.selectCoopCode === ee.coopCode) {
            ee.coopImageList = imageList;
          }
        }
      }
      // EC使用画像情報再取得
      const imageDataVo = new GetImageDataRequestModel();
      imageDataVo.orderCode = this.kymw0900Model.orderCode;
      imageDataVo.pCode = this.kymw0900Model.pCode;
      this.getImageDataService.execute(this.kymw0900Model, imageDataVo, () => {
        setTimeout(() => {
          // 画像リスト表示幅の調整
          let maxLength = 0;
          for (const key of Object.keys(this.kymw0900Model.imageMap)) {
            if (maxLength < this.kymw0900Model.imageMap[key].length) {
              maxLength = this.kymw0900Model.imageMap[key].length;
            }
          }
          if (maxLength > 5) {
            this.dtg_ECImage.columns[2].width = 135 * maxLength;
          }
        }, 500);
      });
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【EC設定タブ】
   * 全生協にコピーコンテキストメニューイベントリスナ
   */
  public copyStock_CLICKHandler(): void {
    this.editCount++;
    const selectedItem = this.kymw0900Model.stockList[this.dtg_StockList.selectedRows[0]._idx];
    for (const e of this.kymw0900Model.stockList) {
      // 取扱生協で自生協以外の場合、コピーする
      if (this.kymw0900Model.isEnabledCoop(e.coopCode) && e.coopCode !== selectedItem.coopCode) {
        e.supplyPrice = selectedItem.supplyPrice;
        e.supplyPriceExplanation = selectedItem.supplyPriceExplanation;
      }
    }
  }

  /**
   * 【予約設定タブ】
   * 追加ボタンイベントリスナ
   */
  public eventPreOrderListAdd_CLICKHandler(): void {
    // 専用商品名付加文字
    const addChar = {
      list: []
    };

    this.getCodeListService.execute('ctp395', '', addChar, 'list', () => {
      const componentRef = this.dialogServiceSub.openModal(KYMW0906Component);
      const instance = componentRef.componentInstance as KYMW0906Component;
      instance.parent = this;
      const vo = new KYMW0906InputModel();
      // モード：追加
      vo.mode = KYMW0906InputModel.MODO_ADD;

      // 予約設定タブの一覧表で登録済みの配達企画回とアイテムコード
      vo.registeredDeliveryCatalogAndItemCodeList = this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
        return {
          delivCatalog: _.delivCatalogId,
          itemCode: _.itemCode
        }
      })

      // 束ね企画回の終了受注コード
      vo.bundleEndDeliveryOrder = this.kymw0900Model.bundleCatalogOrderCode;

      // アイテムコードリスト
      vo.itemCodeList = this.kymw0900Model.itemCodeList;
      // アイテムコードに紐づく会員生協
      vo.itemRelatedCoop = this.itemRelatedCoop;
      vo.itemRelatedCoop_CoopTab = this.itemRelatedCoop_CoopTab;

      // 注文コードは付番前のため空
      vo.orderNum = '';

      // 生協コードの非活性制御
      // 設定済みの生協コードを取得
      this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
        let settedCoopList = [];
        _.preOrderCoopList.map(c => {
          if (c.checked || !PlessViewUtilsSub.isEmpty(c.planNum)) {
            settedCoopList.push(c.coopCode);
          }
        });
        vo.enableCoopByItemCodeList.push({
          DelivCatalog: _.delivCatalogId,
          ItemCode: _.itemCode,
          DisableCoopCodeList: settedCoopList
        });
      })

      // 生協とアイテムコードに関連する生協コード
      this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
        vo.catalogAndItemRelatedCoop.push({
          delivCatalogId: _.delivCatalogId,
          itemCode: _.itemCode,
          preOrderCoopList: _.preOrderCoopList
        });
      });

      // 注文コード割当リスト
      vo.preOrderOrderNumQuotaCodeList = this.kymw0900Model.preOrderOrderNumQuotaCodeList;
      // 専用商品名
      if (addChar.list.length > 0) {
        vo.preOrderGoodsName = addChar.list[0].CodeName + this.kymw0900Model.deliveryGoodsNameKanji;
      } else {
        vo.preOrderGoodsName = this.kymw0900Model.deliveryGoodsNameKanji;
      }
      // 専用商品名(カナ)
      vo.preOrderGoodsNameKana = this.kymw0900Model.deliveryGoodsNameKana;
      // 専用規格名
      vo.preOrderStandardName = this.kymw0900Model.deliveryStandardNameKanji;
      // 専用規格名(カナ)
      vo.preOrderStandardNameKana = this.kymw0900Model.deliveryStandardNameKana;

      // 追加時は一つ目のデータの値引前供給単価を渡す
      vo.supplyPriceStandard = this.kymw0900Model.preOrderDetailListDisplay[0]?.supplyPriceStandard;
      // 追加時は値引後供給単価に値引前供給単価を格納
      vo.discountSupplyUnitPrice = vo.supplyPriceStandard;
      const enabledCoopList = this.itemRelatedCoop_CoopTab.filter(_ => _.ItemCode == vo.itemCodeList[0]?.ItemCode).map(_ => _.CoopCode);
      // 商品計画数予測リスト
      this.kymw0900Model.goodsPlanNumList = [];
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'いばらき',
        coopCode: '142',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('142')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'とちぎ',
        coopCode: '163',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('163')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'ぐんま',
        coopCode: '185',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('185')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'ちば',
        coopCode: '240',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('240')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'さいたま',
        coopCode: '210',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('210')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'とうきょう',
        coopCode: '302',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('302')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'ながの',
        coopCode: '515',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('515')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: 'にいがた',
        coopCode: '451',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: enabledCoopList.includes('451')
      });
      this.kymw0900Model.goodsPlanNumList.push({
        coopName: '合計',
        coopCode: '',
        planNum: 0,
        registFlg: '0',
        deleteFlg: '0',
        checked: false
      });
      vo.goodsPlanNumList = this.kymw0900Model.goodsPlanNumList;

      // アイテムコードリストの一つ目の項目を選択
      vo.selectedItemCode = vo.itemCodeList[0]?.ItemCode;
      // 注文コード割当リストの一つ目の項目を選択
      vo.preOrderNumQuotaCode = vo.preOrderOrderNumQuotaCodeList[0]?.OrderNumQuotaCode;

      // 価格パターンに対応する供給単価リスト
      vo.preOrderSupplyPriceList = this.kymw0900Model.preOrderSupplyPriceList;

      // 価格一覧でアイテムコードが選択されている生協リスト
      vo.enabledCoopList = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);

      instance.setInterfaceParam(vo);
      instance.setKYMW0906Parameter = (outputVO: KYMW0906OutputModel) => {
        // 表に追加
        // 予約詳細情報IDの設定
        let newPreOrderDetailId = 1;
        for (const e of this.kymw0900Model.preOrderDetailList) {
          if (e.itemCode === outputVO.selectedItemCode) {
            if (newPreOrderDetailId <= e.preOrderDetailId) {
              newPreOrderDetailId = Number(e.preOrderDetailId) + 1;
            }
          }
        }

        // 追加データを格納
        const addData = {
          preOrderDetailId: String(newPreOrderDetailId),
          itemCode: outputVO.selectedItemCode,
          preOrderNumQuotaCode: outputVO.preOrderNumQuotaCode,
          preOrderNum: outputVO.orderNum,
          delivCatalogId: outputVO.deliveryCatalog,
          delivMonday: outputVO.delivMonday,
          delivTuesday: outputVO.delivTuesday,
          delivWednesday: outputVO.delivWednesday,
          delivThursday: outputVO.delivThursday,
          delivFriday: outputVO.delivFriday,
          preOrderGoodsName: outputVO.preOrderGoodsName,
          preOrderGoodsNameKana: outputVO.preOrderGoodsNameKana,
          preOrderStandardName: outputVO.preOrderStandardName,
          preOrderStandardNameKana: outputVO.preOrderStandardNameKana,
          discountType: outputVO.discountType,
          discountUnitPrice: outputVO.discountUnitPrice,
          discountRate: outputVO.discountRate,
          discountSupplyUnitPrice: outputVO.discountSupplyUnitPrice,
          preOrderPoints: outputVO.preOrderPoints,
          setPreOrderType: outputVO.setPreOrderType,
          pricePattern: outputVO.pricePattern,
          supplyPriceStandard: outputVO.supplyPriceStandard,
          preOrderCoopList: outputVO.goodsPlanNumList,
          registFlg: '1',
          deleteFlg: '0',
        }
        this.kymw0900Model.preOrderDetailList = [...this.kymw0900Model.preOrderDetailList, addData];
        this.kymw0900Model.preOrderDetailListDisplay = [...this.kymw0900Model.preOrderDetailListDisplay, addData];
        this.dtg_PreOrderDetailList.refresh();
        this.editCount++;
      };
      instance.closeFunction = () => {
        componentRef.close();
      };
    }, null, this.kymw0900Model.mediumType); // getCodeListで使う媒体区分
  }

  /**
   * 【予約設定タブ】
   * 詳細コンテキストメニューイベントリスナ
   */
  public detailPreOrderDetailList_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0906Component);
    const instance = componentRef.componentInstance as KYMW0906Component;
    instance.parent = this;
    // 選択行
    const index = this.dtg_PreOrderDetailList.selectedRows[0].index;
    // 選択したデータ
    const item = this.kymw0900Model.preOrderDetailListDisplay[index];
    // 選択したデータの詳細情報ID
    const selectedPreOrderDetailId = item.preOrderDetailId;
    // 選択したデータのアイテムコード（モーダル側で変更はできないが念のため最初に保持）
    const selectedItemCode = item.itemCode;

    // kymw0906：予約商品設定InputVO
    const vo = new KYMW0906InputModel();
    // モード：
    if (this.kymw0900Model.permission === '1') {
      // 閲覧権限
      vo.mode = KYMW0906InputModel.MODO_READ_ONLY;
    } else {
      // 詳細
      vo.mode = KYMW0906InputModel.MODO_DETAIL;
    }
    // 追加したデータかどうかを確認
    const addFlg = item.registFlg === '1';

    // 予約設定タブの一覧表で登録済みの配達企画回とアイテムコード
    vo.registeredDeliveryCatalogAndItemCodeList = this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
      return {
        delivCatalog: _.delivCatalogId,
        itemCode: _.itemCode
      }
    });

    // 束ね企画回の終了受注コード
    vo.bundleEndDeliveryOrder = this.kymw0900Model.bundleCatalogOrderCode;

    // アイテムコードリスト
    vo.itemCodeList = [{ ItemCode: item.itemCode }]

    // 生協コードの非活性制御
    let settedCoopList = [];
    // 選択したアイテムコード以外で設定済みの生協コードを取得
    this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
      if (_.itemCode !== item.itemCode && _.delivCatalogId === item.delivCatalogId) {
        _.preOrderCoopList.map(c => {
          if (c.checked || !PlessViewUtilsSub.isEmpty(c.planNum)) {
            settedCoopList.push(c.coopCode);
          }
        })
      }
    })
    this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
      vo.enableCoopByItemCodeList.push({
        DelivCatalog: _.delivCatalogId,
        ItemCode: _.itemCode,
        DisableCoopCodeList: settedCoopList
      });
    })

    // 生協とアイテムコードに関連する生協コード
    this.kymw0900Model.preOrderDetailListDisplay.map(_ => {
      vo.catalogAndItemRelatedCoop.push({
        delivCatalogId: _.delivCatalogId,
        itemCode: _.itemCode,
        preOrderCoopList: _.preOrderCoopList
      });
    });

    // アイコンコードに紐づく会員生協
    vo.itemRelatedCoop = this.itemRelatedCoop;

    // 注文コード割当リスト
    vo.preOrderOrderNumQuotaCodeList = this.kymw0900Model.preOrderOrderNumQuotaCodeList;

    // 商品計画数予測リスト
    this.kymw0900Model.goodsPlanNumList = [];
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'いばらき',
      coopCode: '142',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '142')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '142')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '142')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'とちぎ',
      coopCode: '163',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '163')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '163')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '163')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'ぐんま',
      coopCode: '185',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '185')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '185')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '185')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'ちば',
      coopCode: '240',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '240')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '240')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '240')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'さいたま',
      coopCode: '210',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '210')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '210')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '210')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'とうきょう',
      coopCode: '302',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '302')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '302')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '302')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'ながの',
      coopCode: '515',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '515')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '515')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '515')?.checked
    });
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: 'にいがた',
      coopCode: '451',
      planNum: item.preOrderCoopList.find(_ => _.coopCode === '451')?.planNum,
      registFlg: item.preOrderCoopList.find(_ => _.coopCode === '451')?.registFlg,
      deleteFlg: '0',
      checked: item.preOrderCoopList.find(_ => _.coopCode === '451')?.checked
    });

    let total = 0;
    for (const e of item.preOrderCoopList) {
      total = total + Number(e.planNum);
    }
    this.kymw0900Model.goodsPlanNumList.push({
      coopName: '合計',
      coopCode: '',
      planNum: String(total),
      registFlg: '0',
      deleteFlg: '0',
      checked: false
    });
    vo.goodsPlanNumList = this.kymw0900Model.goodsPlanNumList;

    // 選択行の配達企画回
    vo.deliveryCatalog = item.delivCatalogId;
    // 選択行のアイテムコード
    vo.selectedItemCode = item.itemCode;
    // 選択行の注文コード割当
    vo.preOrderNumQuotaCode = item.preOrderNumQuotaCode;
    // 選択行の注文コード
    vo.orderNum = item.preOrderNum;
    // 選択行の配達企画曜日
    vo.delivMonday = item.delivMonday;
    vo.delivTuesday = item.delivTuesday;
    vo.delivWednesday = item.delivWednesday;
    vo.delivThursday = item.delivThursday;
    vo.delivFriday = item.delivFriday;
    // 専用商品名
    vo.preOrderGoodsName = item.preOrderGoodsName;
    // 専用商品名（カナ）
    vo.preOrderGoodsNameKana = item.preOrderGoodsNameKana;
    // 専用規格名
    vo.preOrderStandardName = item.preOrderStandardName;
    // 専用規格名（カナ）
    vo.preOrderStandardNameKana = item.preOrderStandardNameKana;
    // セット企画
    vo.setPreOrderType = item.setPreOrderType;
    // 値引前供給単価
    vo.supplyPriceStandard = this.kymw0900Model.preOrderDetailListDisplay[index].supplyPriceStandard;
    // 値引区分
    vo.discountType = item.discountType;
    // 値引単価
    vo.discountUnitPrice = item.discountUnitPrice;
    // 値引率
    vo.discountRate = item.discountRate;
    // 値引後供給単価
    vo.discountSupplyUnitPrice = item.discountSupplyUnitPrice;
    // ポイント数
    vo.preOrderPoints = item.preOrderPoints;
    // 価格パターン
    vo.pricePattern = item.pricePattern;
    // 価格パターンに対応する供給単価リスト
    vo.preOrderSupplyPriceList = this.kymw0900Model.preOrderSupplyPriceList;
    // 価格一覧でアイテムコードが選択されている生協リスト
    vo.enabledCoopList = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);

    instance.setInterfaceParam(vo);
    instance.setKYMW0906Parameter = (outputVO: KYMW0906OutputModel) => {
      // 表を更新
      const updateData = {
        preOrderDetailId: selectedPreOrderDetailId,
        itemCode: outputVO.selectedItemCode,
        preOrderNumQuotaCode: outputVO.preOrderNumQuotaCode,
        preOrderNum: outputVO.orderNum,
        delivCatalogId: outputVO.deliveryCatalog,
        delivMonday: outputVO.delivMonday,
        delivTuesday: outputVO.delivTuesday,
        delivWednesday: outputVO.delivWednesday,
        delivThursday: outputVO.delivThursday,
        delivFriday: outputVO.delivFriday,
        preOrderGoodsName: outputVO.preOrderGoodsName,
        preOrderGoodsNameKana: outputVO.preOrderGoodsNameKana,
        preOrderStandardName: outputVO.preOrderStandardName,
        preOrderStandardNameKana: outputVO.preOrderStandardNameKana,
        discountType: outputVO.discountType,
        discountUnitPrice: outputVO.discountUnitPrice,
        discountRate: outputVO.discountRate,
        discountSupplyUnitPrice: outputVO.discountSupplyUnitPrice,
        preOrderPoints: outputVO.preOrderPoints,
        setPreOrderType: outputVO.setPreOrderType,
        pricePattern: outputVO.pricePattern,
        supplyPriceStandard: outputVO.supplyPriceStandard,
        preOrderCoopList: outputVO.goodsPlanNumList,
        registFlg: addFlg ? '1' : '0',
        deleteFlg: '0',
      }
      // 保持用
      this.kymw0900Model.preOrderDetailList.forEach((data, index) => {
        // 選択したデータの予約詳細情報ID、アイテムコードが一致するデータに対して変更を行う
        if (selectedPreOrderDetailId === data.preOrderDetailId && selectedItemCode === data.itemCode) {
          for (const key of Object.keys(data)) {
            this.kymw0900Model.preOrderDetailList[index][key] = updateData[key];
          }
        }
      })
      // 表示用
      for (const key of Object.keys(this.kymw0900Model.preOrderDetailListDisplay[index])) {
        this.kymw0900Model.preOrderDetailListDisplay[index][key] = updateData[key];
      }
      this.dtg_PreOrderDetailList.refresh();
      this.editCount++;
    };
    instance.closeFunction = () => {
      componentRef.close();
    }
  }

  /**
   * 【予約設定タブ】
   * 削除コンテキストメニューイベントリスナ
   */
  public deletePreOrderDetailList_CLICKHandler(): void {
    const index = this.dtg_PreOrderDetailList.selectedRows[0].index;
    const item = this.kymw0900Model.preOrderDetailListDisplay[index];
    // 削除対象の予約詳細情報IDとアイテムコードを保持
    const deletedPreOrderDetailId = item.preOrderDetailId;
    const deletedItemCode = item.itemCode;
    this.kymw0900Model.preOrderDetailListDisplay.splice(index, 1);
    this.kymw0900Model.preOrderDetailListDisplay = [...this.kymw0900Model.preOrderDetailListDisplay];
    this.dtg_PreOrderDetailList.refresh();

    let counter = 0;
    let deleteIndex = null;
    for (const e of this.kymw0900Model.preOrderDetailList) {
      // 予約詳細情報ID、アイテムコードで削除対象を判定
      if (deletedPreOrderDetailId === e.preOrderDetailId && deletedItemCode === e.itemCode) {
        if (e.registFlg === '1') {
          // 追加して削除したものは表示元リストからも削除
          deleteIndex = counter;
          if (this.editCount > 0) {
            this.editCount--;
          }
        } else {
          // 削除を指示したデータの全ての削除フラグに1を設定
          e.deleteFlg = '1';
          this.editCount++;
          e.preOrderCoopList.map(c => {
            c.deleteFlg = '1';
          });
          // 削除を指示したデータの予約商品情報と予約商品利用生協情報リストの
          // アイテムコード、生協コード以外のパラメータを初期状態（NULL）とする
          e.preOrderNumQuotaCode = '';
          e.preOrderNum = '';
          e.delivCatalogId = '';
          e.delivMonday = '';
          e.delivTuesday = '';
          e.delivWednesday = '';
          e.delivThursday = '';
          e.delivFriday = '';
          e.preOrderGoodsName = '';
          e.preOrderGoodsNameKana = '';
          e.preOrderStandardName = '';
          e.preOrderStandardNameKana = '';
          e.discountType = '';
          e.discountUnitPrice = '';
          e.discountRate = '';
          e.discountSupplyUnitPrice = '';
          e.preOrderPoints = '';
          e.setPreOrderType = false;
          e.preOrderCoopList.map(c => {
            c.oopName = '';
            c.planNum = 0;
          })
        }
        break;
      }
      counter = counter + 1;
    }
    if (deleteIndex !== null) {
      this.kymw0900Model.preOrderDetailList.splice(deleteIndex, 1);
    }
  }

  /**
   * 詳細タブのアイテムコード変更処理
   *
   * @param {Event} event
   * @param {FlexGrid} grid
   * @memberof KYMW0900Component
   */
  public updateCoopRelateData(event: Event, grid: FlexGrid) {
    // 選択行を取得
    const selectedRow = grid.selection.row;
    const selectedCoop: string = this.kymw0900Model.coopPriceList[selectedRow].CoopCode;
    const selectItemCode: string = this.kymw0900Model.coopPriceList[selectedRow].SelectItemCode;
    const selectedNum: string = this.kymw0900Model.coopPriceList[selectedRow].CoopNum;

    // updateCoopRelateData呼出し
    this.kymw0900Model.updateCoopRelateData(selectedCoop, selectItemCode, selectedNum);

    setTimeout(() => {
      this.dtg_CoopMarkList.editableCollectionView.refresh();
      this.dtg_PriceList.editableCollectionView.refresh();
      this.dtg_CoopDetailList.editableCollectionView.refresh();
      this.dtg_PlanList.editableCollectionView.refresh();
      this.dtg_GuideList.editableCollectionView.refresh();
    });
  }

  /**
   * 【アイテムコード共通】
   * アイテムコードコンボボックス変更イベントリスナ
   * @param e イベント
   */
  public eventItemCode_CHANGEHandler(e: Event): void {
    // ・選択アイテムコードを基に「JANコード」をセットする。
    // ・選択アイテムコードを基に「アイテムタブ情報」を画面に反映する。
    // ・選択アイテムコードを基に「仕様書１タブ情報」を画面に反映する。
    // ・選択アイテムコードを基に「仕様書２タブ情報」を画面に反映する。
    // ・選択アイテムコードを基に「環境タブ情報」を画面に反映する。
    const nowEditCount: number = this.editCount;
    this.kymw0900Model.changeItemInfoEditArea(this.kymw0900Model.selectedItemCode);
    if (nowEditCount < 1) {
      this.editCount = 0;
    }
    this.chk_JanCodeDiv.selected = this.kymw0900Model.janCodeDiv;

    // 栄養成分タブの分析単位数を取得
    const cnt: number = this.kymw0900Model.hiddenNutrientComponentList.length;
    // 複数栄養成分タブの分析単位数を取得
    const cntMulti: number = this.kymw0900Model.hiddenNutrientComponentListMulti.length;

    // 栄養成分タブの分析単位数が1件(以上)存在する場合
    if (cnt > 0) {
      // 分析単位データグリッドの1行目に位置づけ
      this.dtg_NutrientUnitList.select(0, 0);
    }

    // 複数栄養成分タブの分析単位数が1件以上存在する場合
    if (cntMulti > 0) {
      // 分析単位データグリッドの1行目に位置づけ
      this.dtg_NutrientUnitListMulti.select(0, 0);
      // 栄養成分タブの複数栄養成分ありチェックボックスをOnにする
      this.chk_HasMultiNutrientInfo.selected = true;
      this.kymw0900Model.hasMultiNutrientInfo = true;
      this.cnv_MultiNutrientTab.isDisabled = false;		// タブを活性にする
    } else {
      // 複数栄養成分タブの分析単位数が0件の場合
      // 選択中のタブの位置を取得
      const selectedTabIdx: number = this.tab_item.selectedIndex;
      // 複数栄養成分タブの場合
      if (selectedTabIdx === 5) {
        // 栄養成分タブへ強制移動
        this.tab_item.selectedIndex = 4;
        // 栄養成分タブの複数栄養成分ありチェックボックスをOffにする
      }
      this.cnv_MultiNutrientTab.isDisabled = true;		// タブを非活性にする
      this.chk_HasMultiNutrientInfo.selected = false;
      this.kymw0900Model.hasMultiNutrientInfo = false;
    }
  }

  /**
   * 【アイテムタブ】
   * 発注先取引先テキスト入力完了イベントリスナ
   * @param e イベント
   */
  public eventOrderClientCode_FOCUS_OUTHandler(e: Event): void {

    // ・「発注先取引先コード」の入力値を基に取引先確認要求（/KYMW09/getSupplier.xml）をサーバへ送信し、
    //  「取引先名称」を取得する。
    const supplierRequestVO: SupplierRequestVO = new SupplierRequestVO();
    // ※取引先コード：画面設定値
    supplierRequestVO.supplier = this.kymw0900Model.orderClientCode;
    supplierRequestVO.flag = '0';

    // getSupplierServiceサービス呼び出し
    this.getSupplierService.execute(this.kymw0900Model, supplierRequestVO);
  }

  /**
   * 【アイテムタブ】
   * 発注先取引先検索ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventOrderClientCode_CLICKHandler(e: Event): void {
    // 「商品検索ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    // VOに値を設定
    vo.supplierFlg = '0';	// 発注先

    const componentRef = this.dialogServiceSub.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.setInterfaceParam(vo);
    instance.parent = this;
    instance.setKYMW0400Parameter = (outputVo: KYMW0400OutputModel) => {
      // 発注先取引先画面から戻った場合
      this.setKYMW0400Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【アイテムタブ】
   * 支払先取引先テキスト入力完了イベントリスナ
   * @param e イベント
   */
  public eventPayeeClientCode_FOCUS_OUTHandler(e: Event): void {
    // ・「支払先取引先コード」の入力値を基に取引先確認要求（/KYMW09/getSupplier.xml）をサーバへ送信し、
    //  「取引先名称」を取得する。
    const supplierRequestVO: SupplierRequestVO = new SupplierRequestVO();
    // ※取引先コード：画面設定値
    supplierRequestVO.supplier = this.kymw0900Model.payeeClientCode;
    supplierRequestVO.flag = '1';

    // 取引先取得イベントを生成
    // 取引先取得テキスト入力完了イベントにリクエストVOを設定
    // getSupplierServiceサービス呼び出し
    this.getSupplierService.execute(this.kymw0900Model, supplierRequestVO);
  }

  /**
   * 【アイテムタブ】
   * 支払先取引先検索ボタンクリックイベントリスナ
   * @param e イベント
   */
  public eventPayeeClientCode_CLICKHandler(e: Event): void {
    // 「商品検索ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    // VOに値を設定
    vo.supplierFlg = '1';	// 支払先

    const componentRef = this.dialogServiceSub.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.setInterfaceParam(vo);
    instance.parent = this;
    instance.setKYMW0400Parameter = (outputVo: KYMW0400OutputModel) => {
      // 発注先取引先画面から戻った場合
      this.setKYMW0400Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【アイテムタブ】
   * 価格バンドルテキスト入力完了イベントリスナ
   * @param e イベント
   */
  public eventBundlePrice_FOCUS_OUTHandler(e: Event): void {
    // 入力値が前回値と異なる場合
    this.kymw0900Model.updateCostPriceForBundleChange(this.kymw0900Model.bundlePrice, this.dtg_PriceList.collectionView.items);
  }

  /**
   * 栄養成分タブの生成時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventNutrientTab_SHOWHandler(event: Event): void {
    if (!this.makeNutrientTab) {
      this.makeNutrientTab = true;
      const idx: number = this.kymw0900Model.selectedItemCodeIndex;
      // 栄養成分タブに表示する分析単位が存在する場合
      if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional !== null) {
        // 分析単位データグリッドの1行目に位置づけ
        this.dtg_NutrientUnitList.select(0);
      }
    }
  }

  /**
   * 複数栄養成分タブの生成時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventMultiNutrientTab_SHOWHandler(event: Event): void {
    if (!this.makeMultiNutrientTab) {
      this.makeMultiNutrientTab = true;
      const idx: number = this.kymw0900Model.selectedItemCodeIndex;
      // 複数栄養成分タブに表示する分析単位が存在する場合
      if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti !== null) {
        if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List.length > 0) {
          // 分析単位データグリッドの1行目に位置づけ
          this.dtg_NutrientUnitListMulti.select(0);
        }
      }
    }
  }

  /**
   * 【栄養成分タブ】
   * 複数栄養成分ありチェックボックスのクリック時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventHasMultiNutrientInfo_CLICKHandler(event: Event): void {
    if (this.dtg_NutrientUnitListMulti.collectionView.items.length > 0) {
      // 削除確認メッセージを表示
      this.dialogServiceSub.openAlertGetMessage('Q0153', ['複数栄養成分情報'],
        (closeDetail) => { // OKを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            // Q0153のボタンは「はい」と「いいえ」が表示されて、デフォルト選択は「いいえ」。
            this.kymw0900Model.hasMultiNutrientInfo = false;
            this.removeAllNutrientInfoListMulti();
          } else {
            this.kymw0900Model.hasMultiNutrientInfo = true;
          }
        }
      );
    } else {
      if (this.cnv_MultiNutrientTab.isDisabled) {
        this.cnv_MultiNutrientTab.isDisabled = false;
        this.tab_item.selectedIndex = 5;
      } else {
        this.cnv_MultiNutrientTab.isDisabled = true;
      }
    }
    // }
  }

  /**
   * 【プロモーションマークタブ】
   * グループコンボボックス変更イベントリスナ
   * @param e イベント
   */
  public eventMarkGroup_CHANGEHandler(e: Event): void {
    // グループコンボボックスの変更値による供給促進マークの絞り込みを行う
    this.kymw0900Model.narrowingMarkInfoList(this.kymw0900Model.markGroup);
  }

  /**
   * 【環境タブ】
   * 環境区分ラジオボタン変更イベントリスナ
   * @param e イベント
   */
  public eventCologyDiv_CHANGEHandler(): void {
    // 「環境区分」ラジオボタンを判定し、「環境配慮商品」の選択入力可否を設定する。
    // データグリッド「環境区分」の活性／非活性を設定する。
    this.kymw0900Model.goodsEcologyFlag = this.kymw0900Model.ecologyDiv === '1' ? true : false;
    for (let i = Number(0); i < this.dtg_GoodsEcologyList.editableCollectionView.items.length; i++) {
      this.kymw0900Model.goodsEcology[i].SelectValue = false;
    }
    this.dtg_GoodsEcologyList.editableCollectionView.refresh();
  }

  /**
   * 商品企画メンテナンスデータの再取得を行う
   */
  public requestPlanGoodsData(pCode: string): void {
    // 初期管理データをクリア
    this.kymw0900Model.resetInitData();

    // チェックボックスをクリア
    this.resetCheckBox();

    // Ｐコード選択情報を変更
    this.kymw0900Model.pCode = pCode;

    //// ngOnInitで実行するAPI処理を実行
    // 商品マスタでのアイテムコードに紐づく会員生協を取得
    this.getGoodsUseCoopService.execute(this.kymw0900Model, (data: any) => {
      this.itemRelatedCoop = data.CoopCodeList;
    });

    // 選定済1物N価媒体リスト取得（1物N価プロモーションモーダルで使用）
    const requestVO = {
      OrderCode: this.kymw0900Model.orderCode,
      PCode: this.kymw0900Model.pCode
    }
    this.getSelectedNvalMediumListService.execute(requestVO, (data) => {
      this.kymw0900Model.nvalMediumTypeList = data;
    });

    // 画面へ表示する情報を取得する要求を発行する。
    this.getPlanGoodsMaintain(this.kymw0900Model.pCode, () => {
      // 案内タブ情報取得処理
      this.getGuideInfo(this.kymw0900Model.pCode);
      // プロモ設定タブ情報取得処理
      this.getPromotionSettingInfo(this.kymw0900Model.pCode, () => {
        // 予約設定タブ情報取得処理
        this.getPreOrder();
      });
      // タグ情報タブ情報取得処理
      this.getTagInfo();
      // EC設定タブ情報取得処理
      this.getECSettingInfo(() => {
        // 初期表示のみ：アイコンタブのチェックボックスを、会員タブでアイテムコードが選択済みの生協以外非活性とする
        this.kymw0900Model.coopPriceList.map(cp => {
          this.kymw0900Model.iconListDisable[cp.CoopCode] = PlessViewUtilsSub.isEmpty(cp.SelectItemCode)
        })
      });
    });

    // 権限、ロック状態を取得し、編集モード、閲覧モードの判定を行う
    const permission: string = PlessViewUtilsSub.nullToBlank(this.kymw0900Model.permission);
    const lock: string = PlessViewUtilsSub.nullToBlank(this.kymw0900Model.lockInfo);

    this.txti_OrderCode.functionAfterSuccessResponse = () => {
      // 商品企画メンテナスインプットVOの「媒体区分」より、企画進捗管理情報リストAPI実行
      let isExist = false;
      this.txti_OrderCode.catalogProgressTextInputModel.catalogProgressList.forEach(_ => {
        if (_.OrderCode === this.kymw0900Model.orderCode) {
          isExist = true;
          // 取得したリスト.VO.受注コード＝商品企画メンテナスインプットVO.受注コードの場合取得したリスト.VO.工程管理Noを取得する。
          if (Number(_.ProgressWorkNum) < 7) {
            // 1. 取得した工程管理No < 07(企画確定前)の場合
            if (permission === '0' && lock === '0') {
              this.plessEnabledFlag = true;
              setTimeout(() => {
                this.plessEnabledSetting();
              });

              // 複数栄養素成分の表示制御
              this.chk_HasMultiNutrientInfo.disabled = false;

              // マーク・アレルゲンの活性・非活性フラグ
              this.kymw0900Model.markFlag = false;
              this.kymw0900Model.allergenFlag = false;

              // 「権限：閲覧のみ」または「ロック状態：編集不可(ロック時)」
            } else if (permission === '1' || lock === '1') {
              // 閲覧モードを設定
              this.setEnabledByViewPermission();
            }
          } else {
            // 2. 取得した工程管理No >= 07(企画確定以降)の場合
            this.kymw0900Model.isConfirmedForPromo = true;
            // ①【権限：フルコントロール】且つ【編集モード：閲覧】の場合
            if (permission === '0' && lock === '1') {
              this.plessEnabledFlag = false;
              this.LockUtilForPlanGoods('REGIST',
                this.kymw0900Model.orderCode, this.kymw0900Model.mediumType, this.kymw0900Model.pCode,
                (successParam: any) => {
                  setTimeout(() => {
                    // ロック成功のフラグを設けてtrueとする。(このフラグは閉じるボタン押下時に使用する)	
                    this.kymw0900Model.lockSucceeded = true;
                    // 「EC情報タブ」の入力項目(ボタンを含む)を使用可能（活性化）とする。
                    this.chk_CmFlg.nativeElement.disabled = false;
                    this.chk_OrderLimitFlg.nativeElement.disabled = false;
                    this.chk_WebLimitFlg.nativeElement.disabled = false;
                    this.chk_RecommendFlg.nativeElement.disabled = false;
                    this.chk_NonDispFlg.nativeElement.disabled = false;
                    this.chk_StockNumShowFlg.checkbox.nativeElement.disabled = false;
                    this.txti_MinOrderNum.nativeElement.disabled = false;
                    this.txti_MaxOrderNum.nativeElement.disabled = false;
                    this.plessEnabled(this.btn_ECSearch.nativeElement, true);
                    this.plessEnabled(this.btn_Instructions.nativeElement, true);
                    this.plessEnabled(this.groupingCode, true);
                    this.plessEnabled(this.txti_BrandName, true);
                    this.plessEnabled(this.txti_CoopGoodsUrlTitle, true);
                    this.plessEnabled(this.txti_CoopGoodsUrl, true);
                    this.plessEnabled(this.txti_RelatedUrlTitle, true);
                    this.plessEnabled(this.txti_RelatedUrl, true);
                    this.cmb_OrderGoodsDiv.comboBox.nativeElement.disabled = false;
                    // 「アイコンタブ」の入力項目(ボタンを含む)を使用可能（活性化）とする。
                    this.plessEnabled(this.chk_AllCoopValueIcon, true);
                    // 変更確認ボタンを使用可能（活性化）とする。	
                    this.btn_ChangeConfirmation.nativeElement.disabled = false;
                    // Ｐコード、アイテムコードを使用可能（活性化）とする。
                    this.cmb_PCode.nativeElement.disabled = false;
                    this.plessEnabled(this.cmb_ItemCode, true);

                    this.kymw0900Model.isDisabledForGrid = true;
                    this.kymw0900Model.isConfirmed = true;
                  });
                }, this.componentName,
                (faultParam: any) => {
                  // ロック失敗時(他のユーザが編集中の場合)	
                  // Ｐコード、アイテムコードを使用可能（活性化）とする。
                  this.setEnabledByViewPermission();
                }, this.componentName,
                false);
            } else {
              // ② ①のケース以外の場合、1.②と同様の画面制御とする。
              // 閲覧モードを設定
              this.setEnabledByViewPermission();
            }
          }
        }
      });

      if (!isExist) {
        // 工程管理No不明時に閲覧モードとならない問題の対応
        if (permission === '1' || lock === '1') {
          this.setEnabledByViewPermission();
        }
        // 工程管理No不明時にプロモ設定タブのラジオボタン初期表示の活性状態が不整合となる問題の対応
        this.kymw0900Model.isConfirmedForPromo = true;
      }
    };
  }

  /**
   * チェックボックスを初期化する
   * ⇒bindでは画面上変更されていても
   *  Manageの値が変更なければ反映がされないため
   */
  public resetCheckBox(): void {
    // 包材一括表示確認済
    this.kymw0900Model.packMaterialShowFlag = false;
    // 基本タブ　eフレンズ送信不要
    this.kymw0900Model.eFriendsSendDiv = false;
    // 会員タブ　マーク一覧　すべての生協に同一の設定
    this.kymw0900Model.allcoopValue = false;
    // 組合員タブ　生協
    this.kymw0900Model.selectValue1 = false;
    this.kymw0900Model.selectValue2 = false;
    this.kymw0900Model.selectValue3 = false;
    this.kymw0900Model.selectValue4 = false;
    this.kymw0900Model.selectValue5 = false;
    this.kymw0900Model.selectValue6 = false;
    this.kymw0900Model.selectValue7 = false;
    this.kymw0900Model.selectValue8 = false;
    // アイコンタブ　すべての生協に同一の設定
    this.chk_AllCoopValueIcon.selected = false;
    this.kymw0900Model.allcoopValueIcon = false;
    // 仕様書１タブ　メーカー名称表示
    this.kymw0900Model.makerNamePublishType = false;
    // プロモーションタブ　すべての生協に同一の設定
    this.chk_AllcoopValue2.selected = false;
    this.kymw0900Model.allcoopValue2 = false;
    // JANコード識別フラグ
    this.chk_JanCodeDiv.selected = false;
  }

  /**
   * 編集イベントリスナ
   */
  public eventEditHandler(): void {
    // 編集カウントをインクリメント
    this.editCount++;
  }

  /**
   * コールバック情報が無い場合、閲覧モードを設定
   */
  public setScreenModeInfo(): void {
    // エラーメッセージを表示する。
    this.dialogServiceSub.openAlertGetMessage('S0101');

    // 閲覧モードを設定
    this.setScreenMode('true');
    this.cmb_PCode.nativeElement.disabled = true;
  }

  /**
   * 変更確認画面呼出
   */
  public moveInfoKYMW0901(): void {

    // 画面受渡情報としてArrayに受注コード、Ｐコードを設定
    // [0]：受注コード、[1]：Ｐコード
    const orderList: Array<any> = [];
    orderList.push(this.kymw0900Model.orderCode);
    orderList.push(this.kymw0900Model.pCode);
    orderList.push(this.kymw0900Model.pCodeList);
    const vo = {
      orderList: orderList,
      textInfoDivArray: this.kymw0900Model.textInfoDivArray,
      textKindNumArray: this.kymw0900Model.textKindNumArray,
      selectedMediumType: this.kymw0900Model.mediumType
    };

    // KYMW0901_変更確認画面呼出
    const componentRef = this.dialogServiceSub.openModal(KYMW0901Component);
    const instance = componentRef.componentInstance as KYMW0901Component;
    instance.setInterfaceParam(vo);
    instance.parent = this;
    instance.setKYMW0901Parameter = (vo: any) => {
      // 変更確認画面から戻った場合
      this.kymw0900Model.textInfoDivArray = vo.textInfoDivArray;
      this.kymw0900Model.textKindNumArray = vo.textKindNumArray;
    };
    instance.closeFunction = (updateComplete: boolean) => {
      if (updateComplete) {
        this.editCount = 0;
        componentRef.close();
        if (this.kymw0900Model.pCodeList.length === 1) {
          this.closeWindow();
        }
      } else {
        componentRef.close();
      }
    };
  }

  /**
   * 業態区分（デイリー）コンボボックス変更イベントリスナ
   * @param e イベント
   */
  public eventDailyDiv_CHANGEHandler(e: Event): void {

    // 業態区分（デイリー）が【00：掲載なし】の場合
    if (this.cmb_DutiesFormDailyDiv.selectedCodeValue === '00') {
      // コマ削除確認メッセージ
      this.dialogServiceSub.openAlertGetMessage('Q0150', ['デイリー'],
        (closeDetail) => { // OKを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.No) {
            // コンボボックスの値を変更前に戻す
            this.cmb_DutiesFormDailyDiv.setCodeValue(this.tmpDutiesFormDailyDiv);
          } else {
            // 業態区分が【2：デイリー媒体】の場合
            if (this.kymw0900Model.dutiesFormDiv === '2') {
              // エラーメッセージを表示
              this.dialogServiceSub.openAlertGetMessage('E0164', ['デイリー媒体に選定済み', '業態区分を「掲載なし」に変更']);
              // コンボボックスの値を変更前に戻す
              this.cmb_DutiesFormDailyDiv.setCodeValue(this.tmpDutiesFormDailyDiv);
              return;
            }
            // 業態区分（デイリー）一時変数に変更後の値を格納
            this.tmpDutiesFormDailyDiv = this.cmb_DutiesFormDailyDiv.selectedCodeValue;
          }
        }
      );
    } else {
      // 業態区分（デイリー）一時変数に変更後の値を格納
      this.tmpDutiesFormDailyDiv = this.cmb_DutiesFormDailyDiv.selectedCodeValue;
    }
  }

  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/

  /***************************************************************************************************
   * 以下の処理について、共通関数があるかとうか要確認
   * ・半角文字変換
   *  →変換できない文字が指定された場合はエラーメッセージを表示する。
   * ・入力文字数チェック
   * ・NGワードの入力文字チェックを行う。
   ****************************************************************************************************/

  /**
  * 変更管理テーブルクリア処理
  */
  public clearPlanGoodsManage(pCode: string, orderCode: string, mode: string = <string>''): void {

    // リクエストVOを生成
    const clearPlanGoodsChangeManageRequestVO: ClearPlanGoodsChangeManageRequestModel = new ClearPlanGoodsChangeManageRequestModel();
    // パラメータを設定
    clearPlanGoodsChangeManageRequestVO.pCode = pCode;
    clearPlanGoodsChangeManageRequestVO.orderCode = orderCode;
    clearPlanGoodsChangeManageRequestVO.mode = mode;

    // サービス呼び出し
    this.clearPlanGoodsChangeManageService.execute(this.kymw0900Model, clearPlanGoodsChangeManageRequestVO);
  }

  /**
   * 商品企画メンテ画面に表示する内容を取得する
   * @param pCode Ｐコード
   */
  public getPlanGoodsMaintain(pCode: string, nextFunc: Function = null): void {

    // アイテムコード一覧リクエストVOを生成し、Ｐコード・受注コード・媒体区分を設定する
    const planGoodsMaintainVO: PlanGoodsMaintainModel = new PlanGoodsMaintainModel();
    planGoodsMaintainVO.pCode = pCode;
    planGoodsMaintainVO.orderCode = this.kymw0900Model.orderCode;
    planGoodsMaintainVO.mediumType = this.kymw0900Model.mediumType;

    this.getPlanGoodsMaintainService.execute(this.kymw0900Model, planGoodsMaintainVO, () => {
      // グリッドの選択を初期化
      this.dtg_PriceList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_CoopMarkList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_CoopDetailList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_ListingItemList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_MarkList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_PlanList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_GuideList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_AllergenInfo.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_MarkInfo.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_NutrientUnitList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_NutrientComponentList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_NutrientComponentListMulti.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_GoodsEcologyList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_ContainPackingList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_GoodsGWStopList.selection = new CellRange(-1, -1, -1, -1);
      this.dtg_NutrientUnitListMulti.selection = new CellRange(-1, -1, -1, -1);
      if (nextFunc) {
        nextFunc();
      }
    });
  }

  /**
   * 案内一覧情報取得
   * @param pCode Ｐコード
   */
  public getGuideInfo(pCode: string): void {

    // 案内一覧情報リクエストVOを生成し、Ｐコード・受注コードを設定する
    const guideInfoVO: GuideInfoRequestModel = new GuideInfoRequestModel();
    guideInfoVO.pCode = pCode;
    guideInfoVO.orderCode = this.kymw0900Model.orderCode;

    this.getGuideInfoService.execute(this.kymw0900Model, guideInfoVO);
  }

  /**
   * プロモ設定タブ情報取得
   * @param pCode Ｐコード
   */
  public getPromotionSettingInfo(pCode: string, nextFunc: Function = null): void {
    // ポイント交換商品プロモーションの注文コード割当コードを設定
    this.getOrderNumQuotaCodeList(pCode, 'ポイント交換', (data) => {
      this.kymw0900Model.pointExchangeOrderNumQuotaCodeList = this.kymw0900Model.updateOrderNumQuotaCodeList(data);
      // クーポン商品プロモーションの注文コード割当コードを設定
      this.getOrderNumQuotaCodeList(pCode, 'クーポン', (data) => {
        this.kymw0900Model.couponOrderNumQuotaCodeList = this.kymw0900Model.updateOrderNumQuotaCodeList(data);
        if (nextFunc) {
          nextFunc();
        }
      });
    });

    // 抽選商品プロモーション情報取得
    this.getPlanGoodsLotteryPromotion(pCode);

    // ポイント交換商品プロモーション情報取得
    this.getPlanGoodsPointExchangePromotion(pCode);

    // 1物N価媒体プロモーション情報取得
    this.getPlanGoodsNvalPromotion(pCode);

    // クーポン商品プロモーション情報取得
    this.getPlanGoodsCouponPromotion(pCode);

    // 商品会員生協供給価格取得
    this.getGoodsSupplyPriceService.execute(this.kymw0900Model, (data) =>
      this.kymw0900Model.coopSupplyPriceList = data.CoopList
    )
  }

  /**
   * タグタブ情報取得
   */
  public getTagInfo(): void {
    const vo = new GetTagListRequestModel();
    vo.pCode = this.kymw0900Model.pCode;
    this.getTagListService.execute(this.kymw0900Model, vo);
  }

  /**
   * EC設定タブ情報取得
   */
  public getECSettingInfo(nextFunc: Function = null): void {
    const planGoodsECVo = new GetPlanGoodsECRequestModel();
    planGoodsECVo.orderCode = this.kymw0900Model.orderCode;
    planGoodsECVo.pCode = this.kymw0900Model.pCode;
    this.getPlanGoodsECService.execute(this.kymw0900Model, planGoodsECVo);

    const imageDataVo = new GetImageDataRequestModel();
    imageDataVo.orderCode = this.kymw0900Model.orderCode;
    imageDataVo.pCode = this.kymw0900Model.pCode;
    this.getImageDataService.execute(this.kymw0900Model, imageDataVo, () => {
      const groupingListVo = new GetGroupingListRequestModel();
      groupingListVo.groupingDiv142 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_IB) ? '0' : '1';
      groupingListVo.groupingDiv163 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TO) ? '0' : '1';
      groupingListVo.groupingDiv185 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_GU) ? '0' : '1';
      groupingListVo.groupingDiv240 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TI) ? '0' : '1';
      groupingListVo.groupingDiv210 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_SA) ? '0' : '1';
      groupingListVo.groupingDiv302 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_TK) ? '0' : '1';
      groupingListVo.groupingDiv515 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_NA) ? '0' : '1';
      groupingListVo.groupingDiv451 = this.kymw0900Model.isEnabledCoop(this.kymw00Model.COOP_CODE_NI) ? '0' : '1';
      this.getGroupingListService.execute(this.kymw0900Model, groupingListVo);

      setTimeout(() => {
        // 画像リスト表示幅の調整
        let maxLength = 0;
        for (const key of Object.keys(this.kymw0900Model.imageMap)) {
          if (maxLength < this.kymw0900Model.imageMap[key].length) {
            maxLength = this.kymw0900Model.imageMap[key].length;
          }
        }
        if (maxLength > 5) {
          this.dtg_ECImage.columns[2].width = 135 * maxLength;
        }
      }, 500)

      if (nextFunc) {
        nextFunc();
      }
    });

    const stockInfoVo = new GetStockInfoRequestModel();
    stockInfoVo.orderCode = this.kymw0900Model.orderCode;
    stockInfoVo.pCode = this.kymw0900Model.pCode;
    this.getStockInfoService.execute(this.kymw0900Model, stockInfoVo, () => {
      if (!this.kymw0900Model.stockLimitFlg) {
        // 在庫限定アコーディオンメニュー非表示
        this.acc_stock.isVisible = false;
        document.getElementById('div_stock').style.display = 'none';
      } else {
        // 在庫限定アコーディオンメニュー表示
        this.acc_stock.isVisible = true;
        document.getElementById('div_stock').style.display = 'block';
      }
    });

    const groupingInfoVo = new GetGroupingInfoRequestModel();
    groupingInfoVo.orderCode = this.kymw0900Model.orderCode;
    groupingInfoVo.pCode = this.kymw0900Model.pCode;
    this.getGroupingInfoService.execute(this.kymw0900Model, groupingInfoVo);

    const webLinkInfoVo = new GetWebLinkInfoRequestModel();
    webLinkInfoVo.orderCode = this.kymw0900Model.orderCode;
    webLinkInfoVo.pCode = this.kymw0900Model.pCode;
    this.getWebLinkInfoService.execute(this.kymw0900Model, webLinkInfoVo, () => {
      // Webリンク情報アコーディオンメニューの開閉状態の初期値設定
      if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.coopGoodsUrl) || !PlessViewUtilsSub.isEmpty(this.kymw0900Model.relatedUrl)) {
        this.acc_weblink.isCollapsed = false;
      } else {
        this.acc_weblink.isCollapsed = true;
      }
    });
  }

  /**
   * 注文コード割当コード一覧取得
   * @param pCode Ｐコード
   * @param getType 取得種類
   * @param successFunc 成功処理
   * @param mediumType 媒体区分
   */
  public getOrderNumQuotaCodeList(pCode: string, getType: string, successFunc: Function, mediumType?: string): void {

    // 注文コード割当コード一覧取得リクエストVOを生成し、Ｐコード・取得種類・受注コードを設定する
    const orderNumQuotaCodeListVO: GetOrderNumQuotaCodeListRequestModel = new GetOrderNumQuotaCodeListRequestModel();
    orderNumQuotaCodeListVO.pCode = pCode;
    orderNumQuotaCodeListVO.getType = getType;
    orderNumQuotaCodeListVO.orderCode = this.kymw0900Model.orderCode;
    if (getType === '1物N価媒体') {
      // 1物N価媒体の場合は媒体区分を設定
      orderNumQuotaCodeListVO.mediumType = mediumType;
    } else {
      // それ以外の場合は媒体区分に空を設定
      orderNumQuotaCodeListVO.mediumType = '';
    }

    this.getOrderNumQuotaCodeListService.execute(orderNumQuotaCodeListVO, successFunc);
  }

  /**
   * 抽選商品プロモーション情報取得
   * @param pCode Ｐコード
   */
  public getPlanGoodsLotteryPromotion(pCode: string): void {

    // 抽選商品プロモーション情報取得リクエストVOを生成し、Ｐコード・受注コードを設定する
    const planGoodsLotteryPromotionVO: PlanGoodsLotteryPromotionRequestModel = new PlanGoodsLotteryPromotionRequestModel();
    planGoodsLotteryPromotionVO.pCode = pCode;
    planGoodsLotteryPromotionVO.orderCode = this.kymw0900Model.orderCode;

    this.planGoodsLotteryPromotionService.execute(this.kymw0900Model, planGoodsLotteryPromotionVO, () => { });
  }

  /**
   * ポイント交換商品プロモーション情報取得
   * @param pCode Ｐコード
   * @param getType 取得種類
   */
  public getPlanGoodsPointExchangePromotion(pCode: string): void {

    // ポイント交換商品プロモーション情報取得リクエストVOを生成し、Ｐコード・受注コードを設定する
    const planGoodsPointExchangePromotionVO: PlanGoodsPointExchangePromotionRequestModel = new PlanGoodsPointExchangePromotionRequestModel();
    planGoodsPointExchangePromotionVO.pCode = pCode;
    planGoodsPointExchangePromotionVO.orderCode = this.kymw0900Model.orderCode;

    this.planGoodsPointExchangePromotionService.execute(this.kymw0900Model, planGoodsPointExchangePromotionVO, () => {
      this.setPointPromotionAddBtnEnable();
    });
  }

  /**
   * 1物N価媒体プロモーション情報取得
   * @param pCode Ｐコード
   * @param getType 取得種類
   */
  public getPlanGoodsNvalPromotion(pCode: string): void {

    // 1物N価媒体プロモーション情報取得リクエストVOを生成し、Ｐコード・受注コードを設定する
    const getPlanGoodsNvalPromotionVO: PlanGoodsNvalPromotionRequestModel = new PlanGoodsNvalPromotionRequestModel();
    getPlanGoodsNvalPromotionVO.pCode = pCode;
    getPlanGoodsNvalPromotionVO.orderCode = this.kymw0900Model.orderCode;

    this.planGoodsNvalPromotionService.execute(this.kymw0900Model, getPlanGoodsNvalPromotionVO, () => {
      // 1物N価グリッドの背景色設定
      this.setNvalPromotionColorPattern();
      // 1物N価追加ボタン活性制御
      this.setNvalPromotionAddBtnEnable();
      // 1物N価グリッドのヘッダー幅設定
      this.setNvalPromotionWidth();
    });
  }

  /**
   * クーポン商品プロモーション情報取得
   * @param pCode Ｐコード
   * @param getType 取得種類
   */
  public getPlanGoodsCouponPromotion(pCode: string): void {

    // クーポン商品プロモーション情報取得リクエストVOを生成し、Ｐコード・受注コードを設定する
    const getPlanGoodsCouponPromotionVO: PlanGoodsCouponPromotionRequestModel = new PlanGoodsCouponPromotionRequestModel();
    getPlanGoodsCouponPromotionVO.pCode = pCode;
    getPlanGoodsCouponPromotionVO.orderCode = this.kymw0900Model.orderCode;

    this.planGoodsCouponPromotionService.execute(this.kymw0900Model, getPlanGoodsCouponPromotionVO, () => {
      this.setCouponPromotionAddBtnEnable();
    });
  }

  /**
   * 消費税率を取得する
   * @param classCode 部門コード
   * @param orderCode 受注コード
   */
  public getConsumeTax(classCode: string, orderCode: string): void {
    // 企画商品（アイテムグリッド情報）一覧リクエストVOを生成
    const consumeTaxRequestVO: ConsumeTaxRequestModel = new ConsumeTaxRequestModel();
    // 部門コードを設定
    consumeTaxRequestVO.classCode = classCode;
    // 受注コードを設定
    consumeTaxRequestVO.orderCode = orderCode;

    this.getDefaultConsumeTaxInfoService.execute(this.kymw0900Model, consumeTaxRequestVO);
  }

  /**
   * 予約設定タブ情報取得
   */
  public getPreOrder(): void {
    const vo = new GetPreOrderFlagRequestModel();
    vo.orderCode = this.kymw0900Model.orderCode;
    vo.pCode = this.kymw0900Model.pCode;
    this.getPreOrderFlagService.execute(this.kymw0900Model, vo, () => {
      if (!this.kymw0900Model.preOrderFlag) return;
      const vo = new GetPreOrderRequestModel();
      vo.orderCode = this.kymw0900Model.orderCode;
      vo.pCode = this.kymw0900Model.pCode;
      this.getPreOrderService.execute(this.kymw0900Model, vo, () => {
        this.getOrderNumQuotaCodeList(this.kymw0900Model.pCode, '予約商品', (data) => {
          this.kymw0900Model.preOrderOrderNumQuotaCodeList = this.kymw0900Model.updateOrderNumQuotaCodeList(data);
          // 商品会員生協供給価格取得を呼び出す
          this.getGoodsSupplyPriceService.execute(this.kymw0900Model, (data) => {
            // 取得したデータのうち代表生協順で最も優先順位が高いものを取得
            let itemCoopList = [];
            // アイテムコードごとに分ける
            data.CoopList.map(c => {
              if (!itemCoopList.find(_ => _.itemCode === c.ItemCode)) {
                itemCoopList.push({
                  itemCode: c.ItemCode,
                  coopList: [{
                    coopCode: c.CoopCode,
                    supplyPriceStandard: c.SupplyPriceStandard,
                    supplyPriceSpecial1: c.SupplyPriceSpecial1,
                    supplyPriceSpecial2: c.SupplyPriceSpecial2
                  }]
                });
              } else {
                itemCoopList.find(_ => _.itemCode === c.ItemCode).coopList.push({
                  coopCode: c.CoopCode,
                  supplyPriceStandard: c.SupplyPriceStandard,
                  supplyPriceSpecial1: c.SupplyPriceSpecial1,
                  supplyPriceSpecial2: c.SupplyPriceSpecial2
                })
              }
            });
            // アイテムコードごとに分けたデータを代表生協順で最も優先度が高いものをリストに格納
            itemCoopList.map(ic => {
              for (const e of this.kymw0900Model.coopDaihyoOrder) {
                const targetCoopList = ic.coopList.find(cl => cl.coopCode === e);
                if (targetCoopList) {
                  this.kymw0900Model.preOrderSupplyPriceList.push({
                    itemCode: ic.itemCode,
                    supplyPriceStandard: targetCoopList.supplyPriceStandard,
                    supplyPriceSpecial1: targetCoopList.supplyPriceSpecial1,
                    supplyPriceSpecial2: targetCoopList.supplyPriceSpecial2
                  });
                  break;
                }
              }
            });
          });
        });
      });
    });
  }

  /*--------------------------------------------------------------------------------------------
  /* 子画面からのコールバック関数
  /*--------------------------------------------------------------------------------------------*/

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.KYMW04.IKYMW0400#setKYMW0400Parameter()
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {
    // 『取引先一覧』画面（KYMW0400）を呼び出し、取引先を選択する。
    // 発注先
    if (outputVO.supplierFlg === '0') {
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.orderClientCode !== outputVO.supplierCode
        || this.kymw0900Model.orderClientName !== outputVO.supplierNameKanji) {
        this.editCount++;
      }
      this.kymw0900Model.orderClientCode = outputVO.supplierCode;
      this.kymw0900Model.orderClientName = outputVO.supplierNameKanji;
    } else if (outputVO.supplierFlg === '1') {
      // 支払先
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.payeeClientCode !== outputVO.supplierCode
        || this.kymw0900Model.payeeClientName !== outputVO.supplierNameKanji) {
        this.editCount++;
      }
      this.kymw0900Model.payeeClientCode = outputVO.supplierCode;
      this.kymw0900Model.payeeClientName = outputVO.supplierNameKanji;
    }
  }

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.KYMW06.IKYMW0600#setKYMW0600Parameter()
   */
  public setKYMW0600Parameter(outputVO: KYMW0600OutputModel): void {
    // // 値が変更された場合は編集カウントをインクリメント
    if (this.kymw0900Model.relationPcodeOld !== outputVO.relationPCodeOld
      || this.kymw0900Model.relationPcodeNew !== outputVO.relationPCodeNew) {
      this.editCount++;
    }

    // 『関連商品設定』画面（KYMW0600）を呼び出し、関連商品の設定を行う。
    // ・返却情報より「関連Ｐコード（旧）」及び「関連Ｐコード（新）」をセットする。
    this.kymw0900Model.relationPcodeOld = outputVO.relationPCodeOld;
    this.kymw0900Model.relationPcodeNew = outputVO.relationPCodeNew;
  }

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.IKYMW0700#setKYMW0700Parameter()
   */
  public setKYMW0700Parameter(outputVO: KYMW0700OutputModel): void {
    // 『文字情報選択』画面（KYMW0700）を呼び出し、文章を選択する。
    // ・返却情報より「商品説明」～「取扱注意」テキスト入力欄のいずれかに文章をセットする。
    // 商品説明
    if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[0]) {
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.textInfo1 !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[0] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.textInfo1 = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[0] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[0] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[1]) {
      // キャッチコピー
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.textInfo2 !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[1] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.textInfo2 = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[1] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[1] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[2]) {
      // おすすめコメント(吹き出し)
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.textInfo3 !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[2] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.textInfo3 = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[2] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[2] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[7]) {
      // 便利情報(サイズ他)

      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.textInfo8 !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[7] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.textInfo8 = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[7] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[7] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[8]) {
      // 取扱注意
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.textInfo9 !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[8] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.textInfo9 = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[8] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[8] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[10]) {
      // 届出表示・許可表示
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.licencedDescription !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[10] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.licencedDescription = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[10] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[10] = 0;
      }
    } else if (outputVO.textKindId === this.kymw0900Model.textInfoDivArray[11]) {
      // EC用商品説明
      // 値が変更された場合は編集カウントをインクリメント
      if (this.kymw0900Model.licencedDescription !== outputVO.stringValue
        || this.kymw0900Model.textKindNumArray[11] !== outputVO.textKindNum) {
        this.editCount++;
      }

      // 商品付随文字情報文字列,、商品付随文字情報連番を更新
      this.kymw0900Model.licencedDescription = outputVO.stringValue;
      this.kymw0900Model.textKindNumArray[11] = outputVO.textKindNum;
      if (outputVO.textKindNum === -1) {
        this.kymw0900Model.textKindNumArray[11] = 0;
      }
    }
  }

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.IKYMW0A00#setKYMW0A00Parameter()
   */
  public setKYMW0A00Parameter(outputVO: KYMW0A00OutputModel): void {
    // 組合員の声（『組合員の声選択』画面からの戻り値）を設定
    this.kymw0900Model.selectInquiryContents = this.kymw00Model.deleteStartAndEndSpace(outputVO.inquiryContents);
    // 受付番号（『組合員の声選択』画面からの戻り値）を設定
    this.kymw0900Model.selectReceiptNum = outputVO.receiptNum;

    // 「組合員の声」押下ボタン
    const coopNum: number = this.kymw0900Model.selectInquiryContentsButton;
    // 会員生協に紐付く「組合員の声」ボタンが押下された場合
    if (coopNum !== -1) {
      // 組合員の声リクエストVOを生成
      const publishVoiceHistoryRequestVO = new PublishVoiceHistoryRequestModel();
      publishVoiceHistoryRequestVO.orderCode = this.kymw0900Model.orderCode;
      publishVoiceHistoryRequestVO.pCode = this.kymw0900Model.selectedPCode;
      publishVoiceHistoryRequestVO.receiptNum = this.kymw0900Model.selectReceiptNum;
      const tempPublishVoiceArray = {
        CoopCode: this.kymw0900Model.coopCodeArray[coopNum],
        CoopSelect: '1',
      };
      publishVoiceHistoryRequestVO.coopInfoList.push(tempPublishVoiceArray);

      // 組合員の声使用状況を確認する。
      // ・当該会員生協に対して、使用状況確認要求（/KYMW09/getPublishVoiceHistory.xml）をサーバへ送信し、
      //  会員生協への設定の可否を取得する。
      this.getPublishVoiceHistoryService.execute(this.kymw0900Model, publishVoiceHistoryRequestVO);

      // ・返却情報（サーバ処理の結果）を判定する。
      // ①【「組合員の声掲載」に既存データあり】の場合、エラーメッセージを表示する。
      // ※組合員の声は、同一内容を各生協で１回のみ掲載可能とする。（ID=E0164 %1='他で指定済み' %2='指定'）
    } else {
      // 一括反映（組合員の声）を設定
      this.kymw0900Model.inquiryContentsAll = this.kymw00Model.deleteStartAndEndSpace(this.kymw0900Model.selectInquiryContents);
      // 一括反映（受付番号）を設定
      this.kymw0900Model.receiptNumAll = this.kymw0900Model.selectReceiptNum;
    }

    // 同じ受付番号の情報をすべて更新する
    if (outputVO.receiptNum === this.kymw0900Model.receiptNumAll) {
      this.kymw0900Model.inquiryContentsAll = this.kymw00Model.deleteStartAndEndSpace(outputVO.inquiryContents);
    }
    for (let i = Number(0); i < this.kymw0900Model.receiptNumArray.length; i++) {
      if (this.kymw0900Model.receiptNumArray[i] === outputVO.receiptNum) {
        this.kymw0900Model.inquiryContentsArray[i] = outputVO.inquiryContents;
      }
    }
    this.eventEditHandler();
  }

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.IKYMW0905#setKYMW0905Parameter()
   * 商品企画栄養成分情報メンテナンス画面からのリターン
   */
  public setKYMW0905Parameter(outputVO: KYMW0905OutputModel): void {

    // const itemCode: string = this.kymw0900Model.pCode;
    const itemCode: string = this.kymw0900Model.itemCode;
    // アイテムコードの選択位置を取得
    const idx: number = this.kymw0900Model.selectedItemCodeIndex;

    let addObj: any = new Array<any>();											// 栄養成分操作情報
    let row: number = <number>0;													// 栄養成分情報数
    let itemCodeInfoObj: any = new Array<any>();									// アイテム情報

    // 編集モードが'I'(コンテキストメニュー「栄養成分新規登録」からの呼び出し)だった場合)
    if (outputVO.editMode === 'I') {
      // 編集カウントをインクリメント
      this.editCount++;

      // 分析連番が'0'(栄養成分タブ)のデータに対する新規登録だった場合
      if (outputVO.analysisSeqNo === '0') {
        // hidden へのセット
        this.kymw0900Model.hiddenNutrientComponentList = new Array<any>();
        this.kymw0900Model.hiddenNutrientComponentList.push(this.setHiddenNutrientComponentInfo(outputVO));

        // 表示用 へのセット
        this.kymw0900Model.nutrientUnitList = new Array<any>();
        this.kymw0900Model.nutrientUnitList.push(this.setNutrientUnitList(outputVO.analysisSeqNo, outputVO.analysisUnit));
        this.kymw0900Model.nutrientNote = outputVO.nutritionalNote;
        this.kymw0900Model.nutrientDetailList = new Array<any>();
        for (let ii = 0; ii < outputVO.nutrientDetailList.length; ii++) {
          this.kymw0900Model.nutrientDetailList.push(this.setNutrientComponentList(outputVO.nutrientDetailList[ii]));
        }

        // Manageクラス itemCodeInfoList へのセット(更新)
        itemCodeInfoObj = {
          AnalysisSeqNo: Number(outputVO.analysisSeqNo),
          AnalysisUnit: outputVO.analysisUnit,
          NutrientComponentList: {
            List: Array<any>()
          },
          NutritionalNote: outputVO.nutritionalNote,
        };
        const List: Array<any> = new Array<any>();

        for (let ij = 0; ij < outputVO.nutrientDetailList.length; ij++) {
          List.push(this.setItemListInfoComponentList(outputVO.nutrientDetailList[ij]));
        }
        itemCodeInfoObj.NutrientComponentList.List = List;

        if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional === null) {
          this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional = new Array<any>();
          this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0] = new Array<any>();
        }
        this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional = { List: { 0: itemCodeInfoObj } };

        // Manageクラス itemCodeNutritionalInfoList へのセット(追加)
        // 0件の場合 (画面初期表示時からデータが存在していなかった場合を想定)
        if (PlessViewUtilsSub.isEmptyArray(this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional)
          || PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional))) {
          addObj = this.setItemCodeNutritionalInfo(this.kymw0900Model.selectedItemCodeIndex, '0', outputVO);
          this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.push(addObj);
        } else {
          // 1件の場合 (2件以上はないはず)
          const mainteDiv: string = this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[0].maintenanceDivUnit;
          // 0番目のメンテナンス種別(分析単位用)が削除の場合
          if (mainteDiv === 'D') {
            addObj = this.setItemCodeNutritionalInfo(this.kymw0900Model.selectedItemCodeIndex, '0', outputVO);
            // [栄養成分タブ] 栄養成分操作情報 への設定
            this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.push(addObj);
          } else if (mainteDiv === 'I') {
            // 0番目のメンテナンス種別(分析単位用)が新規登録の場合

            // 前回の新規登録分を削除して、、
            this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional = new Array<any>();
            addObj = this.setItemCodeNutritionalInfo(this.kymw0900Model.selectedItemCodeIndex, '0', outputVO);
            // [栄養成分タブ] 栄養成分操作情報 への設定
            this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.push(addObj);
          }
        }

        // 分析単位データグリッドの行の位置づけ
        row = this.kymw0900Model.nutrientUnitList.length;
        if (row > 0) {
          this.dtg_NutrientUnitList.selection = new CellRange(0, 0);
        }

        // 分析連番が'0'以外(複数栄養成分タブ)のデータに対する新規登録だった場合
      } else {
        // hidden へのセット
        this.kymw0900Model.hiddenNutrientComponentListMulti.push(this.setHiddenNutrientComponentInfo(outputVO));

        // 表示用 へのセット
        this.kymw0900Model.nutrientUnitListMulti.push(this.setNutrientUnitList(outputVO.analysisSeqNo, outputVO.analysisUnit));
        this.kymw0900Model.nutrientNoteMulti = outputVO.nutritionalNote;
        this.kymw0900Model.nutrientDetailListMulti = new Array<any>();
        for (let ik = 0; ik < outputVO.nutrientDetailList.length; ik++) {
          this.kymw0900Model.nutrientDetailListMulti.push(this.setNutrientComponentList(outputVO.nutrientDetailList[ik]));
        }

        // Manageクラス itemCodeInfoList へのセット(追加)
        itemCodeInfoObj = {
          AnalysisSeqNo: Number(outputVO.analysisSeqNo),
          AnalysisUnit: outputVO.analysisUnit,
          NutrientComponentList: {
            List: Array<any>()
          },
          NutritionalNote: outputVO.nutritionalNote,
        };
        itemCodeInfoObj.NutrientComponentList.List = [];
        for (let il = 0; il < outputVO.nutrientDetailList.length; il++) {
          itemCodeInfoObj.NutrientComponentList.List.push(this.setItemListInfoComponentList(outputVO.nutrientDetailList[il]));
        }
        if (!this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List) {
          this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti = new Array<any>();
          this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti = { List: new Array<any>() };
        }
        this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List.push(itemCodeInfoObj);

        addObj = this.setItemCodeNutritionalInfo(this.kymw0900Model.selectedItemCodeIndex, outputVO.analysisSeqNo, outputVO);

        // [複数栄養成分タブ] 栄養成分操作情報 への設定
        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti.push(addObj);

        // 分析単位データグリッドの行の位置づけ
        this.dtg_NutrientUnitListMulti.editableCollectionView.refresh();
        row = this.kymw0900Model.nutrientUnitListMulti.length;
        if (row > 0) {
          // 新規登録なので最終行へ位置づけ
          this.dtg_NutrientUnitListMulti.select(row - 1, 0);
        }
      }
    } else if (outputVO.editMode === 'U') {
      // 編集モードが'U'(コンテキストメニュー「栄養成分メンテナンス」からの呼び出し)だった場合)

      // 分析連番が'0'(栄養成分タブ)のデータに対するメンテナンスだった場合
      if (outputVO.analysisSeqNo === '0') {
        if (Number(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].AnalysisSeqNo)
          === Number(outputVO.analysisSeqNo)) {
          // 分析単位名が変更されていた場合
          if (String(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].AnalysisUnit) !== outputVO.analysisUnit) {
            // hidden 分析単位の再セット
            this.kymw0900Model.hiddenNutrientComponentList[0].analysisUnit = outputVO.analysisUnit;
            // 表示用 分析単位の再セット
            this.updateNutrientUnitList(outputVO.analysisSeqNo, outputVO.analysisUnit);
            // itemCodeInfoListの再セット
            this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].AnalysisUnit = outputVO.analysisUnit;
            // Manageクラス itemCodeNutritionalInfoList へのセット
            for (let ui = 0; ui < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.length; ui++) {
              if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ui].analysisSeqNo === outputVO.analysisSeqNo) {
                if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ui].maintenanceDivUnit === 'I') {
                  this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ui].analysisUnit = outputVO.analysisUnit;
                }
              }
            }
            this.editCount++;
          }
          // 栄養成分備考が変更されていた場合
          if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].NutritionalNote !== outputVO.nutritionalNote) {
            // hidden 栄養成分備考の再セット
            this.kymw0900Model.hiddenNutrientComponentList[0].nutritionalNote = outputVO.nutritionalNote;
            // 表示用 栄養成分備考の再セット
            this.kymw0900Model.nutrientNote = outputVO.nutritionalNote;
            // itemCodeInfoListの再セット
            this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].NutritionalNote = outputVO.nutritionalNote;
            // Manageクラス itemCodeNutritionalInfoList へのセット
            for (let uj = 0; uj < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.length; uj++) {
              if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].analysisSeqNo === outputVO.analysisSeqNo) {
                if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].maintenanceDivUnit === 'I') {
                  if (!PlessViewUtilsSub.isEmpty(outputVO.nutritionalNote)) {
                    this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].maintenanceDivNote = 'I';
                    this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].nutritionalNote = outputVO.nutritionalNote;
                  } else if (PlessViewUtilsSub.isEmpty(outputVO.nutritionalNote)) {
                    this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].maintenanceDivNote = '';
                    this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[uj].nutritionalNote = '';
                  }
                }
              }
            }
            this.editCount++;
          }

          // 栄養成分量が変更されていた場合（栄養成分タブ）
          for (let uk = 0; uk < this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0]
            .NutrientComponentList.List.length; uk++) {
            let qty: string = <string>'';
            if (this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0]
              .NutrientComponentList.List[uk].NutritionalQuantity !== null) {
              qty = String(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0]
                .NutrientComponentList.List[uk].NutritionalQuantity);
            }
            if (qty !== outputVO.nutrientDetailList[uk].nutritionalQuantity) {
              // 表示用 栄養成分量の再セット
              this.updateNutrientDetailList(uk, outputVO.nutrientDetailList[uk].nutritionalQuantity);
              this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritional.List[0].NutrientComponentList.List[uk].NutritionalQuantity
                = outputVO.nutrientDetailList[uk].nutritionalQuantity;
              // Manageクラス itemCodeNutritionalInfoList へのセット
              for (let ul = 0; ul < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional.length; ul++) {
                if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].analysisSeqNo === outputVO.analysisSeqNo) {
                  if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].maintenanceDivUnit === 'I') {
                    // 栄養成分量を入力した場合
                    if (!PlessViewUtilsSub.isEmpty(outputVO.nutrientDetailList[uk].nutritionalQuantity)) {
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].nutrientDetailList[uk]
                        .nutritionalQuantity = outputVO.nutrientDetailList[uk].nutritionalQuantity;
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].
                        nutrientDetailList[uk].maintenanceDivQuantity = 'I';
                    } else if (PlessViewUtilsSub.isEmpty(outputVO.nutrientDetailList[uk].nutritionalQuantity)) {
                      // 栄養成分量を入力していない場合 (一旦入力したが、消した場合も)
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].nutrientDetailList[uk].
                        nutritionalQuantity = '';
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritional[ul].nutrientDetailList[uk].
                        maintenanceDivQuantity = '';
                    }
                  }
                }
              }
              this.editCount++;
            }
          }
        }
        // 分析単位データグリッドの行の位置づけ
        row = this.kymw0900Model.nutrientUnitList.length;
        if (row > 0) {
          this.dtg_NutrientUnitList.selection = new CellRange(-1, 0, -1, -1);
        }
      } else {
        // 分析連番が'0'以外(複数栄養成分タブ)のデータに対するメンテナンスだった場合
        // 分析単位データグリッドの行位置を初期化
        row = 0;

        // 値が変更された場合は編集カウントをインクリメント
        for (let mj = 0; mj < this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List.length; mj++) {
          if (Number(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].AnalysisSeqNo)
            === Number(outputVO.analysisSeqNo)) {
            // 分析単位データグリッドの行位置を保存
            row = mj;

            // 分析単位名が変更されていた場合
            if (String(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].AnalysisUnit)
              !== outputVO.analysisUnit) {

              // hidden 分析単位の再セット
              this.kymw0900Model.hiddenNutrientComponentListMulti[mj].analysisUnit = outputVO.analysisUnit;
              // 表示用 分析単位の再セット
              this.updateNutrientUnitListMulti(outputVO.analysisSeqNo, outputVO.analysisUnit);
              // Manageクラス itemCodeNutritionalInfoList へのセット
              for (let j = Number(0);
                j < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti.length; j++) {
                if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[j].analysisSeqNo
                  === outputVO.analysisSeqNo) {
                  if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[j].maintenanceDivUnit
                    === 'I') {
                    this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[j].analysisUnit
                      = outputVO.analysisUnit;
                  }
                }
              }
              // itemCodeInfoListの再セット
              this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].AnalysisUnit = outputVO.analysisUnit;
              //
              this.editCount++;
            }
            // 栄養成分備考が変更されていた場合
            if (String(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].NutritionalNote)
              !== outputVO.nutritionalNote) {
              // hidden 栄養成分備考の再セット
              this.kymw0900Model.hiddenNutrientComponentListMulti[mj].nutritionalNote = outputVO.nutritionalNote;
              // 表示用 栄養成分備考の再セット
              this.kymw0900Model.nutrientNoteMulti = outputVO.nutritionalNote;
              // Manageクラス itemCodeNutritionalInfoList へのセット
              for (let k = Number(0);
                k < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti.length; k++) {
                if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].analysisSeqNo
                  === outputVO.analysisSeqNo) {
                  if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].maintenanceDivUnit
                    === 'I') {
                    if (!PlessViewUtilsSub.isEmpty(outputVO.nutritionalNote)) {
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].maintenanceDivNote = 'I';
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].nutritionalNote
                        = outputVO.nutritionalNote;
                    } else if (PlessViewUtilsSub.isEmpty(outputVO.nutritionalNote)) {
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].maintenanceDivNote = '';
                      this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[k].nutritionalNote = '';
                    }
                  }
                }
              }
              // itemCodeInfoListの再セット
              this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].NutritionalNote = outputVO.nutritionalNote;
              this.editCount++;
            }
            // 栄養成分量が変更されていた場合（複数栄養成分タブ）
            for (let mk = 0; mk < this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].
              NutrientComponentList.List.length; mk++) {
              const qtyMulti = String(this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj].
                NutrientComponentList.List[mk].NutritionalQuantity);
              if (String(qtyMulti) !== outputVO.nutrientDetailList[mk].nutritionalQuantity) {
                // 表示用 栄養成分量の再セット
                this.updateNutrientDetailListMulti(mk, outputVO.nutrientDetailList[mk].nutritionalQuantity);
                // Manageクラス itemCodeNutritionalInfoList へのセット
                for (let l = Number(0);
                  l < this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti.length; l++) {
                  if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].analysisSeqNo
                    === outputVO.analysisSeqNo) {
                    if (this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].maintenanceDivUnit === 'I') {
                      if (PlessViewUtilsSub.isEmpty(qtyMulti)
                        && !PlessViewUtilsSub.isEmpty(outputVO.nutrientDetailList[mk].nutritionalQuantity)) {
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .maintenanceDivQuantity = 'I';
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .nutritionalQuantity
                          = outputVO.nutrientDetailList[mk].nutritionalQuantity;
                      } else if (!PlessViewUtilsSub.isEmpty(qtyMulti)
                        && PlessViewUtilsSub.isEmpty(outputVO.nutrientDetailList[mk].nutritionalQuantity)) {
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .maintenanceDivQuantity = '';
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .nutritionalQuantity = '';
                      } else if (!PlessViewUtilsSub.isEmpty(qtyMulti)
                        && !PlessViewUtilsSub.isEmpty(outputVO.nutrientDetailList[mk].nutritionalQuantity)) {
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .maintenanceDivQuantity = 'I';
                        this.kymw0900Model.itemCodeNutritionalInfoList[idx].itemCodeNutritionalMulti[l].nutrientDetailList[mk]
                          .nutritionalQuantity = outputVO.nutrientDetailList[mk].nutritionalQuantity;
                      }
                    }
                  }
                }
                // itemCodeInfoListの再セット
                this.kymw0900Model.itemCodeInfoList[idx].ItemCodeNutritionalMulti.List[mj]
                  .NutrientComponentList.List[mk].NutritionalQuantity = outputVO.nutrientDetailList[mk].nutritionalQuantity;
                this.editCount++;
              }
            }
          }
        }
        // 分析単位データグリッドの行の位置づけ
        this.dtg_NutrientUnitListMulti.select(row, -1);
      }
    }
  }

  /**
   * マークコードソート
   * 数値としてソートする。
   */
  private sortMarkCode(obj1: any, obj2: any): number {
    const value1: number = <number>obj1.MarkCode;
    const value2: number = <number>obj2.MarkCode;

    if (value1 < value2) {
      return -1;
    } else if (value1 > value2) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * 複数栄養成分タブの分析単位選択変更時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventNutrientUnitListMulti_CHANGEHandler(grid: FlexGrid): void {
    if (grid.selection.row < 0) {
      return;
    }
    this.kymw0900Model.changeNutrientInfoListMulti(grid.selection.row);
  }


  /**
   * コンテキストメニュー [栄養成分新規登録] のクリック
   */
  public eventAddNutrientContextMenu_CLICKHandler(grid: FlexGrid): void {
    // 栄養成分タブの分析単位数を取得
    const cnt: number = this.kymw0900Model.hiddenNutrientComponentList.length;
    // 複数栄養成分タブの分析単位数を取得
    const cntMulti: number = this.kymw0900Model.hiddenNutrientComponentListMulti.length;

    // 栄養成分タブと複数栄養成分タブの分析単位の合計数を取得
    const cntAll: number = cnt + cntMulti;
    // 合計数が20件以上の場合
    if (cntAll >= 20) {
      // 新規登録は不可
      // 「%1は%2件までしか入力できません。」
      this.dialogServiceSub.openAlertGetMessage('E0221', ['分析単位', '20']);
    } else {
      // 商品企画栄養成分情報メンテナンス画面 (新規登録モード) の呼び出し
      this.eventKYMW0905Insert_CLICKHandler();
    }
  }

  /**
   * コンテキストメニュー [栄養成分新規登録] クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントの参照
   */
  public eventKYMW0905Insert_CLICKHandler(): void {

    // 『商品企画メンテナンス』画面 インプットVOを編集する
    const kymw0905vo: KYMW0905InputModel = new KYMW0905InputModel();

    // 編集モードに'I'(コンテキストメニュー 「栄養成分新規登録」での呼び出し)を設定
    kymw0905vo.editMode = 'I';

    kymw0905vo.orderCode = this.kymw0900Model.orderCode;
    kymw0905vo.pCode = this.kymw0900Model.pCode;
    kymw0905vo.itemCode = this.kymw0900Model.itemCode;
    kymw0905vo.guideGoodsName = this.txti_GuideGoodsName.text;
    kymw0905vo.guideStandardName = this.txti_GuideStandardName.text;

    // 選択中のタブの位置を取得
    const selectedTabIdx: number = this.tab_item.selectedIndex;
    // 栄養成分タブの場合
    if (selectedTabIdx === 4) {
      kymw0905vo.analysisSeqNo = '0';	// 0固定
      kymw0905vo.multiFlag = false;
    } else if (selectedTabIdx === 5) {
      // 複数栄養成分タブの場合
      // 分析連番の採番
      kymw0905vo.analysisSeqNo = this.getNextSeqNo(this.kymw0900Model.selectedItemCodeIndex);
      kymw0905vo.multiFlag = true;
    }

    kymw0905vo.analysisUnit = '';
    kymw0905vo.nutritionalNote = '';
    kymw0905vo.nutrientDetailList = this.getCodeMasterpNutritionalDetailList();

    // ポップアップ
    const componentRef = this.dialogServiceSub.openModal(KYMW0905Component);
    const instance = componentRef.componentInstance as KYMW0905Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw0905vo);
    instance.setKYMW0905Parameter = (outputVo: KYMW0905OutputModel) => {
      // 栄養成分文字編集画面から戻った場合
      this.setKYMW0905Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };

  }

  /**
   * アイテム毎に保持している栄養成分の分析連番の新しい番号を採番
   * @param idx アイテムコードの選択位置
   */
  private getNextSeqNo(idx: number): string {
    // 現在の最大値を取得
    let seqNo = Number(this.kymw0900Model.saveAnalysisSeqNo[idx]);
    // インクリメント
    seqNo++;
    // 最大値を書き換える
    this.kymw0900Model.saveAnalysisSeqNo[idx] = String(seqNo);

    return String(seqNo);
  }

  /**
   * コードマスタP栄養成分情報を返却
   */
  private getCodeMasterpNutritionalDetailList(): Array<any> {
    const nutrientDetailList: Array<any> = this.kymw0900Model.codeMasterpNutritionalList;

    const retList: Array<any> = new Array<any>();
    for (let i = 0; i < nutrientDetailList.length; i++) {
      const nutrientDetail = nutrientDetailList[i];
      const detailXml = {
        NutritionalName: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalName),
        NutritionalQuantity: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalQuantity),
        NutritionalUnit: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalUnit),
        NutritionalCode: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalCode),
        PublishDiv: PlessViewUtilsSub.nullToBlank(nutrientDetail.publishDiv),
        Hirearchy: PlessViewUtilsSub.nullToBlank(nutrientDetail.hirearchy),
      };
      retList.push(detailXml);
    }
    return retList;
  }

  /**
   * コンテキストメニュー [栄養成分メンテナンス] のクリック
   */
  public eventUpdateNutrientContextMenu_CLICKHandler(grid: FlexGrid): void {
    if (grid.selection.row < 0) {
      // 「分析単位が選択されていません」
      this.dialogServiceSub.openAlertGetMessage('E0103', ['分析単位']);
    } else {
      // 商品企画栄養成分情報メンテナンス画面 (メンテナンスモード) の呼び出し
      this.eventKYMW0905Update_CLICKHandler();
    }
  }

  /**
   * [栄養成分タブ] hidden への設定
   * @param outputVO メンテナンス画面から返却された栄養成分情報(新規登録)
   */
  private setHiddenNutrientComponentInfo(outputVO: KYMW0905OutputModel): any {
    const obj = {
      analysisSeqNo: outputVO.analysisSeqNo,
      analysisUnit: outputVO.analysisUnit,
      nutrientDetailList: new Array<any>(),
      nutritionalNote: outputVO.nutritionalNote,
    };
    for (let j = Number(0); j < outputVO.nutrientDetailList.length; j++) {
      obj.nutrientDetailList.push(this.setNutrientComponentList(outputVO.nutrientDetailList[j]));
    }
    return obj;
  }

  /**
   * [栄養成分タブ] 栄養成分詳細情報 の組み立て
   * @param idx リストインデックス
   * @param nutrientDetail メンテナンス画面から返却された栄養成分詳細情報
   */
  private setNutrientComponentList(nutrientDetail: any): any {
    const coopXml = {
      NutritionalName: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalName),
      NutritionalQuantity: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalQuantity),
      NutritionalUnit: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalUnit),
      NutritionalCode: PlessViewUtilsSub.nullToBlank(nutrientDetail.nutritionalCode),
      PublishDiv: PlessViewUtilsSub.nullToBlank(nutrientDetail.publishDiv),
      Hirearchy: PlessViewUtilsSub.nullToBlank(nutrientDetail.hirearchy),
    };
    return coopXml;
  }

  /**
   * [栄養成分タブ] 栄養成分詳細情報 の組み立て
   * @param idx リストインデックス
   * @param nutrientDetail メンテナンス画面から返却された栄養成分詳細情報
   */
  private setItemListInfoComponentList(nutrientDetail: any): any {
    const retObj = {
      NutritionalName: nutrientDetail.nutritionalName,
      NutritionalQuantity: nutrientDetail.nutritionalQuantity,
      NutritionalUnit: nutrientDetail.nutritionalUnit,
      NutritionalCode: nutrientDetail.nutritionalCode,
      PublishDiv: nutrientDetail.publishDiv,
      Hirearchy: nutrientDetail.hirearchy,
    };
    return retObj;
  }

  /**
   * Manageクラス ItemCodeNutritionalInfoList の設定
   * @param idx リストインデックス
   * @param nutrientDetail メンテナンス画面から返却された栄養成分詳細情報
   */
  private setItemCodeNutritionalDetail(nutrientDetail: any): any {
    const retObj = {
      nutritionalCode: nutrientDetail.nutritionalCode,
      nutritionalName: nutrientDetail.nutritionalName,
      nutritionalQuantity: nutrientDetail.nutritionalQuantity,
      nutritionalUnit: nutrientDetail.nutritionalUnit,
      publishDiv: nutrientDetail.publishDiv,
      hirearchy: nutrientDetail.hirearchy,
      maintenanceDivQuantity: '',
    };
    // 栄養成分量が画面で入力されていた場合
    if (!PlessViewUtilsSub.isEmpty(nutrientDetail.nutritionalQuantity)) {
      // メンテナンス種別(栄養成分量用)へ'I'(新規登録対象)を設定
      retObj.maintenanceDivQuantity = 'I';
    }
    return retObj;
  }

  /**
   * [栄養成分タブ] 表示用・分析単位リストへの分析単位の設定
   * @param analysisSeqNo 分析連番
   * @param analysisUnit 分析単位
   */
  private setNutrientUnitList(analysisSeqNo: string, analysisUnit: string): any {
    const coopXml = {
      AnalysisSeqNo: PlessViewUtilsSub.nullToBlank(analysisSeqNo),
      AnalysisUnit: PlessViewUtilsSub.nullToBlank(analysisUnit),
    };
    return coopXml;
  }

  /**
   * [栄養成分タブ] 表示用・分析単位リストへの分析単位の再設定
   * @param analysisSeqNo 分析連番
   * @param analysisUnit 分析単位
   */
  private updateNutrientUnitList(analysisSeqNo: string, analysisUnit: string): void {
    for (let i = 0; i < this.kymw0900Model.nutrientUnitList.length; i++) {
      const obj = this.kymw0900Model.nutrientUnitList[i];
      const seqNo: string = obj.AnalysisSeqNo;
      // 分析連番が一致した場合
      if (seqNo === analysisSeqNo) {
        const coopXml = {
          AnalysisSeqNo: PlessViewUtilsSub.nullToBlank(seqNo),
          AnalysisUnit: PlessViewUtilsSub.nullToBlank(analysisUnit),
        };
        this.kymw0900Model.nutrientUnitList[i] = coopXml;
      }
    }
    this.dtg_NutrientUnitList.editableCollectionView.refresh();
  }

  /**
   * [栄養成分タブ] 表示用・栄養成分詳細リストへの栄養成分量の再設定
   * @param idx リストインデックス
   * @param qty 栄養成分量
   */
  private updateNutrientDetailList(idx: number, qty: string): void {
    const obj = this.kymw0900Model.nutrientDetailList[idx];
    const coopXml = {
      NutritionalName: PlessViewUtilsSub.nullToBlank(obj.NutritionalName),
      NutritionalQuantity: PlessViewUtilsSub.nullToBlank(qty),
      NutritionalUnit: PlessViewUtilsSub.nullToBlank(obj.NutritionalUnit),
      NutritionalCode: PlessViewUtilsSub.nullToBlank(obj.NutritionalCode),
      PublishDiv: PlessViewUtilsSub.nullToBlank(obj.PublishDiv),
      Hirearchy: PlessViewUtilsSub.nullToBlank(obj.Hirearchy),
    };
    // [栄養成分タブ] 表示用・栄養成分詳細リストへの再設定
    this.kymw0900Model.nutrientDetailList[idx] = coopXml;
    this.dtg_NutrientComponentList.editableCollectionView.refresh();
  }

  /**
   * [栄養成分タブ] 栄養成分操作情報 への設定
   * @param idx アイテムコードの選択位置
   * @param seqNo 設定する分析連番
   * @param outputVO メンテナンス画面から返却された栄養成分情報(新規登録)
   */
  private setItemCodeNutritionalInfo(idx: number, seqNo: string, outputVO: KYMW0905OutputModel): Object {
    const retObj = {
      analysisSeqNo: seqNo,
      analysisUnit: outputVO.analysisUnit,
      // メンテナンス種別(分析単位用)へ'I'(新規登録対象)を設定
      maintenanceDivUnit: 'I',
      nutritionalNote: outputVO.nutritionalNote,
      maintenanceDivNote: '',
      nutrientDetailList: new Array<any>(),
    };
    if (!PlessViewUtilsSub.isEmpty(outputVO.nutritionalNote)) {
      // メンテナンス種別(栄養成分備考用)へ'I'(新規登録対象)を設定
      retObj.maintenanceDivNote = 'I';
    }
    retObj.nutrientDetailList = new Array<any>();
    for (let i = Number(0); i < outputVO.nutrientDetailList.length; i++) {
      retObj.nutrientDetailList.push(this.setItemCodeNutritionalDetail(outputVO.nutrientDetailList[i]));
    }

    return retObj;
  }

  /**
   * [複数栄養成分タブ] 表示用・分析単位リストへの分析単位の再設定
   * @param analysisSeqNo 分析連番
   * @param analysisUnit 分析単位
   */
  private updateNutrientUnitListMulti(analysisSeqNo: string, analysisUnit: string): void {
    for (let i = Number(0); i < this.kymw0900Model.nutrientUnitListMulti.length; i++) {
      const obj = this.kymw0900Model.nutrientUnitListMulti[i];
      const seqNo: string = obj.AnalysisSeqNo;
      // 分析連番が一致した場合
      if (seqNo === analysisSeqNo) {
        const coopXml = {
          AnalysisSeqNo: PlessViewUtilsSub.nullToBlank(seqNo),
          AnalysisUnit: PlessViewUtilsSub.nullToBlank(analysisUnit),
        };
        // [複数栄養成分タブ] 表示用・分析単位リストへの再設定
        this.kymw0900Model.nutrientUnitListMulti[i] = coopXml;
      }
    }
    this.dtg_NutrientUnitListMulti.editableCollectionView.refresh();
  }

  /**
   * [複数栄養成分タブ] 表示用・栄養成分詳細リストへの栄養成分量の再設定
   * @param idx リストインデックス
   * @param qty 栄養成分量
   */
  private updateNutrientDetailListMulti(idx: number, qty: string): void {
    const obj = this.kymw0900Model.nutrientDetailListMulti[idx];
    const coopXml = {
      NutritionalName: PlessViewUtilsSub.nullToBlank(obj.NutritionalName),
      NutritionalQuantity: PlessViewUtilsSub.nullToBlank(qty),
      NutritionalUnit: PlessViewUtilsSub.nullToBlank(obj.NutritionalUnit),
      NutritionalCode: PlessViewUtilsSub.nullToBlank(obj.NutritionalCode),
      PublishDiv: PlessViewUtilsSub.nullToBlank(obj.PublishDiv),
      Hirearchy: PlessViewUtilsSub.nullToBlank(obj.Hirearchy),
    };
    // [複数栄養成分タブ] 表示用・栄養成分詳細リストへの再設定
    this.kymw0900Model.nutrientDetailListMulti[idx] = coopXml;
    this.dtg_NutrientComponentListMulti.editableCollectionView.refresh();
  }

  /**
   * コンテキストメニュー [栄養成分削除] のクリック
   */
  public eventRemoveNutrientContextMenu_CLICKHandler(grid: FlexGrid, multiFlag = false): void {
    if (grid.selection.row < 0) {
      // 「分析単位が選択されていません」
      this.dialogServiceSub.openAlertGetMessage('E0103', ['分析単位']);
    } else {
      // 削除確認メッセージを表示
      const idx: number = grid.selection.row;
      const list: Array<any> = Array<any>(grid.collectionView.items);

      this.dialogServiceSub.openAlertGetMessage('Q0106', ['選択した分析単位の栄養成分情報'],
        (closeDetail) => { // はいを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            // 複数栄養成分タブでの削除の場合
            if (multiFlag) {
              this.removeNutrientInfoListMulti(idx);
              // 栄養成分タブでの削除の場合
            } else {
              this.removeNutrientInfoList();
            }
          }
        }
      );
    }
  }

  /**
   * コンテキストメニュー [栄養成分メンテナンス] クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントの参照
   */
  public eventKYMW0905Update_CLICKHandler(): void {

    // 『商品企画メンテナンス』画面 インプットVOを編集する
    const kymw0905vo: KYMW0905InputModel = new KYMW0905InputModel();

    // 編集モードに'U'(コンテキストメニュー 「栄養成分メンテナンス」での呼び出し)を設定
    kymw0905vo.editMode = 'U';

    kymw0905vo.orderCode = this.kymw0900Model.orderCode;
    kymw0905vo.pCode = this.kymw0900Model.pCode;
    kymw0905vo.itemCode = this.kymw0900Model.itemCode;
    kymw0905vo.guideGoodsName = this.txti_GuideGoodsName.text;
    kymw0905vo.guideStandardName = this.txti_GuideStandardName.text;

    // 選択中のタブの位置を取得
    const selectedTabIdx: number = this.tab_item.selectedIndex;
    // 栄養成分タブの場合
    if (selectedTabIdx === 4) {
      kymw0905vo.analysisSeqNo = this.kymw0900Model.hiddenNutrientComponentList[0].analysisSeqNo;
      kymw0905vo.analysisUnit = this.kymw0900Model.hiddenNutrientComponentList[0].analysisUnit;
      kymw0905vo.nutritionalNote = this.kymw0900Model.hiddenNutrientComponentList[0].nutritionalNote;
      kymw0905vo.nutrientDetailList = this.cloneNutrientDetailList(this.kymw0900Model.hiddenNutrientComponentList[0].nutrientDetailList);
    } else if (selectedTabIdx === 5) {
      // 複数栄養成分タブの場合
      // 選択した分析単位の行位置を取得
      const idx: number = this.dtg_NutrientUnitListMulti.selection.row;
      kymw0905vo.analysisSeqNo = this.kymw0900Model.hiddenNutrientComponentListMulti[idx].analysisSeqNo;
      kymw0905vo.analysisUnit = this.kymw0900Model.hiddenNutrientComponentListMulti[idx].analysisUnit;
      kymw0905vo.nutritionalNote = this.kymw0900Model.hiddenNutrientComponentListMulti[idx].nutritionalNote;
      kymw0905vo.nutrientDetailList = this.cloneNutrientDetailList(this.kymw0900Model.hiddenNutrientComponentListMulti[idx]
        .nutrientDetailList);
    }
    const componentRef = this.dialogServiceSub.openModal(KYMW0905Component);
    const instance = componentRef.componentInstance as KYMW0905Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw0905vo);
    instance.setKYMW0905Parameter = (outputVo: KYMW0905OutputModel) => {
      // 発注先取引先画面から戻った場合
      this.setKYMW0905Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 栄養成分タブの栄養成分削除
   */
  private removeNutrientInfoList(): void {
    const itemCode: string = this.kymw0900Model.itemCode;
    const analysisSeqNo: string = this.kymw0900Model.hiddenNutrientComponentList[0].analysisSeqNo;

    // サーバ側へ渡す削除情報を設定
    for (let i = Number(0); i < this.kymw0900Model.itemCodeNutritionalInfoList.length; i++) {
      // アイテムコードが一致した場合
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCode === itemCode) {
        if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length === 1) {
          // 1件目が画面で新規登録した分析単位の場合
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].maintenanceDivUnit === 'I') {
            // 1件目を削除
            this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.splice(0, 1);
          } else if (PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i]
            .itemCodeNutritional[0].maintenanceDivUnit)
            || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].maintenanceDivUnit === 'U') {
            // 1件目が画面呼び出し時にDBから取得した分析単位が未修正の場合、または画面呼び出し時にDBから取得した分析単位を修正していた場合

            // メンテナンス種別(分析単位用)へ'D'(削除対象)を設定
            this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].maintenanceDivUnit = 'D';
            // 栄養成分備考は、値が格納されている場合にメンテナンス種別(栄養成分備考用)へ'D'(削除対象)を設定
            if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].nutritionalNote)) {
              this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].maintenanceDivNote = 'D';
            }
            // 栄養成分量は、値が格納されている場合にメンテナンス種別(栄養成分量用)へ'D'(削除対象)を設定
            for (let k = Number(0);
              k < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].nutrientDetailList.length; k++) {
              if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].nutrientDetailList[k]
                .NutritionalQuantity)) {
                this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[0].nutrientDetailList[k].MaintenanceDivQuantity = 'D';
              }
            }
          }

          // 栄養成分タブに表示されている該当の分析単位、栄養成分詳細、hiddenを削除
          this.removeViewNutrientUnitList(analysisSeqNo);
          this.removeHiddenNutrientComponentList(analysisSeqNo);
          this.removeItemInfoNutrientList(Number(analysisSeqNo), itemCode);
          // 分析単位が削除された場合は編集カウントをインクリメント
          this.editCount++;
        } else if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.length === 2) {
          // 2件存在する場合は、「1件目が画面呼び出し時にDBから取得した分析単位を削除した場合、2件目が画面で新規登録した分析単位の場合」を想定

          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional[1].maintenanceDivUnit === 'I') {
            // 2件目を削除
            this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritional.splice(1, 1);
          }

          // 栄養成分タブに表示されている該当の分析単位、栄養成分詳細、hiddenを削除
          this.removeViewNutrientUnitList(analysisSeqNo);
          this.removeHiddenNutrientComponentList(analysisSeqNo);
          this.removeItemInfoNutrientList(Number(analysisSeqNo), itemCode);
          // 分析単位が削除された場合は編集カウントをインクリメント
          this.editCount++;
        }
      }
    }
  }

  /**
   * 栄養成分タブに表示されている分析単位、栄養成分詳細、栄養成分備考の削除
   * @param analysisSeqNo 分析連番
   */
  private removeViewNutrientUnitList(analysisSeqNo: string): void {
    for (let i = Number(0); i < this.kymw0900Model.nutrientUnitList.length; i++) {
      const goods = this.kymw0900Model.nutrientUnitList[i];
      if (goods.AnalysisSeqNo === analysisSeqNo) {
        this.kymw0900Model.nutrientDetailList = new Array<any>();
        this.kymw0900Model.nutrientUnitList = new Array<any>();
        this.txta_NutrientComponentComment.text = '';
        return;
      }
    }
  }

  /**
   * 栄養成分タブのhidden情報の削除
   * @param analysisSeqNo 分析連番
   */
  private removeHiddenNutrientComponentList(analysisSeqNo: string): void {
    for (let i = Number(0); i < this.kymw0900Model.hiddenNutrientComponentList.length; i++) {
      if (this.kymw0900Model.hiddenNutrientComponentList[i].analysisSeqNo === analysisSeqNo) {
        this.kymw0900Model.hiddenNutrientComponentList.splice(i, 1);
        return;
      }
    }
  }

  /**
   * アイテム毎の栄養成分情報の削除
   * @param analysisSeqNo 分析連番
   * @param itemCode アイテムコード
   */
  private removeItemInfoNutrientList(analysisSeqNo: number, itemCode: string): void {
    for (let i = Number(0); i < this.kymw0900Model.itemCodeInfoList.length; i++) {
      if (String(this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode) === itemCode) {
        if (Number(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List[0].AnalysisSeqNo) === analysisSeqNo) {
          this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritional.List = null;
          return;
        }
      }
    }
  }

  /**
   * 複数栄養成分タブの栄養成分削除
   * @param idx 削除指定した画面の分析単位の表示順
   */
  private removeNutrientInfoListMulti(idx: number): void {
    const itemCode: string = this.kymw0900Model.itemCode;
    const analysisSeqNo: string = this.kymw0900Model.hiddenNutrientComponentListMulti[idx].analysisSeqNo;

    // サーバ側へ渡す削除情報を設定
    for (let i = Number(0); i < this.kymw0900Model.itemCodeNutritionalInfoList.length; i++) {
      // アイテムコードが一致した場合
      if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCode === itemCode) {
        for (let j = Number(0); j < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length; j++) {
          // 分析連番が一致した場合
          if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].analysisSeqNo === analysisSeqNo) {
            if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivUnit === 'I') {
              // 該当の分析単位を削除
              this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.splice(j, 1);
            } else if (PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j]
              .maintenanceDivUnit)
              || this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivUnit === 'U') {
              // 画面呼び出し時にDBから取得した分析単位が未修正の場合、または画面呼び出し時にDBから取得した分析単位を修正していた場合

              // メンテナンス種別(分析単位用)へ'D'(削除対象)を設定
              this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivUnit = 'D';
              // 栄養成分備考は、値が格納されている場合にメンテナンス種別(栄養成分備考用)へ'D'(削除対象)を設定
              if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i]
                .itemCodeNutritionalMulti[j].nutritionalNote)) {
                this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivNote = 'D';
              }
              // 栄養成分量は、値が格納されている場合にメンテナンス種別(栄養成分量用)へ'D'(削除対象)を設定
              for (let k = Number(0); k < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].
                nutrientDetailList.length; k++) {
                if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j]
                  .nutrientDetailList[k].nutritionalQuantity)) {
                  this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j]
                    .nutrientDetailList[k].maintenanceDivQuantity = 'D';
                }
              }
            }

            // 複数栄養成分タブに表示されている該当の分析単位、栄養成分詳細、hiddenを削除
            this.removeViewNutrientUnitListMulti(analysisSeqNo);
            this.removeHiddenNutrientComponentListMulti(analysisSeqNo);
            this.removeItemInfoNutrientListMulti(Number(analysisSeqNo), itemCode);
            // 分析単位が削除された場合は編集カウントをインクリメント
            this.editCount++;
          }
        }
      }
    }

    const idx2: number = this.kymw0900Model.selectedItemCodeIndex;
    // 複数栄養成分タブに表示するデータが存在する場合
    if (this.kymw0900Model.itemCodeInfoList[idx2].ItemCodeNutritionalMulti !== null) {
      if (this.kymw0900Model.itemCodeInfoList[idx2].ItemCodeNutritionalMulti.List.length > 0) {
        // 1行目の分析単位に位置づけ
        this.dtg_NutrientUnitListMulti.select(0, -1);
        this.kymw0900Model.nutrientDetailListMulti = this.kymw0900Model.hiddenNutrientComponentListMulti[0].nutrientDetailList;
        this.kymw0900Model.nutrientNoteMulti = this.kymw0900Model.hiddenNutrientComponentListMulti[0].nutritionalNote;
      }
    }
  }

  /**
   * 複数栄養成分タブに表示されている分析単位、栄養成分詳細、栄養成分備考の削除
   * @param analysisSeqNo 分析連番
   */
  private removeViewNutrientUnitListMulti(analysisSeqNo: string): void {
    for (let i = Number(0); i < this.kymw0900Model.nutrientDetailListMulti.length; i++) {
      const goods = this.kymw0900Model.nutrientUnitListMulti[i];
      if (goods.AnalysisSeqNo === analysisSeqNo) {
        this.kymw0900Model.nutrientUnitListMulti.splice(i, 1);
        this.kymw0900Model.nutrientDetailListMulti = [];
        this.kymw0900Model.nutrientNoteMulti = '';
        this.dtg_NutrientUnitListMulti.editableCollectionView.refresh();
        this.dtg_NutrientComponentListMulti.editableCollectionView.refresh();
        return;
      }
    }
  }

  /**
   * 複数栄養成分タブのhidden情報の削除
   * @param analysisSeqNo 分析連番
   */
  private removeHiddenNutrientComponentListMulti(analysisSeqNo: string): void {
    for (let i = Number(0); i < this.kymw0900Model.hiddenNutrientComponentListMulti.length; i++) {
      if (this.kymw0900Model.hiddenNutrientComponentListMulti[i].analysisSeqNo === analysisSeqNo) {
        this.kymw0900Model.hiddenNutrientComponentListMulti.splice(i, 1);
        return;
      }
    }
  }

  /**
   * アイテム毎の複数栄養成分情報の削除
   * @param analysisSeqNo 分析連番
   * @param itemCode アイテムコード
   */
  private removeItemInfoNutrientListMulti(analysisSeqNo: number, itemCode: string): void {
    for (let i = Number(0); i < this.kymw0900Model.itemCodeInfoList.length; i++) {
      //  if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode === itemCode) {
      if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode === itemCode) {
        for (let j = Number(0); j < this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length; j++) {
          if (Number(this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List[j].AnalysisSeqNo) === analysisSeqNo) {
            this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.splice(j, 1);
            return;
          }
        }
      }
    }
  }

  /**
   * 複数栄養成分タブの栄養成分全削除
   */
  private removeAllNutrientInfoListMulti(): void {
    const itemCode: string = this.kymw0900Model.itemCode;

    if (this.dtg_NutrientUnitListMulti.collectionView.items.length > 0) {
      // サーバ側へ渡す削除情報を設定
      for (let i = Number(0); i < this.kymw0900Model.itemCodeNutritionalInfoList.length; i++) {
        // アイテムコードが一致した場合
        if (this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCode === itemCode) {
          for (let j = Number(0); j < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti.length; j++) {
            // メンテナンス種別(分析単位用)へ'D'(削除対象)を設定
            this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivUnit = 'D';
            // 栄養成分備考は、値が格納されている場合にメンテナンス種別(栄養成分備考用)へ'D'(削除対象)を設定
            if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j]
              .nutritionalNote)) {
              this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].maintenanceDivNote = 'D';
            }
            for (let k = Number(0); k < this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].
              nutrientDetailList.length; k++) {
              if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j]
                .nutrientDetailList[k].nutritionalQuantity)) {
                // 栄養成分量は、値が格納されている場合にメンテナンス種別(栄養成分量用)へ'D'(削除対象)を設定
                this.kymw0900Model.itemCodeNutritionalInfoList[i].itemCodeNutritionalMulti[j].nutrientDetailList[k]
                  .maintenanceDivQuantity = 'D';
              }
            }
          }

          // 複数栄養成分タブに存在している全ての分析単位、栄養成分詳細、hiddenを削除
          this.removeAllViewNutrientUnitListMulti();
          this.removeAllHiddenNutrientComponentListMulti();
          this.removeAllItemInfoNutrientListMulti(itemCode);
          // 分析単位が削除された場合は編集カウントをインクリメント
          this.editCount++;
        }
      }
    }
  }

  /**
   * 複数栄養成分タブに存在している分析単位、栄養成分詳細、栄養成分備考の削除
   */
  private removeAllViewNutrientUnitListMulti(): void {
    if (this.dtg_NutrientUnitListMulti.collectionView.items.length > 0) {
      this.kymw0900Model.nutrientUnitListMulti = new Array<any>();
      this.kymw0900Model.nutrientDetailListMulti = new Array<any>();
      this.txta_NutrientComponentCommentMulti.text = '';
    }
  }

  /**
   * 複数栄養成分タブで使用している全てのhidden情報の削除
   */
  private removeAllHiddenNutrientComponentListMulti(): void {
    if (this.kymw0900Model.hiddenNutrientComponentListMulti.length > 0) {
      this.kymw0900Model.hiddenNutrientComponentListMulti = new Array<any>();
    }
  }

  /**
   * アイテム毎の複数栄養成分情報の全削除
   * @param itemCode アイテムコード
   */
  private removeAllItemInfoNutrientListMulti(itemCode: string): void {
    for (let i = Number(0); i < this.kymw0900Model.itemCodeInfoList.length; i++) {
      if (this.kymw0900Model.itemCodeInfoList[i].ItemCodeCommon.ItemCode === itemCode) {
        this.kymw0900Model.itemCodeInfoList[i].ItemCodeNutritionalMulti.List = new Array<any>();
      }
    }
  }

  /**
   * 商品企画メンテ変更管理テーブル「画面表示用データ項目名」へ設定する内容　(分析単位)
   * @param unit 分析単位
   */
  private editItemNameForUnit(unit: string): string {
    // 分析単位は10文字まで
    const retStr: string = unit.substring(0, 10);
    return retStr;
  }

  /**
   * 商品企画メンテ変更管理テーブル「画面表示用データ項目名」へ設定する内容　(栄養成分備考)
   * @param unit 分析単位
   */
  private editItemNameForNote(unit: string): string {
    // 備考は、編集後の「分析単位」 + '　備考'
    const retStr: string = this.editItemNameForUnit(String(unit)) + '　備考';
    return retStr;
  }

  /**
   * 商品企画メンテ変更管理テーブル「画面表示用データ項目名」へ設定する内容　(栄養成分量)
   * @param unit 分析単位
   * @param nutritionalName 栄養成分名称
   */
  private editItemNameForQuantity(unit: string, nutritionalName: string): string {
    // 栄養成分名称の前方の全角スペースを一旦無くす
    let str: string = nutritionalName;
    for (let i = Number(0); i < nutritionalName.length; i++) {
      if (str.substring(0, 1) === '　') {
        str = str.substring(1, str.length);
      }
    }
    // 栄養成分量は、編集後の「分析単位」 + 全角スペース1文字 + 編集後の「栄養成分名称」
    str = this.editItemNameForUnit(String(unit)) + '　' + str;
    // さらに200文字まで
    const retStr: string = str.substring(0, 200);
    return retStr;
  }

  /**
   * 商品企画栄養成分情報メンテナンス画面のために栄養成分詳細情報リストのクローンを作る。
   * @param nutrientDetailList 栄養成分詳細情報リスト
   */
  private cloneNutrientDetailList(nutrientDetailList: Array<any>): Array<any> {
    const list: Array<any> = new Array<any>();
    for (let i = Number(0); i < nutrientDetailList.length; i++) {
      list.push(nutrientDetailList[i]);
    }
    return list;
  }

  /**
   * チェックボックス処理
   *
   * @memberof KYMW0900Component
   */
  public checkBoxEventCoopMark(event: Event, grid: FlexGrid): void {

    // 押下されたチェックボックスの状態を取得
    const checkStatus: boolean = event.target['checked'];

    // collectinViewでgridに表示している情報を取得
    const items = grid.collectionView.items;
    if (this.kymw0900Model.allcoopValue) {
      const checkId: string = event.target['id'].substr(0, 14);
      for (let i = Number(0); i < items.length; i++) {
        if (items[i].Enabled === '1') {
          // 対象の生協のみ更新する
          switch (checkId) {
            case 'cb_coop_mark_1':
              items[i].Mark1Value = checkStatus;
              break;
            case 'cb_coop_mark_2':
              items[i].Mark2Value = checkStatus;
              break;
            case 'cb_coop_mark_3':
              items[i].Mark3Value = checkStatus;
              break;
            case 'cb_coop_mark_4':
              items[i].Mark4Value = checkStatus;
              break;
            case 'cb_coop_mark_5':
              items[i].Mark5Value = checkStatus;
              break;
          }
        }
      }
      grid.editableCollectionView.refresh();
    }
    // 変更があったタイミングでコピーしておく
    this.coopMarkList.splice(grid.selection.row, 1, items[grid.selection.row]);
  }

  /**
 * チェックボックス処理
 *
 * @memberof KYMW0900Component
 */
  public checkBoxEventMarkInfo(event: Event, grid: FlexGrid): void {

    // 押下されたセルの位置を取得(行)
    let selectedRow = this.dtg_MarkInfo.selection.row;

    // ソートされている場合を考慮し、ソート後の配列と当てつけを行い選択行を矯正
    // 基になる（フィルタリングもソートもされていない）コレクションを取得
    const orgItems = this.dtg_MarkInfo.collectionView.sourceCollection;
    // 編集行を取得
    const editRow = this.dtg_MarkInfo.collectionView.items[selectedRow];

    for (let i = Number(0); i < orgItems.length; i++) {
      if (orgItems[i] === editRow) {
        // 元データにおける行の位置を取得
        selectedRow = i;
      }
    }

    // 押下されたチェックボックスの状態を取得
    const checkStatus: boolean = event.target['checked'];

    // 全生協
    if (this.kymw0900Model.allcoopValue2) {
      // 各生協のチェックボックスを、押下されたチェックボックスの状態で更新（会員タブでチェックがついている生協のみが対象）
      this.kymw0900Model.markInfoList[selectedRow].SelectValue1 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_IB] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue2 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TO] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue3 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_GU] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue4 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TI] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue5 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_SA] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue6 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TK] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue7 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NA] ? checkStatus : false;
      this.kymw0900Model.markInfoList[selectedRow].SelectValue8 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NI] ? checkStatus : false;
    }
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0900Component
   */
  plessEnabledSetting() {
    this.setEnable(this.plessEnabledFlag);
  }

  /**
   * 画面内の部品をすべて活性・非活性にするメソッド
   *
   * @private
   * @param {boolean} boolean
   * @memberof KYMW0900Component
   */
  private setEnable(boolean: boolean) {

    this.kymw0900Model.isDisabledForGrid = !boolean;

    // Ｐコード共通
    this.plessEnabled(this.cmb_PCode, true);
    this.plessEnabled(this.cmb_ClassCode, boolean);
    this.plessEnabled(this.cmb_LargeClassCode, boolean);
    this.plessEnabled(this.cmb_MiddleClassCode, boolean);
    this.plessEnabled(this.cmb_SmallClassCodeList, boolean);
    this.plessEnabled(this.txti_GuideGoodsName, boolean);
    this.plessEnabled(this.txti_GuideStandardName, boolean);
    this.plessEnabled(this.chk_PackMaterialShowFlag, boolean);
    // 基本
    this.plessEnabled(this.txti_RelationPcodeOld, boolean);
    this.plessEnabled(this.txti_RelationPcodeNew, boolean);
    this.plessEnabled(this.cmb_ConsumeTaxDivList, boolean);
    this.plessEnabled(this.cmb_CycleTerm, boolean);
    this.plessEnabled(this.cmb_EdlpDiv, boolean);
    this.plessEnabled(this.cmb_RoomTempZoneDiv, boolean);
    this.plessEnabled(this.cmb_UnitPriceDiv, boolean);
    this.plessEnabled(this.cmb_LiquorCode, boolean);
    this.plessEnabled(this.cmb_ContainerForm, boolean);
    this.plessEnabled(this.cmb_BlindDiv, boolean);
    this.plessEnabled(this.cmb_KomaScheduleDiv, boolean);
    this.plessEnabled(this.txti_AlcoholType, boolean);
    this.plessEnabled(this.txti_ContainerCapacity, boolean);
    this.plessEnabled(this.txti_DeliveryGoodsNameKanji, boolean);
    this.plessEnabled(this.txti_DeliveryStandardNameKanji, boolean);
    this.plessEnabled(this.txti_DeliveryGoodsNameKana, boolean);
    this.plessEnabled(this.txti_DeliveryStandardNameKana, boolean);
    this.plessEnabled(this.txti_OcrGoodsName, boolean);
    this.plessEnabled(this.txti_ConsumeTaxDivRate, boolean);
    this.plessEnabled(this.txti_UnitPriceCoefficient, boolean);
    this.plessEnabled(this.txti_UnitPriceUnit, boolean);
    this.plessEnabled(this.txti_ConsumeTerm, boolean);
    this.plessEnabled(this.txti_ConsumeByDate, boolean);
    this.plessEnabled(this.txti_LeaveConsumeTerm, boolean);
    this.plessEnabled(this.btn_RelationPcode, boolean);
    // 会員
    this.plessEnabled(this.cmb_PricePattern, boolean);
    this.plessEnabled(this.chk_AllcoopValue, boolean);
    this.plessEnabled(this.txti_AllthistimeSupplyPrice, boolean);
    this.plessEnabled(this.txti_AllthistimeCostPrice, boolean);
    this.plessEnabled(this.btn_BatchReflection, boolean);
    // 詳細
    this.plessEnabled(this.txti_ListingGoodsName, boolean);
    // 付加
    this.plessEnabled(this.lnb_TextInfo1, boolean);
    this.plessEnabled(this.txta_TextInfo1, boolean);
    this.plessEnabled(this.lnb_TextInfo2, boolean);
    this.plessEnabled(this.txta_TextInfo2, boolean);
    this.plessEnabled(this.lnb_TextInfo3, boolean);
    this.plessEnabled(this.txta_TextInfo3, boolean);
    this.plessEnabled(this.txta_TextInfo4, boolean);
    this.plessEnabled(this.txta_TextInfo5, boolean);
    this.plessEnabled(this.txta_TextInfo6, boolean);
    this.plessEnabled(this.txta_TextInfo7, boolean);
    this.plessEnabled(this.lnb_TextInfo8, boolean);
    this.plessEnabled(this.txta_TextInfo8, boolean);
    this.plessEnabled(this.lnb_TextInfo9, boolean);
    this.plessEnabled(this.txta_TextInfo9, boolean);
    this.plessEnabled(this.txta_TextInfoA, boolean);
    this.plessEnabled(this.txta_TextInfoB, boolean);
    this.plessEnabled(this.txta_TextInfoC, boolean);
    this.plessEnabled(this.txta_TextInfoD, boolean);
    this.plessEnabled(this.txta_TextInfoE, boolean);
    this.plessEnabled(this.txta_TextInfoF, boolean);
    this.plessEnabled(this.txta_TextInfoG, boolean);
    this.plessEnabled(this.txta_TextInfoH, boolean);
    this.plessEnabled(this.txta_TextInfoI, boolean);
    this.plessEnabled(this.txta_TextInfoJ, boolean);
    this.plessEnabled(this.txta_TextInfoK, boolean);
    // 発注業態
    this.plessEnabled(this.cmb_StinkGoodsDivList, boolean);
    this.plessEnabled(this.cmb_CaseSupplyDivList, boolean);
    this.plessEnabled(this.cmb_LongKeepDivList, boolean);
    this.plessEnabled(this.cmb_ArrivalAreaDivList, boolean);
    this.plessEnabled(this.cmb_DutiesFormDailyDiv, boolean);
    this.plessEnabled(this.cmb_DutiesFormSpotDiv, boolean);
    this.plessEnabled(this.txti_ArrivalGoodsTemp, boolean);
    this.plessEnabled(this.txti_ArrivalAdminDays, boolean);
    // 組合員
    this.plessEnabled(this.txti_PlanPInum, boolean);
    this.plessEnabled(this.btn_PlanDistribution, boolean);
    this.plessEnabled(this.btn_PlanAutoSetting, boolean);
    // 案内
    this.plessEnabled(this.btn_SettingNextGuide, boolean);
    // 保健
    this.plessEnabled(this.txta_LicencedDescription, boolean);
    // アイコン
    this.plessEnabled(this.chk_AllCoopValueIcon, boolean);
    // アイテムコード共通
    this.plessEnabled(this.cmb_ItemCode, true);
    this.plessEnabled(this.txti_BuyerCode, boolean);
    this.plessEnabled(this.txti_JanCode, boolean);
    this.plessEnabled(this.chk_JanCodeDiv, boolean);
    // アイテム
    this.plessEnabled(this.txti_FcmcFee, boolean);
    this.plessEnabled(this.txta_LicencedNo, boolean);
    this.plessEnabled(this.txti_PayeeClientName, boolean);
    this.plessEnabled(this.txti_ItfCode, boolean);
    this.plessEnabled(this.txti_OrderClientName, boolean);
    this.plessEnabled(this.txti_MakerPrice, boolean);
    this.plessEnabled(this.txti_BundlePrice, boolean);
    this.plessEnabled(this.txti_OrderClientCode, boolean);
    this.plessEnabled(this.txti_PayeeClientCode, boolean);
    this.plessEnabled(this.txti_InstallmentTimes, boolean);
    this.plessEnabled(this.txti_PdPilingUpDays, boolean);
    this.plessEnabled(this.txti_FixContainNum, boolean);
    this.plessEnabled(this.txti_SetQuantity, boolean);
    this.plessEnabled(this.cmb_SpecialOrderTypeList, boolean);
    this.plessEnabled(this.cmb_StockTypeList, boolean);
    this.plessEnabled(this.cmb_OrderUnitType, boolean);
    this.plessEnabled(this.cmb_MakerType, boolean);
    this.plessEnabled(this.btn_OrderClientCode, boolean);
    this.plessEnabled(this.btn_PayeeClientCode, boolean);
    // 仕様書1
    this.plessEnabled(this.txti_MakerName, boolean);
    this.plessEnabled(this.txti_EbaseSpecCode, boolean);
    this.plessEnabled(this.txti_SpecApplyDate, boolean);
    this.plessEnabled(this.txti_CaseWeight, boolean);
    this.plessEnabled(this.txti_CaseSizeHight, boolean);
    this.plessEnabled(this.txti_CaseSizeWidth, boolean);
    this.plessEnabled(this.txti_CaseSizeLength, boolean);
    this.plessEnabled(this.txti_PeaceWeight, boolean);
    this.plessEnabled(this.txti_PeaceSizeWidth, boolean);
    this.plessEnabled(this.txti_PeaceSizeLength, boolean);
    this.plessEnabled(this.txti_PeaceSizeHight, boolean);
    this.plessEnabled(this.cmb_GeneRecombinationDivList, boolean);
    this.plessEnabled(this.chk_MakerNamePublishType, boolean);
    this.plessEnabled(this.txta_StringValue1, boolean);
    this.plessEnabled(this.txta_StringValue2, boolean);
    this.plessEnabled(this.txta_StringValue3, boolean);
    this.plessEnabled(this.txta_StringValue5, boolean);
    this.plessEnabled(this.txta_StringValue6, boolean);
    // 仕様書2
    this.plessEnabled(this.cmb_AllergenTergetType, boolean);
    // プロモ
    this.plessEnabled(this.cmb_MarkGroup, boolean);
    this.plessEnabled(this.chk_AllcoopValue2, boolean);
    // 栄養成分
    this.plessEnabled(this.chk_HasMultiNutrientInfo, boolean);
    // 環境
    this.plessEnabled(this.rdb_Ecology0, boolean);
    this.plessEnabled(this.rdb_Ecology1, boolean);
  }

  /**
   * 閲覧モード時の活性・非活性制御
   *
   * @memberof KYMW0900Component
   */
  setEnabledByViewPermission() {
    this.plessEnabledFlag = false;
    setTimeout(() => {
      this.plessEnabledSetting();
      this.dtg_PriceList.isReadOnly = false;
      this.dtg_CoopDetailList.isReadOnly = false;
      this.dtg_ListingItemList.isReadOnly = false;
      this.dtg_ContainPackingList.isReadOnly = false;
      this.chk_HasMultiNutrientInfo.disabled = true;
      this.btn_ChangeConfirmation.nativeElement.disabled = true;
      // マーク・アレルゲンの活性・非活性フラグ
      this.kymw0900Model.markFlag = true;
      this.kymw0900Model.allergenFlag = true;
    });
  }

  /**
   * 価格リストチェックボックス制御
   *
   * @param {Event} event
   * @param {FlexGrid} grid
   * @memberof KYMW0900Component
   */
  public priceListCheckEvent(event: Event, grid: FlexGrid): void {

    // チェックボックスの状態を取得
    const checkStatus: boolean = event.target['checked'];
    // 押下されたセルの位置を取得(行)
    const selectedRow = grid.selection.row;
    const selectItemCode: string = this.kymw0900Model.coopPriceList[selectedRow].SelectItemCode;
    const selectedNum: string = this.kymw0900Model.coopPriceList[selectedRow].CoopNum;
    // 生協コードを取得
    const selectedCoopCode = grid.collectionView.items[selectedRow].CoopCode;

    const copyMarkList: Array<any> = PlessViewUtilsSub.getCloneArray(this.coopMarkList);
    if (!checkStatus) {
      // 「価格一覧」の項目を非活性状態にする
      // 「価格一覧」の項目の設定値をクリアする
      this.kymw0900Model.disableCoopPrice(this.kymw0900Model.coopPriceList[selectedRow]);

      // 「通常媒体フラグ(PLAN_GOODS_BASE)」の値が「1：商品を対象生協の通常媒体で取り扱う」かつ「EnableMode」が「TRUE」の場合
      // それ以外の場合操作不可
      if (this.kymw0900Model.RegularFlg === this.kymw0900Model.REGULAR_FLG_ON && grid.collectionView.items[selectedRow].DealCoopDiv) {
        // 「情報一覧」の項目をクリアし、非活性状態にする
        this.setCoopDetailListEnabled(selectedCoopCode, false);

        // 「案内一覧」の項目をクリアし、非活性状態にする
        this.kymw0900Model.setNextGuideListEnabled(selectedCoopCode, false);

        // 選択した組合員の声タブの当該会員生協の「生協チェック」をチェック解除状態にする。
        this.kymw0900Model.setPublishHistoryEnabled(Number(selectedRow), true);

        // 「計画数一覧」の項目をクリアし、非活性状態にする
        // 「計画数一覧」の計画数(修正)、限定数量総数、限定数量個人の合算値を再計算する
        this.kymw0900Model.setPlanNumListEnabled(selectedCoopCode, false);
      }
    } else {
      // アイテムコードの選択がある場合、「価格一覧」の入力項目を活性状態にする
      if (!PlessViewUtilsSub.isEmpty(this.kymw0900Model.coopPriceList[selectedRow].SelectItemCode) && this.kymw0900Model.coopPriceList[selectedRow].SelectItemCode !== '0') {
        this.kymw0900Model.enableCoopPrice(this.kymw0900Model.coopPriceList[selectedRow]);
      }

      if (this.kymw0900Model.RegularFlg === this.kymw0900Model.REGULAR_FLG_ON && grid.collectionView.items[selectedRow].DealCoopDiv) {
        // 「情報一覧」の以下項目をクリアし、活性状態にする
        this.setCoopDetailListEnabled(selectedCoopCode, true);

        // 「案内一覧」の以下項目をクリアし、活性状態にする
        this.kymw0900Model.setNextGuideListEnabled(selectedCoopCode, true);

        // 「案内一覧」に選択した生協の行が表示されていない場合、「案内一覧」に選択した生協の行を追加する。
        if (!this.kymw0900Model.guideList.some(item => item.CoopCode === selectedCoopCode)) {
          const item = {
            CoopCode: selectedCoopCode,
            CoopName: this.kymw0900Model.convertCoopName(selectedCoopCode),
            OrderNum: '',
            AppearDiv: '',
            NextGuideMap: [],
            Enabled: '1',
          }
          this.kymw0900Model.guideList.push(item)
        }

        // 選択した組合員の声タブの当該会員生協の「生協チェック」をチェック状態にする。
        this.kymw0900Model.setPublishHistoryEnabled(Number(selectedRow), true);

        // 「計画数一覧」の以下項目をクリアし、活性状態にする
        // 「計画数一覧」の計画数(修正)、限定数量総数、限定数量個人の合算値を再計算する
        this.kymw0900Model.setPlanNumListEnabled(selectedCoopCode, true);
      }
    }
    // 価格一覧の今回供給価格を変更したときのメソッドを追加
    this.setPromotionThistimeSupplyPrice(grid, grid.collectionView.items[selectedRow]);

    // 一時退避したマークリストを反映
    this.coopMarkList = PlessViewUtilsSub.getCloneArray(copyMarkList);

    this.dtg_CoopMarkList.editableCollectionView.refresh();
    this.dtg_PriceList.editableCollectionView.refresh();
    this.dtg_CoopDetailList.editableCollectionView.refresh();
    this.dtg_PlanList.collectionView.refresh();
    this.dtg_GuideList.collectionView.refresh();
  }

  /**
 * 7大アレルゲン編集
 *
 * @param {Event} event
 * @memberof KYMW0900Component
 */
  public editAllergenTargetType(selected: boolean, publishDiv: string) {
    // 7大アレルゲン編集処理の呼出し
    this.kymw0900Model.editAllergenTargetType(selected, publishDiv);
  }

  public changeThistimeSupplyPrice(e: Event, grid: FlexGrid): void {

    const tempPriceList: Array<any> = new Array<any>();
    const selectedRow = grid.selection.row;

    for (let i: number = <number>0; i < this.kymw0900Model.coopPriceList.length; i++) {
      // 当該会員生協の場合
      if (this.kymw0900Model.coopPriceList[i].DealCoopDiv &&
        !PlessViewUtilsSub.isEmpty(this.kymw0900Model.coopPriceList[i].SelectItemCode)) {
        // ツールチップの取得
        const toolTipText: string = this.kymw0900Model.getCoopPriceListToolTip(
          this.kymw0900Model.consumeTaxDiv,
          this.kymw0900Model.consumeTaxDivRate,
          grid.editableCollectionView.items[i].ThistimeSupplyPrice
        );
        let thisTimeSupplyPrice: string = <string>'';
        let thisTimeCostPrice: string = <string>'';
        let costPrice: string = <string>'';
        switch (this.kymw0900Model.coopPriceList[i].SelectPricePattern) {
          // ①【0:通常価格】の場合
          case '0':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ②【1:特価１】の場合
          case '1':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ③【2:特価２】の場合
          case '2':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ④【3:特価３】の場合
          case '3':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
        }
        if (thisTimeCostPrice.length > 0) {
          const bundlePrice: number = this.kymw0900Model.bundlePriceListContents[this.kymw0900Model.coopPriceList[i].SelectItemCode];
          costPrice = String(Number(thisTimeCostPrice) * bundlePrice);
        }
        const coopXml = {
          CoopCode: this.kymw0900Model.coopPriceList[i].CoopCode,
          CoopNum: this.kymw0900Model.coopPriceList[i].CoopNum,
          CoopName: this.kymw0900Model.coopPriceList[i].CoopName,
          CoopShortName: this.kymw0900Model.coopPriceList[i].CoopShortName,
          SelectValue: this.kymw0900Model.coopPriceList[i].SelectValue,
          SelectItemCode: this.kymw0900Model.coopPriceList[i].SelectItemCode,
          SelectPricePattern: this.kymw0900Model.coopPriceList[i].SelectPricePattern,
          LSupplyPricecoefficient: this.kymw0900Model.coopPriceList[i].SupplyPricecoefficient,
          SupplyPricecoefficient: this.kymw0900Model.coopPriceList[i].SupplyPricecoefficient,
          SupplyPriceSpecial1: this.kymw0900Model.coopPriceList[i].SupplyPriceSpecial1,
          SupplyPriceSpecial2: this.kymw0900Model.coopPriceList[i].SupplyPriceSpecial2,
          ThistimeSupplyPrice: thisTimeSupplyPrice,
          LCostPriceCoefficient: this.kymw0900Model.coopPriceList[i].CostPriceCoefficient,
          CostPriceCoefficient: this.kymw0900Model.coopPriceList[i].CostPriceCoefficient,
          CostPriceSpecial1: this.kymw0900Model.coopPriceList[i].CostPriceSpecial1,
          CostPriceSpecial2: this.kymw0900Model.coopPriceList[i].CostPriceSpecial2,
          ThistimeCostPrice: thisTimeCostPrice,
          CostPrice: costPrice,
          Enabled: this.kymw0900Model.coopPriceList[i].Enabled,
          DealCoopDiv: this.kymw0900Model.coopPriceList[i].DealCoopDiv,
          Caption: this.kymw0900Model.coopPriceList[i].Caption,
          PromotionDiv: this.kymw0900Model.coopPriceList[i].PromotionDiv,
          SupplyPriceToolTipText: toolTipText,
          CostPriceToolTipText: this.kymw0900Model.coopPriceList[i].CostPriceToolTipText,
          EnabledCheck: this.kymw0900Model.coopPriceList[i].EnabledCheck,
        };
        tempPriceList.push(coopXml);
      } else {
        tempPriceList.push(this.kymw0900Model.coopPriceList[i]);
      }
    }
    this.kymw0900Model.coopPriceList = tempPriceList;
    this.dtg_PriceList.editableCollectionView.refresh();
    this.dtg_PriceList.selection = new CellRange(selectedRow, -1, -1, -1);
  }

  public changeThistimeCostPrice(e: Event, grid: FlexGrid): void {

    const tempPriceList: Array<any> = new Array<any>();
    const selectedRow = grid.selection.row;

    for (let i: number = <number>0; i < this.kymw0900Model.coopPriceList.length; i++) {
      // 当該会員生協の場合
      if (this.kymw0900Model.coopPriceList[i].DealCoopDiv &&
        !PlessViewUtilsSub.isEmpty(this.kymw0900Model.coopPriceList[i].SelectItemCode)) {
        // ツールチップの取得
        const toolTipText: string = this.kymw0900Model.getCoopPriceListToolTip(
          this.kymw0900Model.consumeTaxDiv,
          this.kymw0900Model.consumeTaxDivRate,
          grid.editableCollectionView.items[i].ThistimeCostPrice
        );
        let thisTimeSupplyPrice: string = <string>'';
        let thisTimeCostPrice: string = <string>'';
        let costPrice: string = <string>'';
        let isPricePattern: boolean = true;
        switch (this.kymw0900Model.coopPriceList[i].SelectPricePattern) {
          // ①【0:通常価格】の場合
          case '0':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ②【1:特価１】の場合
          case '1':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ③【2:特価２】の場合
          case '2':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          // ④【3:特価３】の場合
          case '3':
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
          default:
            isPricePattern = false;
            thisTimeSupplyPrice = grid.collectionView.items[i].ThistimeSupplyPrice;
            thisTimeCostPrice = grid.collectionView.items[i].ThistimeCostPrice;
            break;
        }
        if (thisTimeCostPrice.length > 0) {
          const bundlePrice: number = this.kymw0900Model.bundlePriceListContents[this.kymw0900Model.coopPriceList[i].SelectItemCode];
          costPrice = String(Number(thisTimeCostPrice) * bundlePrice);
        }
        const coopXml = {
          CoopCode: this.kymw0900Model.coopPriceList[i].CoopCode,
          CoopNum: this.kymw0900Model.coopPriceList[i].CoopNum,
          CoopName: this.kymw0900Model.coopPriceList[i].CoopName,
          CoopShortName: this.kymw0900Model.coopPriceList[i].CoopShortName,
          SelectValue: this.kymw0900Model.coopPriceList[i].SelectValue,
          SelectItemCode: this.kymw0900Model.coopPriceList[i].SelectItemCode,
          SelectPricePattern: this.kymw0900Model.coopPriceList[i].SelectPricePattern,
          LSupplyPricecoefficient: isPricePattern ? this.kymw0900Model.coopPriceList[i].SupplyPricecoefficient : '',
          SupplyPricecoefficient: this.kymw0900Model.coopPriceList[i].SupplyPricecoefficient,
          SupplyPriceSpecial1: this.kymw0900Model.coopPriceList[i].SupplyPriceSpecial1,
          SupplyPriceSpecial2: this.kymw0900Model.coopPriceList[i].SupplyPriceSpecial2,
          ThistimeSupplyPrice: thisTimeSupplyPrice,
          LCostPriceCoefficient: isPricePattern ? this.kymw0900Model.coopPriceList[i].CostPriceCoefficient : '',
          CostPriceCoefficient: this.kymw0900Model.coopPriceList[i].CostPriceCoefficient,
          CostPriceSpecial1: this.kymw0900Model.coopPriceList[i].CostPriceSpecial1,
          CostPriceSpecial2: this.kymw0900Model.coopPriceList[i].CostPriceSpecial2,
          ThistimeCostPrice: thisTimeCostPrice,
          CostPrice: costPrice,
          Enabled: this.kymw0900Model.coopPriceList[i].Enabled,
          DealCoopDiv: this.kymw0900Model.coopPriceList[i].DealCoopDiv,
          Caption: this.kymw0900Model.coopPriceList[i].Caption,
          PromotionDiv: this.kymw0900Model.coopPriceList[i].PromotionDiv,
          SupplyPriceToolTipText: this.kymw0900Model.coopPriceList[i].SupplyPriceToolTipText,
          CostPriceToolTipText: toolTipText,
          EnabledCheck: this.kymw0900Model.coopPriceList[i].EnabledCheck,
        };
        tempPriceList.push(coopXml);
      } else {
        tempPriceList.push(this.kymw0900Model.coopPriceList[i]);
      }
    }
    this.kymw0900Model.coopPriceList = tempPriceList;
    this.dtg_PriceList.editableCollectionView.refresh();
    this.dtg_PriceList.selection = new CellRange(selectedRow, -1, -1, -1);
  }

  /**
 * 注文コード割当の保持データを更新する
 *
 * @param {*} e
 * @memberof KYMW0900Component
 */
  public eventOrderNumQuotaHandler(e: any): void {
    // 全生協へコピー以外の場合、選択行を対象とする
    let index: number;
    if (e.detail != null) {
      index = e.detail.index;
    } else {
      index = this.dtg_CoopDetailList.selection.row;
    }
    // 会員生協情報を取得
    const coopCode = this.kymw0900Model.coopDetailList[index].CoopCode;
    const coopName = this.kymw0900Model.coopDetailList[index].CoopName;
    const plan: Array<any> = this.kymw0900Model.planList;
    let list: Array<any>;
    switch (coopCode) {
      case this.kymw00Model.COOP_CODE_IB:
        // いばらき
        list = this.kymw0900Model.orderNumQuotaList_Ibaraki;
        break;
      case this.kymw00Model.COOP_CODE_TO:
        // とちぎ
        list = this.kymw0900Model.orderNumQuotaList_Tochigi;
        break;
      case this.kymw00Model.COOP_CODE_GU:
        // ぐんま
        list = this.kymw0900Model.orderNumQuotaList_Gunma;
        break;
      case this.kymw00Model.COOP_CODE_TI:
        // ちば
        list = this.kymw0900Model.orderNumQuotaList_Chiba;
        break;
      case this.kymw00Model.COOP_CODE_SA:
        // さいたま
        list = this.kymw0900Model.orderNumQuotaList_Saitama;
        break;
      case this.kymw00Model.COOP_CODE_TK:
        // とうきょう
        list = this.kymw0900Model.orderNumQuotaList_Tokyo;
        break;
      case this.kymw00Model.COOP_CODE_NA:
        // ながの
        list = this.kymw0900Model.orderNumQuotaList_Nagano;
        break;
      case this.kymw00Model.COOP_CODE_NI:
        // にいがた
        list = this.kymw0900Model.orderNumQuotaList_Niigata;
        break;
    }

    let planCoop: string = <string>'';
    // 計画数情報を更新
    for (let i: number = <number>0; i < plan.length; i++) {
      planCoop = PlessViewUtilsSub.nullToBlank(plan[i].CoopName.toString());
      if (coopName === planCoop) {
        const coopXml: object = {
          CoopCode: PlessViewUtilsSub.nullToBlank(plan[i].CoopCode),
          CoopName: PlessViewUtilsSub.nullToBlank(plan[i].CoopName),
          Plannum: PlessViewUtilsSub.nullToBlank(plan[i].Plannum),
          LimitnumTotal: PlessViewUtilsSub.nullToBlank(plan[i].LimitnumTotal),
          LimitnumPerson: PlessViewUtilsSub.nullToBlank(plan[i].LimitnumPerson),
          DeliveryLeadTimeType: PlessViewUtilsSub.nullToBlank(list[e.target.selectedIndex].DeliveryWeekFixFlag),
          DelivCatalogID: PlessViewUtilsSub.nullToBlank(list[e.target.selectedIndex].DelivCatalogID),
          Enabled: PlessViewUtilsSub.nullToBlank(plan[i].Enabled)
        };
        plan.splice(i, 1, coopXml);
      }

      this.kymw0900Model.planList = plan;
      // 編集カウントをインクリメント
      this.kymw0900Model.addEditCount();

      this.dtg_PlanList.editableCollectionView.refresh();
    }
  }


  public onSourceChangeSelectedMark() {
    this.dtg_SelectedMark.autoSizeRows();
  }
  /**
* 組合員の声クリアボタンのキーダウンイベント
* TABキー押下時に遷移先がない場合は別タブへ移動させる。
*
* @param {KeyboardEvent} e キーイベント
* @param {number} btnIndex 基準となる組合員の声ボタン
*/
  public eventInquiryContentsTabKeyHandler(e: KeyboardEvent, btnIndex: number) {

    // TABキーではない、又はShiftキーがおされている場合は処理をしない
    if (e.keyCode !== 9 || e.shiftKey) {
      return;
    }
    const buttons = Array<any>();
    buttons.push(this.btn_InquiryContents1);
    buttons.push(this.btn_InquiryContents2);
    buttons.push(this.btn_InquiryContents3);
    buttons.push(this.btn_InquiryContents4);
    buttons.push(this.btn_InquiryContents5);
    buttons.push(this.btn_InquiryContents6);
    buttons.push(this.btn_InquiryContents7);
    buttons.push(this.btn_InquiryContents8);

    let targetButton: any = null;
    for (let i: number = btnIndex; i < buttons.length; i++) {
      // 基準のボタンかそれより前のボタンの場合は飛ばす
      if (i <= btnIndex) {
        continue;
      }

      // ボタンが非活性の場合は飛ばす
      if (buttons[i].nativeElement.disabled) {
        continue;
      }

      targetButton = buttons[i];
      break;
    }

    // 次に遷移する組合員の声ボタンがない場合はタブを移動
    if (targetButton === null) {
      this.tab_pCode.selectedIndex = 7;
      e.preventDefault();
    }
  }

  /**
   * データグリッド内キーダウンイベント
   * TABキー押下時に遷移先がグリッド内にない場合は別タブへ移動させる。
   *
   * @param {KeyboardEvent} e キーイベント
   * @param {FlexGrid} grid データグリッド
   * @param {number} col カラム番号
   * @param {number} tabItemIndex 移動先tabのIndex番号
   */
  public eventGridTabKeyHandler(e: KeyboardEvent, grid: FlexGrid, col: number, tabItemIndex: number) {

    // TABキーではない、又はShiftキーがおされている場合は処理をしない
    if (e.keyCode !== 9 || e.shiftKey) {
      return;
    }

    let nextRow: number = grid.selection.row;
    let cell: any;
    let inputEl: HTMLInputElement;

    for (let rowIndex: number = grid.selection.row + 1; rowIndex < grid.rows.length; rowIndex++) {
      grid.startEditing(true, rowIndex, col, true);
      cell = grid.cells.getCellElement(rowIndex, col);
      inputEl = this.getTargetGridElement(cell);
      if (inputEl != null && !inputEl.disabled) {
        nextRow = rowIndex;
        break;
      }
    }
    if (nextRow === grid.selection.row) {
      this.tab_pCode.selectedIndex = tabItemIndex;
      // デフォルトイベントをキャンセル
      e.preventDefault();
    }
  }

  /**
   * 活性制御対象のエレメントを取得する
   *
   * @private
   * @param {*} el
   * @returns {*}
   * @memberof PlessViewHelperSub
   */
  private getTargetGridElement(el: any): any {
    if (el.nativeElement != null) {
      if (el.nativeElement instanceof HTMLInputElement ||
        el.nativeElement instanceof HTMLTextAreaElement ||
        el.nativeElement instanceof HTMLSelectElement ||
        el.nativeElement instanceof HTMLButtonElement) {
        return el.nativeElement;
      }
    }
    if (el instanceof HTMLInputElement ||
      el instanceof HTMLTextAreaElement ||
      el instanceof HTMLSelectElement ||
      el instanceof HTMLButtonElement) {
      return el;
    } else {
      // 共通部品の場合、子要素を取得
      if (el.elementRef != null) {
        for (const child of el.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement ||
            child instanceof HTMLTextAreaElement ||
            child instanceof HTMLSelectElement ||
            child instanceof HTMLButtonElement) {
            return child;
          } else {
            return this.getTargetGridElement(child);
          }
        }
      } else {
        // CheckBox,RadioButton部品の場合、孫要素を取得
        if (el.children) {
          for (const child of el.children) {
            if (child instanceof HTMLInputElement ||
              child instanceof HTMLTextAreaElement ||
              child instanceof HTMLSelectElement ||
              child instanceof HTMLButtonElement) {
              return child;
            } else {
              return this.getTargetGridElement(child);
            }
          }
        }
      }
    }

    return null;
  }

  /**
   * tab_pCodeのタブ選択変更時処理
   *
   * タブ内で最初に出てくるaに参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabPCodeChange(): void {
    const selectedIndex = this.tab_pCode.selectedIndex;
    if (selectedIndex === 0) {
      this.a_BaseInfo.nativeElement.focus();
    } else if (selectedIndex === 1) {
      this.a_CoopInfo.nativeElement.focus();
    } else if (selectedIndex === 2) {
      this.a_DetailsInfo.nativeElement.focus();
    } else if (selectedIndex === 3) {
      this.a_MarkInfo.nativeElement.focus();
    } else if (selectedIndex === 4) {
      this.a_AddInfo.nativeElement.focus();
    } else if (selectedIndex === 5) {
      this.a_DivInfo.nativeElement.focus();
    } else if (selectedIndex === 6) {
      this.a_InquirInfo.nativeElement.focus();
    } else if (selectedIndex === 7) {
      this.a_PlanInfo.nativeElement.focus();
    } else if (selectedIndex === 8) {
      this.a_GuideInfo.nativeElement.focus();
    } else if (selectedIndex === 9) {
      this.a_HealthPromotion.nativeElement.focus();
    } else if (selectedIndex === 10) {
      this.a_PromotionInfoSetting.nativeElement.focus();
    } else if (selectedIndex === 11) {
      this.a_TagInfo.nativeElement.focus();
    } else if (selectedIndex === 12) {
      this.a_ECInfoSetting.nativeElement.focus();
    } else if (selectedIndex === 13) {
      this.a_IconSetting.nativeElement.focus();
      // アイコンタブ遷移時に選択済みアイコンリストを初期化
      this.initializeSelectedIconList();
    } else if (selectedIndex === 14) {
      this.a_ReservationInfoSetting.nativeElement.focus();
    }
  }

  /**
   * tab_itemのタブ選択変更時処理
   *
   * タブ内で最初に出てくるaに参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabItemChange(): void {
    const selectedIndex = this.tab_item.selectedIndex;
    if (selectedIndex === 0) {
      this.a_ItemInfo.nativeElement.focus();
    } else if (selectedIndex === 1) {
      this.a_Spec1Info.nativeElement.focus();
    } else if (selectedIndex === 2) {
      this.a_Spec2Info.nativeElement.focus();
    } else if (selectedIndex === 3) {
      this.a_PromotionInfo.nativeElement.focus();
    } else if (selectedIndex === 4) {
      this.a_Nutrient.nativeElement.focus();
    } else if (selectedIndex === 5) {
      this.a_MultiNutrient.nativeElement.focus();
    } else if (selectedIndex === 6) {
      this.a_EnvInfo.nativeElement.focus();
    }
  }

  /**
   * タブ移動制御（読み取り専用またはロック時）
   *
   * @param {*} event
   * @memberof KYMW0900Component
   */
  public nextFocusForReadonlyUser(e: any): void {
    // 読み取り専用ユーザ又はロック時以外は処理を飛ばす
    if (this.kymw0900Model.permission !== '1') {
      return;
    }

    // TABキーではない、又はShiftキーがおされている場合は処理をしない
    if (e.keyCode === 9 && !e.shiftKey) {

      // デフォルトイベントをキャンセル
      e.preventDefault();

      if (e.target.id === 'a_BaseInfo') {
        // 基本→会員
        this.tab_pCode.selectedIndex = 1;
      } else if (e.target.id === 'dtg_PriceList') {
        // 会員→詳細
        this.tab_pCode.selectedIndex = 2;
      } else if (e.target.id === 'dtg_ListingItemList') {
        // 詳細→マーク
        this.tab_pCode.selectedIndex = 3;
      } else if (e.target.id === 'dtg_SelectedMark') {
        // マーク→付加
        this.tab_pCode.selectedIndex = 4;
      } else if (e.target.id === 'a_DivInfo') {
        // 発注→組合員
        this.tab_pCode.selectedIndex = 6;
      } else if (e.target.id === 'a_InquirInfo') {
        // 組合員→計画数
        this.tab_pCode.selectedIndex = 7;
      } else if (e.target.id === 'dtg_PlanList') {
        // 計画数→案内
        this.tab_pCode.selectedIndex = 8;
      } else if (e.target.id === 'dtg_GuideList') {
        // 案内→保健機能
        this.tab_pCode.selectedIndex = 9;
      } else if (e.target.id === 'a_ItemInfo') {
        // アイテム→仕様書1
        this.tab_item.selectedIndex = 1;
      } else if (e.target.id === 'a_Spec1Info') {
        // 仕様書1→仕様書2
        this.tab_item.selectedIndex = 2;
      } else if (e.target.id === 'dtg_NutrientComponentList') {
        if (this.kymw0900Model.hasMultiNutrientInfo) {
          // 栄養成分→複数栄養成分
          this.tab_item.selectedIndex = 5;
        } else {
          // 栄養成分→環境関連
          this.tab_item.selectedIndex = 6;
        }
      } else if (e.target.id === 'dtg_NutrientUnitListMulti') {
        // 複数栄養成分→環境関連
        this.tab_item.selectedIndex = 6;
      }
    }

  }

  /**
   * 生協の各項目(ブランド区分、セット区分、仕分温度帯、注文コード割当、次回案内)の活性制御を行う
   */
  public isDisabledCoopItem(cell: any, event: any) {
    if (this.kymw0900Model.coopPriceList[cell.row.index] == null) {
      // coopPriceListの値が存在しなければ現在の活性状態を返す
      return event.disabled;
    } else {
      return !this.kymw0900Model.coopPriceList[cell.row.index].DealCoopDiv
        || cell.item.Enabled !== '1' || this.kymw0900Model.isDisabledForGrid;
    }
  }

  /**
  * 案内一覧の登場区分の活性制御を行う
  * 会員タブのチェックに関わらない
  */
  public isDisabledAppearDiv(cell: any, event: any) {
    const target = this.kymw0900Model.coopPriceList.find(_ => _.CoopCode == cell.item.CoopCode);
    if (target == null) {
      // coopPriceListの値が存在しなければ現在の活性状態を返す
      return event.disabled;
    } else {
      return !target.DealCoopDiv
        || this.kymw0900Model.isDisabledForGrid;
    }
  }

  /**
   * 【プロモ設定タブ：抽選商品プロモーション】
   * このプロモーション設定を使用するチェックボックスの変更時
   * @param _event 企画マスタ管理マークへの連携用（未使用）
   *
   */
  public eventUseLotteryPromotion_CHANGEHandler(_event?: Event): void {
    if (!this.kymw0900Model.lotteryPromotionFlg) {
      // 選択（アイテムコード）を全てチェックボックスOFF状態に変更する
      // 選択チェックボックスがOFFになった場合は抽選商品プロモーションの以下画面項目の入力内容をクリアし、非活性にする。
      // 当選商品数、1人あたりの抽選商品数、限定の訳、月曜日当選数(予定)～金曜日当選数(予定)
      this.kymw0900Model.planGoodsLotteryList.map(_ => {
        _.check = false;
        _.winningGoodsNum = '';
        _.winningGoodsPerPersonNum = '';
        _.limitedMeaning = '';
        _.mondayPlanNum = '';
        _.tuesdayPlanNum = '';
        _.wednesdayPlanNum = '';
        _.thursdayPlanNum = '';
        _.fridayPlanNum = '';
      })
    } else {
      // 抽選商品プロモーション一覧.アイテムコードが、
      // 「会員タブ」で表示されているアイテムコードリストに含まれている場合、選択（アイテムコード）をチェックボックスON状態に変更する。
      // 「会員タブ」で表示されているアイテムコードリストに含まれていない場合、選択（アイテムコード）をチェックボックスOFF状態のままとする。（活性状態）
      this.kymw0900Model.setLotteryListCheck(true);
    }

    // 画面でチェックボックスが変更されたとき、企画マスタ管理マークに連動する
    if (_event) this.setLotteryPromotionMark(_event);
  }

  /**
   * 抽選商品プロモーションの「このプロモーション設定を使用する」チェックボックスのONOFF状態を
   * プロモ設定タブ＞プロモタブ（企画マスタ管理マーク）のマークコード033【０１：数量限定】に連携する。
   * 
   * @param _event 未使用
   */
  public setLotteryPromotionMark(_event: Event) {
    this.setPromoMark(this.kymw0900Model.lotteryPromotionFlg, this.LOTTERYPROMOTION_MARKCODE, _event);
  }

  /**
   * 【プロモ設定タブ：抽選商品プロモーション】
   * 曜日別当選数自動振分ボタン押下イベント
   *
   */
  public async eventWinningGoodsNumDistribution_CLICKHandler() {
    try {
      for (const item of this.kymw0900Model.planGoodsLotteryList) {
        if (item.check) {
          if (PlessViewUtilsSub.isEmpty(item.winningGoodsNum)) {
            // エラーメッセージを表示する。（メッセージID：E0110）
            this.dialogServiceSub.openAlertGetMessage('E0110', ['当選商品数']);
            break;
          } else {
            // 曜日別当選数取得リクエストVOを生成し、受注コード・抽選商品当選数を設定する
            const numberOfUserstVO: NumberOfUsersRequestModel = new NumberOfUsersRequestModel();
            numberOfUserstVO.winningGoodsNum = PlessViewUtilsSub.stringToNumber(item.winningGoodsNum);

            await this.numberOfUsersService.executeAsync(numberOfUserstVO, item, this.kymw0900Model);
          }
        }
      }
    } catch (e) {
      return;
    }
  }

  /**
   * 【プロモ設定タブ：抽選商品プロモーション】
   * 月～金曜日当選数(予定)入力完了イベントリスナ
   */
  public eventDayOfWeekPlanNum_FOCUS_OUTHandler(item: any): void {
    const mondayPlanNum = PlessViewUtilsSub.stringToNumber(item.mondayPlanNum);
    const tuesdayPlanNum = PlessViewUtilsSub.stringToNumber(item.tuesdayPlanNum);
    const wednesdayPlanNum = PlessViewUtilsSub.stringToNumber(item.wednesdayPlanNum);
    const thursdayPlanNum = PlessViewUtilsSub.stringToNumber(item.thursdayPlanNum);
    const fridayPlanNum = PlessViewUtilsSub.stringToNumber(item.fridayPlanNum);
    const winningGoodsNum = mondayPlanNum + tuesdayPlanNum + wednesdayPlanNum + thursdayPlanNum + fridayPlanNum;
    item.winningGoodsNum = PlessViewUtilsSub.numberToString(winningGoodsNum);
  }

  /**
   * 【プロモ設定タブ：クーポン商品プロモーション】
   * 追加ボタンイベントリスナ
   */
  public eventCouponPromotionListAdd_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0908Component);
    const instance = componentRef.componentInstance as KYMW0908Component;
    instance.parent = this;
    const vo = new KYMW0908InputModel();
    // モード：追加
    vo.mode = KYMW0908InputModel.MODE_ADD;

    // 会員タブの選択されたアイテムコード
    vo.coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();

    // アイテムコードセレクトボックスを取得する
    // getGoodsUseCoopで取得したリストからアイテムコードの重複を削除
    const list = [];
    for (const e of this.itemRelatedCoop) {
      list[e.ItemCode] = e;
    }
    // アイテムコードリストに格納
    vo.itemCodeList = Object.keys(list).map(key => list[key]);
    // アイテムコード
    vo.selectedItemCode = vo.itemCodeList[0].ItemCode;

    // クーポン種別セレクトボックス:ctp213、グループセレクトボックス:ctp218は遷移後取得

    // 注文コード割当コードセレクトボックスを取得する
    vo.couponOrderNumQuotaCodeList = this.kymw0900Model.couponOrderNumQuotaCodeList;
    // 注文コード割当コード
    vo.couponOrderNumQuotaCode = vo.couponOrderNumQuotaCodeList[0].OrderNumQuotaCode;

    // クーポン名（共通部のお届け明細書用商品名(漢字)）
    vo.couponName = this.kymw0900Model.deliveryGoodsNameKanji;
    // クーポン名（カナ）（共通部の発注用商品名(カナ)）
    vo.couponNameKana = this.kymw0900Model.deliveryGoodsNameKana;
    // クーポン規格名（共通部のお届け明細書用規格名(漢字)）
    vo.couponGuideName = this.kymw0900Model.deliveryStandardNameKanji;
    // クーポン規格名（カナ）（共通部の発注用規格名(カナ)）
    vo.couponGuideNameKana = this.kymw0900Model.deliveryStandardNameKana;

    // 有効期限（クーポン商品プロモーション設定情報一覧の一行目の有効期限）
    vo.validatedDate = this.kymw0900Model.couponPromotionList[0]?.validatedDate;

    let couponCoopList = [];
    // ＜活性制御＞
    // 価格一覧でアイテムコードが選択されている場合は活性・ON。存在しない場合非活性。
    const enableCoopList = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);
    // ＜ON/OFF制御＞
    // アイテムコードが「会員」タブで選択されている場合、チェックボックスON・選択されていない場合チェックボックスOFF
    // 会員タブの選択されたアイテムコードを使用
    const selectedCoop = vo.coopInfoItemCoopCode.find(_ => _.itemCode === vo.selectedItemCode)?.coopCode;
    couponCoopList.push({
      coopName: 'いばらき',
      coopCode: '142',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('142') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('142'),
    });
    couponCoopList.push({
      coopName: 'とちぎ',
      coopCode: '163',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('163') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('163'),
    });
    couponCoopList.push({
      coopName: 'ぐんま',
      coopCode: '185',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('185') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('185'),
    });
    couponCoopList.push({
      coopName: 'ちば',
      coopCode: '240',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('240') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('240'),
    });
    couponCoopList.push({
      coopName: 'さいたま',
      coopCode: '210',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('210') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('210'),
    });
    couponCoopList.push({
      coopName: 'とうきょう',
      coopCode: '302',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('302') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('302'),
    });
    couponCoopList.push({
      coopName: 'ながの',
      coopCode: '515',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('515') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('515'),
    });
    couponCoopList.push({
      coopName: 'にいがた',
      coopCode: '451',
      planGoodsCoopCouponApplicablePriceFlg: !PlessViewUtilsSub.isEmpty(selectedCoop) ? selectedCoop.includes('451') : false,
      thisTimeSupplyPrice: null,
      discountUnitPrice: null,
      discountRate: null,
      discountedUnitPrice: null,
      limitNum: null,
      disable: !enableCoopList.includes('451'),
    });

    // 会員生協タブの価格一覧.今回供給価格の値が表示されている場合、同生協に紐つく今回供給価格の値を供給単価に表示する。
    // 会員タブの価格一覧から生協コードと今回供給価格のリストを作成
    const coopPriceList = this.kymw0900Model.coopPriceList.map(_ => {
      return {
        coopCode: _.CoopCode,
        thisTimeSupplyPrice: _.ThistimeSupplyPrice
      }
    });
    // 今回供給価格の値を設定
    couponCoopList.map(_ => {
      // 会員タブに今回供給価格が表示されているのかをチェック
      const coopPrice = coopPriceList.find(c => c.coopCode === _.coopCode);
      if (coopPrice?.thisTimeSupplyPrice) {
        // 会員タブに今回供給価格が表示されている場合はその値を使用
        _.thisTimeSupplyPrice = coopPrice.thisTimeSupplyPrice;
      } else {
        // 表示されていない場合、
        // 対象のアイテムコードの1物N価の情報がある場合はそこに設定されている供給単価を設定、無い場合は選定時供給価格を設定

        // 1物N価媒体プロモーションのアイテムコードごとの供給単価の取得
        const nvalSupplyUnitPriceList = this.getNvalSupplyUnitPriceSortList();
        // 1物N価の情報で対象のアイテムコードの供給単価を取得
        const nvalSupplyPrice = nvalSupplyUnitPriceList.find(s => s.itemCode === vo.selectedItemCode)?.supplyPriceStandard;
        for (const couponPromotion of this.kymw0900Model.couponPromotionList) {
          if (nvalSupplyPrice) {
            // 対象のアイテムコードの1物N価情報に設定されている供給単価を設定
            _.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalSupplyPrice, true);
          } else {
            // 遷移元一覧で保持している供給単価を表示する。
            // (Wトラック商品の場合はそれぞれのアイテムコードに生協毎の供給単価が紐ついているため、紐つく生協毎の値を表示する)
            const price = couponPromotion.couponApplicablePriceList.find(cp => cp.coopCode === _.coopCode)?.thisTimeSupplyPrice;
            if (price) {
              _.thisTimeSupplyPrice = price;
              break;
            }
          }
        }
      }
    })
    vo.couponApplicablePriceList = couponCoopList;

    vo.registFlg = '1';
    vo.deleteFlg = '0';

    // 消費区分
    vo.consumeTaxDiv = this.kymw0900Model.consumeTaxDiv;
    // 消費税率
    vo.consumeTaxDivRate = this.kymw0900Model.getConsumeTaxDivRate();

    // アイテムコードに紐づく会員生協
    vo.itemRelatedCoop = this.itemRelatedCoop;
    // 設定済みのデータのアイテムコードとグループの組み合わせリスト
    vo.settedItemGroup = this.kymw0900Model.couponPromotionListDisplay.map(_ => {
      return {
        itemCode: _.itemCode,
        groupType: _.groupType
      }
    });

    instance.setInterfaceParam(vo);
    instance.setKYMW0908Parameter = (outputVO: KYMW0908OutputModel) => {
      // 戻ってきたら表に追加する
      const addData = {
        couponGoodsNo: outputVO.couponGoodsNo,
        itemCode: outputVO.selectedItemCode,
        couponType: outputVO.couponType,
        couponTypeName: outputVO.couponTypeName,
        displayCouponType: !PlessViewUtilsSub.isEmpty(outputVO.couponType) ? outputVO.couponType + '：' + outputVO.couponTypeName : '',
        groupType: outputVO.groupType,
        couponOrderNumQuotaCode: outputVO.couponOrderNumQuotaCode,
        notificationFlg: outputVO.notificationFlg,
        notificationFlgName: outputVO.notificationFlgName,
        displayNotificationFlg: !PlessViewUtilsSub.isEmpty(outputVO.notificationFlg) ? outputVO.notificationFlg + '：' + outputVO.notificationFlgName : '',
        deliveryFlg: outputVO.deliveryFlg,
        deliveryFlgName: outputVO.deliveryFlgName,
        displayDeliveryFlg: !PlessViewUtilsSub.isEmpty(outputVO.deliveryFlg) ? outputVO.deliveryFlg + '：' + outputVO.deliveryFlgName : '',
        newsletterFlg: outputVO.newsletterFlg,
        newsletterFlgName: outputVO.newsletterFlgName,
        displayNewsletterFlg: !PlessViewUtilsSub.isEmpty(outputVO.newsletterFlg) ? outputVO.newsletterFlg + '：' + outputVO.newsletterFlgName : '',
        couponName: outputVO.couponName,
        couponNameKana: outputVO.couponNameKana,
        couponGuideName: outputVO.couponGuideName,
        couponGuideNameKana: outputVO.couponGuideNameKana,
        couponTitleEc: outputVO.couponTitleEc,
        couponTitleDelivery: outputVO.couponTitleDelivery,
        contentOne: outputVO.contentOne,
        contentTwo: outputVO.contentTwo,
        contentThree: outputVO.contentThree,
        contentFour: outputVO.contentFour,
        validatedDate: outputVO.validatedDate,
        staffCouponFlg: outputVO.staffCouponFlg,
        couponApplicablePriceList: outputVO.couponApplicablePriceList,
        registFlg: outputVO.registFlg,
        deleteFlg: outputVO.deleteFlg,
      };

      // 保持データ
      this.kymw0900Model.couponPromotionList = [...this.kymw0900Model.couponPromotionList, addData];
      // 表示用データ
      this.kymw0900Model.couponPromotionListDisplay = [...this.kymw0900Model.couponPromotionListDisplay, addData];
      this.dtg_CouponPromotionList.refresh();
      this.editCount++;
    };

    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【プロモ設定タブ：クーポン商品プロモーション】
   * 詳細コンテキストメニューイベントリスナ
   */
  public detailCouponPromotionList_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0908Component);
    const instance = componentRef.componentInstance as KYMW0908Component;
    instance.parent = this;
    // 選択行
    const index = this.dtg_CouponPromotionList.selectedRows[0].index;
    // 選択したデータ
    const item = this.kymw0900Model.couponPromotionListDisplay[index];
    // 選択したデータのクーポン商品連番採番
    const selectedCouponGoodsNo = item.couponGoodsNo;

    const vo = new KYMW0908InputModel();
    // モード：
    if (this.kymw0900Model.permission === '1') {
      // 閲覧権限
      vo.mode = KYMW0908InputModel.MODE_READ_ONLY;
    } else {
      // 詳細
      vo.mode = KYMW0908InputModel.MODE_DETAIL;
    }

    // 会員タブの選択されたアイテムコード
    vo.coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();

    vo.couponGoodsNo = item.couponGoodsNo;

    // アイテムコードセレクトボックスを取得する
    // getGoodsUseCoopで取得したリストからアイテムコードの重複を削除
    const list = [];
    for (const e of this.itemRelatedCoop) {
      list[e.ItemCode] = e;
    }
    // アイテムコードリストに格納
    vo.itemCodeList = Object.keys(list).map(key => list[key]);

    // クーポン種別セレクトボックス:ctp213、グループセレクトボックス:ctp218は遷移後取得

    // 注文コード割当コードセレクトボックスを取得する
    vo.couponOrderNumQuotaCodeList = this.kymw0900Model.couponOrderNumQuotaCodeList;

    vo.selectedItemCode = item.itemCode;
    vo.couponType = item.couponType;
    vo.couponOrderNumQuotaCode = item.couponOrderNumQuotaCode;
    vo.notificationFlg = item.notificationFlg;
    vo.staffCouponFlg = item.staffCouponFlg;
    // クーポン名がnullもしくは空ではない場合：クーポン名を表示する
    // クーポン名がnullもしくは空の場合：商品案内用商品名の先頭から入力欄の最大桁数までの文字列を初期表示する
    vo.couponName = item.couponName ? item.couponName : this.kymw0900Model.guideGoodsName;
    vo.couponNameKana = item.couponNameKana;
    // クーポン規格名がnullもしくは空ではない場合：クーポン規格名を表示する
    // クーポン規格名がnullもしくは空の場合：商品案内用規格名の先頭から入力欄の最大桁数までの文字列を初期表示する
    vo.couponGuideName = item.couponGuideName ? item.couponGuideName : this.kymw0900Model.guideStandardName;
    vo.couponGuideNameKana = item.couponGuideNameKana;
    vo.groupType = item.groupType;
    vo.couponOrderNum = item.couponOrderNum;
    vo.deliveryFlg = item.deliveryFlg;
    vo.newsletterFlg = item.newsletterFlg;
    vo.couponDiscountUnitPrice = item.couponDiscountUnitPrice;
    vo.couponDiscountRate = item.couponDiscountRate;
    vo.couponLimitNum = item.couponLimitNum;
    // クーポン利用生協情報一覧
    let couponCoopList = [];
    // ＜活性制御＞
    // 価格一覧でアイテムコードが選択されている場合は活性・ON。存在しない場合非活性。
    const enableCoopList = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);
    // 生協リスト
    const coopCodeList = [
      this.kymw00Model.COOP_CODE_IB,
      this.kymw00Model.COOP_CODE_TO,
      this.kymw00Model.COOP_CODE_GU,
      this.kymw00Model.COOP_CODE_TI,
      this.kymw00Model.COOP_CODE_SA,
      this.kymw00Model.COOP_CODE_TK,
      this.kymw00Model.COOP_CODE_NA,
      this.kymw00Model.COOP_CODE_NI,
    ]
    coopCodeList.forEach(coopCode => {
      // レスポンスにない生協も空行として追加する。
      const exist = item.couponApplicablePriceList.find(_ => _.coopCode == coopCode);
      if (exist) {
        couponCoopList.push({
          coopName: exist.coopName,
          coopCode: exist.coopCode,
          planGoodsCoopCouponApplicablePriceFlg: exist.planGoodsCoopCouponApplicablePriceFlg && enableCoopList.includes(exist.coopCode),
          thisTimeSupplyPrice: exist.thisTimeSupplyPrice,
          // チェックがOFFの場合、「値引単価」「値引率」「制限数」は空欄
          discountUnitPrice: exist.planGoodsCoopCouponApplicablePriceFlg ? exist.discountUnitPrice : '',
          discountRate: exist.planGoodsCoopCouponApplicablePriceFlg ? exist.discountRate : '',
          discountedUnitPrice: exist.discountedUnitPrice,
          limitNum: exist.planGoodsCoopCouponApplicablePriceFlg ? exist.limitNum : '',
          disable: !enableCoopList.includes(exist.coopCode),
        })
      } else {
        couponCoopList.push({
          coopName: this.kymw0900Model.convertCoopName(coopCode),
          coopCode: coopCode,
          planGoodsCoopCouponApplicablePriceFlg: false,
          thisTimeSupplyPrice: '',
          // チェックがOFFの場合、「値引単価」「値引率」「制限数」は空欄
          discountUnitPrice: '',
          discountRate: '',
          discountedUnitPrice: '',
          limitNum: '',
          disable: !enableCoopList.includes(coopCode),
        });
      };
    });
    vo.couponApplicablePriceList = couponCoopList;

    vo.couponTitleEc = item.couponTitleEc;
    vo.couponTitleDelivery = item.couponTitleDelivery;
    vo.contentOne = item.contentOne;
    vo.contentTwo = item.contentTwo;
    vo.contentThree = item.contentThree;
    vo.contentFour = item.contentFour;
    vo.validatedDate = item.validatedDate;
    vo.registFlg = item.registFlg;
    vo.deleteFlg = item.deleteFlg;

    // 会員生協タブの価格一覧.今回供給価格の値が表示されている場合、同生協に紐つく今回供給価格の値を供給単価に表示する。
    // 会員タブの価格一覧から生協コードと今回供給価格のリストを作成
    const coopPriceList = this.kymw0900Model.coopPriceList.map(_ => {
      return {
        coopCode: _.CoopCode,
        thisTimeSupplyPrice: _.ThistimeSupplyPrice
      }
    });
    // 今回供給価格の値を設定
    vo.couponApplicablePriceList.map(_ => {
      // 会員タブに今回供給価格が表示されているのかをチェック
      const coopPrice = coopPriceList.find(c => c.coopCode === _.coopCode);
      if (coopPrice?.thisTimeSupplyPrice) {
        // 会員タブに今回供給価格が表示されている場合はその値を使用
        _.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(coopPrice.thisTimeSupplyPrice, true);
      } else {
        // 表示されていない場合は既に格納されている値をそのまま使用。
        // 格納されている値がない場合、遷移元一覧で保持している供給単価を表示する。
        // (Wトラック商品の場合はそれぞれのアイテムコードに生協毎の供給単価が紐ついているため、紐つく生協毎の値を表示する)
        if (PlessViewUtilsSub.isEmpty(_.thisTimeSupplyPrice)) {
          for (const couponPromotion of this.kymw0900Model.couponPromotionList) {
            const price = couponPromotion.couponApplicablePriceList.find(cp => cp.coopCode === _.coopCode)?.thisTimeSupplyPrice ?? '';
            if (price) {
              _.thisTimeSupplyPrice = price;
              break;
            }
          }
        }
      }
    })

    // 消費区分
    vo.consumeTaxDiv = this.kymw0900Model.consumeTaxDiv;
    // 消費税率
    vo.consumeTaxDivRate = this.kymw0900Model.getConsumeTaxDivRate();
    // アイテムコードに紐づく会員生協
    vo.itemRelatedCoop = this.itemRelatedCoop;
    // 設定済みのデータのアイテムコードとグループの組み合わせリスト
    vo.settedItemGroup = this.kymw0900Model.couponPromotionListDisplay.map(_ => {
      return {
        itemCode: _.itemCode,
        groupType: _.groupType
      }
    });

    instance.setInterfaceParam(vo);
    instance.setKYMW0908Parameter = (outputVO: KYMW0908OutputModel) => {
      // 表を更新
      const updateData = {
        couponGoodsNo: outputVO.couponGoodsNo,
        itemCode: outputVO.selectedItemCode,
        couponType: outputVO.couponType,
        couponTypeName: outputVO.couponTypeName,
        displayCouponType: !PlessViewUtilsSub.isEmpty(outputVO.couponType) ? outputVO.couponType + '：' + outputVO.couponTypeName : '',
        groupType: outputVO.groupType,
        couponOrderNum: outputVO.couponOrderNum,
        couponOrderNumQuotaCode: outputVO.couponOrderNumQuotaCode,
        notificationFlg: outputVO.notificationFlg,
        notificationFlgName: outputVO.notificationFlgName,
        displayNotificationFlg: !PlessViewUtilsSub.isEmpty(outputVO.notificationFlg) ? outputVO.notificationFlg + '：' + outputVO.notificationFlgName : '',
        deliveryFlg: outputVO.deliveryFlg,
        deliveryFlgName: outputVO.deliveryFlgName,
        displayDeliveryFlg: !PlessViewUtilsSub.isEmpty(outputVO.deliveryFlg) ? outputVO.deliveryFlg + '：' + outputVO.deliveryFlgName : '',
        newsletterFlg: outputVO.newsletterFlg,
        newsletterFlgName: outputVO.newsletterFlgName,
        displayNewsletterFlg: !PlessViewUtilsSub.isEmpty(outputVO.newsletterFlg) ? outputVO.newsletterFlg + '：' + outputVO.newsletterFlgName : '',
        couponName: outputVO.couponName,
        couponNameKana: outputVO.couponNameKana,
        couponGuideName: outputVO.couponGuideName,
        couponGuideNameKana: outputVO.couponGuideNameKana,
        couponTitleEc: outputVO.couponTitleEc,
        couponTitleDelivery: outputVO.couponTitleDelivery,
        contentOne: outputVO.contentOne,
        contentTwo: outputVO.contentTwo,
        contentThree: outputVO.contentThree,
        contentFour: outputVO.contentFour,
        validatedDate: outputVO.validatedDate,
        staffCouponFlg: outputVO.staffCouponFlg,
        couponApplicablePriceList: outputVO.couponApplicablePriceList,
        registFlg: outputVO.registFlg,
        deleteFlg: outputVO.deleteFlg,
      };
      // 保持用
      // setPromotionThistimeSupplyPriceで変更前の値を使用するため、
      // 保持用リストは更新せずそのままとしておく（変更確定時に表示用リストをそのまま格納）
      // 表示用
      for (const key of Object.keys(this.kymw0900Model.couponPromotionListDisplay[index])) {
        this.kymw0900Model.couponPromotionListDisplay[index][key] = updateData[key];
      }
      this.dtg_CouponPromotionList.refresh();
      this.editCount++;
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【プロモ設定タブ：クーポン商品プロモーション】
   * 削除コンテキストメニューイベントリスナ
   */
  public deleteCouponPromotionList_CLICKHandler(): void {
    const index = this.dtg_CouponPromotionList.selectedRows[0].index;
    const item = this.kymw0900Model.couponPromotionListDisplay[index];
    // 削除対象のクーポン商品連番を保持
    const deletedCouponGoodsNo = item.couponGoodsNo;
    this.kymw0900Model.couponPromotionListDisplay.splice(index, 1);
    this.kymw0900Model.couponPromotionListDisplay = [...this.kymw0900Model.couponPromotionListDisplay];
    this.dtg_CouponPromotionList.refresh();

    let counter = 0;
    let deleteIndex = null;
    for (const e of this.kymw0900Model.couponPromotionList) {
      // クーポン商品連番で削除対象を判定
      if (deletedCouponGoodsNo === e.couponGoodsNo) {
        if (e.registFlg === '1') {
          // 追加して削除したものは表示元リストからも削除
          deleteIndex = counter;
          if (this.editCount > 0) {
            this.editCount--;
          }
        } else {
          this.editCount++;
          // 削除フラグに「1」を設定し、選択した行をクリアして一覧に反映する
          // （アイテムコードはデータ判別のためそのまま）
          e.deleteFlg = '1';
          e.couponType = '';
          e.couponTypeName = '';
          e.groupType = '';
          e.couponOrderNumQuotaCode = '';
          e.couponOrderNum = '';
          e.notificationFlg = '';
          e.notificationFlgName = '';
          e.deliveryFlg = '';
          e.deliveryFlgName = '';
          e.newsletterFlg = '';
          e.newsletterFlgName = '';
          e.standardUsageAmount = '';
          e.startMembershipWeeks = '';
          e.endMembershipWeeks = '';
          e.couponName = '';
          e.couponNameKana = '';
          e.couponGuideName = '';
          e.couponGuideNameKana = '';
          e.couponTitleEc = '';
          e.couponTitleDelivery = '';
          e.contentOne = '';
          e.contentTwo = '';
          e.contentThree = '';
          e.contentFour = '';
          e.validatedDate = '';
          e.staffCouponFlg = '';
          // クーポン利用生協情報は企画商品クーポン利用生協情報フラグを0:falseとする
          e.couponApplicablePriceList.map(_ => {
            _.planGoodsCoopCouponApplicablePriceFlg = false;
          });
        }
        break;
      }
      counter = counter + 1;
    }
    if (deleteIndex !== null) {
      this.kymw0900Model.couponPromotionList.splice(deleteIndex, 1);
    }
  }

  /**
   * 会員生協別割引情報一覧.チェックボックス判定
   * (優先大) ち > さ > とう > い > と > ぐ > な > に
   */
  public getCoopCheckbox(couponApplicablePriceList: any): Array<number> {
    // 優先大
    const priorityOrder = [
      this.kymw00Model.COOP_CODE_TI, // ちば
      this.kymw00Model.COOP_CODE_SA, // さいたま
      this.kymw00Model.COOP_CODE_TK, // とうきょう
      this.kymw00Model.COOP_CODE_IB, // いばらき
      this.kymw00Model.COOP_CODE_TO, // とちぎ
      this.kymw00Model.COOP_CODE_GU, // ぐんま
      this.kymw00Model.COOP_CODE_NA, // ながの
      this.kymw00Model.COOP_CODE_NI, // にいがた
    ];

    // 選択済み要素を優先大にソートし、元のインデックスリストを生成
    let coopIndexList = couponApplicablePriceList
      .map((item) => ({ ...item }))
      .filter((item) => item.planGoodsCoopCouponApplicablePriceFlg)
      .sort((a, b) => priorityOrder.indexOf(a.coopCode) - priorityOrder.indexOf(b.coopCode))
      .map((item) => item.coopCode);

    return coopIndexList;
  }

  /**
   * プロモ設定 ポイントプロモーション追加ボタンの活性制御
   */
  public setCouponPromotionAddBtnEnable(): void {
    if (this.kymw0900Model.permission === this.USER_PERMISSION_READONLY || this.kymw0900Model.isConfirmed) {
      this.kymw0900Model.couponPromotionAddDisable = true;
      return;
    }

    //  ポイントプロモーションフラグが「1:ポイント交換商品プロモーション設定を使用する」の場合、活性
    // 「1:ポイント交換商品プロモーション設定を使用する」以外の場合、非活性
    if (this.kymw0900Model.couponPromotionFlg) {
      this.kymw0900Model.couponPromotionAddDisable = false;
    } else {
      this.kymw0900Model.couponPromotionAddDisable = true;
    }
  }

  /**
   * 【プロモ設定タブ：ポイント交換商品プロモーション】
   * 追加ボタンイベントリスナ
   */
  public eventPointPromotionListAdd_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0909Component);
    const instance = componentRef.componentInstance as KYMW0909Component;
    instance.parent = this;
    const vo = new KYMW0909InputModel();

    // モード
    vo.mode = KYMW0909InputModel.MODE_ADD;

    // アイテムコードリスト
    vo.itemCodeList = this.kymw0900Model.itemCodeList;
    // アイテムコード
    vo.selectedItemCode = vo.itemCodeList[0]?.ItemCode;

    // 注文コード割当リスト
    vo.pointExchangeOrderNumQuotaCodeList = this.kymw0900Model.pointExchangeOrderNumQuotaCodeList;
    // 注文コード割当コード
    vo.pointExchangeOrderNumQuotaCode = vo.pointExchangeOrderNumQuotaCodeList[0]?.OrderNumQuotaCode;

    // 専用商品名：遷移元画面の共通部のお届け明細書用商品名(漢字)
    vo.pointExchangeGoodsName = this.kymw0900Model.deliveryGoodsNameKanji;
    // 専用商品名(カナ)：遷移元画面の共通部の発注用商品名(カナ)
    vo.pointExchangeGoodsNameKana = this.kymw0900Model.deliveryGoodsNameKana;
    // 専用規格名：遷移元画面の共通部のお届け明細書用規格名(漢字)
    vo.pointExchangeGuideName = this.kymw0900Model.deliveryStandardNameKanji;
    // 専用規格名(カナ)：遷移元画面の共通部の発注用規格名(カナ)
    vo.pointExchangeGuideNameKana = this.kymw0900Model.deliveryStandardNameKana;

    // ポイント不足エラー区分
    vo.shortOfPointDiv = '0';

    // ECのみ掲載フラグ
    vo.ecOnlyFlg = '0';

    // 消費税率
    vo.consumeTaxRate = Number(this.kymw0900Model.getConsumeTaxDivRate());
    // 消費税区分
    vo.consumeTaxDiv = this.kymw0900Model.consumeTaxDiv;

    // ポイント購入時割引率一括設定値
    vo.pointRateAllSetting = '';

    let tempCoopPointRateList = [];
    const coopCodeIB = this.kymw00Model.COOP_CODE_IB;
    const coopCodeTO = this.kymw00Model.COOP_CODE_TO;
    const coopCodeGU = this.kymw00Model.COOP_CODE_GU;
    const coopCodeTI = this.kymw00Model.COOP_CODE_TI;
    const coopCodeSA = this.kymw00Model.COOP_CODE_SA;
    const coopCodeTK = this.kymw00Model.COOP_CODE_TK;
    const coopCodeNA = this.kymw00Model.COOP_CODE_NA;
    const coopCodeNI = this.kymw00Model.COOP_CODE_NI;
    // 会員生協タブのアイテムコードに紐づく会員生協のチェックボックスON、存在しない場合OFF
    // アイテムコードに紐づく会員生協を取得
    const itemRelatedCoopList = this.getSelectedCoopInfoItemCoopCode().find(_ => _.itemCode === vo.selectedItemCode)?.coopCode;
    // 価格一覧でアイテムコードが選択されている会員生協のチェックボックスを活性
    const enabledCoop = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_IB,
      CoopCode: coopCodeIB,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeIB),
      RegistFlg: itemRelatedCoopList.includes(coopCodeIB) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeIB),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TO,
      CoopCode: coopCodeTO,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeTO),
      RegistFlg: itemRelatedCoopList.includes(coopCodeTO) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeTO),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_GU,
      CoopCode: coopCodeGU,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeGU),
      RegistFlg: itemRelatedCoopList.includes(coopCodeGU) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeGU),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TI,
      CoopCode: coopCodeTI,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeTI),
      RegistFlg: itemRelatedCoopList.includes(coopCodeTI) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeTI),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_SA,
      CoopCode: coopCodeSA,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeSA),
      RegistFlg: itemRelatedCoopList.includes(coopCodeSA) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeSA),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TK,
      CoopCode: coopCodeTK,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeTK),
      RegistFlg: itemRelatedCoopList.includes(coopCodeTK) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeTK),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_NA,
      CoopCode: coopCodeNA,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeNA),
      RegistFlg: itemRelatedCoopList.includes(coopCodeNA) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeNA),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_NI,
      CoopCode: coopCodeNI,
      ThisTimeSupplyPrice: '',
      PointRate: '',
      ExchangePointWithoutTax: '',
      ExchangePoint: '',
      PlanGoodsCoopPointRateEnableFlg: itemRelatedCoopList.includes(coopCodeNI),
      RegistFlg: itemRelatedCoopList.includes(coopCodeNI) ? '1' : '0',
      DeleteFlg: '0',
      DisabledFlg: !enabledCoop.includes(coopCodeNI),
    });

    // 会員タブに今回供給価格が表示されているのかをチェック
    // 会員タブの価格一覧から生協コードと今回供給価格のリストを作成
    const coopPriceList = this.kymw0900Model.coopPriceList.map(_ => {
      return {
        coopCode: _.CoopCode,
        thisTimeSupplyPrice: _.ThistimeSupplyPrice
      }
    });
    // 1物N価媒体プロモーションのアイテムコードごとの供給単価の取得
    const nvalSupplyUnitPriceList = this.getNvalSupplyUnitPriceSortList();
    // 1物N価の情報で対象のアイテムコードのデータを取得
    const nvalSupplyPrice = nvalSupplyUnitPriceList.find(s => s.itemCode === vo.selectedItemCode)?.supplyPriceStandard;
    for (const _ of tempCoopPointRateList) {
      const coopPrice = coopPriceList.find(c => c.coopCode === _.CoopCode);
      if (coopPrice?.thisTimeSupplyPrice) {
        // 会員タブに今回供給価格が表示されている場合はその値を使用
        _.ThisTimeSupplyPrice = coopPrice.thisTimeSupplyPrice;
      } else {
        // 表示されていない場合、
        // 対象のアイテムコードの1物N価情報がある場合はそこに設定されている供給単価を設定、無い場合は選定時供給価格を設定
        if (nvalSupplyPrice) {
          // 対象のアイテムコードの1物N価情報に設定されている供給単価を設定
          _.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalSupplyPrice, true);
        } else {
          for (const pointPromotion of this.kymw0900Model.pointExchangeList) {
            const price = pointPromotion.coopPointRateList.find(cp => cp.CoopCode === _.CoopCode)?.ThisTimeSupplyPrice;
            if (price) {
              _.ThisTimeSupplyPrice = price;
              break;
            }
          }
        }
      }
    }
    vo.coopPointRateList = tempCoopPointRateList;


    // 会員タブのアイテムコードリスト
    vo.coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();

    vo.registFlg = '1';
    vo.deleteFlg = '0';

    // 登録済みのデータリスト
    vo.settedItemCodeList = this.kymw0900Model.pointExchangeListDisplay.map(_ => _.itemCode);

    instance.setInterfaceParam(vo);
    instance.setKYMW0909Parameter = (outputVO: KYMW0909OutputModel) => {
      // 戻ってきたら表に追加する
      // 代表生協順（さ、い、と、ぐ、ち、とう、な、に）で最初にヒットした情報の交換ポイント、供給単価を取得
      let displayExchangePoint = '';
      let displayThisTimeSupplyPrice = '';
      for (const e of this.kymw0900Model.coopDaihyoOrder) {
        outputVO.coopPointRateList.map(c => {
          if (e === c.CoopCode) {
            displayExchangePoint = c.ExchangePoint;
            displayThisTimeSupplyPrice = c.ThisTimeSupplyPrice;
          }
        });
        if (!PlessViewUtilsSub.isEmpty(displayExchangePoint)) {
          break;
        }
      }
      const addData = {
        itemCode: outputVO.selectedItemCode,
        pointExchangeOrderNumQuotaCode: outputVO.pointExchangeOrderNumQuotaCode,
        pointExchangeOrderNum: outputVO.pointExchangeOrderNum,
        pointExchangeGoodsName: outputVO.pointExchangeGoodsName,
        pointExchangeGoodsNameKana: outputVO.pointExchangeGoodsNameKana,
        pointExchangeGuideName: outputVO.pointExchangeGuideName,
        pointExchangeGuideNameKana: outputVO.pointExchangeGuideNameKana,
        consumeTaxRate: outputVO.consumeTaxRate,
        shortOfPointDiv: outputVO.shortOfPointDiv,
        ecOnlyFlg: outputVO.ecOnlyFlg,
        coopPointRateList: outputVO.coopPointRateList,
        displayExchangePoint: displayExchangePoint,
        displayThisTimeSupplyPrice: displayThisTimeSupplyPrice,
        registFlg: outputVO.registFlg,
        deleteFlg: outputVO.deleteFlg,
      };

      // 保持データ
      this.kymw0900Model.pointExchangeList = [...this.kymw0900Model.pointExchangeList, addData];
      // 表示用データ
      this.kymw0900Model.pointExchangeListDisplay = [...this.kymw0900Model.pointExchangeListDisplay, addData];
      this.dtg_PointPromotionList.refresh();
      this.editCount++;
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【プロモ設定タブ：ポイント交換商品プロモーション】
   * 詳細コンテキストメニューイベントリスナ
   */
  public detailPointPromotionList_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0909Component);
    const instance = componentRef.componentInstance as KYMW0909Component;
    instance.parent = this;
    // 選択行
    const index = this.dtg_PointPromotionList.selectedRows[0].index;
    // 選択したデータ
    const item = this.kymw0900Model.pointExchangeListDisplay[index];
    // 選択したアイテムコード
    const selectedItemCode = item.itemCode;

    const vo = new KYMW0909InputModel();
    // モード：
    if (this.kymw0900Model.permission === '1') {
      // 閲覧権限
      vo.mode = KYMW0909InputModel.MODE_READ_ONLY;
    } else {
      // 詳細
      vo.mode = KYMW0909InputModel.MODE_DETAIL;
    }

    // アイテムコード
    vo.selectedItemCode = item.itemCode;

    // アイテムコードリスト
    vo.itemCodeList = [{ ItemCode: item.itemCode }];

    // 注文コード割当コード
    vo.pointExchangeOrderNumQuotaCode = item.pointExchangeOrderNumQuotaCode;

    // 注文コード割当リスト
    vo.pointExchangeOrderNumQuotaCodeList = this.kymw0900Model.pointExchangeOrderNumQuotaCodeList;

    // ポイント交換注文コード
    vo.pointExchangeOrderNum = item.pointExchangeOrderNum;

    // 専用商品名
    vo.pointExchangeGoodsName = item.pointExchangeGoodsName;

    // 専用商品名(カナ)
    vo.pointExchangeGoodsNameKana = item.pointExchangeGoodsNameKana;

    // 専用規格名
    vo.pointExchangeGuideName = item.pointExchangeGuideName;

    // 専用規格名(カナ)
    vo.pointExchangeGuideNameKana = item.pointExchangeGuideNameKana;

    // ポイント不足エラー区分
    vo.shortOfPointDiv = item.shortOfPointDiv;

    // ECのみ掲載フラグ
    vo.ecOnlyFlg = item.ecOnlyFlg;

    // 消費税率
    vo.consumeTaxRate = Number(this.kymw0900Model.getConsumeTaxDivRate());
    // 消費税区分
    vo.consumeTaxDiv = this.kymw0900Model.consumeTaxDiv;

    // ポイント購入時割引率一括設定値
    vo.pointRateAllSetting = item.pointRateAllSetting;

    let tempCoopPointRateList = [];
    const coopCodeIB = this.kymw00Model.COOP_CODE_IB;
    const coopCodeTO = this.kymw00Model.COOP_CODE_TO;
    const coopCodeGU = this.kymw00Model.COOP_CODE_GU;
    const coopCodeTI = this.kymw00Model.COOP_CODE_TI;
    const coopCodeSA = this.kymw00Model.COOP_CODE_SA;
    const coopCodeTK = this.kymw00Model.COOP_CODE_TK;
    const coopCodeNA = this.kymw00Model.COOP_CODE_NA;
    const coopCodeNI = this.kymw00Model.COOP_CODE_NI;
    const disabledCoop = this.kymw0900Model.coopPriceList.filter(_ => PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);

    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_IB,
      CoopCode: coopCodeIB,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeIB) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeIB) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeIB) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeIB) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeIB) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeIB)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeIB),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TO,
      CoopCode: coopCodeTO,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeTO) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeTO) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeTO) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeTO) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeTO) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTO)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeTO),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_GU,
      CoopCode: coopCodeGU,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeGU) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeGU) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeGU) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeGU) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeGU) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeGU)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeGU),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TI,
      CoopCode: coopCodeTI,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeTI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeTI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeTI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeTI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeTI) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTI)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeTI),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_SA,
      CoopCode: coopCodeSA,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeSA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeSA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeSA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeSA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeSA) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeSA)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeSA),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_TK,
      CoopCode: coopCodeTK,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeTK) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeTK) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeTK) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeTK) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeTK) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeTK)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeTK),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_NA,
      CoopCode: coopCodeNA,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeNA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeNA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeNA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeNA) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeNA) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeNA)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeNA),
    });
    tempCoopPointRateList.push({
      CoopName: this.kymw00Model.COOP_NI,
      CoopCode: coopCodeNI,
      ThisTimeSupplyPrice: disabledCoop.includes(coopCodeNI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.ThisTimeSupplyPrice,
      PointRate: disabledCoop.includes(coopCodeNI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.PointRate,
      ExchangePointWithoutTax: disabledCoop.includes(coopCodeNI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.ExchangePointWithoutTax,
      ExchangePoint: disabledCoop.includes(coopCodeNI) ? '' : item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.ExchangePoint,
      PlanGoodsCoopPointRateEnableFlg: !PlessViewUtilsSub.isEmpty(item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.PlanGoodsCoopPointRateEnableFlg) ?
        item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.PlanGoodsCoopPointRateEnableFlg && !disabledCoop.includes(coopCodeNI) : false,
      RegistFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.RegistFlg,
      DeleteFlg: item.coopPointRateList.find(_ => _.CoopCode === coopCodeNI)?.DeleteFlg,
      DisabledFlg: disabledCoop.includes(coopCodeNI),
    });

    // 会員タブに今回供給価格が表示されているのかをチェック
    // 会員タブの価格一覧から生協コードと今回供給価格のリストを作成
    const coopPriceList = this.kymw0900Model.coopPriceList.map(_ => {
      return {
        coopCode: _.CoopCode,
        thisTimeSupplyPrice: _.ThistimeSupplyPrice
      }
    });
    for (const _ of tempCoopPointRateList) {
      const coopPrice = coopPriceList.find(c => c.coopCode === _.CoopCode);
      if (coopPrice?.thisTimeSupplyPrice) {
        // 会員タブに今回供給価格が表示されている場合はその値を使用
        _.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(coopPrice.thisTimeSupplyPrice, true);
      }
    }
    vo.coopPointRateList = tempCoopPointRateList;

    // 会員タブのアイテムコードリスト
    vo.coopInfoItemCoopCode = this.getSelectedCoopInfoItemCoopCode();

    vo.registFlg = item.registFlg;
    vo.deleteFlg = '0';

    // 登録済みのデータリスト
    vo.settedItemCodeList = this.kymw0900Model.pointExchangeListDisplay.map(_ => _.itemCode);

    // 会員生協別ポイント一覧（現状で登録されているデータ）
    vo.coopPointRateCurrentList = item.coopPointRateList;

    instance.setInterfaceParam(vo);
    instance.setKYMW0909Parameter = (outputVO: KYMW0909OutputModel) => {
      // 戻ってきたら表を更新
      // 代表生協順（さ、い、と、ぐ、ち、とう、な、に）で最初にヒットした情報の交換ポイント、供給単価を取得
      let displayExchangePoint = '';
      let displayThisTimeSupplyPrice = '';
      for (const e of this.kymw0900Model.coopDaihyoOrder) {
        outputVO.coopPointRateList.map(c => {
          if (e === c.CoopCode) {
            displayExchangePoint = c.ExchangePoint;
            displayThisTimeSupplyPrice = c.ThisTimeSupplyPrice;
          }
        });
        if (!PlessViewUtilsSub.isEmpty(displayExchangePoint)) {
          break;
        }
      }
      const updateData = {
        itemCode: outputVO.selectedItemCode,
        pointExchangeOrderNumQuotaCode: outputVO.pointExchangeOrderNumQuotaCode,
        pointExchangeOrderNum: outputVO.pointExchangeOrderNum,
        pointExchangeGoodsName: outputVO.pointExchangeGoodsName,
        pointExchangeGoodsNameKana: outputVO.pointExchangeGoodsNameKana,
        pointExchangeGuideName: outputVO.pointExchangeGuideName,
        pointExchangeGuideNameKana: outputVO.pointExchangeGuideNameKana,
        consumeTaxRate: outputVO.consumeTaxRate,
        shortOfPointDiv: outputVO.shortOfPointDiv,
        ecOnlyFlg: outputVO.ecOnlyFlg,
        pointRateAllSetting: outputVO.pointRateAllSetting,
        coopPointRateList: outputVO.coopPointRateList,
        displayExchangePoint: displayExchangePoint,
        displayThisTimeSupplyPrice: displayThisTimeSupplyPrice,
        registFlg: outputVO.registFlg,
        deleteFlg: outputVO.deleteFlg,
      };

      // 保持用
      // setPromotionThistimeSupplyPriceで変更前の値を使用するため、
      // 保持用リストは更新せずそのままとしておく（変更確定時に表示用リストをそのまま格納）
      // 表示用
      for (const key of Object.keys(this.kymw0900Model.pointExchangeListDisplay[index])) {
        this.kymw0900Model.pointExchangeListDisplay[index][key] = updateData[key];
      }
      this.dtg_PointPromotionList.refresh();
      this.editCount++;
    };

    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【プロモ設定タブ：ポイント交換商品プロモーション】
   * 削除コンテキストメニューイベントリスナ
   */
  public deletePointPromotionList_CLICKHandler(): void {
    const index = this.dtg_PointPromotionList.selectedRows[0].index;
    const item = this.kymw0900Model.pointExchangeListDisplay[index];
    // 削除対象のアイテムコードを保持
    const deletedItemCode = item.itemCode;
    this.kymw0900Model.pointExchangeListDisplay.splice(index, 1);
    this.kymw0900Model.pointExchangeListDisplay = [...this.kymw0900Model.pointExchangeListDisplay];
    this.dtg_PointPromotionList.refresh();

    let counter = 0;
    let deleteIndex = null;
    for (const e of this.kymw0900Model.pointExchangeList) {
      // アイテムコードで削除対象を判定
      if (deletedItemCode === e.itemCode) {
        if (e.registFlg === '1') {
          // 追加して削除したものは表示元リストからも削除
          deleteIndex = counter;
          if (this.editCount > 0) {
            this.editCount--;
          }
        } else {
          // 削除を指示したデータの削除フラグに1を設定
          e.deleteFlg = '1';
          this.editCount++;
          // 選択したデータの値引情報をクリアして一覧に表示する
          e.pointExchangeOrderNumQuotaCode = '';
          e.pointExchangeOrderNum = '';
          e.pointExchangeGoodsName = '';
          e.pointExchangeGoodsNameKana = '';
          e.pointExchangeGuideName = '';
          e.pointExchangeGuideNameKana = '';
          e.consumeTaxRate = '';
          e.shortOfPointDiv = '';
          e.ecOnlyFlg = '0';
          e.coopPointRateList.map(_ => {
            _.DeleteFlg = '1';
            _.PointRate = '';
            _.ExchangePointWithoutTax = '';
            _.ExchangePoint = '';
          })
        }
        break;
      }
      counter = counter + 1;
    }
    if (deleteIndex !== null) {
      this.kymw0900Model.pointExchangeList.splice(deleteIndex, 1);
    }
  }

  /**
   * プロモ設定 ポイントプロモーション追加ボタンの活性制御
   */
  public setPointPromotionAddBtnEnable(): void {
    // 閲覧モードまたは企画確定済の場合
    if (this.kymw0900Model.permission === this.USER_PERMISSION_READONLY || this.kymw0900Model.isConfirmed) {
      this.kymw0900Model.pointExchangeAddDisable = true;
      return;
    }

    //  ポイントプロモーションフラグが「1:ポイント交換商品プロモーション設定を使用する」の場合、活性
    // 「1:ポイント交換商品プロモーション設定を使用する」以外の場合、非活性
    if (this.kymw0900Model.pointPromotionFlg) {
      this.kymw0900Model.pointExchangeAddDisable = false;
    } else {
      this.kymw0900Model.pointExchangeAddDisable = true;
    }
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 追加ボタンイベントリスナ
   */
  public eventNvalPromotionListAdd_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0907Component);
    const instance = componentRef.componentInstance as KYMW0907Component;
    instance.parent = this;
    let vo = new KYMW0907InputModel();

    // モード
    vo.mode = KYMW0907InputModel.MODO_ADD;

    vo = this.setNvalPromotionCommonInputVO(vo);

    // 選定済1物N価媒体リスト
    vo.mediumTypeList = this.kymw0900Model.nvalMediumTypeList;
    // 媒体（初期値：先頭の情報）
    vo.mediumType = vo.mediumTypeList[0]?.MediumType;

    // アイテムコードに紐づく会員生協
    vo.itemRelatedCoop_CoopTab = this.itemRelatedCoop_CoopTab;

    // アイテムコードセレクトボックスを取得する
    // アイテムコードの重複を削除
    const list = [];
    for (const e of this.itemRelatedCoop) {
      list[e.ItemCode] = e;
    }
    // アイテムコードリストに格納
    vo.itemCodeList = Object.keys(list).map(key => list[key]);
    // アイテムコード（初期値：セレクトボックスの先頭）
    vo.selectedItemCode = vo.itemCodeList[0].ItemCode;

    // 商品企画担当区分
    vo.shkkktantKb = '';

    // 専用商品名付加文字
    const addChar = {
      list: []
    };

    this.getCodeListService.execute('ctp395', '', addChar, 'list', () => {
      // パラメータ設定（空データに対して「詳細」で開いた時にも同じ値を設定するため、共通イベントを使用している）
      vo = this.setNvalPromotionInputParam_ADD_emptyDETAIL(vo, addChar);      // 利用生協設定
      vo = this.setNvalPromotionCoopCheckDisabled(vo);
      vo = this.setNvalPromotionCoopCheckONOFF(vo);

      instance.setInterfaceParam(vo);
      instance.setKYMW0907Parameter = (outputVO: KYMW0907OutputModel) => {
        // 戻ってきたら表に追加する
        const addData = this.crateNvalPromotionOutputVO(outputVO);

        // 保持データ
        this.kymw0900Model.nvalPromotionList = [...this.kymw0900Model.nvalPromotionList, addData];
        // 表示用データ
        const displayData = { mediumType: addData.mediumType, mediumName: addData.mediumName, mediumTypeName: addData.mediumTypeName, nvalOrderNum: addData.nvalOrderNum, itemCode: addData.itemCode, nvalDetailId: addData.nvalDetailId, dataList: [addData] };
        this.kymw0900Model.nvalPromotionListDisplay = [...this.kymw0900Model.nvalPromotionListDisplay, displayData];
        this.dtg_NvalPromotionList.refresh();
        this.editCount++;

        // 同一アイテムコードの1物N価媒体プロモーション設定情報の供給単価を更新する。
        this.updateNvalPromotionSupplyPrice(addData.itemCode, addData.supplyPriceStandard);
        // 他プロモーションの供給単価を変更
        this.eventReCalcSupplyUnitPrice_Handler();
      };
      instance.closeFunction = () => {
        componentRef.close();
      };
    }, null, vo.mediumType); // getCodeListで使う媒体区分
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 詳細コンテキストメニューイベントリスナ
   */
  public detailNvalPromotionList_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW0907Component);
    const instance = componentRef.componentInstance as KYMW0907Component;
    instance.parent = this;
    // 選択行
    const index = this.dtg_NvalPromotionList.selectedRows[0].index;
    // 選択したデータ（受注コード単位）
    const item = this.kymw0900Model.nvalPromotionListDisplay[index].dataList.find(data => data.orderCode === this.kymw0900Model.orderCode);
    // 選択したデータ
    const dataItem = this.kymw0900Model.nvalPromotionListDisplay[index];
    // 選択したデータの詳細情報ID
    const selectedNvalDetailId = dataItem.nvalDetailId;

    let vo = new KYMW0907InputModel();
    // モード：
    if (this.kymw0900Model.permission === '1') {
      // 閲覧権限
      vo.mode = KYMW0907InputModel.MODO_READ_ONLY;
    } else {
      // 詳細
      vo.mode = KYMW0907InputModel.MODO_DETAIL;
    }

    // 注文コード割当一覧取得処理を呼び出し、
    // 取得した情報を1物N価媒体プロモーションの注文コード割当コードに反映する
    this.getOrderNumQuotaCodeList(this.kymw0900Model.pCode, '1物N価媒体', (data) => {
      // 注文コード割当コード一覧
      vo.nvalOrderNumQuotaCodeList = this.kymw0900Model.updateOrderNumQuotaCodeList(data);
      // コード一覧取得処理を呼び出し、取得した情報を1物N価詳細区分に反映する。
      this.getCodeListService.execute('ctp113', '', vo, 'nvalDetailDevList', async () => {
        vo = this.setNvalPromotionCommonInputVO(vo);
        if (item) {
          // データがある場合
          vo.nvalDetailId = selectedNvalDetailId;
          vo.mediumTypeList = [{ MediumType: item.mediumType, MediumName: item.mediumName }];
          vo.mediumType = item.mediumType;
          vo.itemCodeList = [{ ItemCode: item.itemCode }];
          vo.selectedItemCode = item.itemCode;
          vo.nvalOrderNumQuotaCode = item.nvalOrderNumQuotaCode;
          vo.orderNum = item.nvalOrderNum;
          vo.nvalDetailDev = item.ibnkssaKb;
          vo.shkkktantKb = item.shkkktantKb;
          vo.nvalPromotionGoodsName = item.nvalGoodsName;
          vo.nvalPromotionGoodsNameKana = item.nvalGoodsNameKana;
          vo.nvalPromotionStandardName = item.nvalGuideName;
          vo.nvalPromotionStandardNameKana = item.nvalGuideNameKana;
          vo.discountType = item.discountType;
          vo.discountUnitPrice = item.discountUnitPrice;
          vo.discountRate = item.discountRate;
          vo.supplyPriceStandard = item.supplyPriceStandard;
          vo.pricePattern = item.pricePattern;

          // 値引後供給単価
          if (item.discountType === '0') {
            // 値引区分が値引きなしの場合、供給単価を格納
            vo.discountSupplyUnitPrice = item.supplyPriceStandard;
          } else if (item.discountType === '1') {
            // 値引区分が単価指定の場合、「選定時供給価格（通常価）-値引単価」を格納
            vo.discountSupplyUnitPrice = String(Number(item.supplyPriceStandard) - Number(item.discountUnitPrice));
          } else if (item.discountType === '2') {
            // 値引区分が単価指定の場合、「選定時供給価格（通常価）×（100-値引率）/ 100」を格納
            const discountPrice = Math.ceil(Number(item.supplyPriceStandard) * ((100 - Number(item.discountRate)) / 100));
            vo.discountSupplyUnitPrice = String(discountPrice);
          }

          // 利用生協の活性制御
          vo = this.setNvalPromotionCoopCheckDisabled(vo);
          // 利用生協のONOFF
          vo.usePrefecture1Flg = item.usePrefecture1Flg === '1' && !vo.coopIBDisable;
          vo.usePrefecture2Flg = item.usePrefecture2Flg === '1' && !vo.coopTODisable;
          vo.usePrefecture3Flg = item.usePrefecture3Flg === '1' && !vo.coopGUDisable;
          vo.usePrefecture4Flg = item.usePrefecture4Flg === '1' && !vo.coopTIDisable;
          vo.usePrefecture5Flg = item.usePrefecture5Flg === '1' && !vo.coopSADisable;
          vo.usePrefecture6Flg = item.usePrefecture6Flg === '1' && !vo.coopTKDisable;
          vo.usePrefecture7Flg = item.usePrefecture7Flg === '1' && !vo.coopNADisable;
          vo.usePrefecture8Flg = item.usePrefecture8Flg === '1' && !vo.coopNIDisable;

          vo.remarks = item.remarks;
          vo.registFlg = item.registFlg;
          vo.deleteFlg = '0';
        } else {
          // データがない（セルが空）の場合、1物N価詳細情報ID、媒体、アイテムコード以外を「追加」時と同じ値で表示する
          vo.nvalDetailId = dataItem.nvalDetailId;
          vo.mediumTypeList = [{ MediumType: dataItem.mediumType, MediumName: dataItem.mediumName }];
          vo.mediumType = dataItem.mediumType;
          vo.itemCodeList = [{ ItemCode: dataItem.itemCode }];
          vo.selectedItemCode = dataItem.itemCode;

          // 専用商品名付加文字
          const addChar = {
            list: []
          };
          await this.getCodeListService.executeAsync('ctp395', '', addChar, 'list', vo.mediumType);
          // 「追加」時と同じ値を設定
          vo = this.setNvalPromotionInputParam_ADD_emptyDETAIL(vo, addChar);
          // 利用生協設定
          vo = this.setNvalPromotionCoopCheckDisabled(vo);
          vo = this.setNvalPromotionCoopCheckONOFF(vo);
          // 初期値設定（kymw0907で追加モードのときに設定している値）
          vo.nvalOrderNumQuotaCode = vo.nvalOrderNumQuotaCodeList[0]?.OrderNumQuotaCode;
          vo.nvalDetailDev = vo.nvalDetailDevList[0]?.Reserve1;
          vo.shkkktantKb = '2';
          vo.registFlg = '1';
          vo.deleteFlg = '0';
          // 空のデータに対して「詳細」で開いたことを確認するためのフラグ
          vo.emptyDetailFlg = true;
        }

        instance.setInterfaceParam(vo);
        instance.setKYMW0907Parameter = (outputVO: KYMW0907OutputModel) => {
          // 表を更新
          const updateData = this.crateNvalPromotionOutputVO(outputVO);
          if (item) {
            // 対象データがある場合はそのまま格納
            // 保持用
            this.kymw0900Model.nvalPromotionList.forEach((data, index) => {
              // 選択したデータの詳細情報IDと、受注コードが一致するデータに対して変更を行う
              if (selectedNvalDetailId === data.nvalDetailId && data.orderCode === this.kymw0900Model.orderCode) {
                for (const key of Object.keys(data)) {
                  this.kymw0900Model.nvalPromotionList[index][key] = updateData[key];
                }
              }
            })
            // 表示用
            for (const data of this.kymw0900Model.nvalPromotionListDisplay[index].dataList) {
              if (data.orderCode === this.kymw0900Model.orderCode) {
                for (const key of Object.keys(data)) {
                  data[key] = updateData[key];
                }
                break;
              }
            }
          } else {
            // 対象データがない場合は新しく作成
            // 保持用
            this.kymw0900Model.nvalPromotionList = [...this.kymw0900Model.nvalPromotionList, updateData];
            // 表示用
            this.kymw0900Model.nvalPromotionListDisplay[index].dataList = [...this.kymw0900Model.nvalPromotionListDisplay[index].dataList, updateData];
          }
          this.dtg_NvalPromotionList.refresh();
          this.editCount++;

          // 同一アイテムコードの1物N価媒体プロモーション設定情報の供給単価を更新する。
          this.updateNvalPromotionSupplyPrice(updateData.itemCode, updateData.supplyPriceStandard);
          // 他プロモーションの供給単価を変更
          this.eventReCalcSupplyUnitPrice_Handler();
        };

        instance.closeFunction = () => {
          componentRef.close();
        };
      }, null, dataItem.mediumType); // getCodeListで使う媒体区分
    }, dataItem.mediumType); // getOrderNumQuotaCodeListで使う媒体区分
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 追加ボタン・詳細で共通のinputvo
   */
  private setNvalPromotionCommonInputVO(vo: KYMW0907InputModel): KYMW0907InputModel {
    // 受注コード
    vo.orderCode = this.kymw0900Model.orderCode;
    // Pコード
    vo.pCode = this.kymw0900Model.pCode;
    // 会員タブのアイテムコード
    vo.coopInfoItemCode = this.getSelectedCoopInfoItemCoopCode();
    // 価格パターン表示用リスト
    vo.coopSupplyPriceList = this.kymw0900Model.coopSupplyPriceList;
    return vo;
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 利用生協チェックボックスの活性制御
   * @param vo 
   * @returns 
   */
  private setNvalPromotionCoopCheckDisabled(vo: KYMW0907InputModel): KYMW0907InputModel {
    // ＜活性制御＞
    // 会員タブでアイテムコードが選択されている場合は活性・ON。選択されていない場合非活性
    const coopList = this.kymw0900Model.coopPriceList.filter(_ => !PlessViewUtilsSub.isEmpty(_.SelectItemCode)).map(_ => _.CoopCode);
    vo.coopIBDisable = !coopList.includes(this.kymw00Model.COOP_CODE_IB);
    vo.coopTODisable = !coopList.includes(this.kymw00Model.COOP_CODE_TO);
    vo.coopGUDisable = !coopList.includes(this.kymw00Model.COOP_CODE_GU);
    vo.coopTIDisable = !coopList.includes(this.kymw00Model.COOP_CODE_TI);
    vo.coopSADisable = !coopList.includes(this.kymw00Model.COOP_CODE_SA);
    vo.coopTKDisable = !coopList.includes(this.kymw00Model.COOP_CODE_TK);
    vo.coopNADisable = !coopList.includes(this.kymw00Model.COOP_CODE_NA);
    vo.coopNIDisable = !coopList.includes(this.kymw00Model.COOP_CODE_NI);
    return vo;
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 利用生協チェックボックスのONOFF設定
   * @param vo 
   * @returns 
   */
  private setNvalPromotionCoopCheckONOFF(vo: KYMW0907InputModel): KYMW0907InputModel {
    // ＜ON/OFF制御＞
    // アイテムコードが「会員」タブで選択されている場合、チェックボックスON・選択されていない場合チェックボックスOFF
    const checkedCoop = vo.coopInfoItemCode.find(_ => _.itemCode === vo.selectedItemCode);
    if (checkedCoop) {
      const coopInfoItemCodeList = checkedCoop?.coopCode;
      // 選択したアイテムコード（リストの一つ目）が会員タブで選択されている場合、その生協にチェックを入れる
      vo.usePrefecture1Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_IB) && !vo.coopIBDisable;
      vo.usePrefecture2Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TO) && !vo.coopTODisable;
      vo.usePrefecture3Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_GU) && !vo.coopGUDisable;
      vo.usePrefecture4Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TI) && !vo.coopTIDisable;
      vo.usePrefecture5Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_SA) && !vo.coopSADisable;
      vo.usePrefecture6Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_TK) && !vo.coopTKDisable;
      vo.usePrefecture7Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_NA) && !vo.coopNADisable;
      vo.usePrefecture8Flg = coopInfoItemCodeList.includes(this.kymw00Model.COOP_CODE_NI) && !vo.coopNIDisable;
    }
    return vo;
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * setKYMW0907Parameter内でのdata作成処理
   * @param outputVO 
   * @returns 
   */
  private crateNvalPromotionOutputVO(outputVO): any {
    const updateData = {
      nvalDetailId: outputVO.nvalDetailId,
      orderCode: outputVO.orderCode,
      mediumType: outputVO.mediumType,
      mediumName: outputVO.mediumName,
      mediumTypeName: outputVO.mediumType + '：' + outputVO.mediumName,
      itemCode: outputVO.selectedItemCode,
      nvalOrderNumQuotaCode: outputVO.nvalOrderNumQuotaCode,
      nvalOrderNum: outputVO.orderNum,
      ibnkssaKb: outputVO.nvalDetailDev,
      shkkktantKb: outputVO.shkkktantKb,
      nvalGoodsName: outputVO.nvalPromotionGoodsName,
      nvalGoodsNameKana: outputVO.nvalPromotionGoodsNameKana,
      nvalGuideName: outputVO.nvalPromotionStandardName,
      nvalGuideNameKana: outputVO.nvalPromotionStandardNameKana,
      discountType: outputVO.discountType,
      discountUnitPrice: outputVO.discountUnitPrice,
      discountRate: outputVO.discountRate,
      supplyPriceStandard: outputVO.supplyPriceStandard,
      nvalDiscountSupplyUnitPrice: outputVO.discountSupplyUnitPrice,
      pricePattern: outputVO.pricePattern,
      usePrefecture1Flg: outputVO.usePrefecture1Flg,
      usePrefecture2Flg: outputVO.usePrefecture2Flg,
      usePrefecture3Flg: outputVO.usePrefecture3Flg,
      usePrefecture4Flg: outputVO.usePrefecture4Flg,
      usePrefecture5Flg: outputVO.usePrefecture5Flg,
      usePrefecture6Flg: outputVO.usePrefecture6Flg,
      usePrefecture7Flg: outputVO.usePrefecture7Flg,
      usePrefecture8Flg: outputVO.usePrefecture8Flg,
      remarks: outputVO.remarks,
      registFlg: outputVO.registFlg,
      deleteFlg: outputVO.deleteFlg,
      displayDiscount: this.kymw0900Model.setDisplayDiscount(outputVO.discountType, outputVO.discountUnitPrice, outputVO.discountRate)
    };

    return updateData;
  }

  /**
   * 【プロモ設定タブ：1物N価媒体プロモーション】
   * 削除コンテキストメニューイベントリスナ
   */
  public deleteNvalPromotionList_CLICKHandler(): void {
    const index = this.dtg_NvalPromotionList.selectedRows[0].index;
    // 削除確認ダイアログを表示する
    this.dialogServiceSub.openAlertGetMessage('Q0106', ['選択したプロモーション'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          // 選択した行で対象の受注コードの場合
          const item = this.kymw0900Model.nvalPromotionListDisplay[index].dataList.find(_ => !_.otherOrderCode);
          // 追加して削除した値引情報は保持データから削除
          if (item.registFlg === '1') {
            const deleteIdx = this.kymw0900Model.nvalPromotionList.indexOf(item);
            if (deleteIdx !== -1) {
              this.kymw0900Model.nvalPromotionList.splice(deleteIdx, 1);
            }
            // 削除フラグに「1」を設定
            item.deleteFlg = '1';
            // 選択したデータの値引情報をクリアして一覧に表示する
            this.clearNvalPromotionDiscount(item);
            if (this.editCount > 0) {
              this.editCount--;
            }
          } else {
            // 削除フラグに「1」を設定
            item.deleteFlg = '1';
            // 選択したデータの値引情報をクリアして一覧に表示する
            this.clearNvalPromotionDiscount(item);
            this.editCount++;
          }
        }
      }
    );
  }

  private clearNvalPromotionDiscount(item: any): void {
    // 選択したデータの値引情報をクリアして一覧に表示する
    item.displayDiscount = '';
    item.discountType = '0';
    item.discountUnitPrice = '';
    item.discountRate = '';
    this.dtg_NvalPromotionList.refresh();
  }

  /**
   * プロモ設定 1物N価データグリッド列の背景色設定
   */
  public setNvalPromotionColorPattern(): void {
    const grid = this.dtg_NvalPromotionList;

    grid.itemFormatter = (panel, r, c, cell) => {
      // セル配色
      if (CellType.Cell === panel.cellType && c > 3) {
        // ヘッダーの受注コードリスト
        const oCodeList = this.kymw0900Model.nvalOrderCodeList;
        // セルの持つ媒体
        const cMedium = this.dtg_NvalPromotionList.collectionView.items[r].mediumType;
        // セルの持つ媒体の束ね期間データを取得
        const bStartEndOCode = this.kymw0900Model.nvalBundlePeriodVOList.find(b => b.mediumType === cMedium);
        // セルのヘッダー（受注コード）を保持
        const headerOCode = oCodeList[c - 4];

        // ヘッダーの受注コードが束ね期間外か確認
        if (Number(headerOCode) < Number(bStartEndOCode.startOrderCode) ||
          Number(headerOCode) > Number(bStartEndOCode.endOrderCode)) {
          // 束ね期間外の場合、背景色を濃いグレーに変更
          cell.classList.add('nval_bundle');
        } else if (headerOCode !== this.kymw0900Model.orderCode) {
          // 束ね期間内で商品のインプットVO.受注コード以外の場合、背景色を薄いグレーに変更
          cell.classList.add('nval_disable');
        }
      }
    };
    // 選択行をクリア
    this.dtg_NvalPromotionList.selection = new CellRange(-1, -1, -1, -1);
  }

  /**
   * プロモ設定 1物N価追加ボタンの活性制御
   */
  public setNvalPromotionAddBtnEnable(): void {
    // 1物N価媒体プロモーションフラグが「1:1物N価媒体プロモーション設定を使用する」の場合、活性
    // 「1:1物N価媒体プロモーション設定を使用する」以外の場合、非活性
    if (this.kymw0900Model.nvalPromotionFlg) {
      this.kymw0900Model.nvalAddDisable = false;
    } else {
      this.kymw0900Model.nvalAddDisable = true;
    }
  }

  /**
   * 1物N価グリッドのヘッダーの幅設定
   */
  public setNvalPromotionWidth(): void {
    // 受注コードのデータが1列の時、ヘッダーの列を可変にする
    const list: Array<any> = this.kymw0900Model.nvalOrderCodeList;
    if (list.length < 2) {
      Object.keys(this.colWidths).forEach((key) => {
        this.colWidths[key] = this.NVAL_COLUMN_WIDTH[key].default;
      });
    }
  }

  /**
   * アイコンタブ：アイコン情報一覧チェックボックス処理
   *
   * @memberof KYMW0900Component
   */
  public checkBoxEventIconInfo(event: Event, grid: FlexGridFilter): void {

    // 押下されたセルの位置を取得(行)
    let selectedRow = this.fltr_Icon.grid.selection.row;

    // ソートされている場合を考慮し、ソート後の配列と当てつけを行い選択行を矯正
    // 基になる（フィルタリングもソートもされていない）コレクションを取得
    const orgItems = this.dtg_IconList.collectionView.sourceCollection;
    // 編集行を取得
    const editRow = this.fltr_Icon.grid.collectionView.items[selectedRow];

    for (let i = Number(0); i < orgItems.length; i++) {
      if (orgItems[i] === editRow) {
        // 元データにおける行の位置を取得
        selectedRow = i;
      }
    }

    // 押下されたチェックボックスの状態を取得
    const checkStatus: boolean = event.target['checked'];

    // 全生協
    if (this.kymw0900Model.allcoopValueIcon) {
      // 各生協のチェックボックスを、押下されたチェックボックスの状態で更新（入力不可になっている生協のチェックボックスには設定しない）
      this.kymw0900Model.iconList[selectedRow].icon0 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_IB] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon1 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TO] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon2 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_GU] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon3 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TI] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon4 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_SA] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon5 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TK] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon6 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NA] ? checkStatus : false;
      this.kymw0900Model.iconList[selectedRow].icon7 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NI] ? checkStatus : false;
    }
  }

  /**
   * 会員タブのチェックでアイコンタブと連動
   * @param event 
   * @param cell 
   */
  public coopInfoUpdateIconCheck(event: Event, cell: any, markCode: string) {
    // チェックボックスのチェック状況
    const checkStatus: boolean = event.target['checked'];
    // クリックした生協コード
    const coopCode = cell.item.CoopCode;
    // マークコードを3桁に0埋めして文字列に変換
    const zeroPaddingMark = PlessViewUtilsSub.zeroPadding(3, markCode);
    // iconXを格納する変数
    let iconIndex = '';

    // 生協コードに合うiconXを取得。全生協のチェックが入っている場合は全生協allを返す
    if (!this.kymw0900Model.allcoopValue) {
      iconIndex = this.getCoopIconNum(coopCode);
    } else {
      iconIndex = this.getCoopIconNum();
    }

    this.getIconDataFunction(zeroPaddingMark, iconIndex, checkStatus, event, coopCode);
  }

  /**
   * マークタブのチェックでアイコンタブと連動
   * @param event 
   * @param cell 
   */
  public markInfoUpdateIconCheck(event: Event, cell: any) {
    // チェックボックスのチェック状況
    const checkStatus: boolean = event.target['checked'];
    // マークタブは生協の選択毎のチェックができないため、全生協allを返す
    let iconIndex = this.getCoopIconNum();

    this.getIconDataFunction(cell.item.MarkCode, iconIndex, checkStatus, event);
  }

  /**
   * プロモタブのチェックでアイコンタブと連動
   * @param event 
   * @param cell 
   * @param coopCode 
   */
  public promotionInfoUpdateIconCheck(event: Event, cell: any, coopCode: string) {
    // チェックボックスのチェック状況
    const checkStatus: boolean = event.target['checked'];
    // iconXを格納する変数
    let iconIndex = '';

    // 生協コードに合うiconXを取得。全生協のチェックが入っている場合は全生協allを返す
    if (!this.kymw0900Model.allcoopValue2) {
      iconIndex = this.getCoopIconNum(coopCode);
    } else {
      iconIndex = this.getCoopIconNum();
    }

    this.getIconDataFunction(cell.item.MarkCode, iconIndex, checkStatus, event, coopCode);

    // マークコード033【０１：数量限定】の場合
    if (cell.item.MarkCode === this.LOTTERYPROMOTION_MARKCODE) {
      const lotteryMark = this.kymw0900Model.markInfoList.find(mark => mark.MarkCode === this.LOTTERYPROMOTION_MARKCODE);
      const hasCoop = lotteryMark.SelectValue1 || lotteryMark.SelectValue2 || lotteryMark.SelectValue3 || lotteryMark.SelectValue4
        || lotteryMark.SelectValue5 || lotteryMark.SelectValue6 || lotteryMark.SelectValue7 || lotteryMark.SelectValue8;

      // 1つ以上選択されている場合、抽選商品プロモーションにチェックをつける
      this.kymw0900Model.lotteryPromotionFlg = hasCoop;
      this.acc_UseLotteryPromotion.isCollapsed = !this.kymw0900Model.lotteryPromotionFlg;
      this.eventUseLotteryPromotion_CHANGEHandler();
    }
  }

  /**
   * 企画マスタ管理マークに自動チェック
   * 
   * @param check
   * @param _event  アイコン連動で使用
   */
  public setPromoMark(check: boolean, markCode: string, _event: Event) {
    const targetMark = this.kymw0900Model.markInfoList.find(mark => mark.MarkCode === markCode);

    if (targetMark) {
      targetMark.SelectValue1 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_IB] && check;
      targetMark.SelectValue2 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TO] && check;
      targetMark.SelectValue3 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_GU] && check;
      targetMark.SelectValue4 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TI] && check;
      targetMark.SelectValue5 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_SA] && check;
      targetMark.SelectValue6 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TK] && check;
      targetMark.SelectValue7 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NA] && check;
      targetMark.SelectValue8 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NI] && check;

      // アイコン情報のチェックボックス活性状態はアイコン側で判定しているため、ここでは"all"とする
      this.getIconDataFunction(targetMark.MarkCode, "all", check, _event);
    }
  }

  /**
   * 生協コードに対応するiconXを取得
   * @param coopCode 
   * @returns 
   */
  public getCoopIconNum(coopCode?: string): string {
    if (coopCode) {
      // 生協の指定がある場合、その生協のみを選択する
      // 対象の生協を確認
      switch (coopCode) {
        case this.kymw00Model.COOP_CODE_IB:
          return 'icon0';
        case this.kymw00Model.COOP_CODE_TO:
          return 'icon1';
        case this.kymw00Model.COOP_CODE_GU:
          return 'icon2';
        case this.kymw00Model.COOP_CODE_TI:
          return 'icon3';
        case this.kymw00Model.COOP_CODE_SA:
          return 'icon4';
        case this.kymw00Model.COOP_CODE_TK:
          return 'icon5';
        case this.kymw00Model.COOP_CODE_NA:
          return 'icon6';
        case this.kymw00Model.COOP_CODE_NI:
          return 'icon7';
      }
    } else {
      // 生協の指定がない場合、全生協を選択する
      return 'all';
    }
  }

  /**
   * getIconDataService実行メソッド
   * @param markCode マークコード
   * @param iconIndex iconListのインデックスiconX
   * @param checkStatus チェック可否
   * @param e イベント
   * @param coopCode 生協コード
   */
  public getIconDataFunction(markCode: string, iconIndex: string, checkStatus: boolean, e: Event, coopCode?: string): void {
    // API:getIconDataのリクエストVO
    const vo = {
      markCode: markCode
    }

    this.getIconDataService.execute(this.kymw0900Model, vo, data => {
      data.IconCodeList.map(response => {
        this.kymw0900Model.iconList.map((_, index) => {
          if (_.iconCode === response.IconCode) {
            if (iconIndex !== 'all') {
              this.kymw0900Model.iconList[index][iconIndex] = !this.kymw0900Model.iconListDisable[coopCode] ? checkStatus : false;
            } else {
              // すべての生協を選択
              this.kymw0900Model.iconList[index].icon0 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_IB] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon1 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TO] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon2 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_GU] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon3 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TI] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon4 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_SA] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon5 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_TK] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon6 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NA] ? checkStatus : false;
              this.kymw0900Model.iconList[index].icon7 = !this.kymw0900Model.iconListDisable[this.kymw00Model.COOP_CODE_NI] ? checkStatus : false;
            }
          }
        })
      })
      this.updateIconCheck(e, this.dtg_IconList, this.dtg_SelectedIconList);
      // フィルタを解除
      this.fltr_Icon.clear();
    });
  }

  /**
   * 会員タブで選択されたアイテムコードと生協をまとめたリストを返却するメソッド
   */
  public getSelectedCoopInfoItemCoopCode(): Array<any> {
    let coopInfoItemCoopCode = [];
    // 会員タブの価格一覧
    for (const cp of this.kymw0900Model.coopPriceList) {
      // 価格一覧で選択されているアイテムコードのデータを取得
      if (!PlessViewUtilsSub.isEmpty(cp.SelectItemCode)) {
        // そのアイテムコードを選択している生協コードを格納
        if (PlessViewUtilsSub.isEmpty(coopInfoItemCoopCode[cp.SelectItemCode])) {
          coopInfoItemCoopCode[cp.SelectItemCode] = {
            itemCode: cp.SelectItemCode,
            coopCode: [cp.CoopCode]
          }
        } else {
          coopInfoItemCoopCode[cp.SelectItemCode].coopCode.push(cp.CoopCode);
        }
      }
    }
    coopInfoItemCoopCode = Object.keys(coopInfoItemCoopCode).map(key => coopInfoItemCoopCode[key]);
    return coopInfoItemCoopCode;
  }

  /**
   * 基本タブ消費税区分変更時イベントハンドラ
   */
  public consumeTaxDiv_CHANGEHandler(): void {
    const taxRate = Number(this.kymw0900Model.getConsumeTaxDivRate());
    // プロモ設定タブのクーポン商品プロモーションの「このプロモーション設定を使用する」がチェック状態かつ、
    // 値引き前本体価格・税込み価格または値引き後本体価格・税込み価格に値が存在する場合下記処理を行う。
    if (this.kymw0900Model.couponPromotionFlg) {
      // ①「0:外税」に変更した場合、税込み価格部分を供給単価 + (供給単価 * 消費税率)の値で反映する。
      // ②「0:外税」以外に変更した場合、税込み価格部分を供給単価の値で反映する。
      this.kymw0900Model.couponPromotionListDisplay.map(_ => {
        // 値引き前本体価格・税込み価格
        if (_.contentTwo) {
          // 税抜き価格（文字列の前半部分）の数値を取得
          const originalPrice = _.contentTwo.split('円')[0].replace('本体　', '');
          // 税抜き価格を半角の数値に変換
          const originalPriceHalf = Number(PlessViewUtilsSub.toHalfWidth(originalPrice));
          _.contentTwo = this.kymw0900Model.formatUnitRatePrice(originalPriceHalf, taxRate);
          // 保持用リストにも保存
          this.kymw0900Model.couponPromotionList.map(data => {
            if (data.couponGoodsNo === _.couponGoodsNo) {
              data.contentTwo = _.contentTwo;
            }
          });
        }

        // 値引き後本体価格・税込み価格
        if (_.contentFour) {
          // 税抜き価格（文字列の前半部分）の数値を取得
          const originalPrice = _.contentFour.split('円')[0].replace('本体　', '');
          // 税抜き価格を半角の数値に変換
          const originalPriceHalf = Number(PlessViewUtilsSub.toHalfWidth(originalPrice));
          _.contentFour = this.kymw0900Model.formatUnitRatePrice(originalPriceHalf, taxRate);
          // 保持用リストにも保存
          this.kymw0900Model.couponPromotionList.map(data => {
            if (data.couponGoodsNo === _.couponGoodsNo) {
              data.contentFour = _.contentFour;
            }
          });
        }
      })
    }
    // ※上記反映先の項目はクーポン商品プロモーション設定モーダル表示時に反映されるが、
    // 消費税区分のみ変更した場合にも不整合が発生しないように消費税区分変更時も内部保持値を反映する。

    // プロモ設定タブのポイント交換商品プロモーションの「このプロモーション設定を使用する」がチェック状態かつ、
    // 交換ポイント（税抜）に値が存在する場合下記処理を行う。
    if (this.kymw0900Model.pointPromotionFlg) {
      // ①「0:外税」に変更した場合、交換ポイントを交換ポイント(税抜) * (1 + (基本タブ.消費税率/100))の値で反映する。		
      // ②「0:外税」以外に変更した場合、交換ポイントを交換ポイント(税抜)の値で反映する。
      this.kymw0900Model.pointExchangeListDisplay.map(p => {
        for (const cp of p.coopPointRateList) {
          if (this.kymw0900Model.consumeTaxDiv !== '0') {
            cp.ExchangePoint = cp.ExchangePointWithoutTax;
          } else {
            // ポイント購入時割引率が設定されている場合
            if (!PlessViewUtilsSub.isEmpty(cp.PointRate)) {
              // 交換ポイント（税抜）のカンマをはずす
              const numberExchangePointWithoutTax = Number(PlessViewUtilsSub.editPriceComma(cp.ExchangePointWithoutTax, false));
              // 交換ポイントを計算
              const exchangePoint = Math.floor(numberExchangePointWithoutTax * (1 + (Number(this.kymw0900Model.getConsumeTaxDivRate()) / 100)));
              cp.ExchangePoint = PlessViewUtilsSub.editPriceComma(exchangePoint, true);
            }
          }
        }
      })
    }
    // ※上記反映先の項目はポイント交換商品プロモーション設定モーダル表示時に反映されるが、
    // 消費税区分のみ変更した場合にも不整合が発生しないように消費税区分変更時も内部保持値を反映する。	
  }

  /**
   * 会員タブ.価格一覧の今回供給価格変更時のイベントリスナ
   * プロモ設定タブの項目に反映する
   */
  public setPromotionThistimeSupplyPrice(grid: FlexGrid, item: any): void {
    // 「会員生協タブの価格一覧.今回供給価格」の変更をリアルタイムで「プロモ設定タブのクーポン商品プロモーション」の項目に反映する。
    // 変更が合った生協に対して、処理を行う。																																					
    const changeCoopCode = item.CoopCode;
    const changeThistimeSupplyPrice = item.ThistimeSupplyPrice;

    // 1物N価媒体プロモーションのアイテムコードごとの供給単価の取得
    const nvalSupplyUnitPriceList = this.getNvalSupplyUnitPriceSortList();

    // クーポンプロモーションの項目に反映
    for (const c of this.kymw0900Model.couponPromotionListDisplay) {
      const coopIndexList = this.getCoopCheckbox(c.couponApplicablePriceList);
      c.couponApplicablePriceList.map(cp => {
        if (cp.coopCode === changeCoopCode) {
          // プロモ設定タブのクーポン商品プロモーション.供給単価の値を設定する。
          if (!PlessViewUtilsSub.isEmpty(changeThistimeSupplyPrice)) {
            // 変更後の値がnullではない、かつ空文字ではない場合、会員生協タブの価格一覧.今回供給価格の値を設定する。
            cp.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(changeThistimeSupplyPrice, true);
          } else {
            // 変更後の値がnullまたは空文字の場合
            if (!this.kymw0900Model.nvalPromotionFlg) {
              // プロモ設定タブの1物N価媒体プロモーションの「このプロモーション設定を使用する」が未チェック状態
              // 同生協に紐つくクーポン利用生協情報一覧.今回供給価格を設定する。
              const savedThisTimeSupplyPrice = this.kymw0900Model.couponPromotionList.find(_ => _.couponGoodsNo === c.couponGoodsNo)?.couponApplicablePriceList.find(_ => _.coopCode === changeCoopCode)?.thisTimeSupplyPrice;
              if (savedThisTimeSupplyPrice) {
                cp.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(savedThisTimeSupplyPrice, true);
              } else {
                cp.thisTimeSupplyPrice = '';
              }
            } else {
              // プロモ設定タブの1物N価媒体プロモーションの「このプロモーション設定を使用する」がチェック状態
              // アイテムコードに紐づく1物N価媒体プロモーション.供給単価を設定する。
              // ※1物N価媒体プロモーションが複数存在する場合、1物N価詳細情報IDの小さいものを利用する
              const nvalPromoSupplyPrice = nvalSupplyUnitPriceList.find(_ => _.itemCode === c.itemCode)?.supplyPriceStandard;
              if (nvalPromoSupplyPrice) {
                cp.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalPromoSupplyPrice, true);
              } else {
                cp.thisTimeSupplyPrice = '';
              }
            }
          }

          // 値引後単価を算出し、計算結果を設定する。
          // 値引後単価の計算時は小数点以下を切り捨てとする
          let resultPrice = '';
          // 供給単価のカンマを外す
          let supplyPriceWithoutComma = PlessViewUtilsSub.editPriceComma(cp.thisTimeSupplyPrice, false);
          supplyPriceWithoutComma = supplyPriceWithoutComma ? supplyPriceWithoutComma : '0';
          if (!PlessViewUtilsSub.isEmpty(cp.discountUnitPrice) && PlessViewUtilsSub.isEmpty(cp.discountRate)) {
            // 値引単価があり、値引率がない場合：供給単価 - 値引単価
            const result = Number(supplyPriceWithoutComma) - Number(cp.discountUnitPrice);
            resultPrice = String(Math.ceil(result));
          } else if (PlessViewUtilsSub.isEmpty(cp.discountUnitPrice) && !PlessViewUtilsSub.isEmpty(cp.discountRate)) {
            // 値引率があり、値引単価がない場合：供給単価 - （供給単価 * 値引率 * 0.01）
            const result = Number(supplyPriceWithoutComma) - (Number(supplyPriceWithoutComma) * Number(cp.discountRate) * 0.01);
            resultPrice = String(Math.ceil(result));
          } else if (PlessViewUtilsSub.isEmpty(cp.discountUnitPrice) && PlessViewUtilsSub.isEmpty(cp.discountRate)) {
            // 値引単価と値引率がどちらもない場合は空欄（空白）で表示する
            resultPrice = '';
          }
          // 【表示形式】n,nnn,nnnに変換
          cp.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(resultPrice, true);

          // 値引き前本体価格・税込み価格に値を設定する。
          if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
            // 全生協の企画商品クーポン利用生協情報フラグが「1」ではない場合、
            // 値引き前本体価格・税込み価格には空欄を設定する
            c.contentTwo = '';
          } else {
            // 優先度が高い生協の供給単価のカンマを外してnumber型にする
            const supplyPrice = PlessViewUtilsSub.stringToNumber(
              PlessViewUtilsSub.editPriceComma(c.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0])?.thisTimeSupplyPrice, false)
            );
            // 消費税
            const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0900Model.getConsumeTaxDivRate()) * 0.01;
            // 「供給単価 + (供給単価 * 消費税率)」の値を計算。小数点以下は切り下げ
            c.contentTwo = this.kymw0900Model.formatUnitRatePrice(supplyPrice, consumeTaxDivRate);
          }

          // 値引き後本体価格・税込み価格に値を設定する。
          if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
            c.contentFour = '';
          } else if (item.CoopCode === coopIndexList[0]) {
            if (PlessViewUtilsSub.isEmpty(cp.discountUnitPrice) &&
              PlessViewUtilsSub.isEmpty(cp.discountRate)) {
              c.contentFour = '';
            } else {
              // 値引後単価
              const discountedUnitPriceNum = PlessViewUtilsSub.stringToNumber(
                PlessViewUtilsSub.editPriceComma(cp.discountedUnitPrice, false)
              );
              // 消費税
              const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0900Model.consumeTaxDivRate) * 0.01;
              // 値引き後本体価格・税込み価格
              c.contentFour = this.kymw0900Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
            }
          }
        }
      })
    }

    // ポイント交換プロモーションの項目に反映
    for (const c of this.kymw0900Model.pointExchangeListDisplay) {
      c.coopPointRateList.map(cp => {
        if (cp.CoopCode === changeCoopCode) {
          // プロモ設定タブのポイント交換プロモーション.供給単価の値を設定する。
          if (!PlessViewUtilsSub.isEmpty(changeThistimeSupplyPrice)) {
            // 変更後の値がnullではない、かつ空文字ではない場合、会員生協タブの価格一覧.今回供給価格の値を設定する。
            cp.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(changeThistimeSupplyPrice, true);
          } else {
            // 変更後の値がnullまたは空文字の場合、
            if (!this.kymw0900Model.nvalPromotionFlg) {
              // プロモ設定タブの1物N価媒体プロモーションの「このプロモーション設定を使用する」が未チェック状態
              // 同生協に紐つく会員生協別ポイント率一覧.今回供給価格を設定する。
              const savedThisTimeSupplyPrice = this.kymw0900Model.pointExchangeList.find(_ => _.itemCode === c.itemCode)?.coopPointRateList.find(_ => _.CoopCode === changeCoopCode)?.ThisTimeSupplyPrice;
              if (savedThisTimeSupplyPrice) {
                cp.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(savedThisTimeSupplyPrice, true);
              } else {
                cp.ThisTimeSupplyPrice = '';
              }
            } else {
              // プロモ設定タブの1物N価媒体プロモーションの「このプロモーション設定を使用する」がチェック状態
              // アイテムコードに紐づく1物N価媒体プロモーション.供給単価を設定する。
              // ※1物N価媒体プロモーションが複数存在する場合、1物N価詳細情報IDの小さいものを利用する
              const nvalPromoSupplyPrice = nvalSupplyUnitPriceList.find(_ => _.itemCode === c.itemCode)?.supplyPriceStandard;
              if (nvalPromoSupplyPrice) {
                cp.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalPromoSupplyPrice, true);
              } else {
                cp.ThisTimeSupplyPrice = '';
              }
            }
          }

          // ポイント購入時割引率が設定されている場合
          if (!PlessViewUtilsSub.isEmpty(cp.PointRate)) {
            // 割引率
            let pointRateNum = 0;
            switch (cp.PointRate) {
              case '10':
                pointRateNum = 0.1;
                break;
              case '15':
                pointRateNum = 0.15;
                break;
              case '20':
                pointRateNum = 0.2;
                break;
              default:
                break;
            }
            // 供給単価のカンマを外す
            const supplyPrice = PlessViewUtilsSub.stringToNumber(PlessViewUtilsSub.editPriceComma(cp.ThisTimeSupplyPrice, false));

            // 交換ポイント（税抜）を算出し、計算結果を設定する。
            // ※小数点以下切り捨て
            // 供給単価-(供給単価 * ポイント購入時割引率)
            const exchangePointWithoutTax = Math.floor(supplyPrice - (supplyPrice * pointRateNum));
            cp.ExchangePointWithoutTax = PlessViewUtilsSub.editPriceComma(exchangePointWithoutTax, true);

            // 交換ポイントを算出し、計算結果を設定する。
            // ※小数点以下切り捨て
            // ※基本情報タブの消費税区分が0:外税以外の場合、交換ポイントには交換ポイント（税抜）と同値を表示する
            // 交換ポイント(税抜) * (1 + (基本タブ.消費税率/100))
            if (this.kymw0900Model.consumeTaxDiv !== '0') {
              cp.ExchangePoint = cp.ExchangePointWithoutTax;
            } else {
              const exchangePoint = Math.floor(exchangePointWithoutTax * (1 + (Number(this.kymw0900Model.getConsumeTaxDivRate()) / 100)));
              cp.ExchangePoint = PlessViewUtilsSub.editPriceComma(exchangePoint, true);
            }
          }
        }
      });
      // 表示用
      let displayExchangePoint = '';
      let displayThisTimeSupplyPrice = '';
      let chkFlg = false;
      for (const e of this.kymw0900Model.coopDaihyoOrder) {
        c.coopPointRateList.map(cp => {
          if (e === cp.CoopCode && cp.PlanGoodsCoopPointRateEnableFlg) {
            c.displayExchangePoint = cp.ExchangePoint;
            // 「会員生協タブ.今回供給価格」があればその値を、なければ「会員生協別ポイント情報取得.供給価格」
            const coopInfoPrice = this.kymw0900Model.coopPriceList.find(_ => e === _.CoopCode)?.ThistimeSupplyPrice;
            if (coopInfoPrice) {
              c.displayThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(coopInfoPrice, true);
            } else {
              c.displayThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(cp.ThisTimeSupplyPrice, true);
            }
            chkFlg = true;
          }
        });
        if (chkFlg) {
          chkFlg = false;
          break;
        }
      }
    }

    this.dtg_PointPromotionList.refresh();
    // 選択した行にフォーカスが当たる処理
    const selectedRow = grid.selection.row;
    this.dtg_PriceList.selection = new CellRange(selectedRow, -1, -1, -1);
  }

  /**
   * 会員タブのアイテムコード変更時、他タブの活性状態・項目選択状態を変更するイベント
   * @param cell 
   */
  public setCoopListItemCodeEmptyFlg(cell: any): void {
    const coopCode = cell.item.CoopCode;
    let disableFlg = false;
    // 「会員」タブで生協の「アイテムコード」を空欄にしたとき
    if (PlessViewUtilsSub.isEmpty(cell.item.SelectItemCode)) {
      disableFlg = true;
    } else {
      disableFlg = false;
    }
    this.kymw0900Model.coopPriceListItemCodeEmpty.find(_ => _.coopCode === coopCode).flg = disableFlg;

    // 「EC設定」タブの「EC使用画像」の同じ生協のラジオボタンの活性状態を変更する。非活性の場合、画像は非表示とする。
    // 活性状態に合わせて「EC設定」タブのラジオボタンの選択状態を変更する。
    this.setSelectECRadio(coopCode, disableFlg);
    // 「アイコン」タブ、「プロモ」タブの同じ生協のチェックボックスの活性状態を変更する。
    // 活性状態に合わせて「アイコン」タブ、「プロモ」タブのチェックボックスの状態を変更する。
    this.setCheckIconCheckBox(coopCode, disableFlg);

    // 「案内一覧」に選択した生協の行が表示されていない場合、「案内一覧」に選択した生協の行を追加する。
    if (!this.kymw0900Model.guideList.some(item => item.CoopCode === coopCode)) {
      const item = {
        CoopCode: coopCode,
        CoopName: this.kymw0900Model.convertCoopName(coopCode),
        OrderNum: '',
        AppearDiv: '',
        NextGuideMap: [],
        Enabled: '1',
      }
      this.kymw0900Model.guideList.push(item)
    }

    // 「計画数一覧」の活性状態を変更する
    // 「計画数一覧」の計画数(修正)、限定数量総数、限定数量個人の合算値を再計算する
    this.kymw0900Model.setPlanNumListEnabled(coopCode, !disableFlg);

    // 「プロモ設定」タブの1N、ポイント、クーポンの同じ生協のラジオボタンの活性状態を変更する。非活性の場合、チェックを外し項目をクリアする。
    this.kymw0900Model.setNvalPromotionListEnabled(coopCode, !disableFlg);
    this.kymw0900Model.setCouponPromotionListEnabled(coopCode, !disableFlg);
    this.kymw0900Model.setPointExchangePromotionListEnabled(coopCode, !disableFlg);
  
    // 「予約設定」タブの同じ生協のラジオボタンの活性状態を変更する。非活性の場合、チェックを外し項目をクリアする。
    this.kymw0900Model.setPreOrderListEnabled(coopCode, !disableFlg);
  }

  /**
   * EC設定タブのラジオボタンの活性可否に合わせて選択状態を変更する
   * @param coopCode 変更した生協
   * @param flg 選択不可かどうか
   */
  public setSelectECRadio(coopCode: string, flg: boolean): void {
    // 選択不可の生協のラジオボタンが選択済であれば選択肢の一番上を選択する。すべて選択不可であれば、ラジオボタンは選択しない
    // 選択可能な生協リストを取得
    const falseFlgList = this.kymw0900Model.coopPriceListItemCodeEmpty.filter(_ => _.flg === false);

    if (PlessViewUtilsSub.isEmptyArray(falseFlgList)) {
      // 全て選択不可の場合、ラジオボタンの選択を外す
      this.kymw0900Model.selectCoopImage = null;
    } else {
      if (this.kymw0900Model.selectCoopImage === coopCode && flg ||
        PlessViewUtilsSub.isEmpty(this.kymw0900Model.selectCoopImage)) {
        // 変更した生協のラジオボタンが選択済みかつ選択不可（非活性）の場合、
        // もしくは、選択されているラジオボタンがない場合、選択可能の生協の一番上を選択する。
        this.kymw0900Model.selectCoopImage = falseFlgList[0].coopCode;
      }
    }
  }

  /**
   * アイコンタブ、プロモタブのチェックボックスの活性可否と選択状態を変更する
   * @param coopCode 変更した生協
   * @param flg 選択不可かどうか（true:選択不可、false:選択可能）
   */
  public setCheckIconCheckBox(coopCode: string, flg: boolean): void {
    // 選択不可かどうかを格納
    this.kymw0900Model.iconListDisable[coopCode] = flg;

    if (flg) {
      // 選択不可の場合、アイコンタブのチェックを外す
      for (const value of this.kymw0900Model.iconList) {
        switch (coopCode) {
          case this.kymw00Model.COOP_CODE_IB:
            value.icon0 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TO:
            value.icon1 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_GU:
            value.icon2 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TI:
            value.icon3 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_SA:
            value.icon4 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TK:
            value.icon5 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_NA:
            value.icon6 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_NI:
            value.icon7 = !flg;
            break;
          default:
            break;
        }
      }
      // 選択不可の場合、プロモタブのチェックを外す
      for (const value of this.kymw0900Model.markInfoList) {
        switch (coopCode) {
          case this.kymw00Model.COOP_CODE_IB:
            value.SelectValue1 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TO:
            value.SelectValue2 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_GU:
            value.SelectValue3 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TI:
            value.SelectValue4 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_SA:
            value.SelectValue5 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_TK:
            value.SelectValue6 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_NA:
            value.SelectValue7 = !flg;
            break;
          case this.kymw00Model.COOP_CODE_NI:
            value.SelectValue8 = !flg;
            break;
          default:
            break;
        }
      }
    }
  }

  /**
   * 発注用商品名(カナ)の入力から半角カンマを削除
   */
  public eventDeliveryGoodsNameKana_deleteCommaHandler(): void {
    this.kymw0900Model.deliveryGoodsNameKana = this.kymw0900Model.deliveryGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 発注用規格名(カナ)の入力から半角カンマを削除
   */
  public eventDeliveryStandardNameKana_deleteCommaHandler(): void {
    this.kymw0900Model.deliveryStandardNameKana = this.kymw0900Model.deliveryStandardNameKana.replace(/,/g, '');
  }

  /**
   * 関連情報URLの入力から半角カンマを削除
   * ※restrictで弾いているはずが入力できてしまう
   */
  public eventRelatedUrl_deleteCommaHandler(): void {
    this.kymw0900Model.relatedUrl = this.kymw0900Model.relatedUrl.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }

  /**
   * 同一アイテムコードの1物N価媒体プロモーション設定情報の供給単価を更新する
   */
  public updateNvalPromotionSupplyPrice(targetItemCode: string, supplyPrice: string): void {
    this.kymw0900Model.nvalPromotionListDisplay.map(nval => {
      if (nval.itemCode === targetItemCode) {
        nval.dataList.map(data => {
          if (data.orderCode === this.kymw0900Model.orderCode) {
            data.supplyPriceStandard = supplyPrice;
            if (data.discountType === '0') {
              data.nvalDiscountSupplyUnitPrice = data.supplyPriceStandard;
            } else if (data.discountType === '1') {
              data.nvalDiscountSupplyUnitPrice = String(Number(data.supplyPriceStandard) - Number(data.discountUnitPrice));
            } else if (data.discountType === '2') {
              if (PlessViewUtilsSub.isEmpty(data.discountRate) || data.discountRate === 'blankVal') {
                // 値引率未選択の場合は供給単価をそのまま表示する
                data.nvalDiscountSupplyUnitPrice = data.supplyPriceStandard;
              } else {
                // 小数点以下切り上げ
                data.nvalDiscountSupplyUnitPrice = String(Math.ceil(Number(data.supplyPriceStandard) - (Number(data.supplyPriceStandard) / 100 * Number(data.discountRate))));
              }
            }
          }
        })
      }
    })
  }

  /**
   * 1Nを更新・追加したときの供給単価に合わせて、ポイント交換、クーポン商品の情報を更新する
   */
  public eventReCalcSupplyUnitPrice_Handler(): void {
    // ・以下の条件を満たした場合、変更後の供給単価を使用して再計算を行う。
    // ・ポイント交換商品プロモーション、クーポン商品プロモーションの情報が存在し、会員生協タブの今回供給価が空の場合

    // 1物N価媒体プロモーションのアイテムコードごとの供給単価の取得
    const nvalSupplyUnitPriceList = this.getNvalSupplyUnitPriceSortList()

    // ポイント交換プロモーション
    if (this.kymw0900Model.pointPromotionFlg) {
      // ポイント交換リスト
      this.kymw0900Model.pointExchangeListDisplay.map(point => {
        // ポイント交換
        point.coopPointRateList.map(cpr => {
          const coopPrice = this.kymw0900Model.coopPriceList.find(cp => cp.CoopCode === cpr.CoopCode);
          if (coopPrice.SelectItemCode === point.itemCode) {
            // 会員生協タブの価格一覧.今回供給価格がNULLまたは空白の場合、1物N価プロモーションの供給単価で再計算を行う。
            if (PlessViewUtilsSub.isEmpty(coopPrice.ThistimeSupplyPrice)) {
              const nvalSupplyPrice = nvalSupplyUnitPriceList.find(s => s.itemCode === point.itemCode)?.supplyPriceStandard;
              cpr.ThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalSupplyPrice, true);
              // 交換ポイントを計算
              if (!PlessViewUtilsSub.isEmpty(cpr.PointRate)) {
                // 割引率
                let pointRateNum = 0;
                switch (cpr.PointRate) {
                  case '10':
                    pointRateNum = 0.1;
                    break;
                  case '15':
                    pointRateNum = 0.15;
                    break;
                  case '20':
                    pointRateNum = 0.2;
                    break;
                  default:
                    break;
                }
                // 供給単価のカンマを外す
                const supplyPrice = PlessViewUtilsSub.stringToNumber(PlessViewUtilsSub.editPriceComma(cpr.ThisTimeSupplyPrice, false));

                // 交換ポイント（税抜）を算出し、計算結果を設定する。
                // ※小数点以下切り捨て
                // 供給単価-(供給単価 * ポイント購入時割引率)
                const exchangePointWithoutTax = Math.floor(supplyPrice - (supplyPrice * pointRateNum));
                cpr.ExchangePointWithoutTax = PlessViewUtilsSub.editPriceComma(exchangePointWithoutTax, true);

                // 交換ポイントを算出し、計算結果を設定する。
                // ※小数点以下切り捨て
                // ※基本情報タブの消費税区分が0:外税以外の場合、交換ポイントには交換ポイント（税抜）と同値を表示する
                // 交換ポイント(税抜) * (1 + (基本タブ.消費税率/100))
                if (this.kymw0900Model.consumeTaxDiv !== '0') {
                  cpr.ExchangePoint = cpr.ExchangePointWithoutTax;
                } else {
                  const exchangePoint = Math.floor(exchangePointWithoutTax * (1 + (Number(this.kymw0900Model.getConsumeTaxDivRate()) / 100)));
                  cpr.ExchangePoint = PlessViewUtilsSub.editPriceComma(exchangePoint, true);
                }
              }
            }
          }
        })
        // 表示を更新
        let chkFlg = false;
        for (const e of this.kymw0900Model.coopDaihyoOrder) {
          point.coopPointRateList.map(cp => {
            if (e === cp.CoopCode && cp.PlanGoodsCoopPointRateEnableFlg) {
              point.displayExchangePoint = cp.ExchangePoint;
              // 「会員生協タブ.今回供給価格」があればその値を、なければ「会員生協別ポイント情報取得.供給価格」
              const coopInfoPrice = this.kymw0900Model.coopPriceList.find(_ => e === _.CoopCode)?.ThistimeSupplyPrice;
              if (coopInfoPrice) {
                point.displayThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(coopInfoPrice, true);
              } else {
                point.displayThisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(cp.ThisTimeSupplyPrice, true);
              }
              chkFlg = true;
            }
          });
          if (chkFlg) {
            chkFlg = false;
            break;
          }
        }
        this.dtg_PointPromotionList.refresh();
      })
    }
    // クーポン商品プロモーション
    if (this.kymw0900Model.couponPromotionFlg) {
      this.kymw0900Model.couponPromotionListDisplay.map(coupon => {
        const coopIndexList = this.getCoopCheckbox(coupon.couponApplicablePriceList);
        coupon.couponApplicablePriceList.map(cap => {
          const coopPrice = this.kymw0900Model.coopPriceList.find(cp => cp.CoopCode === cap.coopCode);
          if (coopPrice.SelectItemCode === coupon.itemCode) {
            // 会員生協タブの価格一覧.今回供給価格がNULLまたは空白の場合、1物N価プロモーションの供給単価で再計算を行う。
            if (PlessViewUtilsSub.isEmpty(coopPrice.ThistimeSupplyPrice)) {
              const nvalSupplyPrice = nvalSupplyUnitPriceList.find(s => s.itemCode === coupon.itemCode)?.supplyPriceStandard;
              cap.thisTimeSupplyPrice = PlessViewUtilsSub.editPriceComma(nvalSupplyPrice, true);

              // 値引後単価を算出し、計算結果を設定する。
              // 値引後単価の計算時は小数点以下を切り捨てとする
              let resultPrice = '';
              // 供給単価のカンマを外す
              let supplyPriceWithoutComma = PlessViewUtilsSub.editPriceComma(cap.thisTimeSupplyPrice, false);
              supplyPriceWithoutComma = supplyPriceWithoutComma ? supplyPriceWithoutComma : '0';
              if (!PlessViewUtilsSub.isEmpty(cap.discountUnitPrice) && PlessViewUtilsSub.isEmpty(cap.discountRate)) {
                // 値引単価があり、値引率がない場合：供給単価 - 値引単価
                const result = Number(supplyPriceWithoutComma) - Number(cap.discountUnitPrice);
                resultPrice = String(Math.ceil(result));
              } else if (PlessViewUtilsSub.isEmpty(cap.discountUnitPrice) && !PlessViewUtilsSub.isEmpty(cap.discountRate)) {
                // 値引率があり、値引単価がない場合：供給単価 - （供給単価 * 値引率 * 0.01）
                const result = Number(supplyPriceWithoutComma) - (Number(supplyPriceWithoutComma) * Number(cap.discountRate) * 0.01);
                resultPrice = String(Math.ceil(result));
              } else if (PlessViewUtilsSub.isEmpty(cap.discountUnitPrice) && PlessViewUtilsSub.isEmpty(cap.discountRate)) {
                // 値引単価と値引率がどちらもない場合は空欄（空白）で表示する
                resultPrice = '';
              }
              // 【表示形式】n,nnn,nnnに変換
              cap.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(resultPrice, true);

              if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
                // 全生協の企画商品クーポン利用生協情報フラグが「1」ではない場合、
                // 値引き前本体価格・税込み価格には空欄を設定する
                coupon.contentTwo = '';
                coupon.contentFour = '';
              } else if (cap.coopCode === coopIndexList[0]) {
                // 1. 値引き前本体価格・税込み価格に値を設定する。
                // 優先度が高い生協の供給単価のカンマを外してnumber型にする
                const supplyPrice = PlessViewUtilsSub.stringToNumber(
                  PlessViewUtilsSub.editPriceComma(cap.thisTimeSupplyPrice, false)
                );
                // 消費税
                const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0900Model.getConsumeTaxDivRate()) * 0.01;
                // 「供給単価 + (供給単価 * 消費税率)」の値を計算。小数点以下は切り下げ
                coupon.contentTwo = this.kymw0900Model.formatUnitRatePrice(supplyPrice, consumeTaxDivRate);

                // 2. 値引き後本体価格・税込み価格に値を設定する。
                if (PlessViewUtilsSub.isEmpty(cap.discountUnitPrice) &&
                  PlessViewUtilsSub.isEmpty(cap.discountRate)) {
                  coupon.contentFour = '';
                } else {
                  // 値引後単価
                  const discountedUnitPriceNum = PlessViewUtilsSub.stringToNumber(
                    PlessViewUtilsSub.editPriceComma(cap.discountedUnitPrice, false)
                  );
                  // 消費税
                  const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0900Model.consumeTaxDivRate) * 0.01;
                  // 値引き後本体価格・税込み価格
                  coupon.contentFour = this.kymw0900Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
                }
              }
            }
          }
        })
      })
    }
  }

  /**
   * 1物N価媒体プロモーションに設定済みの供給単価を取得する
   * ※同じアイテムコードがある場合はidの小さいものを取得
   * @returns 
   */
  public getNvalSupplyUnitPriceSortList(): any {
    // 1物N価媒体プロモーションのアイテムコードごとの供給単価の取得
    // （同じアイテムコードが複数ある場合はidが小さいものを取得）
    // id小さい順に並び替えたリスト
    const nvalPromotionSortList = [...this.kymw0900Model.nvalPromotionListDisplay].sort((a, b) => a.nvalDetailId - b.nvalDetailId);
    // 並び変えたリストのdataListで対象の受注コードのデータを取得
    let nvalPromotionSortDataList = [];
    nvalPromotionSortList.map(_ => {
      const returnData = _.dataList.find(d => this.kymw0900Model.orderCode === d.orderCode);
      if (returnData) {
        nvalPromotionSortDataList.push(returnData);
      }
    })
    // 対象dataListで重複するアイテムコードを除外する
    let nvalSupplyUnitPriceList = [];
    nvalPromotionSortDataList.map(_ => {
      if (!nvalSupplyUnitPriceList.find(n => n.itemCode === _.itemCode)) {
        nvalSupplyUnitPriceList.push(_);
      }
    });
    return nvalSupplyUnitPriceList
  }

  /**
   * 次回案内の入力制御イベント
   * @param event 
   * @param cell 
   * @param mediumType 
   */
  public eventNextGuide_FOCUSOUTHandler(event: any, cell: any, mediumType: string): void {
    const input = event.target as HTMLInputElement;
    if(!input || !cell) {
      return;
    }

    // 入力した文字列のうち、数値と記号が全角の場合半角に変換
    let strWrd = input.value.replace(/[０-９！＃＄％＆’（）－＋＝＾～｜＠；：＊＜＞？＿，．／＼｛｝［］]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
    // 半角記号に変換されない記号を除外
    strWrd = strWrd.replace(/[「」、。・￥”‘]/g, '');
    input.value = strWrd;
    cell.value = strWrd;
    cell.item.NextGuideMap[mediumType] = strWrd;
  }

  /**
   * 1物N価媒体プロモーションで「追加」時、もしくは空のデータに対して「詳細」時、
   * パラメータを格納する共通イベント
   * ※空のデータに対して「詳細」時、「1物N価詳細情報ID」「媒体」「アイテムコード」以外のパラメータは
   * 「追加」時と同じように値を格納するため
   * @param vo 
   * @param addChar 
   */
  public setNvalPromotionInputParam_ADD_emptyDETAIL(vo: KYMW0907InputModel, addChar: any): KYMW0907InputModel {
    // 専用商品名
    if (addChar.list.length > 0) {
      // 商品名の先頭文字を取得
      const startChar = this.kymw0900Model.deliveryGoodsNameKanji.substr(0,1);
      // 半角に変換
      const halfStartChar = PlessViewUtilsSub.toHalfWidth(startChar);
      // 数値かどうか判定
      const numberFlg = PlessViewUtilsSub.isIntString(halfStartChar);
      // 英字かどうか判定
      const alphabetFlg = /[a-zA-Z]+$/.test(halfStartChar);
      
      // 先頭文字が英数字の場合、addCharとの間に空欄を入れる
      let tempAddChar = addChar.list[0].CodeName;
      if (numberFlg || alphabetFlg) {
        tempAddChar += '　';
      }
      vo.nvalPromotionGoodsName = tempAddChar + this.kymw0900Model.deliveryGoodsNameKanji;
    } else {
      vo.nvalPromotionGoodsName = this.kymw0900Model.deliveryGoodsNameKanji;
    }
    // 専用商品名(カナ)
    vo.nvalPromotionGoodsNameKana = this.kymw0900Model.deliveryGoodsNameKana;
    // 専用規格名
    vo.nvalPromotionStandardName = this.kymw0900Model.deliveryStandardNameKanji;
    // 専用規格名(カナ)
    vo.nvalPromotionStandardNameKana = this.kymw0900Model.deliveryStandardNameKana;

    // 供給単価
    const selectedData = this.kymw0900Model.nvalPromotionListDisplay.find(_ => _.itemCode === vo.selectedItemCode);
    if (selectedData) {
      // 1物N価媒体プロモーションに表示されているもののうち、同アイテムコードを持つデータの供給単価を使用
      vo.supplyPriceStandard = selectedData.dataList.find(_ => _.orderCode === this.kymw0900Model.orderCode)?.supplyPriceStandard;
    } else {
      // 画面上同じアイテムコードのデータがない場合、最初のデータの供給価格を使用
      vo.supplyPriceStandard = this.kymw0900Model.nvalPromotionListDisplay[0]?.dataList?.find(_ => _.orderCode === this.kymw0900Model.orderCode)?.supplyPriceStandard;
    }
    return vo;
  }

  /**
   * 商品名・規格に対して全角スペース埋めを行う
   * @param contentOne 
   */
  public contentOneSpacePadding(contentOne: string): string {
    const strLength = contentOne.length;
    let retVal = contentOne;
    if (strLength < 13) {
      // 全角１３文字未満の場合、全角１３文字まで頭に全角スペースを埋める
      retVal = PlessViewUtilsSub.padding(retVal, 13, '　', 1);
    } else if (14 <= strLength && strLength < 26) {
      // 全角１４文字以上２６文字未満の場合、全角２６文字まで頭に全角スペースを埋める
      retVal = PlessViewUtilsSub.padding(retVal, 26, '　', 1);
    }
    return retVal;
  }
}
